// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../fonts/stylesheet.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../fonts/inter/stylesheet.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./all.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/icons/arrow-down-gray-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/icons/arrow-down-white-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/banner-left-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/banner-right-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/hubrid-setup-left-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/hubrid-setup-right-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/compliance-left-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/compliance-right-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/compliance-bg-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/compliance-bg-mobile-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/partnerships-top-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/partnerships-top-bg-lines-mobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/partnerships-bottom-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/partnerships-bottom-bg-lines-mobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/join-bg-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/join-left-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/join-right-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/footer-left-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/footer-right-bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/xdc-banner-bg-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/safe-card-bg-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: #000000;
  font-family: "Manrope";
  background: #E6F2FE;
}

.container {
  max-width: 1280px;
}

.p-lr-40 {
  padding-left: 40px;
  padding-right: 40px;
}
@media screen and (max-width: 767px) {
  .p-lr-40 {
    padding-left: 32px;
    padding-right: 32px;
  }
}

h1 {
  font-size: 40px;
  line-height: 50px;
  font-weight: 500;
  color: #191D23;
  font-family: "Gabarito";
}
@media screen and (max-width: 991px) {
  h1 {
    font-size: 28px;
    line-height: 36px;
  }
}

h2, .h2 {
  font-size: 40px;
  line-height: 48px;
  font-weight: 700;
  color: #191D23;
  font-family: "Gabarito";
}
@media screen and (max-width: 991px) {
  h2, .h2 {
    font-size: 28px;
    line-height: 36px;
  }
}
h2.w-500, .h2.w-500 {
  font-weight: 500;
}
h2.w-400, .h2.w-400 {
  font-weight: 400;
}
h2.f-48, .h2.f-48 {
  font-size: 48px;
  line-height: 58px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  h2.f-48, .h2.f-48 {
    font-size: 40px;
    line-height: 48px;
  }
}
@media screen and (max-width: 767px) {
  h2.f-48, .h2.f-48 {
    font-size: 24px;
    line-height: 34px;
  }
  h2.f-48 br, .h2.f-48 br {
    display: none;
  }
}

h3, .h3 {
  font-size: 18px;
  line-height: 26px;
  font-weight: 700;
  color: #191D23;
  font-family: "Manrope";
}
h3.f-17, .h3.f-17 {
  font-size: 17px;
  line-height: 25px;
}
h3.f-20, .h3.f-20 {
  font-size: 20px;
  line-height: 28px;
}
h3.f-24, .h3.f-24 {
  font-size: 24px;
  line-height: 32px;
}
@media screen and (max-width: 767px) {
  h3.f-24, .h3.f-24 {
    font-size: 20px;
    line-height: 28px;
  }
}
h3.f-30, .h3.f-30 {
  font-size: 30px;
  line-height: 38px;
}
@media screen and (max-width: 767px) {
  h3.f-30, .h3.f-30 {
    font-size: 25px;
    line-height: 33px;
  }
}
h3.f-32, .h3.f-32 {
  font-size: 32px;
  line-height: 40px;
}
@media screen and (max-width: 767px) {
  h3.f-32, .h3.f-32 {
    font-size: 25px;
    line-height: 33px;
  }
}
h3.f-40, .h3.f-40 {
  font-size: 40px;
  line-height: 48px;
}
@media screen and (max-width: 767px) {
  h3.f-40, .h3.f-40 {
    font-size: 35px;
    line-height: 42px;
  }
}
h3.w-400, .h3.w-400 {
  font-weight: 400;
}
h3.w-500, .h3.w-500 {
  font-weight: 500;
}
h3.w-600, .h3.w-600 {
  font-weight: 600;
}
h3.h-font, .h3.h-font {
  font-family: "Gabarito";
}

.h3 {
  font-size: 22px;
  line-height: 30px;
}
p, .p {
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  color: #191D23;
  font-family: "Manrope";
}
p.w-500, .p.w-500 {
  font-weight: 500;
}
p.w-600, .p.w-600 {
  font-weight: 600;
}
p.w-700, .p.w-700 {
  font-weight: 700;
}
p.w-800, .p.w-800 {
  font-weight: 800;
}
p.f-10, .p.f-10 {
  font-size: 10px;
  line-height: 16px;
}
p.f-12, .p.f-12 {
  font-size: 12px;
  line-height: 18px;
}
p.f-13, .p.f-13 {
  font-size: 13px;
  line-height: 18px;
}
p.f-15, .p.f-15 {
  font-size: 15px;
  line-height: 12px;
}
p.f-18, .p.f-18 {
  font-size: 18px;
  line-height: 26px;
}
p.f-20, .p.f-20 {
  font-size: 20px;
  line-height: 28px;
}
p.gray01, .p.gray01 {
  color: rgba(230, 242, 254, 0.7);
}

.p {
  font-size: 16px;
  line-height: 25px;
  /*@media screen and (max-width: \$screen-xs) {
    font-size: 14px;
    line-height: 22px;
  }*/
}

strong {
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  color: #191D23;
  font-family: "Manrope";
}
strong.w-400 {
  font-weight: 400;
}

span {
  font-size: 12px;
  line-height: 19px;
  font-weight: 400;
  color: #787878;
  font-family: "Manrope";
  display: inline-block;
}

a, .a {
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  color: #191D23;
  font-family: "Manrope";
  text-decoration: none;
}
a:hover, .a:hover {
  color: #191D23;
  text-decoration: none;
}
a.w-600, .a.w-600 {
  font-weight: 600;
}
a.w-700, .a.w-700 {
  font-weight: 700;
}
a.f-12, .a.f-12 {
  font-size: 12px;
  line-height: 18px;
}
a.f-16, .a.f-16 {
  font-size: 16px;
  line-height: 25px;
}
@media screen and (max-width: 767px) {
  a.f-16, .a.f-16 {
    font-size: 14px;
    line-height: 22px;
  }
}

ul {
  padding-left: 0;
  margin-bottom: 0;
}
ul li {
  list-style: none;
  display: inline-block;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  color: #191D23;
  font-family: "Manrope";
}

.btn-style {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  height: 44px;
  padding: 10px 16px;
  color: #ffffff;
  cursor: pointer;
  border-radius: 4px;
  text-decoration: none;
  font-family: "Manrope";
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  background: #000000;
  border: 2px solid #000000;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  text-shadow: 0 40px 0 #ffffff;
}
@media screen and (max-width: 767px) {
  .btn-style {
    font-size: 14px;
    line-height: 20px;
    height: 44px;
    padding: 10px 12px;
  }
}
.btn-style:hover {
  transition: all 0.3s ease-in-out;
  background: #000000;
  border: 2px solid #000000;
  color: #ffffff;
}
.btn-style:hover:after {
  left: -30%;
  opacity: 1;
  top: -20%;
  transition-duration: 0.7s, 0.7s, 0.15s;
  transition-property: left, top, opacity;
  transition-timing-function: linear;
}
.btn-style:hover span {
  transform: translateY(-40px);
}
.btn-style span {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}
.btn-style .icon-white {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(17deg) brightness(104%) contrast(104%);
  max-width: 18px;
}
.btn-style span {
  transition: transform 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.btn-style:after {
  content: "";
  height: 200%;
  width: 200%;
  position: absolute;
  left: -210%;
  top: -50%;
  background: linear-gradient(90deg, hsla(0, 0%, 100%, 0.13), hsla(0, 0%, 100%, 0.13) 77%, hsla(0, 0%, 100%, 0.5) 92%, hsla(0, 0%, 100%, 0));
  opacity: 0;
  transition: all 0.7s ease 0s;
}
.btn-style.small {
  padding: 10px 15px 11px;
  height: 30px;
  font-size: 12px;
  line-height: 18px;
}
.btn-style.h-36 {
  padding: 5px 32px;
  height: 36px;
}
.btn-style.transparent {
  background: transparent;
  border-color: #000000;
  color: #000000;
  padding: 10px 32px;
  font-weight: 700;
}
@media screen and (max-width: 767px) {
  .btn-style.transparent {
    font-size: 14px;
    line-height: 20px;
    padding: 8px 8px;
  }
}
.btn-style.transparent:after {
  display: none;
}
.btn-style.transparent.white-border {
  border-color: #ffffff;
  color: #ffffff;
}
.btn-style.colored-border {
  color: #DEEBF8;
  text-transform: capitalize;
  border-radius: 60px;
  background: 0 0;
  background: linear-gradient(#fff, #fff) padding-box, linear-gradient(90deg, rgb(255, 1, 2), rgba(243, 182, 0, 0.5)) border-box;
  border: 2px solid transparent;
}
.btn-style.text {
  min-width: 90px;
  height: 32px;
  padding: 7px 5px;
  background: transparent;
  border: none;
  box-shadow: none;
  color: #DEEBF8;
}
.btn-style.round {
  border-radius: 50px;
}
.btn-style.shadow {
  box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;
}
.btn-style.full {
  min-width: 100%;
}
.btn-style.icon {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.btn-style.gradient {
  background: rgb(219, 10, 10);
  background: linear-gradient(0deg, rgb(219, 10, 10) 0%, rgb(253, 219, 45) 100%);
  border: none;
  color: white;
}
.btn-style.icon-circle {
  border-radius: 50%;
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
}
.btn-style.icon-circle i {
  font-size: 22px;
}
.btn-style.pink {
  background: #DEEBF8;
  color: #ffffff;
  border-color: #DEEBF8;
}
.btn-style.pink:hover {
  background: transparent;
  color: #DEEBF8;
  border-color: #DEEBF8;
}
.btn-style.white {
  background: #ffffff;
  color: #000000;
  border-color: #ffffff;
}
.btn-style.white:hover {
  background: #ffffff;
  color: #000000;
  border-color: #ffffff;
}
.btn-style.white:hover:after {
  display: none;
}

.form .form-group {
  margin-bottom: 24px;
}
.form .form-group .upload-card input[type=file] {
  display: none;
}
.form .form-group .upload-card label.upload-label {
  width: 100%;
  height: 179px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-bottom: 16px;
  cursor: pointer;
  background: transparent;
  border: 1px solid #B5D2DF;
}
.form .form-group .upload-card label.upload-label .upload-gallery-wrapper {
  text-align: center;
}
.form .form-group .upload-card label.upload-label .upload-gallery-wrapper .upload-content .upload-icon {
  max-width: 60px;
}
.form .form-group .upload-card label.upload-label .upload-gallery-wrapper .upload-content p {
  font-weight: 600;
  margin: 10px 0 8px;
}
.form .form-group .upload-card label.upload-label .upload-gallery-wrapper .upload-content p.or {
  margin: 0 0 8px;
}
@media screen and (max-width: 767px) {
  .form .form-group .upload-card label.upload-label .upload-gallery-wrapper .upload-content .btn-style {
    min-width: 146px;
  }
}
.form .form-group .search-wrapper {
  position: relative;
}
.form .form-group .search-wrapper.align-left .form-control {
  padding: 9px 12px 9px 35px;
}
.form .form-group .search-wrapper.align-left .search-icon {
  position: absolute;
  right: unset;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 16px;
}
.form .form-group .search-wrapper .form-control {
  padding: 9px 35px 9px 12px;
}
.form .form-group .search-wrapper .search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 16px;
}
.form .form-group.radio-group ul.radio-list li:not(:last-of-type) {
  margin: 0 10px 6px 0;
}
.form .form-group.radio-group ul.radio-list li input {
  display: none;
}
.form .form-group.radio-group ul.radio-list li label:not(.radio-label) {
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  margin-bottom: 0;
}
.form .form-group.radio-group ul.radio-list li label:not(.radio-label):before, .form .form-group.radio-group ul.radio-list li label:not(.radio-label):after {
  content: "";
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: transparent;
  border: 1px solid #B5D2DF;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  transition: all 0.2s ease;
}
.form .form-group.radio-group ul.radio-list li label:not(.radio-label)::after {
  background-color: #DEEBF8;
  border-color: #DEEBF8;
  transform: translateY(-50%) scale(0);
}
.form .form-group.radio-group ul.radio-list li input[type=radio]:checked + label::before {
  border-color: #DEEBF8;
}
.form .form-group.radio-group ul.radio-list li input[type=radio]:checked + label::after {
  transform: translateY(-50%) scale(0.55);
}
.form .form-group.checkbox-group label {
  position: relative;
  top: 1px;
  cursor: pointer;
  margin: 0 0 0 3px;
}
.form .form-group.checkbox-group input[type=checkbox] {
  position: relative;
  height: 20px;
  width: 20px;
  cursor: pointer;
  border-radius: 4px;
  border: 2px solid #000000;
  vertical-align: text-top;
  -webkit-appearance: none;
}
.form .form-group.checkbox-group input[type=checkbox]:checked {
  opacity: 1;
  border-color: #000000;
  background: #000000;
}
.form .form-group.checkbox-group input[type=checkbox]:checked:before {
  opacity: 1;
}
.form .form-group.checkbox-group input[type=checkbox]:before {
  content: "";
  width: 5px;
  height: 10px;
  position: absolute;
  top: 45%;
  right: calc(50% - 1px);
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translate(-50%, -50%);
  z-index: 2;
  opacity: 0;
}
.form .form-group select {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 12px;
  background-position: calc(100% - 13px) 50%;
  padding: 9px 35px 9px 12px;
}
.form label {
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  color: #191D23;
  display: inline-flex;
  align-items: self-start;
  gap: 1px;
  margin-bottom: 4px;
}
.form label sup {
  font-size: 14px;
  line-height: 10px;
  color: #F15338;
  position: relative;
  top: 1px;
}
.form textarea {
  min-height: 121px;
  resize: none;
}
.form .form-control {
  width: 100%;
  height: 44px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: #64748B;
  border-radius: 4px;
  padding: 9px 12px 9px;
  border: 1px solid #B5D2DF;
  position: relative;
  outline: none;
  appearance: none;
  background-color: transparent;
}
.form .form-control::placeholder {
  color: #64748B;
}
.form .form-control:focus {
  box-shadow: none;
}

/*<div class="circle-animation">
<span class="tp-circle-1"></span>
<span class="tp-circle-2"></span>
</div>*/
body.landing-page-body {
  background: #ffffff;
  padding: 0;
}

@media screen and (max-width: 767px) {
  .d-visible {
    display: none !important;
  }
}

.m-visible {
  display: none;
}
@media screen and (max-width: 767px) {
  .m-visible {
    display: block !important;
  }
}

@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner .container, .sec-hubrid-setup .container, .sec-digital-asset .container, .sec-mobile-wallet .container, .sec-trading-desk .container, .sec-security .container, .sec-compliance .container {
    max-width: 1140px;
  }
}

.title-style-01 {
  font-size: 56px;
  line-height: 80px;
  font-weight: 500;
  color: #000000;
  text-transform: capitalize;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .title-style-01 {
    font-size: 46px;
    line-height: 62px;
  }
}
@media screen and (max-width: 767px) {
  .title-style-01 {
    font-size: 26px;
    line-height: 34px;
  }
}
.title-style-01.lh-same {
  line-height: 1.2;
}
.title-style-01 b {
  padding: 0 8px;
  font-weight: 500;
  border-radius: 7px;
  background: #D9EAFF;
}

.landing-header {
  position: absolute;
  top: 45px;
  left: 0;
  width: 100%;
  z-index: 2;
}
@media screen and (max-width: 767px) {
  .landing-header {
    top: 9px;
  }
}
@media screen and (max-width: 767px) {
  .landing-header.menu-open .header-wrapper {
    border-radius: 8px 8px 0 0;
  }
}
.landing-header .header-wrapper {
  padding: 20px 32px;
  border-radius: 8px;
  background: #090F17;
  box-shadow: 0px 4px 52px 0px rgba(0, 0, 0, 0.1490196078);
  max-width: 746px;
  margin: auto;
  display: grid;
  grid-template-columns: 109px 1fr;
  justify-content: space-between;
  column-gap: 30px;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper {
    grid-template-columns: 72px 1fr;
    max-width: 328px;
    padding: 16px 24px;
  }
}
.landing-header .header-wrapper .logo-wrapper a.logo img {
  max-width: 109px;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .logo-wrapper a.logo img {
    max-width: 72px;
  }
}
.landing-header .header-wrapper .navbar-menu .menu-bar {
  display: none;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu .menu-bar {
    display: block;
    text-align: right;
  }
}
.landing-header .header-wrapper .navbar-menu .menu-bar img {
  max-width: 20px;
}
.landing-header .header-wrapper .navbar-menu ul.menu {
  text-align: right;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu {
    position: fixed;
    top: 66px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 328px;
    height: auto;
    box-shadow: 0 4px 52px 0 rgba(0, 0, 0, 0.1490196078);
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    display: none;
  }
  .landing-header .header-wrapper .navbar-menu ul.menu.active {
    display: block;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li {
    display: block;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li:not(:last-of-type) {
  margin: 0 25px 0 0;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li:not(:last-of-type) {
    margin: 0;
    border-bottom: 1px solid #D3E7F1;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li.arrow {
  margin: 0 45px 0 0;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li.arrow {
    margin: 0;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li.arrow:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: cover;
  width: 6px;
  height: 9px;
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li.arrow:before {
    width: 12px;
    right: 24px;
    filter: brightness(0) saturate(100%) invert(0%) sepia(97%) saturate(0%) hue-rotate(43deg) brightness(95%) contrast(102%);
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li a {
  color: #ffffff;
  font-weight: 400;
  display: inline-block;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li a {
    display: block;
    font-weight: 500;
    text-align: left;
    color: #000000;
    padding: 20px 33px 20px 28px;
  }
}

.sec-landing-banner {
  position: relative;
}
.sec-landing-banner:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner:before {
    background: transparent;
    width: 16px;
  }
}
.sec-landing-banner:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner:before, .sec-landing-banner:after {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .container {
    padding: 0;
  }
}
.sec-landing-banner .banner-wrapper {
  position: relative;
  margin: 0 60px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner .banner-wrapper {
    margin: 0 30px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper {
    margin: 0;
  }
}
.sec-landing-banner .banner-wrapper .bg-img {
  width: 100%;
  height: 100%;
}
.sec-landing-banner .banner-wrapper .banner-content {
  position: absolute;
  top: 192px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 899px;
  text-align: center;
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content {
    top: 90px;
    padding: 0 16px;
  }
}
.sec-landing-banner .banner-wrapper .banner-content .banner-tag {
  padding: 12px 16px;
  min-height: 42px;
  border-radius: 8px;
  border: 1px solid #E4E4E4;
  display: inline-flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 32px;
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content .banner-tag {
    text-align: left;
    margin-bottom: 24px;
  }
}
.sec-landing-banner .banner-wrapper .banner-content .banner-tag img {
  max-width: 20px;
}
.sec-landing-banner .banner-wrapper .banner-content .banner-tag p {
  color: #424A53;
  margin-bottom: 0;
}
.sec-landing-banner .banner-wrapper .banner-content h1 {
  font-size: 72px;
  line-height: 80px;
  font-weight: 500;
  color: #000000;
  margin: 0;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner .banner-wrapper .banner-content h1 {
    font-size: 60px;
    line-height: 70px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content h1 {
    font-size: 40px;
    line-height: 50px;
  }
}
.sec-landing-banner .banner-wrapper .banner-content h3 {
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.9);
  margin: 32px 0;
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content h3 {
    margin: 24px 0;
    font-size: 14px;
    line-height: 22px;
  }
  .sec-landing-banner .banner-wrapper .banner-content h3 br {
    display: none;
  }
}
.sec-landing-banner .banner-wrapper .banner-content ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-landing-banner .banner-wrapper .banner-content ul.btn-list li:not(:last-of-type) {
  margin: 0 16px 0 0;
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content ul.btn-list li .btn-style {
    height: 36px;
    min-width: 111px;
  }
}

.sec-crypto-banner {
  position: relative;
  padding: 120px 0 100px;
}
.sec-crypto-banner:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-crypto-banner:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner:before {
    background: transparent;
    width: 16px;
  }
}
.sec-crypto-banner:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-crypto-banner:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner {
    padding: 100px 0 62px;
  }
}
.sec-crypto-banner:before, .sec-crypto-banner:after {
  background-color: #ffffff;
  z-index: 1;
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner:before, .sec-crypto-banner:after {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner .container {
    padding: 0;
  }
}
.sec-crypto-banner .banner-wrapper {
  position: relative;
  margin: 0 60px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-crypto-banner .banner-wrapper {
    margin: 0 30px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner .banner-wrapper {
    margin: 0;
  }
}
.sec-crypto-banner .banner-wrapper .banner-img {
  position: relative;
}
.sec-crypto-banner .banner-wrapper .banner-img .bg-img {
  width: 100%;
  height: 100%;
}
.sec-crypto-banner .banner-wrapper .banner-img ul.crypto-list {
  width: 100%;
  max-width: 80%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sec-crypto-banner .banner-wrapper .banner-img ul.crypto-list li .btn-style {
  height: 34px;
  padding: 8px 20px !important;
  border-radius: 60px;
  font-size: 11px;
  line-height: 17px;
  font-weight: 700;
  border-color: #C5D4E4;
  font-family: "Manrope";
}
.sec-crypto-banner .banner-wrapper .banner-content {
  max-width: 940px;
  margin: auto;
  text-align: center;
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner .banner-wrapper .banner-content {
    top: 90px;
    padding: 0 16px;
  }
}
.sec-crypto-banner .banner-wrapper .banner-content h1 {
  margin: 0;
}
.sec-crypto-banner .banner-wrapper .banner-content h3 {
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.9);
  margin: 32px 0;
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner .banner-wrapper .banner-content h3 {
    margin: 24px 0;
    font-size: 14px;
    line-height: 22px;
  }
  .sec-crypto-banner .banner-wrapper .banner-content h3 br {
    display: none;
  }
}
.sec-crypto-banner .banner-wrapper .banner-content ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-crypto-banner .banner-wrapper .banner-content ul.btn-list li:not(:last-of-type) {
  margin: 0 16px 0 0;
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner .banner-wrapper .banner-content ul.btn-list li:not(:last-of-type) {
    margin: 0 8px 0 0;
  }
}
.sec-crypto-banner .banner-wrapper .banner-content ul.btn-list li .btn-style {
  font-family: "Manrope";
}
@media screen and (max-width: 767px) {
  .sec-crypto-banner .banner-wrapper .banner-content ul.btn-list li .btn-style {
    padding: 8px 22px;
    height: 36px;
    min-width: 111px;
  }
}

.sec-empty-banner {
  position: relative;
  min-height: 150px;
}
.sec-empty-banner:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-empty-banner:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-empty-banner:before {
    width: 16px;
  }
}
.sec-empty-banner:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-empty-banner:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-empty-banner:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-empty-banner {
    min-height: 80px;
  }
}
.sec-empty-banner:before, .sec-empty-banner:after {
  height: calc(100% + 1px);
}
@media screen and (max-width: 767px) {
  .sec-empty-banner:before, .sec-empty-banner:after {
    height: 100%;
    display: none;
  }
}

.sec-otc-trading-desk {
  padding: 100px 0;
  position: relative;
  border-top: 1px solid #D3E7F1;
  border-bottom: 1px solid #D3E7F1;
}
.sec-otc-trading-desk:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-otc-trading-desk:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-otc-trading-desk:before {
    width: 16px;
  }
}
.sec-otc-trading-desk:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-otc-trading-desk:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-otc-trading-desk:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-otc-trading-desk {
    padding: 56px 0 40px;
  }
}
.sec-otc-trading-desk:before, .sec-otc-trading-desk:after {
  height: calc(100% + 1px);
}
@media screen and (max-width: 767px) {
  .sec-otc-trading-desk:before, .sec-otc-trading-desk:after {
    height: 100%;
  }
}
.sec-otc-trading-desk .container > h2 {
  text-align: center;
  margin-bottom: 44px;
}
.sec-otc-trading-desk .desk-grid {
  display: grid;
  grid-template-columns: repeat(2, 485px);
  align-items: self-start;
  justify-content: center;
  column-gap: 36px;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-otc-trading-desk .desk-grid {
    grid-template-columns: 485px;
    row-gap: 36px;
  }
}
@media screen and (max-width: 767px) {
  .sec-otc-trading-desk .desk-grid {
    grid-template-columns: 100%;
    row-gap: 36px;
  }
}
.sec-otc-trading-desk .desk-grid .desk-card {
  padding: 32px;
  border-radius: 16px;
  border: 1px solid #C5D4E4;
}
@media screen and (max-width: 767px) {
  .sec-otc-trading-desk .desk-grid .desk-card {
    padding: 0;
    border: none;
  }
}
.sec-otc-trading-desk .desk-grid .desk-card .content-wrapper {
  margin-bottom: 24px;
}
@media screen and (max-width: 767px) {
  .sec-otc-trading-desk .desk-grid .desk-card .content-wrapper {
    margin-bottom: 16px;
  }
}
.sec-otc-trading-desk .desk-grid .desk-card .content-wrapper h3 {
  margin-bottom: 8px;
}
@media screen and (max-width: 767px) {
  .sec-otc-trading-desk .desk-grid .desk-card .content-wrapper h3 {
    font-size: 24px;
    line-height: 32px;
  }
}
.sec-otc-trading-desk .desk-grid .desk-card .content-wrapper p {
  color: rgba(47, 47, 47, 0.7);
  min-height: 99px;
}
@media screen and (max-width: 767px) {
  .sec-otc-trading-desk .desk-grid .desk-card .content-wrapper p {
    min-height: auto;
    font-size: 14px;
    line-height: 22px;
  }
}
.sec-otc-trading-desk .desk-grid .desk-card .img-wrapper img {
  width: 100%;
}

.sec-crypto-legal {
  padding: 100px 0;
  position: relative;
  border-top: 1px solid #D3E7F1;
}
.sec-crypto-legal:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-crypto-legal:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-legal:before {
    width: 16px;
  }
}
.sec-crypto-legal:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-crypto-legal:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-legal:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-legal {
    padding: 32px 0 40px;
  }
}
.sec-crypto-legal:before, .sec-crypto-legal:after {
  height: calc(100% + 1px);
}
@media screen and (max-width: 767px) {
  .sec-crypto-legal:before, .sec-crypto-legal:after {
    height: 100%;
  }
}
.sec-crypto-legal .legal-card h2 {
  margin-bottom: 16px;
}
@media screen and (max-width: 767px) {
  .sec-crypto-legal .legal-card h2 {
    margin-bottom: 24px;
  }
}
.sec-crypto-legal .legal-card ul.legal-list li {
  font-size: 14px;
  line-height: 22px;
  color: rgba(47, 47, 47, 0.9);
  display: block;
  vertical-align: middle;
  position: relative;
  padding-left: 14px;
}
.sec-crypto-legal .legal-card ul.legal-list li:not(:last-of-type) {
  margin: 0 0 4px;
}
.sec-crypto-legal .legal-card ul.legal-list li:before {
  content: "";
  background: rgba(47, 47, 47, 0.9);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 9px;
}
@media screen and (max-width: 767px) {
  .sec-crypto-legal .legal-card ul.legal-list li br {
    display: none;
  }
}

.sec-crypto-global {
  padding: 100px 0 42px;
  position: relative;
  background: #F9FCFF;
}
.sec-crypto-global:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-crypto-global:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-global:before {
    width: 16px;
  }
}
.sec-crypto-global:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-crypto-global:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-global:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-global {
    padding: 41px 0;
  }
}
.sec-crypto-global:before, .sec-crypto-global:after {
  height: calc(100% + 1px);
}
@media screen and (max-width: 767px) {
  .sec-crypto-global:before, .sec-crypto-global:after {
    height: 100%;
  }
}
.sec-crypto-global .sec-heading {
  max-width: 1042px;
  text-align: center;
  margin: 0 auto 27px;
}
@media screen and (max-width: 767px) {
  .sec-crypto-global .sec-heading {
    margin: 0 auto 12px;
  }
}
.sec-crypto-global .sec-heading h2 {
  margin-bottom: 24px;
}
@media screen and (max-width: 767px) {
  .sec-crypto-global .sec-heading h2 {
    margin-bottom: 13px;
  }
}
.sec-crypto-global .sec-heading h3 {
  margin: 0;
  font-size: 33px;
  line-height: 50px;
  font-weight: 500;
  color: #000000;
  font-family: "Gabarito";
  text-transform: capitalize;
  border-radius: 7px;
  padding: 4px 12px;
  background: #D9EAFF;
  display: inline-block;
}
@media screen and (max-width: 767px) {
  .sec-crypto-global .sec-heading h3 {
    font-size: 20px;
    line-height: 28px;
  }
}
.sec-crypto-global .map-img {
  max-width: 1078px;
  margin: 0 auto;
}
.sec-crypto-global .map-img img {
  width: 100%;
}

.sec-hubrid-setup {
  padding: 145px 0;
  position: relative;
  border-top: 1px solid #D3E7F1;
  border-bottom: 1px solid #D3E7F1;
}
.sec-hubrid-setup:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-hubrid-setup:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-hubrid-setup:before {
    background: transparent;
    width: 16px;
  }
}
.sec-hubrid-setup:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-hubrid-setup:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-hubrid-setup:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-hubrid-setup {
    padding: 90px 0;
  }
}
@media screen and (max-width: 767px) {
  .sec-hubrid-setup {
    padding: 41px 0;
  }
}
.sec-hubrid-setup .content-wrapper h2 {
  text-transform: capitalize;
}
.sec-hubrid-setup .content-wrapper h2 b {
  font-weight: 400;
  color: #92A9B3;
}

.sec-digital-asset {
  padding: 96px 0;
  border-bottom: 1px solid #D3E7F1;
  position: relative;
}
.sec-digital-asset:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-digital-asset:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-digital-asset:before {
    width: 16px;
  }
}
.sec-digital-asset:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-digital-asset:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-digital-asset:after {
    width: 16px;
  }
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-digital-asset {
    padding: 70px 0;
  }
}
@media screen and (max-width: 767px) {
  .sec-digital-asset {
    padding: 40px 0 30px;
    border-bottom: unset;
  }
}
.sec-digital-asset:before, .sec-digital-asset:after {
  height: calc(100% + 1px);
}
@media screen and (max-width: 767px) {
  .sec-digital-asset:before, .sec-digital-asset:after {
    height: 100%;
  }
}
.sec-digital-asset .content-wrapper h2 {
  text-transform: capitalize;
  margin-bottom: 16px;
}
@media screen and (max-width: 767px) {
  .sec-digital-asset .content-wrapper h2 {
    margin-bottom: 8px;
  }
}
.sec-digital-asset .content-wrapper h3 {
  color: rgba(47, 47, 47, 0.9);
  margin: 0;
}
@media screen and (max-width: 767px) {
  .sec-digital-asset .content-wrapper h3 {
    font-size: 14px;
    line-height: 22px;
  }
}

.sec-mobile-wallet {
  padding: 47px 0 0;
  border-bottom: 1px solid #D3E7F1;
  position: relative;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet {
    padding: 30px 0 8px;
    border-bottom: unset;
  }
}
.sec-mobile-wallet:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-mobile-wallet:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet:before {
    width: 16px;
  }
}
.sec-mobile-wallet:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-mobile-wallet:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet:after {
    width: 16px;
  }
}
.sec-mobile-wallet:before, .sec-mobile-wallet:after {
  height: calc(100% + 1px);
}
.sec-mobile-wallet .wallet-card:not(:last-of-type) {
  margin-bottom: 47px;
}
.sec-mobile-wallet .wallet-card:nth-of-type(even) .col-md-6:nth-of-type(1) {
  order: 2;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card:nth-of-type(even) .col-md-6:nth-of-type(1) {
    order: 1;
  }
}
.sec-mobile-wallet .wallet-card:nth-of-type(even) .col-md-6:nth-of-type(2) {
  order: 1;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card:nth-of-type(even) .col-md-6:nth-of-type(2) {
    order: 2;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper {
  padding: 0 40px;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper {
    padding: 0 20px;
    margin-bottom: 31px;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper h3 {
  font-family: "Gabarito";
  text-transform: capitalize;
  margin: 0 0 16px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-mobile-wallet .wallet-card .content-wrapper h3 {
    font-size: 25px;
    line-height: 33px;
  }
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper h3 {
    font-weight: 400;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 18px;
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.9);
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li {
    font-size: 16px;
    line-height: 24px;
  }
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li {
    padding-left: 14px;
    font-size: 14px;
    line-height: 22px;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li:not(:last-of-type) {
  margin: 0 0 12px;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li:not(:last-of-type) {
    margin: 0 0 6px;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li:before {
  content: "";
  background: rgba(47, 47, 47, 0.9);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 10px;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li:before {
    width: 4px;
    height: 4px;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li a img {
  max-width: 16px;
}
.sec-mobile-wallet .wallet-card .img-wrapper img {
  width: 100%;
}

.sec-trading-desk {
  position: relative;
  border-bottom: 1px solid #D3E7F1;
}
.sec-trading-desk:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-trading-desk:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk:before {
    width: 16px;
  }
}
.sec-trading-desk:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-trading-desk:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk {
    border-bottom: unset;
    padding-bottom: 32px;
  }
}
.sec-trading-desk:before, .sec-trading-desk:after {
  height: calc(100% + 1px);
}
.sec-trading-desk .trading-grid {
  display: grid;
  grid-template-columns: repeat(2, 50%);
  align-items: self-start;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid {
    grid-template-columns: 1fr;
  }
}
.sec-trading-desk .trading-grid .trading-card {
  padding: 64px 40px;
  min-height: 313px;
  display: grid;
  column-gap: 16px;
  grid-template-columns: 1fr 134px;
  align-items: self-start;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card {
    grid-template-columns: 1fr;
    padding: 32px 20px;
    min-height: auto;
  }
}
.sec-trading-desk .trading-grid .trading-card:first-of-type {
  border-right: 1px solid #D3E7F1;
}
.sec-trading-desk .trading-grid .trading-card .content h3 {
  font-family: "Gabarito";
  text-transform: capitalize;
  margin: 0 0 16px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-trading-desk .trading-grid .trading-card .content h3 {
    font-size: 20px;
    line-height: 28px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .content h3 {
    font-size: 24px;
    line-height: 32px;
    display: grid;
    column-gap: 16px;
    grid-template-columns: 1fr 68px;
    align-items: center;
  }
}
.sec-trading-desk .trading-grid .trading-card .content h3 img {
  display: none;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .content h3 img {
    display: block;
    width: 100%;
    border-radius: 8px;
  }
}
.sec-trading-desk .trading-grid .trading-card .content ul.feature-list li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 18px;
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.9);
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-trading-desk .trading-grid .trading-card .content ul.feature-list li {
    font-size: 16px;
    line-height: 24px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .content ul.feature-list li {
    padding-left: 14px;
    font-size: 14px;
    line-height: 22px;
  }
}
.sec-trading-desk .trading-grid .trading-card .content ul.feature-list li:not(:last-of-type) {
  margin: 0 0 3px;
}
.sec-trading-desk .trading-grid .trading-card .content ul.feature-list li:before {
  content: "";
  background: rgba(47, 47, 47, 0.9);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 10px;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .content ul.feature-list li:before {
    width: 4px;
    height: 4px;
  }
}
.sec-trading-desk .trading-grid .trading-card .content ul.feature-list li a img {
  max-width: 16px;
}
.sec-trading-desk .trading-grid .trading-card .icon {
  align-self: end;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .icon {
    display: none;
  }
}
.sec-trading-desk .trading-grid .trading-card .icon img {
  width: 100%;
  border-radius: 16px;
}

.sec-security {
  position: relative;
  border-bottom: 1px solid #E5E5E5;
}
.sec-security:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-security:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-security:before {
    width: 16px;
  }
}
.sec-security:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-security:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-security:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-security {
    padding: 32px 0 25px;
  }
}
.sec-security .security-grid {
  display: grid;
  grid-template-columns: 1fr 466px;
  column-gap: 6px;
  align-items: center;
}
@media screen and (max-width: 767px) {
  .sec-security .security-grid {
    grid-template-columns: 1fr;
  }
}
.sec-security .security-grid .content {
  padding-left: 40px;
}
@media screen and (max-width: 767px) {
  .sec-security .security-grid .content {
    padding: 0 20px 24px;
  }
}
.sec-security .security-grid .content h3 {
  color: #000000;
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .sec-security .security-grid .content h3 {
    font-size: 14px;
    line-height: 22px;
    color: rgba(47, 47, 47, 0.9);
  }
}
.sec-security .security-grid .img-wrapper img {
  width: 100%;
  height: 315px;
  object-fit: cover;
}
@media screen and (max-width: 767px) {
  .sec-security .security-grid .img-wrapper img {
    height: 148px;
  }
}

.sec-compliance {
  position: relative;
  border-bottom: 1px solid #D3E7F1;
}
.sec-compliance:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-compliance:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance:before {
    background: transparent;
    width: 16px;
  }
}
.sec-compliance:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-compliance:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance:after {
    background: transparent;
    width: 16px;
  }
}
.sec-compliance .compliance-wrapper {
  padding: 85px 0 238px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
  background-position: bottom;
  background-size: cover;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper {
    padding: 40px 0 148px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat;
    background-position: bottom;
    background-size: contain;
  }
}
.sec-compliance .compliance-wrapper .bg-img {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateY(-50%);
}
.sec-compliance .compliance-wrapper > h2 {
  text-transform: capitalize;
  margin-bottom: 24px;
  text-align: center;
}
.sec-compliance .compliance-wrapper > h3 {
  margin-bottom: 48px;
  text-align: center;
}
.sec-compliance .compliance-wrapper ul.feature-list {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: 32px;
  row-gap: 25px;
  max-width: 1017px;
  margin: auto;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list {
    column-gap: 0;
    row-gap: 0;
    margin: auto 4px;
  }
}
.sec-compliance .compliance-wrapper ul.feature-list:has(li) li:nth-of-type(1), .sec-compliance .compliance-wrapper ul.feature-list:has(li) li:nth-of-type(2), .sec-compliance .compliance-wrapper ul.feature-list:has(li) li:nth-of-type(3) {
  grid-column: span 4;
}
.sec-compliance .compliance-wrapper ul.feature-list li {
  grid-column: span 3;
}
.sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(1) .feature-card {
  border-right: 1px solid #C4E3F2 !important;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(1), .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(2) {
    grid-column: span 6 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(1) .feature-card, .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(2) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(3) {
    grid-column: span 7 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(3) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
    border-right: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(4) {
    grid-column: span 5 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(4) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(5) {
    grid-column: span 5 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(5) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
    border-right: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(6) {
    grid-column: span 7 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(6) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(7) {
    grid-column: span 12 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(7) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
    border-bottom: 1px solid #C4E3F2 !important;
  }
}
.sec-compliance .compliance-wrapper ul.feature-list li .feature-card {
  padding: 32px 20px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #C4E3F2;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li .feature-card {
    height: 100%;
    border-radius: 0;
    padding: 22px 16px;
  }
}
.sec-compliance .compliance-wrapper ul.feature-list li .feature-card h3 {
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
  color: #000000;
  font-family: "Gabarito";
  margin: 0;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li .feature-card h3 {
    font-size: 14px;
    line-height: 20px;
  }
}

.sec-crypto-faqs {
  padding: 108px 0;
  position: relative;
  border-bottom: 1px solid #D3E7F1;
}
.sec-crypto-faqs:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-crypto-faqs:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-faqs:before {
    background: transparent;
    width: 16px;
  }
}
.sec-crypto-faqs:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-crypto-faqs:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-faqs:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-faqs {
    padding: 56px 0 40px;
  }
}
.sec-crypto-faqs .container > h2 {
  text-align: center;
  margin-bottom: 36px;
}
.sec-crypto-faqs .faq-wrapper {
  max-width: 950px;
  margin: auto;
}
.sec-crypto-faqs .faq-wrapper .accordion {
  margin: auto;
}
.sec-crypto-faqs .faq-wrapper .accordion .accordion-item {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #D3E7F1;
}
.sec-crypto-faqs .faq-wrapper .accordion .accordion-item:not(:last-of-type) {
  margin-bottom: 24px;
}
@media screen and (max-width: 767px) {
  .sec-crypto-faqs .faq-wrapper .accordion .accordion-item:not(:last-of-type) {
    margin-bottom: 12px;
  }
}
.sec-crypto-faqs .faq-wrapper .accordion .accordion-item button {
  border: unset;
  padding: 30px 27px;
  background: transparent;
  box-shadow: unset !important;
  border-radius: 14px !important;
  font-size: 22px;
  line-height: 32px;
  font-weight: 600;
  color: rgba(47, 47, 47, 0.9);
  font-family: "Manrope";
}
@media screen and (max-width: 767px) {
  .sec-crypto-faqs .faq-wrapper .accordion .accordion-item button {
    padding: 16px;
    font-size: 14px;
    line-height: 22px;
  }
}
@media screen and (max-width: 767px) {
  .sec-crypto-faqs .faq-wrapper .accordion .accordion-item button:after {
    width: 16px;
    height: 16px;
    background-size: 16px;
  }
}
.sec-crypto-faqs .faq-wrapper .accordion .accordion-body {
  border: unset;
  background: #ffffff;
  border-radius: 14px;
  padding: 0 24px 24px;
}
@media screen and (max-width: 767px) {
  .sec-crypto-faqs .faq-wrapper .accordion .accordion-body {
    padding: 16px;
  }
}
.sec-crypto-faqs .faq-wrapper .accordion .accordion-body p {
  margin-bottom: 0;
  font-size: 16px;
  line-height: 24px;
  font-family: "Manrope";
}

.sec-partnerships {
  position: relative;
}
.sec-partnerships:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships:before {
    width: 16px;
  }
}
.sec-partnerships:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships:after {
    width: 16px;
  }
}
.sec-partnerships .partnerships-wrapper {
  padding: 80px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships .partnerships-wrapper {
    padding: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper {
    padding: 48px 0;
  }
}
.sec-partnerships .partnerships-wrapper:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: repeat;
  background-size: cover;
  height: 80px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-bottom: 1px solid #D3E7F1;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper:before {
    height: 48px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  }
}
.sec-partnerships .partnerships-wrapper:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: repeat;
  background-size: cover;
  height: 80px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  border-top: 1px solid #D3E7F1;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper:after {
    height: 48px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid {
  display: grid;
  grid-template-columns: 298px 298px 1fr;
  align-items: self-start;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid {
    grid-template-columns: 1fr;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card {
  padding: 40px;
  min-height: 327px;
  display: flex;
  align-items: center;
  justify-content: left;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card {
    padding: 32px;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card {
    padding: 32px 16px;
    min-height: auto;
    text-align: center;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:not(:last-of-type) {
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:not(:last-of-type) {
    border: unset;
    border-bottom: 1px solid #D3E7F1;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:nth-child(1) {
    order: 3;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:nth-child(2) {
    order: 2;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:nth-child(3) {
    order: 1;
  }
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper h2 {
    font-size: 32px;
    line-height: 38px;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper h3 {
  color: #000000;
  font-family: "Gabarito";
  margin-bottom: 16px;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper h3 {
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 26px;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper p {
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.9);
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper p {
    font-size: 14px;
    line-height: 22px;
    color: #000000;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper p.black {
  color: #000000;
}

.sec-join {
  padding: 128px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center;
  background-size: cover;
  position: relative;
}
.sec-join:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-join:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-join:before {
    background: transparent;
    width: 16px;
  }
}
.sec-join:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-join:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-join:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-join {
    padding: 72px 0 80px;
  }
}
.sec-join:before, .sec-join:after {
  border-color: #424A53;
}
.sec-join .content-wrapper {
  text-align: center;
}
.sec-join .content-wrapper h2 {
  color: #ffffff;
  margin-bottom: 0;
}
.sec-join .content-wrapper p {
  font-weight: 500;
  color: #ffffff;
}
@media screen and (max-width: 767px) {
  .sec-join .content-wrapper p {
    font-size: 14px;
    line-height: 22px;
    margin: 16px 0 24px;
  }
  .sec-join .content-wrapper p br {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .sec-join .content-wrapper .btn-style {
    min-width: 296px;
    font-weight: 700;
  }
}

.sec-join-partner {
  padding: 147px 0 144px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center;
  background-size: cover;
  position: relative;
}
.sec-join-partner:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-join-partner:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-join-partner:before {
    background: transparent;
    width: 16px;
  }
}
.sec-join-partner:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-join-partner:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-join-partner:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-join-partner {
    padding: 72px 0 80px;
  }
}
.sec-join-partner:before, .sec-join-partner:after {
  border-color: #424A53;
}
.sec-join-partner .content-wrapper {
  text-align: center;
  max-width: 809px;
  margin: 0 auto;
}
.sec-join-partner .content-wrapper h2 {
  color: #ffffff;
  font-weight: 400;
  margin-bottom: 0;
}
.sec-join-partner .content-wrapper p {
  font-weight: 500;
  color: #ffffff;
  margin: 24px 0;
}
@media screen and (max-width: 767px) {
  .sec-join-partner .content-wrapper p {
    font-size: 14px;
    line-height: 22px;
    margin: 16px 0;
  }
  .sec-join-partner .content-wrapper p br {
    display: none;
  }
}
.sec-join-partner .content-wrapper ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
@media screen and (max-width: 767px) {
  .sec-join-partner .content-wrapper ul.btn-list li {
    display: block;
  }
}
.sec-join-partner .content-wrapper ul.btn-list li:not(:last-of-type) {
  margin: 0 24px 0 0;
}
@media screen and (max-width: 767px) {
  .sec-join-partner .content-wrapper ul.btn-list li:not(:last-of-type) {
    margin: 0 0 8px;
  }
}
.sec-join-partner .content-wrapper ul.btn-list li .btn-style {
  font-weight: 700;
  min-width: 305px;
}

.sec-meeting {
  position: relative;
  border-bottom: 1px solid #D3E7F1;
}
.sec-meeting:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-meeting:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-meeting:before {
    width: 16px;
  }
}
.sec-meeting:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-meeting:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-meeting:after {
    width: 16px;
  }
}
.sec-meeting:before, .sec-meeting:after {
  border-color: #E5E5E5;
  z-index: 2;
}
@media screen and (max-width: 767px) {
  .sec-meeting:before, .sec-meeting:after {
    border-color: #D3E7F1;
  }
}
.sec-meeting .container-fluid {
  padding: 0;
}
.sec-meeting .partnerships-wrapper {
  padding: 80px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-meeting .partnerships-wrapper {
    padding: 80px 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper {
    padding: 48px 0;
  }
}
.sec-meeting .partnerships-wrapper:before {
  content: "";
  background: transparent;
  height: 80px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-bottom: 1px solid #E5E5E5;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper:before {
    height: 48px;
    border-color: #D3E7F1;
  }
}
.sec-meeting .partnerships-wrapper:after {
  content: "";
  background: transparent;
  height: 80px;
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  border-top: 1px solid #E5E5E5;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper:after {
    height: 48px;
    border-color: #D3E7F1;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid {
  display: grid;
  grid-template-columns: 1fr 237px 237px;
  align-items: self-start;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid {
    grid-template-columns: 1fr;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card {
  padding: 40px;
  min-height: 266px;
  display: flex;
  align-items: center;
  justify-content: left;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card {
    padding: 24px;
    min-height: auto;
    text-align: center;
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card:first-of-type {
    padding: 32px 28px;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card:not(:first-of-type) {
  background: #F3F9FF;
  border: 1px solid #D3E7F1;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card:not(:first-of-type) {
    border: unset;
    border-top: 1px solid #D3E7F1;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card:not(:last-of-type) {
  border-right: unset;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper h2 {
    font-size: 32px;
    line-height: 38px;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper h3 {
  color: #000000;
  font-family: "Gabarito";
  margin-bottom: 16px;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper h3 {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 8px;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper a.f-24 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
  color: #000000;
  font-family: "Gabarito";
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper a.f-24 {
    font-size: 18px;
    line-height: 26px;
  }
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper a.f-24 br {
    display: none;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p {
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p {
    font-size: 14px;
    line-height: 22px;
  }
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p br {
    display: none;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p:not(:last-of-type) {
  margin-bottom: 16px;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p:not(:last-of-type) {
    margin-bottom: 8px;
  }
}

.landing-footer {
  position: relative;
  min-height: 332px;
  padding-bottom: 27px;
  display: flex;
  align-items: self-end;
  background: #010102;
}
.landing-footer:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .landing-footer:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .landing-footer:before {
    background: transparent;
    width: 16px;
  }
}
.landing-footer:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .landing-footer:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .landing-footer:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .landing-footer {
    padding-bottom: 16px;
    min-height: 160px;
  }
}
.landing-footer:before, .landing-footer:after {
  border-color: #424A53;
  z-index: 2;
}
.landing-footer .bg-img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: contain;
  object-position: top;
}
.landing-footer .content-wrapper {
  text-align: center;
  position: relative;
  z-index: 1;
}
.landing-footer .content-wrapper p {
  font-weight: 300;
  color: rgba(255, 255, 255, 0.4);
  margin: 0;
}
@media screen and (max-width: 767px) {
  .landing-footer .content-wrapper p {
    font-size: 10px;
    line-height: 16px;
  }
}

.crypto-landing-footer {
  position: relative;
  min-height: 451px;
  padding-bottom: 27px;
  display: flex;
  align-items: self-end;
  background: #010102;
}
.crypto-landing-footer:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .crypto-landing-footer:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .crypto-landing-footer:before {
    background: transparent;
    width: 16px;
  }
}
.crypto-landing-footer:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .crypto-landing-footer:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .crypto-landing-footer:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .crypto-landing-footer {
    padding-bottom: 16px;
    min-height: 238px;
  }
}
.crypto-landing-footer:before, .crypto-landing-footer:after {
  border-color: #424A53;
  z-index: 2;
}
.crypto-landing-footer .bg-img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: contain;
  object-position: top;
}
.crypto-landing-footer .content-wrapper {
  text-align: center;
  position: relative;
  z-index: 1;
}
.crypto-landing-footer .content-wrapper ul.link-list:not(:last-of-type) {
  margin-bottom: 16px;
}
.crypto-landing-footer .content-wrapper ul.link-list li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
.crypto-landing-footer .content-wrapper ul.link-list li:not(:last-of-type) {
  margin: 0 18px 0 0;
}
.crypto-landing-footer .content-wrapper ul.link-list li:not(:last-of-type):before {
  content: "";
  background: #F7F7F7;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  position: absolute;
  right: -11px;
  top: 9px;
}
.crypto-landing-footer .content-wrapper ul.link-list li a {
  font-weight: 300;
  color: #F7F7F7;
  margin: 0;
}
@media screen and (max-width: 767px) {
  .crypto-landing-footer .content-wrapper ul.link-list li a {
    font-size: 12px;
    line-height: 16px;
  }
}

.landing-bottom-footer {
  position: relative;
  padding: 18px 0;
  background: #010102;
  border-top: 1px solid #494949;
}
.landing-bottom-footer:before {
  content: "";
  background: #010102;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .landing-bottom-footer:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .landing-bottom-footer:before {
    width: 16px;
  }
}
.landing-bottom-footer:after {
  content: "";
  background: #010102;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .landing-bottom-footer:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .landing-bottom-footer:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .landing-bottom-footer {
    padding: 16px 0;
  }
}
.landing-bottom-footer:before, .landing-bottom-footer:after {
  border-color: #494949;
  z-index: 2;
}
.landing-bottom-footer .content-wrapper {
  text-align: center;
  position: relative;
  z-index: 1;
}
.landing-bottom-footer .content-wrapper p {
  font-weight: 300;
  color: #F7F7F7;
  margin: 0;
}
@media screen and (max-width: 767px) {
  .landing-bottom-footer .content-wrapper p {
    font-size: 10px;
    line-height: 16px;
  }
}

.crypto-landing-bottom-footer {
  position: relative;
  padding: 18px 0;
  background: #010102;
  border-top: 1px solid #494949;
}
.crypto-landing-bottom-footer:before {
  content: "";
  background: #010102;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .crypto-landing-bottom-footer:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .crypto-landing-bottom-footer:before {
    width: 16px;
  }
}
.crypto-landing-bottom-footer:after {
  content: "";
  background: #010102;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .crypto-landing-bottom-footer:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .crypto-landing-bottom-footer:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .crypto-landing-bottom-footer {
    padding: 16px 0;
  }
}
.crypto-landing-bottom-footer:before, .crypto-landing-bottom-footer:after {
  border-color: #494949;
  z-index: 2;
}
.crypto-landing-bottom-footer .content-wrapper {
  text-align: center;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.crypto-landing-bottom-footer .content-wrapper p {
  font-weight: 300;
  color: #F7F7F7;
  margin: 0;
}
@media screen and (max-width: 767px) {
  .crypto-landing-bottom-footer .content-wrapper p {
    font-size: 10px;
    line-height: 16px;
  }
}
.crypto-landing-bottom-footer .content-wrapper ul.social-list li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
.crypto-landing-bottom-footer .content-wrapper ul.social-list li:not(:last-of-type) {
  margin: 0 10px 0 0;
}
.crypto-landing-bottom-footer .content-wrapper ul.social-list li a img {
  max-width: 20px;
}

body.xdc-landing-page-body {
  background: #ffffff;
  padding: 0;
}

.xdc-landing-main {
  position: relative;
}
.xdc-landing-main .xdc-border-grid {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: auto;
  z-index: 1;
  padding: 0 13px;
}
@media screen and (max-width: 767px) {
  .xdc-landing-main .xdc-border-grid {
    padding: 0 30px;
    display: none;
  }
}
.xdc-landing-main .xdc-border-grid .xdc-bg-border {
  width: 1px;
  height: 100%;
  background: #DAD6F5;
}
@media screen and (max-width: 767px) {
  .xdc-landing-main .xdc-border-grid .xdc-bg-border:nth-of-type(1), .xdc-landing-main .xdc-border-grid .xdc-bg-border:nth-of-type(2), .xdc-landing-main .xdc-border-grid .xdc-bg-border:nth-of-type(3), .xdc-landing-main .xdc-border-grid .xdc-bg-border:nth-of-type(4) {
    display: none;
  }
}
.xdc-landing-main section .container {
  position: relative;
  z-index: 2;
}

.xdc-heading {
  text-align: center;
  margin-bottom: 60px;
}
@media screen and (max-width: 767px) {
  .xdc-heading {
    margin-bottom: 40px;
  }
}
.xdc-heading strong {
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
  font-family: "Inter";
  color: #5235E8;
  text-transform: uppercase;
}
.xdc-heading h2 {
  font-size: 44px;
  line-height: 52px;
  font-weight: 600;
  font-family: "Inter";
  color: #0D0637;
  margin: 25px 0;
}
@media screen and (max-width: 1366px) and (min-width: 1200px) {
  .xdc-heading h2 {
    font-size: 38px;
    line-height: 48px;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .xdc-heading h2 {
    font-size: 34px;
    line-height: 42px;
    margin: 16px 0;
  }
}
@media screen and (max-width: 767px) {
  .xdc-heading h2 {
    font-size: 30px;
    line-height: 40px;
    margin: 12px 0;
  }
}
.xdc-heading p {
  font-size: 17px;
  line-height: 25px;
  font-weight: 400;
  font-family: "Inter";
  color: #717184;
  margin-bottom: 0;
}
.xdc-header {
  position: absolute;
  top: 32px;
  left: 0;
  width: 100%;
  z-index: 2;
}
@media screen and (max-width: 767px) {
  .xdc-header {
    top: 16px;
  }
}
@media screen and (max-width: 767px) {
  .xdc-header.menu-open .header-wrapper {
    border-radius: 8px 8px 0 0;
  }
}
.xdc-header .header-wrapper {
  padding: 0;
  max-width: 1200px;
  margin: auto;
  display: grid;
  grid-template-columns: 200px 1fr;
  justify-content: space-between;
  align-items: center;
  column-gap: 30px;
}
@media screen and (max-width: 1300px) and (min-width: 1200px) {
  .xdc-header .header-wrapper {
    max-width: 1140px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 992px) {
  .xdc-header .header-wrapper {
    padding: 0 24px;
    grid-template-columns: 120px 1fr;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .xdc-header .header-wrapper {
    max-width: 600px;
    padding: 14px 22px 11px;
    grid-template-columns: 120px 1fr;
    border-radius: 8px;
    box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;
  }
}
@media screen and (max-width: 767px) {
  .xdc-header .header-wrapper {
    max-width: 328px;
    padding: 14px 22px 11px;
    grid-template-columns: 90px 1fr;
    border-radius: 8px;
    box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;
  }
}
.xdc-header .header-wrapper .logo-wrapper a.logo {
  display: inline-block;
}
.xdc-header .header-wrapper .logo-wrapper a.logo img {
  width: 100%;
  max-width: 200px;
}
.xdc-header .header-wrapper .navbar-menu .menu-bar {
  display: none;
}
@media screen and (max-width: 991px) {
  .xdc-header .header-wrapper .navbar-menu .menu-bar {
    display: flex;
    align-items: center;
    justify-content: right;
  }
}
.xdc-header .header-wrapper .navbar-menu .menu-bar img {
  max-width: 20px;
  filter: brightness(0) saturate(100%) invert(0%) sepia(2%) saturate(7500%) hue-rotate(212deg) brightness(105%) contrast(95%);
}
.xdc-header .header-wrapper .navbar-menu ul.menu {
  text-align: right;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .xdc-header .header-wrapper .navbar-menu ul.menu {
    top: 89px !important;
    max-width: 600px !important;
  }
}
@media screen and (max-width: 991px) {
  .xdc-header .header-wrapper .navbar-menu ul.menu {
    position: fixed;
    top: 66px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 328px;
    height: auto;
    box-shadow: rgba(0, 0, 0, 0.16) 0 1px 4px;
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    display: none;
  }
  .xdc-header .header-wrapper .navbar-menu ul.menu.active {
    display: block;
  }
}
.xdc-header .header-wrapper .navbar-menu ul.menu li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
@media screen and (max-width: 991px) {
  .xdc-header .header-wrapper .navbar-menu ul.menu li {
    display: block;
  }
}
.xdc-header .header-wrapper .navbar-menu ul.menu li:not(:last-of-type) {
  margin: 0 35px 0 0;
}
@media screen and (max-width: 1199px) and (min-width: 992px) {
  .xdc-header .header-wrapper .navbar-menu ul.menu li:not(:last-of-type) {
    margin: 0 25px 0 0;
  }
}
@media screen and (max-width: 991px) {
  .xdc-header .header-wrapper .navbar-menu ul.menu li:not(:last-of-type) {
    margin: 0;
    border-bottom: 1px solid #D3E7F1;
  }
}
.xdc-header .header-wrapper .navbar-menu ul.menu li.arrow {
  margin: 0 45px 0 0;
}
@media screen and (max-width: 991px) {
  .xdc-header .header-wrapper .navbar-menu ul.menu li.arrow {
    margin: 0;
  }
}
.xdc-header .header-wrapper .navbar-menu ul.menu li.arrow:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: cover;
  width: 6px;
  height: 9px;
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
}
@media screen and (max-width: 991px) {
  .xdc-header .header-wrapper .navbar-menu ul.menu li.arrow:before {
    width: 12px;
    right: 24px;
    filter: brightness(0) saturate(100%) invert(0%) sepia(97%) saturate(0%) hue-rotate(43deg) brightness(95%) contrast(102%);
  }
}
.xdc-header .header-wrapper .navbar-menu ul.menu li a {
  font-size: 15px;
  line-height: 23px;
  font-weight: 400;
  font-family: "Inter";
  display: inline-block;
}
@media screen and (max-width: 991px) {
  .xdc-header .header-wrapper .navbar-menu ul.menu li a {
    display: block;
    font-weight: 500;
    text-align: left;
    color: #000000;
    padding: 20px 33px 20px 28px;
  }
}

.sec-xdc-banner {
  padding: 175px 0 157px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat;
  background-position: bottom;
  background-size: cover;
}
@media screen and (max-width: 1199px) and (min-width: 992px) {
  .sec-xdc-banner {
    padding: 175px 0 80px;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-xdc-banner {
    padding: 160px 0 70px;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-banner {
    padding: 120px 0 40px;
  }
}
@media screen and (max-width: 991px) {
  .sec-xdc-banner .content-wrapper {
    text-align: center;
  }
}
.sec-xdc-banner .content-wrapper h1 {
  font-size: 75px;
  line-height: 83px;
  font-weight: 600;
  margin-bottom: 0;
}
@media screen and (max-width: 1366px) and (min-width: 1200px) {
  .sec-xdc-banner .content-wrapper h1 {
    font-size: 65px;
    line-height: 73px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 992px) {
  .sec-xdc-banner .content-wrapper h1 {
    font-size: 55px;
    line-height: 62px;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-xdc-banner .content-wrapper h1 {
    font-size: 45px;
    line-height: 52px;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-banner .content-wrapper h1 {
    font-size: 35px;
    line-height: 42px;
  }
}
.sec-xdc-banner .content-wrapper h3 {
  color: #717184;
  margin: 43px 0 55px;
}
@media screen and (max-width: 991px) {
  .sec-xdc-banner .content-wrapper h3 {
    margin: 20px 0 30px;
  }
}
.sec-xdc-banner .content-wrapper ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-xdc-banner .content-wrapper ul.btn-list li:not(:last-of-type) {
  margin: 0 17px 0 0;
}
.sec-xdc-banner .img-wrapper {
  text-align: right;
}
@media screen and (max-width: 991px) {
  .sec-xdc-banner .img-wrapper {
    display: none;
  }
}

.xdc-statistics {
  padding: 78px 0 61px;
}
@media screen and (max-width: 767px) {
  .xdc-statistics {
    padding: 40px 0 10px;
  }
}
.xdc-statistics .statistics-card {
  text-align: center;
}
@media screen and (max-width: 767px) {
  .xdc-statistics .statistics-card {
    margin-bottom: 40px;
  }
}
.xdc-statistics .statistics-card strong {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 46px;
  line-height: 46px;
  font-weight: 700;
}
@media screen and (max-width: 767px) {
  .xdc-statistics .statistics-card strong {
    font-size: 40px;
    line-height: 40px;
  }
}
.xdc-statistics .statistics-card p {
  margin: 26px 0 0;
}
@media screen and (max-width: 767px) {
  .xdc-statistics .statistics-card p {
    margin: 16px 0 0;
  }
}

.sec-xdc-features {
  padding: 61px 0 82px;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-xdc-features {
    padding: 60px 0;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-features {
    padding: 40px 0;
  }
}
.sec-xdc-features .feature-grid {
  display: grid;
  grid-template-columns: repeat(4, calc(25% - 16px));
  column-gap: 21px;
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .sec-xdc-features .feature-grid {
    grid-template-columns: repeat(2, calc(50% - 16px));
    row-gap: 20px;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-features .feature-grid {
    grid-template-columns: 1fr;
    row-gap: 20px;
  }
}
.sec-xdc-features .feature-grid .feature-card {
  padding: 36px 28px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #DAD6F5;
}
.sec-xdc-features .feature-grid .feature-card .icon {
  margin-bottom: 29px;
}
.sec-xdc-features .feature-grid .feature-card .icon img {
  max-width: 40px;
}
.sec-xdc-features .feature-grid .feature-card .content h3 {
  margin-bottom: 20px;
}
@media screen and (max-width: 1366px) and (min-width: 1200px) {
  .sec-xdc-features .feature-grid .feature-card .content h3 {
    font-size: 18px;
    line-height: 26px;
  }
}
.sec-xdc-features .feature-grid .feature-card .content p {
  margin-bottom: 0;
  line-height: 24px;
}

.about-bg-main {
  background: #FFFFFF;
  background: linear-gradient(0deg, rgb(255, 255, 255) 0%, rgb(237, 235, 254) 71%);
}
@media screen and (max-width: 767px) {
  .about-bg-main {
    background: rgba(237, 235, 254, 0.4);
  }
}

.sec-xdc-about {
  padding: 81px 0 62px;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-xdc-about {
    padding: 60px 0;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-about {
    padding: 40px 0;
  }
}
.sec-xdc-about .about-grid {
  display: grid;
  grid-template-columns: 1fr 430px;
  align-items: center;
  column-gap: 0;
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .sec-xdc-about .about-grid {
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-about .about-grid {
    display: flex;
    flex-direction: column-reverse;
  }
}
.sec-xdc-about .about-grid .content-wrapper .xdc-heading {
  text-align: left;
  margin-bottom: 23px;
}
@media screen and (max-width: 767px) {
  .sec-xdc-about .about-grid .content-wrapper .xdc-heading h2 br {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-about .about-grid .content-wrapper p br {
    display: none;
  }
}
.sec-xdc-about .about-grid .content-wrapper .about-card-grid {
  display: grid;
  grid-template-columns: repeat(2, 275px);
  column-gap: 20px;
}
@media screen and (max-width: 767px) {
  .sec-xdc-about .about-grid .content-wrapper .about-card-grid {
    grid-template-columns: 1fr;
    row-gap: 20px;
  }
}
.sec-xdc-about .about-grid .content-wrapper .about-card-grid .about-card {
  padding: 24px 23px 20px;
  background: #ffffff;
  border-radius: 20px;
}
.sec-xdc-about .about-grid .content-wrapper .about-card-grid .about-card .icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: #5235E8;
  margin-bottom: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sec-xdc-about .about-grid .content-wrapper .about-card-grid .about-card .icon img {
  max-width: 40px;
}
.sec-xdc-about .about-grid .content-wrapper .about-card-grid .about-card .content h3 {
  margin-bottom: 6px;
}
.sec-xdc-about .about-grid .content-wrapper .about-card-grid .about-card .content p {
  margin-bottom: 0;
  line-height: 24px;
}
.sec-xdc-about .about-grid .img-wrapper {
  position: relative;
  left: -36px;
  top: 60px;
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .sec-xdc-about .about-grid .img-wrapper {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-about .about-grid .img-wrapper {
    left: 0;
    top: 0;
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-about .about-grid .img-wrapper img {
    width: 100%;
    max-width: 300px;
  }
}

.sec-choose-xdc {
  padding: 62px 0 83px;
  position: relative;
}
@media screen and (max-width: 767px) {
  .sec-choose-xdc {
    padding: 40px 0;
  }
}
.sec-choose-xdc .bg-circle {
  position: absolute;
  bottom: 90px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
@media screen and (max-width: 767px) {
  .sec-choose-xdc .bg-circle {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .sec-choose-xdc .xdc-heading h2 br {
    display: none;
  }
}
.sec-choose-xdc .choose-grid {
  display: grid;
  grid-template-columns: repeat(3, calc(33% - 10px));
  column-gap: 20px;
  position: relative;
  z-index: 2;
}
@media screen and (max-width: 991px) {
  .sec-choose-xdc .choose-grid {
    grid-template-columns: 1fr;
    row-gap: 20px;
  }
}
.sec-choose-xdc .choose-grid .choose-column .choose-card {
  padding: 34px;
  background: #ffffff;
  border-radius: 20px;
}
.sec-choose-xdc .choose-grid .choose-column .choose-card:not(:last-of-type) {
  margin-bottom: 23px;
}
.sec-choose-xdc .choose-grid .choose-column .choose-card .icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  background: #5235E8;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sec-choose-xdc .choose-grid .choose-column .choose-card .icon img {
  max-width: 40px;
}
.sec-choose-xdc .choose-grid .choose-column .choose-card .content h3 {
  margin-bottom: 15px;
}
.sec-choose-xdc .choose-grid .choose-column .choose-card .content p {
  margin-bottom: 0;
  line-height: 24px;
}
.sec-choose-xdc .choose-grid .choose-column .mobile-card {
  padding: 35px 33px 0;
  background: #5235E8;
  border-radius: 20px;
}
.sec-choose-xdc .choose-grid .choose-column .mobile-card .content {
  margin-bottom: 47px;
}
.sec-choose-xdc .choose-grid .choose-column .mobile-card .content h3 {
  color: #ffffff;
  margin-bottom: 20px;
}
.sec-choose-xdc .choose-grid .choose-column .mobile-card .content p {
  color: #ffffff;
  line-height: 24px;
  margin-bottom: 0;
}
.sec-choose-xdc .choose-grid .choose-column .mobile-card .mobile-img {
  text-align: center;
}
.sec-choose-xdc .choose-grid .choose-column .mobile-card .mobile-img img {
  width: 100%;
  max-width: 335px;
}
.sec-choose-xdc ul.btn-list {
  margin-top: 44px;
  text-align: center;
}
.sec-choose-xdc ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-choose-xdc ul.btn-list li:not(:last-of-type) {
  margin: 0 28px 0 0;
}
.sec-review {
  padding: 81px 0 62px;
  background: #EDEBFE;
}
@media screen and (max-width: 767px) {
  .sec-review {
    padding: 40px 0;
  }
}
.sec-review .review-grid {
  display: grid;
  grid-template-columns: repeat(3, calc(33% - 10px));
  column-gap: 20px;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-review .review-grid {
    grid-template-columns: repeat(2, calc(50% - 10px));
    row-gap: 20px;
  }
}
@media screen and (max-width: 767px) {
  .sec-review .review-grid {
    grid-template-columns: 1fr;
    row-gap: 20px;
  }
}
.sec-review .review-grid .review-card {
  padding: 45px;
  text-align: center;
  background: #ffffff;
  border-radius: 20px;
}
.sec-review .review-grid .review-card .star-img img {
  max-width: 160px;
}
.sec-review .review-grid .review-card .review-content {
  margin: 35px auto 64px;
  max-width: 250px;
}
.sec-review .review-grid .review-card .review-content p {
  line-height: 20px;
  margin-bottom: 0;
}
.sec-review .review-grid .review-card .user-profile {
  display: grid;
  grid-template-columns: 42px auto;
  align-items: center;
  justify-content: center;
  column-gap: 20px;
}
.sec-review .review-grid .review-card .user-profile .user-img img {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  object-position: top;
}
.sec-review .review-grid .review-card .user-profile .user-content strong {
  display: block;
}
.sec-review .review-grid .review-card .user-profile .user-content p {
  margin: 0;
}

.sec-xdc-chain {
  padding: 62px 0 119px;
  background: #EDEBFE;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-xdc-chain {
    padding: 60px 0;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-chain {
    padding: 40px 0;
  }
}
.sec-xdc-chain .chain-list-card {
  border-radius: 100px;
  padding: 30px 171px 39px;
  background: linear-gradient(180deg, #FFFFFF 30%, rgba(255, 255, 255, 0) 100%);
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-xdc-chain .chain-list-card {
    padding: 20px 60px 29px;
  }
}
@media screen and (max-width: 767px) {
  .sec-xdc-chain .chain-list-card {
    padding: 60px;
    max-width: 220px;
    margin: auto;
  }
}
.sec-xdc-chain .chain-list-card ul.chain-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
@media screen and (max-width: 767px) {
  .sec-xdc-chain .chain-list-card ul.chain-list {
    display: grid;
    row-gap: 40px;
  }
}
.sec-xdc-chain .chain-list-card ul.chain-list:before {
  content: "";
  background: #D5CDFD;
  height: 1px;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 1;
}
@media screen and (max-width: 767px) {
  .sec-xdc-chain .chain-list-card ul.chain-list:before {
    height: 100%;
    width: 1px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}
.sec-xdc-chain .chain-list-card ul.chain-list li {
  position: relative;
  z-index: 2;
}
.sec-xdc-chain .chain-list-card ul.chain-list li .chain-icon {
  display: inline-block;
}
.sec-xdc-chain .chain-list-card ul.chain-list li .chain-icon img {
  max-width: 100px;
}
.sec-xdc-chain .safe-crypto-card {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat;
  background-position: bottom;
  background-size: cover;
  padding: 70px 64px 0;
  border-radius: 20px;
  margin-top: 116px;
  display: grid;
  grid-template-columns: 1fr 335px 150px;
  align-items: self-start;
  column-gap: 40px;
}
@media screen and (max-width: 991px) {
  .sec-xdc-chain .safe-crypto-card {
    margin-top: 30px;
    grid-template-columns: 1fr;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 40px;
    text-align: center;
  }
}
.sec-xdc-chain .safe-crypto-card .safe-content h2 {
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 0;
}
@media screen and (max-width: 1199px) and (min-width: 992px) {
  .sec-xdc-chain .safe-crypto-card .safe-content h2 {
    font-size: 28px;
    line-height: 36px;
  }
}
@media screen and (max-width: 1366px) and (min-width: 1200px) {
  .sec-xdc-chain .safe-crypto-card .safe-content h2 {
    font-size: 36px;
    line-height: 44px;
  }
}
.sec-xdc-chain .safe-crypto-card .safe-content p {
  color: #ffffff;
  margin: 30px 0 35px;
}
@media screen and (max-width: 1199px) {
  .sec-xdc-chain .safe-crypto-card .safe-content p {
    margin: 20px 0 25px;
  }
}
.sec-xdc-chain .safe-crypto-card .safe-content ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-xdc-chain .safe-crypto-card .safe-content ul.btn-list li:not(:last-of-type) {
  margin: 0 17px 0 0;
}
@media screen and (max-width: 991px) {
  .sec-xdc-chain .safe-crypto-card .safe-mobile-img {
    display: none;
  }
}
.sec-xdc-chain .safe-crypto-card .safe-mobile-img img {
  width: 100%;
}
.sec-xdc-chain .safe-crypto-card .barcode-wrapper {
  text-align: center;
}
@media screen and (max-width: 991px) {
  .sec-xdc-chain .safe-crypto-card .barcode-wrapper {
    margin: auto;
  }
}
.sec-xdc-chain .safe-crypto-card .barcode-wrapper .barcode-icon-main {
  width: 150px;
  height: 150px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(131.3deg, #DAF727 31.14%, rgba(255, 255, 255, 0.25) 97.16%);
}
@media screen and (max-width: 991px) {
  .sec-xdc-chain .safe-crypto-card .barcode-wrapper .barcode-icon-main {
    margin: auto;
  }
}
.sec-xdc-chain .safe-crypto-card .barcode-wrapper .barcode-icon-main .barcode-icon {
  width: 134px;
  height: 134px;
  border-radius: 35px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sec-xdc-chain .safe-crypto-card .barcode-wrapper .barcode-icon-main .barcode-icon img {
  max-width: 90px;
}
.sec-xdc-chain .safe-crypto-card .barcode-wrapper .arrow-icon {
  margin: 18px 0;
}
.sec-xdc-chain .safe-crypto-card .barcode-wrapper .arrow-icon img {
  max-width: 22px;
}
.sec-xdc-chain .safe-crypto-card .barcode-wrapper p {
  color: #F8F8F8;
  margin-bottom: 0;
}

.xdc-footer {
  padding: 83px 0 67px;
}
@media screen and (max-width: 767px) {
  .xdc-footer {
    padding: 50px 0;
  }
}
.xdc-footer p,
.xdc-footer a,
.xdc-footer ul li,
.xdc-footer ol li,
.xdc-footer strong {
  color: #717184;
}
.xdc-footer .top-footer {
  padding-bottom: 64px;
  margin-bottom: 51px;
  border-bottom: 1px solid #DAD6F5;
}
@media screen and (max-width: 767px) {
  .xdc-footer .top-footer {
    margin-bottom: 30px;
    padding-bottom: 10px;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .xdc-footer .top-footer .social-wrapper {
    display: grid;
    grid-template-columns: auto auto;
    align-items: self-start;
    margin-bottom: 40px;
  }
}
@media screen and (max-width: 767px) {
  .xdc-footer .top-footer .social-wrapper {
    margin-bottom: 40px;
  }
}
.xdc-footer .top-footer .social-wrapper .logo-wrapper a.logo img {
  max-width: 200px;
}
@media screen and (max-width: 767px) {
  .xdc-footer .top-footer .social-wrapper .logo-wrapper a.logo img {
    max-width: 140px;
  }
}
.xdc-footer .top-footer .social-wrapper .logo-wrapper p {
  margin: 50px 0 0;
}
@media screen and (max-width: 767px) {
  .xdc-footer .top-footer .social-wrapper .logo-wrapper p {
    margin: 20px 0 0;
  }
}
.xdc-footer .top-footer .social-wrapper .social-card {
  margin-top: 74px;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .xdc-footer .top-footer .social-wrapper .social-card {
    margin-top: 0;
  }
}
@media screen and (max-width: 767px) {
  .xdc-footer .top-footer .social-wrapper .social-card {
    margin-top: 40px;
  }
}
.xdc-footer .top-footer .social-wrapper .social-card ul.social-list li {
  display: inline-block;
  vertical-align: middle;
}
.xdc-footer .top-footer .social-wrapper .social-card ul.social-list li:not(:last-of-type) {
  margin: 0 22px 0 0;
}
.xdc-footer .top-footer .social-wrapper .social-card ul.social-list li a img {
  max-width: 18px;
  filter: brightness(0) saturate(100%) invert(45%) sepia(11%) saturate(515%) hue-rotate(202deg) brightness(96%) contrast(89%);
}
.xdc-footer .top-footer .social-wrapper .social-card p {
  margin: 35px 0 0;
}
@media screen and (max-width: 767px) {
  .xdc-footer .top-footer .social-wrapper .social-card p {
    margin: 20px 0 0;
  }
}
@media screen and (max-width: 767px) {
  .xdc-footer .top-footer .link-wrapper .link-card {
    margin-bottom: 30px;
  }
}
.xdc-footer .top-footer .link-wrapper .link-card:first-of-type {
  min-height: 181px;
}
@media screen and (max-width: 767px) {
  .xdc-footer .top-footer .link-wrapper .link-card:first-of-type {
    min-height: auto;
  }
}
.xdc-footer .top-footer .link-wrapper .link-card:not(:last-of-type) {
  margin-bottom: 44px;
}
@media screen and (max-width: 767px) {
  .xdc-footer .top-footer .link-wrapper .link-card:not(:last-of-type) {
    margin-bottom: 30px;
  }
}
.xdc-footer .top-footer .link-wrapper .link-card strong,
.xdc-footer .top-footer .link-wrapper .link-card a {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  font-family: "Inter";
}
.xdc-footer .top-footer .link-wrapper .link-card strong {
  display: block;
  color: #0E0637;
  margin-bottom: 12px;
}
.xdc-footer .top-footer .link-wrapper .link-card ul.link-list li {
  display: block;
}
.xdc-footer .top-footer .link-wrapper .link-card ul.link-list li:not(:last-of-type) {
  margin-bottom: 3px;
}
.xdc-footer .bottom-footer strong,
.xdc-footer .bottom-footer p {
  font-size: 13px;
  line-height: 19px;
  font-weight: 300;
  font-family: "Inter";
}
.xdc-footer .bottom-footer strong {
  font-weight: 500;
}
.xdc-footer .bottom-footer p {
  margin-bottom: 0;
}
.xdc-footer .bottom-footer p:not(:last-of-type) {
  margin-bottom: 18px;
}

@media screen and (max-width: 767px) {
  body {
    padding: 0 0 70px;
  }
}

.sec-wallet.sec-otc-wallet .wallet-wrapper {
  margin: -180px 0 0;
  height: auto;
}
@media screen and (max-width: 767px) {
  .sec-wallet.sec-otc-wallet .wallet-wrapper {
    height: auto;
    margin: -310px 0 0;
  }
}
.sec-wallet.sec-otc-wallet .wallet-wrapper .wallet-wrapper-table .asset-wrapper .asset-body .asset-list-wrapper .asset-list {
  height: 500px;
}
@media screen and (max-width: 767px) {
  .sec-wallet.sec-otc-wallet .wallet-wrapper .wallet-wrapper-table .asset-wrapper .asset-body .asset-list-wrapper .asset-list {
    height: 357px;
  }
}
.sec-wallet .p-h-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 125px;
}
.sec-wallet .wallet-wrapper {
  width: 100%;
  height: auto;
  background: #DEEBF8;
  border-radius: 16px 16px 0 0;
  padding: 16px 24px;
  margin: -32px 0 0;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper {
    margin: -80px 0 0;
    padding: 16px 8px;
    height: auto;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper.mt-375 {
    margin: -375px 0 0;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header {
  margin-bottom: 24px;
  position: relative;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header {
    margin-bottom: 16px;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header > .title {
  margin-bottom: 24px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .search-wrapper-v1 {
  max-width: 310px;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header .search-wrapper-v1.w-100 {
    max-width: 100%;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header .search-wrapper-v1.mb-16 {
    margin-bottom: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header .otc-search-wrapper {
    display: grid;
    grid-template-columns: 1fr 130px;
    align-items: center;
    column-gap: 16px;
    margin: 16px 0 0;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .otc-search-wrapper .show-mobile {
  display: none;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header .otc-search-wrapper .show-mobile {
    display: flex;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list {
  text-align: right;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list.otc-btn-list li {
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list.otc-btn-list li:not(:last-of-type) {
    margin: 0 0 8px;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list.otc-btn-list li .btn-style {
    min-width: 100%;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list li .date-btn {
  padding: 8px 12px;
  border-color: #D0D5DD;
  color: #64748B;
  font-weight: 400;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list li .date-btn {
    justify-content: left;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list li .date-btn .arrow-icon {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header ul.btn-list li .btn-style.m-w-130 {
  min-width: 130px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper {
  position: relative;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date {
  background: #DEEBF8;
  border-radius: 8px;
  padding: 24px 0 0;
  box-shadow: 0 3px 12px 2px rgba(31, 34, 39, 0.21);
  width: 360px;
  position: absolute;
  left: 0;
  top: 60px;
  z-index: 4;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date {
    max-width: 350px;
    overflow: auto;
    padding: 10px 0 0;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper {
  text-align: center;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .rdrCalendarWrapper {
  background: #DEEBF8;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .rdrCalendarWrapper .rdrDateDisplayWrapper {
  background: transparent;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .rdrCalendarWrapper .rdrDateDisplayWrapper .rdrDateDisplay .rdrDateInput {
  background: #000000;
  border: none;
  box-shadow: none;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .rdrCalendarWrapper .rdrDateDisplayWrapper .rdrDateDisplay .rdrDateInput input {
  color: #ffffff;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .rdrCalendarWrapper .rdrDateDisplayWrapper .rdrDateDisplay .rdrDateInput input::placeholder {
  color: #ffffff;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .rdrCalendarWrapper .rdrMonthAndYearWrapper button {
  background: #CEDDEB;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .btn-wrapper {
  padding: 12px 24px;
  background: #CEDDEB;
  border-radius: 0 0 8px 8px;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .btn-wrapper {
    padding: 12px 24px;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .btn-wrapper ul.btn-list {
  text-align: right;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .btn-wrapper ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .btn-wrapper ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-header .filter-wrapper .select-date .select-date-wrapper .btn-wrapper ul.btn-list li .btn-style {
  height: 40px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list {
  height: 500px;
  overflow: auto;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list {
    height: 362px;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list.desktop {
  display: block;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list.desktop {
    display: none;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list::-webkit-scrollbar {
  background-color: #DEEBF8;
  width: 16px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list::-webkit-scrollbar-track {
  background-color: #DEEBF8;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list::-webkit-scrollbar-thumb {
  background-color: #000000;
  border-radius: 16px;
  border: 4px solid #DEEBF8;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list::-webkit-scrollbar-button {
  display: none;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-4 {
  display: grid;
  grid-template-columns: 400px 215px 215px 330px;
  column-gap: 10px;
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-4 {
    grid-template-columns: 340px 205px 205px 330px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 992px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-4 {
    grid-template-columns: 280px 190px 190px 295px;
    min-width: 995px;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-4 {
    grid-template-columns: 270px 150px 150px 295px;
    min-width: 905px;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-4 {
    grid-template-columns: 250px 140px 140px 265px;
    min-width: 834px;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-3 {
  display: grid;
  grid-template-columns: 500px 2fr 330px;
  column-gap: 10px;
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-3 {
    grid-template-columns: 200px 1fr 330px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-3 {
    grid-template-columns: 180px 1fr 295px;
    min-width: 700px;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-3 {
    grid-template-columns: 160px 1fr 265px;
    min-width: 650px;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-6 {
  display: grid;
  grid-template-columns: 220px 198px 175px 150px 90px 330px;
  column-gap: 10px;
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-6 {
    grid-template-columns: 200px 170px 180px 175px 155px 330px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-6 {
    grid-template-columns: 200px 130px 130px 105px 100px 295px;
    min-width: 910px;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-6 {
    grid-template-columns: 185px 105px 120px 75px 65px 265px;
    min-width: 807px;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-7 {
  display: grid;
  grid-template-columns: 44px 148px 195px 155px 130px 225px 225px;
  column-gap: 10px;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-7 {
    grid-template-columns: 44px 148px 195px 155px 130px 225px 225px;
    min-width: 1192px;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .Otc-grid-8 {
  display: grid;
  grid-template-columns: 35px 90px 200px 140px 170px 140px 250px 190px;
  column-gap: 10px;
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .Otc-grid-8 {
    grid-template-columns: 35px 35px 195px 185px 160px 120px 115px 185px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .Otc-grid-8 {
    min-width: 1195px;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .Otc-grid-8 {
    grid-template-columns: 44px 44px 244px 244px 180px 160px 130px 180px;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-8 {
  display: grid;
  grid-template-columns: 35px 35px 210px 200px 170px 140px 130px 190px;
  column-gap: 10px;
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-8 {
    grid-template-columns: 35px 35px 195px 185px 160px 120px 115px 185px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-8 {
    min-width: 1195px;
  }
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .grid-8 {
    grid-template-columns: 44px 44px 244px 244px 180px 160px 130px 180px;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .checkbox-wrapper input[type=checkbox] {
  position: relative;
  height: 16px;
  width: 16px;
  cursor: pointer;
  border-radius: 2px;
  border: 2px solid rgba(4, 9, 33, 0.32);
  vertical-align: text-top;
  -webkit-appearance: none;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .checkbox-wrapper input[type=checkbox]:checked {
  opacity: 1;
  border-color: #000000;
  background: #000000;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .checkbox-wrapper input[type=checkbox]:checked:before {
  opacity: 1;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .checkbox-wrapper input[type=checkbox]:before {
  content: "";
  width: 5px;
  height: 10px;
  position: absolute;
  top: 45%;
  right: calc(50% - 1px);
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translate(-50%, -50%);
  z-index: 2;
  opacity: 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .table-header {
  padding: 20px 8px;
  border-bottom: 1px solid #B5D2DF;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .table-header.style-v2 {
  border-top: 1px solid #B5D2DF;
  border-bottom: 1px solid #B5D2DF;
  background: #CEDDEB;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .table-header .asset-item:first-of-type {
  padding-left: 40px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .table-header .asset-item p {
  margin-bottom: 0;
  font-weight: 800;
  color: #787878;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .table-header .asset-item p img {
  cursor: pointer;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card {
  padding: 17px 8px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card:not(:last-of-type) {
  border-bottom: 1px solid #B5D2DF;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item p {
  margin-bottom: 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item .transaction-name img {
  max-width: 18px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item .transaction-name p {
  margin-bottom: 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper {
  display: grid;
  grid-template-columns: 51px 1fr;
  column-gap: 10px;
  align-items: center;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .icon img {
  max-width: 51px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .wallet-icon {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #D2DEEB;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .wallet-icon .wallet-icon {
  max-width: 21px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .wallet-icon .tag-icon {
  position: absolute;
  right: -3px;
  bottom: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #ffffff;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .content p {
  margin-bottom: 0;
  color: #4E4E4E;
  font-weight: 600;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .content p.title {
  color: #191D23;
  font-weight: 800;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item ul.btn-list {
  text-align: center;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list .asset-card .asset-item ul.btn-list li:not(:last-of-type) {
  margin: 0 8px 0 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile {
  display: none;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile {
    display: block;
  }
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #B5D2DF;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card:not(:last-of-type) {
  margin: 0 0 16px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card .transaction-icon {
  margin-bottom: 12px;
  padding: 6px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card .transaction-icon img {
  max-width: 18px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: space-between;
  column-gap: 12px;
  row-gap: 12px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li:nth-of-type(even) {
  text-align: left;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li p {
  margin-bottom: 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li p.f-10 {
  color: #4E4E4E;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper {
  display: grid;
  grid-template-columns: 36px 1fr;
  column-gap: 10px;
  align-items: center;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .icon img {
  max-width: 36px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .wallet-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #D2DEEB;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .wallet-icon .wallet-icon {
  max-width: 21px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .wallet-icon .tag-icon {
  position: absolute;
  right: -3px;
  bottom: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #ffffff;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .content p {
  margin-bottom: 0;
  color: #4E4E4E;
  font-weight: 600;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .content p.title {
  color: #191D23;
  font-weight: 800;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card .approved-date {
  margin: 12px 0 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card .approved-date p {
  margin-bottom: 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card .approved-date p.f-10 {
  color: #4E4E4E;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-btn {
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 6px));
  align-items: center;
  justify-content: space-between;
  column-gap: 8px;
  margin: 11px 0 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-btn li {
  display: block;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-btn li .btn-style {
  height: 38px;
  min-width: 100%;
  font-size: 14px;
  line-height: 22px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.trade-date-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.trade-date-list li p {
  margin-bottom: 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.trade-date-list li p.f-10 {
  color: #4E4E4E;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.source-date-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.source-date-list li p {
  margin-bottom: 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.source-date-list li p.f-10 {
  color: #4E4E4E;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.source-date-list li p.wallet-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.destination-date-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.destination-date-list li p {
  margin-bottom: 0;
}
.sec-wallet .wallet-wrapper .asset-wrapper .asset-body .asset-list-wrapper .asset-list-mobile .asset-list-card ul.destination-date-list li p.f-10 {
  color: #4E4E4E;
}
.sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header {
  margin-bottom: 24px;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header {
    margin-bottom: 16px;
  }
}
.sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header .nav {
  background: transparent;
  text-align: left;
  display: block;
  border-bottom: 2px solid #B5D2DF;
}
.sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header .nav .nav-item {
  display: inline-block;
}
.sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header .nav .nav-item .nav-link {
  background: transparent;
  padding: 16px 20px;
  border-radius: 0;
  height: 57px;
  border: unset;
  position: relative;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header .nav .nav-item .nav-link {
    height: 27px;
    padding: 3px 8px;
  }
}
.sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header .nav .nav-item .nav-link:before {
  content: "";
  background: #000000;
  width: 100%;
  height: 2px;
  position: absolute;
  left: 0;
  bottom: -2px;
  display: none;
}
.sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header .nav .nav-item .nav-link.active:before {
  display: block;
}
.sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header .nav .nav-item .nav-link.active h3 {
  color: #000000;
}
.sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header .nav .nav-item .nav-link h3 {
  color: #929DAE;
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .sec-wallet .wallet-wrapper .tabs-wrapper .tabs-header .nav .nav-item .nav-link h3 {
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
  }
}
.auth-modal .modal-dialog {
  max-width: 500px;
}
.auth-modal .modal-dialog .modal-content {
  border-radius: 12px;
  border: none;
}
.auth-modal .modal-dialog .modal-content .modal-body {
  padding: 40px;
}
.auth-modal .modal-dialog .modal-content .modal-body .auth-modal-wrapper.google-only .auth-modal-center {
  text-align: center;
}
.auth-modal .modal-dialog .modal-content .modal-body .auth-modal-wrapper.google-only .auth-modal-center .content-wrapper h2 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
}
.auth-modal .modal-dialog .modal-content .modal-body .auth-modal-wrapper.google-only .auth-modal-center .content-wrapper p {
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
}
.auth-modal .modal-dialog .modal-content .modal-body .auth-modal-wrapper.google-only .auth-modal-center .content-wrapper .google-login-center {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}
.auth-modal .modal-dialog .modal-content .modal-body .auth-modal-wrapper.google-only .auth-modal-center .content-wrapper .switch-auth {
  font-size: 14px;
  color: #666;
  margin: 0;
}
.auth-modal .modal-dialog .modal-content .modal-body .auth-modal-wrapper.google-only .auth-modal-center .content-wrapper .switch-auth a {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}
.auth-modal .modal-dialog .modal-content .modal-body .auth-modal-wrapper.google-only .auth-modal-center .content-wrapper .switch-auth a:hover {
  text-decoration: underline;
}

.auth-offcanvas .offcanvas-body {
  padding: 30px 20px;
}
.auth-offcanvas .offcanvas-body .auth-content.google-only-offcanvas {
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-offcanvas .offcanvas-body .auth-content.google-only-offcanvas .content-wrapper {
  width: 100%;
}
.auth-offcanvas .offcanvas-body .auth-content.google-only-offcanvas .content-wrapper p {
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
}
.auth-offcanvas .offcanvas-body .auth-content.google-only-offcanvas .content-wrapper .google-login-center {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}
.auth-offcanvas .offcanvas-body .auth-content.google-only-offcanvas .content-wrapper .switch-auth {
  font-size: 14px;
  color: #666;
  margin: 0;
}
.auth-offcanvas .offcanvas-body .auth-content.google-only-offcanvas .content-wrapper .switch-auth a {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}
.auth-offcanvas .offcanvas-body .auth-content.google-only-offcanvas .content-wrapper .switch-auth a:hover {
  text-decoration: underline;
}

.sec-auth {
  padding: 0 0 60px;
}
.sec-auth .auth-banner-wrapper {
  background: #D5E8FB;
  margin-bottom: 50px;
}
.sec-auth .auth-banner-wrapper span.top-notch {
  display: block;
  width: 164px;
  height: 31px;
  margin: auto;
  border-radius: 0 0 30px 30px;
  background: #E6F2FE;
}
.sec-auth .auth-banner-wrapper .auth-banner-card {
  margin: 42px 0 0;
  text-align: center;
}
.sec-auth .auth-banner-wrapper .auth-banner-card a.logo {
  display: inline-block;
}
.sec-auth .auth-banner-wrapper .auth-banner-card a.logo img {
  max-width: 100px;
}
.sec-auth .auth-banner-wrapper .auth-banner-card .laptop-img {
  margin: 33px 0 0;
}
.sec-auth .auth-banner-wrapper .auth-banner-card .laptop-img img {
  width: 100%;
  max-width: 360px;
  margin: auto;
}
.sec-auth .user-auth-wrapper .form-wrapper {
  width: 100%;
  max-width: 310px;
  margin: auto;
}
.sec-auth .user-auth-wrapper .form-wrapper > h3 {
  font-size: 24px;
  line-height: 30px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 24px;
}
.sec-auth .user-auth-wrapper .form-wrapper ul.social-auth {
  text-align: center;
  margin: 0 0 24px;
}
.sec-auth .user-auth-wrapper .form-wrapper ul.social-auth li {
  display: block;
}
.sec-auth .user-auth-wrapper .form-wrapper ul.social-auth li:not(:last-of-type) {
  margin: 0 0 8px;
}
.sec-auth .user-auth-wrapper .form-wrapper ul.social-auth li .btn-style {
  min-width: 100%;
  height: 55px;
}
.sec-auth .user-auth-wrapper .form-wrapper ul.social-auth li .btn-style img {
  max-width: 24px;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group {
  margin-bottom: 16px;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit {
  margin-bottom: 0;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit .btn-style {
  height: 55px;
  font-weight: 700;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit .no-account {
  margin: 24px 0 0;
  text-align: center;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit .no-account p {
  margin-bottom: 0;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group label {
  font-size: 14px;
  line-height: 22px;
  font-weight: 700;
  margin-bottom: 12px;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .otp-text {
  margin-bottom: 33px;
  text-align: center;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .resend-otp {
  text-align: right;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .resend-otp label {
  cursor: pointer;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .form-control {
  height: 48px;
  font-size: 16px;
  line-height: 22px;
  border-color: #B5D2DF;
  color: #000000;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .form-control::placeholder {
  color: #8097A2;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .form-control.otp-input {
  letter-spacing: 31px;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .key-input {
  position: relative;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .key-input .form-control {
  padding: 9px 40px 9px 12px;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .key-input .icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 24px;
  cursor: pointer;
}
.sec-auth .user-auth-wrapper .form-wrapper .form.auth-form .form-group .more-link {
  margin: 12px 0 0;
}
.sec-registration .img-wrapper img {
  width: 100%;
  height: 100vh;
  object-fit: contain;
  object-position: top;
}
@media screen and (max-width: 1199px) {
  .sec-registration .img-wrapper img {
    object-fit: contain;
  }
}

.sec-profile .profile-wrapper {
  background: #DEEBF8;
  border-radius: 16px 16px 0 0;
  padding: 16px 24px;
  margin: -80px 0 0;
  min-height: 600px;
}
@media screen and (max-width: 767px) {
  .sec-profile .profile-wrapper {
    min-height: 400px;
    margin: -280px 0 0;
  }
}
.sec-profile .profile-wrapper .profile-card {
  margin: -85px 0 0;
}
.sec-profile .profile-wrapper .profile-card .user-image {
  text-align: center;
}
.sec-profile .profile-wrapper .profile-card .user-image img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0 auto 30px;
}
.sec-profile .profile-wrapper .profile-card .user-detail {
  text-align: center;
}
.sec-profile .profile-wrapper .profile-card .user-detail ul.personal-list {
  max-width: 300px;
  margin: auto;
}
.sec-profile .profile-wrapper .profile-card .user-detail ul.personal-list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.sec-profile .profile-wrapper .profile-card .user-detail ul.personal-list li:not(:last-of-type) {
  margin-bottom: 20px;
}
.sec-profile .profile-wrapper .profile-card .user-detail ul.personal-list li h3 {
  font-weight: 600;
  margin-bottom: 0;
}
.sec-profile .profile-wrapper .profile-card .user-detail ul.personal-list li p {
  margin-bottom: 0;
}
.sec-profile .profile-wrapper .profile-card .user-detail ul.personal-list li .btn-style {
  min-width: 100%;
}

header {
  width: 100%;
  padding: 18px 0;
  position: absolute;
  top: 0;
  left: 0;
}
@media screen and (max-width: 767px) {
  header {
    padding: 12px 21px 14px;
    width: 100%;
    height: 66px;
    position: fixed;
    top: unset;
    bottom: 0;
    left: 0;
    z-index: 4;
    background: #000000;
  }
}
header .header-desktop {
  display: block;
}
@media screen and (max-width: 767px) {
  header .header-desktop {
    display: none;
  }
}
header .header-mobile {
  display: none;
}
@media screen and (max-width: 767px) {
  header .header-mobile {
    display: block;
  }
}
header .header-mobile ul.mobile-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: 335px;
  margin: auto;
}
header .header-mobile ul.mobile-menu li a {
  display: inline-block;
  text-align: center;
}
header .header-mobile ul.mobile-menu li a.active .icon img:not(.user-img) {
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7499%) hue-rotate(130deg) brightness(99%) contrast(101%);
}
header .header-mobile ul.mobile-menu li a.active p {
  color: #ffffff;
}
header .header-mobile ul.mobile-menu li a .icon {
  margin-bottom: 4px;
}
header .header-mobile ul.mobile-menu li a .icon img {
  max-width: 18px;
}
header .header-mobile ul.mobile-menu li a .icon img:not(.user-img) {
  filter: brightness(0) saturate(100%) invert(50%) sepia(15%) saturate(18%) hue-rotate(111deg) brightness(97%) contrast(87%);
}
header .header-mobile ul.mobile-menu li a .icon img.user-img {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  object-fit: cover;
}
header .header-mobile ul.mobile-menu li a p {
  margin-bottom: 0;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
}
header .logo-wrapper a.logo img {
  max-width: 118px;
}
@media screen and (max-width: 767px) {
  header .logo-wrapper a.logo img {
    max-width: 100px;
  }
}
header ul.features {
  text-align: right;
}
header ul.features li {
  display: inline-block;
  vertical-align: middle;
}
header ul.features li:not(:last-of-type) {
  margin: 0 24px 0 0;
}
header ul.features li a.bel-wrapper img {
  max-width: 24px;
}
header ul.features li a.user-wrapper img {
  width: 42px;
  height: 42px;
  object-fit: cover;
  border-radius: 50%;
}

.sec-banner .container-fluid {
  padding: 0;
}
.sec-banner .banner-wrapper {
  width: 100%;
  min-height: 362px;
  padding: 92px 0 59px;
  border-radius: 0 0 16px 16px;
  background: #000000;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper {
    min-height: 571px;
    padding: 0 0 50px;
  }
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper.mh-400 {
    min-height: 400px;
  }
}
.sec-banner .banner-wrapper .top-notch-wrapper {
  display: none;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .top-notch-wrapper {
    display: block;
    margin-bottom: 42px;
    text-align: center;
  }
}
.sec-banner .banner-wrapper .top-notch-wrapper span.top-notch {
  display: block;
  width: 164px;
  height: 31px;
  margin: auto;
  border-radius: 0 0 30px 30px;
  background: #E6F2FE;
}
.sec-banner .banner-wrapper .top-notch-wrapper a.logo {
  display: inline-block;
  margin: 48px 0 0;
}
.sec-banner .banner-wrapper .top-notch-wrapper a.logo img {
  max-width: 100px;
}
.sec-banner .banner-wrapper .crypto-card {
  display: grid;
  grid-template-columns: 1fr 395px;
  align-items: center;
  background: #E6F2FE;
  border-radius: 16px;
  position: relative;
  min-height: 221px;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-banner .banner-wrapper .crypto-card {
    grid-template-columns: 1fr 245px;
  }
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .crypto-card {
    padding: 16px 16px 0;
    grid-template-columns: auto;
    overflow: hidden;
  }
}
.sec-banner .banner-wrapper .crypto-card .content-wrapper {
  padding: 41px 0 41px 32px;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .crypto-card .content-wrapper {
    padding: 0;
    text-align: center;
  }
}
.sec-banner .banner-wrapper .crypto-card .content-wrapper h1 {
  margin: 0;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .crypto-card .content-wrapper h1 {
    font-size: 20px;
    line-height: 24px;
    max-width: 225px;
    margin: auto;
  }
}
.sec-banner .banner-wrapper .crypto-card .content-wrapper h3 {
  margin: 11px 0 15px;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .crypto-card .content-wrapper h3 {
    font-size: 10px;
    line-height: 14px;
    max-width: 225px;
    margin: auto;
  }
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .crypto-card .content-wrapper ul.btn-list {
    margin-top: 13px;
  }
}
.sec-banner .banner-wrapper .crypto-card .content-wrapper ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-banner .banner-wrapper .crypto-card .content-wrapper ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
@media screen and (max-width: 991px) {
  .sec-banner .banner-wrapper .crypto-card .content-wrapper ul.btn-list li:not(:last-of-type) {
    margin: 0 8px 0 0;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-banner .banner-wrapper .crypto-card .content-wrapper ul.btn-list li .btn-style {
    padding: 10px 6px;
    height: 38px;
    font-size: 14px;
    line-height: 22px;
  }
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .crypto-card .content-wrapper ul.btn-list li .btn-style {
    padding: 10px 6px;
    height: 38px;
    font-size: 12px;
    line-height: 18px;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-banner .banner-wrapper .crypto-card .content-wrapper ul.btn-list li .btn-style img {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .crypto-card .img-wrapper {
    margin: 0 0 -32px;
  }
}
.sec-banner .banner-wrapper .crypto-card .img-wrapper img {
  width: 100%;
  height: 100%;
  max-width: 400px;
  position: absolute;
  right: 0;
  top: 0;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-banner .banner-wrapper .crypto-card .img-wrapper img {
    max-width: 270px;
  }
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .crypto-card .img-wrapper img {
    position: relative;
  }
}
.sec-banner .banner-wrapper .value-asset-card {
  background: #E6F2FE;
  border-radius: 16px;
  position: relative;
  padding: 8px 25px;
  min-height: 227px;
  display: grid;
  align-items: center;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-banner .banner-wrapper .value-asset-card {
    margin-bottom: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .value-asset-card {
    padding: 16px;
    margin-bottom: 12px;
  }
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .value-asset-card .content-wrapper {
    display: flex;
    align-items: self-start;
    justify-content: space-between;
    margin-bottom: 22px;
  }
}
.sec-banner .banner-wrapper .value-asset-card .content-wrapper h3 {
  margin: 0 0 12px;
  font-weight: 500;
}
@media screen and (max-width: 1199px) and (min-width: 992px) {
  .sec-banner .banner-wrapper .value-asset-card .content-wrapper h3 br {
    display: none;
  }
}
.sec-banner .banner-wrapper .value-asset-card .content-wrapper strong {
  font-size: 42px;
  line-height: 50px;
  font-weight: 600;
  color: #000000;
  font-family: "Gabarito";
}
@media screen and (max-width: 1199px) and (min-width: 992px) {
  .sec-banner .banner-wrapper .value-asset-card .content-wrapper strong {
    font-size: 35px;
    line-height: 43px;
  }
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .value-asset-card .content-wrapper strong {
    font-size: 32px;
    line-height: 40px;
  }
}
.sec-banner .banner-wrapper .value-asset-card .chart-wrapper .line-chart {
  width: 100%;
  height: 150px;
  background: #E6F2FE;
  border-left: 1px solid #9BACB4;
  border-bottom: 1px solid #9BACB4;
  position: relative;
}
.sec-banner .banner-wrapper .value-asset-card .chart-wrapper .pie-chart {
  width: 100%;
  height: 210px;
  text-align: right;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .value-asset-card .chart-wrapper .pie-chart {
    text-align: center;
  }
}
.sec-banner .banner-wrapper .value-asset-card .chart-wrapper .pie-chart canvas {
  height: 210px !important;
  margin: 0 0 0 auto;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .value-asset-card .chart-wrapper .pie-chart canvas {
    width: 210px !important;
    height: 210px !important;
    margin: 0 auto 0;
  }
}
.sec-banner .banner-wrapper .your-asset-card {
  background: #E6F2FE;
  border-radius: 16px;
  position: relative;
  padding: 20px 0 20px 16px;
}
.sec-banner .banner-wrapper .your-asset-card > h3 {
  margin-bottom: 16px;
}
.sec-banner .banner-wrapper .your-asset-card .asset-slider .slick-slider .slick-dots,
.sec-banner .banner-wrapper .your-asset-card .asset-slider .slick-slider .slick-arrow {
  display: none !important;
}
.sec-banner .banner-wrapper .your-asset-card .asset-slider .slick-slider .slick-list .slick-track {
  display: flex;
  align-items: center;
}
.sec-banner .banner-wrapper .your-asset-card .asset-slider .slick-slider .slick-list .slick-track .slick-slide {
  margin-right: 16px;
}
.sec-banner .banner-wrapper .your-asset-card .asset-slider .slick-slider .slick-list .slick-track .slick-slide .your-asset-card {
  background: #D3E4EC;
  border-radius: 16px;
  padding: 16px;
}
.sec-banner .banner-wrapper .your-asset-card .asset-slider .slick-slider .slick-list .slick-track .slick-slide .your-asset-card .icon {
  margin-bottom: 10px;
}
.sec-banner .banner-wrapper .your-asset-card .asset-slider .slick-slider .slick-list .slick-track .slick-slide .your-asset-card .icon img {
  max-width: 27px;
}
.sec-banner .banner-wrapper .your-asset-card .asset-slider .slick-slider .slick-list .slick-track .slick-slide .your-asset-card .content h3 {
  margin-bottom: 0;
  font-weight: 400;
}
.sec-banner .banner-wrapper .your-asset-card .asset-slider .slick-slider .slick-list .slick-track .slick-slide .your-asset-card .content h3.title {
  font-weight: 500;
  margin-bottom: 8px;
}
.sec-banner .banner-wrapper .otc-banner-wrapper {
  margin-top: 12px;
}
.sec-banner .banner-wrapper .otc-banner-wrapper h2 {
  color: #ffffff;
  margin-bottom: 0;
}
.sec-banner .banner-wrapper .otc-banner-wrapper h3 {
  color: #ffffff;
  margin-bottom: 0;
}
.sec-banner .banner-wrapper .otc-banner-wrapper p {
  margin: 16px 0 0;
}
.sec-banner .banner-wrapper .otc-banner-wrapper ul.btn-list {
  text-align: right;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .otc-banner-wrapper ul.btn-list {
    margin: 16px 0 0;
  }
}
.sec-banner .banner-wrapper .otc-banner-wrapper ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .otc-banner-wrapper ul.btn-list li {
    display: block;
  }
}
.sec-banner .banner-wrapper .otc-banner-wrapper ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
@media screen and (max-width: 767px) {
  .sec-banner .banner-wrapper .otc-banner-wrapper ul.btn-list li .btn-style {
    min-width: 100%;
  }
}

.dropdown-v1 button {
  width: unset;
  padding: 0;
  background: transparent !important;
  border: none;
  outline: none;
  box-shadow: none;
}
.dropdown-v1 button:focus, .dropdown-v1 button:active, .dropdown-v1 button:hover {
  outline: none;
  box-shadow: none;
  background: transparent;
}
.dropdown-v1 button:after {
  display: none;
}
.dropdown-v1 .dropdown-menu {
  background: #E6F2FE;
  box-shadow: 0 4px 20px 4px rgba(183, 186, 203, 0.15);
  padding: 0;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  min-width: 180px;
  margin: 7px 0 0;
}
.dropdown-v1 .dropdown-menu .dropdown-item {
  padding: 15px 24px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  color: #191D23;
  background: #E6F2FE;
}
.dropdown-v1 .dropdown-menu .dropdown-item:focus, .dropdown-v1 .dropdown-menu .dropdown-item:active, .dropdown-v1 .dropdown-menu .dropdown-item:hover {
  color: #191D23;
}

.notification-dropdown button {
  width: unset;
  padding: 0;
  background: transparent !important;
  border: none;
  outline: none;
  box-shadow: none;
}
.notification-dropdown button:focus, .notification-dropdown button:active, .notification-dropdown button:hover {
  outline: none;
  box-shadow: none;
  background: transparent;
}
.notification-dropdown button:after {
  display: none;
}
.notification-dropdown .dropdown-menu {
  background: #E6F2FE;
  box-shadow: 0 4px 20px 4px rgba(183, 186, 203, 0.15);
  padding: 0;
  border: none;
  border-radius: 12px;
  overflow: hidden;
  width: 400px;
  max-width: 400px;
  margin: 7px 0 0;
}
.notification-dropdown .dropdown-menu .dropdown-item {
  padding: 0;
  background: #E6F2FE;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper {
  padding: 16px 24px;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 0 0 16px;
  border-bottom: 1px solid #C3DBE5;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-header .cross-icon img {
  max-width: 13px;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-body ul.notification-list li {
  display: block;
  margin: 0;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-body ul.notification-list li:not(:last-of-type) .notification-card {
  border-bottom: 1px solid #C3DBE5;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-body ul.notification-list li .notification-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-body ul.notification-list li .notification-card .content h3 {
  margin-bottom: 0;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-body ul.notification-list li .notification-card .content p {
  margin: 8px 0;
  line-height: 20px;
  white-space: normal;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-body ul.notification-list li .notification-card .content span.date {
  color: #787878;
  font-weight: 500;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-body ul.notification-list li .notification-card .icon {
  display: flex;
  align-items: center;
  gap: 16px;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-body ul.notification-list li .notification-card .icon .success {
  max-width: 60px;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-body ul.notification-list li .notification-card .icon span.status {
  width: 8px;
  height: 8px;
  border-radius: 50px;
  background: #000000;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-footer {
  padding: 16px 0 0;
  border-top: 1px solid #C3DBE5;
}
.notification-dropdown .dropdown-menu .dropdown-item .notification-wrapper .notification-footer a {
  color: #000000;
  font-weight: 500;
}

.search-wrapper-v1 .form .form-group {
  position: relative;
  margin-bottom: 0;
}
.search-wrapper-v1 .form .form-group .form-control {
  padding: 9px 8px 9px 32px;
}
.search-wrapper-v1 .form .form-group .icon {
  position: absolute;
  right: unset;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 12px;
}

.custom-select {
  background: #DEEBF8;
  border: 1px solid #B5D2DF;
  border-radius: 4px;
  padding: 12px;
  cursor: pointer;
  position: relative;
}
.custom-select.wallet-dropdown .select-header .name-wrapper .content p {
  padding: 4px 0 0;
}
.custom-select.wallet-dropdown ul.select-options li .option-card p {
  padding: 4px 0 0;
}
.custom-select.coin-dropdown .coin-img {
  max-width: 32px;
}
.custom-select .select-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
@media screen and (max-width: 767px) {
  .custom-select .select-header {
    gap: 10px;
  }
}
.custom-select .select-header .name-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}
.custom-select .select-header .name-wrapper .icon img {
  max-width: 32px;
}
.custom-select .select-header .name-wrapper .content p {
  margin-bottom: 0;
}
.custom-select .select-header .arrow-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}
.custom-select .select-header .arrow-wrapper p {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .custom-select .select-header .arrow-wrapper p {
    white-space: nowrap;
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.custom-select .select-header .arrow-wrapper a.arrow.open img {
  transform: rotate(180deg);
}
.custom-select .select-header .arrow-wrapper a.arrow img {
  max-width: 32px;
  transition: all 0.3s ease-in-out;
}
@media screen and (max-width: 767px) {
  .custom-select .select-header .arrow-wrapper a.arrow img {
    max-width: 20px;
  }
}
.custom-select ul.select-options {
  padding: 19px;
  border-radius: 4px;
  background: #DEEBF8;
  border: 1px solid #B5D2DF;
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  height: auto;
  overflow: auto;
  z-index: 3;
}
@media screen and (max-width: 767px) {
  .custom-select ul.select-options {
    padding: 14px;
  }
}
.custom-select ul.select-options::-webkit-scrollbar {
  background-color: #DEEBF8;
  width: 16px;
}
.custom-select ul.select-options::-webkit-scrollbar-track {
  background-color: #DEEBF8;
}
.custom-select ul.select-options::-webkit-scrollbar-thumb {
  background-color: #000000;
  border-radius: 16px;
  border: 4px solid #DEEBF8;
}
.custom-select ul.select-options::-webkit-scrollbar-button {
  display: none;
}
.custom-select ul.select-options:has(li:nth-of-type(6)) {
  height: 250px;
}
.custom-select ul.select-options:has(li:nth-of-type(6))::-webkit-scrollbar {
  background-color: #DEEBF8;
  width: 12px;
}
.custom-select ul.select-options:has(li:nth-of-type(6))::-webkit-scrollbar-track {
  background-color: #DEEBF8;
}
.custom-select ul.select-options:has(li:nth-of-type(6))::-webkit-scrollbar-thumb {
  background-color: #95ACB6;
  border-radius: 8px;
  border: 4px solid #DEEBF8;
}
.custom-select ul.select-options:has(li:nth-of-type(6))::-webkit-scrollbar-button {
  display: none;
}
.custom-select ul.select-options li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.custom-select ul.select-options li:not(:last-of-type) {
  margin-bottom: 4px;
}
.custom-select ul.select-options li .option-card {
  width: 100%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
}
.custom-select ul.select-options li .option-card:hover, .custom-select ul.select-options li .option-card.active {
  background: #D8E6F5;
}
.custom-select ul.select-options li .option-card .option-name {
  display: flex;
  align-items: center;
  gap: 8px;
}
.custom-select ul.select-options li .option-card .option-name .icon-wrapper img {
  max-width: 32px;
}
.custom-select ul.select-options li .option-card .option-name p {
  margin-bottom: 0;
}
.custom-select ul.select-options li .option-card > p {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .custom-select ul.select-options li .option-card > p {
    white-space: nowrap;
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.pagination-wrapper-main {
  background: #CEDDEB;
  padding: 24px 12px;
}
@media screen and (max-width: 767px) {
  .pagination-wrapper-main {
    padding: 18px 12px 16px;
  }
}
.pagination-wrapper-main .pagination-wrapper {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .pagination-wrapper-main .pagination-wrapper {
    grid-template-columns: 1fr 1fr;
  }
}
@media screen and (max-width: 767px) {
  .pagination-wrapper-main .pagination-wrapper {
    display: block;
  }
}
.pagination-wrapper-main .pagination-wrapper p {
  margin-bottom: 0;
}
@media screen and (max-width: 991px) {
  .pagination-wrapper-main .pagination-wrapper p.empty-tag {
    display: none;
  }
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list {
  text-align: center;
  min-width: 445px;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .pagination-wrapper-main .pagination-wrapper ul.pagination-list {
    text-align: left;
  }
}
@media screen and (max-width: 767px) {
  .pagination-wrapper-main .pagination-wrapper ul.pagination-list {
    min-width: auto;
  }
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list li {
  display: inline-block;
  vertical-align: middle;
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list li:not(:last-of-type) {
  margin: 0 8px 0 0;
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list li .pagination-btn {
  display: inline-block;
  height: 38px;
  padding: 7px 12px 8px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  border-radius: 4px;
  color: #000000;
  border: 1px solid #000000;
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list li .pagination-btn.active {
  color: #ffffff;
  background: #000000;
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list li .pagination-btn.no-border {
  border: unset;
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list li .pagination-btn.w-96 {
  min-width: 96px;
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list li .pagination-btn.desktop {
  display: block;
}
@media screen and (max-width: 991px) {
  .pagination-wrapper-main .pagination-wrapper ul.pagination-list li .pagination-btn.desktop {
    display: none;
  }
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list li .pagination-btn.mobile {
  display: none;
}
@media screen and (max-width: 991px) {
  .pagination-wrapper-main .pagination-wrapper ul.pagination-list li .pagination-btn.mobile {
    display: block;
  }
}
.pagination-wrapper-main .pagination-wrapper ul.pagination-list li .pagination-btn .arrow-icon {
  max-width: 16px;
  margin: 0 0 2px;
}
.pagination-wrapper-main .pagination-wrapper .show-result {
  margin-bottom: 0;
  text-align: right;
}
@media screen and (max-width: 767px) {
  .pagination-wrapper-main .pagination-wrapper .show-result {
    margin: 12px 0 0;
    text-align: center;
  }
}

.pre-registration-page .modal-backdrop {
  -webkit-backdrop-filter: unset;
          backdrop-filter: unset;
  background: transparent;
  opacity: 1;
}

.deposit-wallet-modal .modal-dialog {
  max-width: 1099px;
}
.deposit-wallet-modal .modal-dialog .modal-content {
  padding: 0;
  border-radius: 16px;
  background: #DEEBF8;
  overflow: visible;
}
@media screen and (max-width: 1199px) {
  .deposit-wallet-modal .modal-dialog .modal-content {
    margin: 0 10px;
  }
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body {
  padding: 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-header {
  padding: 16px 24px 24px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-header h3 {
  margin-bottom: 0;
  font-weight: 800;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-header .reset-wrapper {
  text-align: right;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-header .reset-wrapper a img {
  max-width: 11px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body {
  padding: 0 24px 24px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item:not(:last-of-type) {
  margin-bottom: 24px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item > h3 {
  margin-bottom: 12px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group {
  margin-bottom: 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .form-control {
  border: 1px solid #B5D2DF;
  border-radius: 4px;
  padding: 12px;
  height: 48px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #000000;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .form-control::placeholder {
  color: #7F9AA6;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-header .nav {
  background: transparent;
  text-align: left;
  display: inline-block;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-header .nav .nav-item {
  display: inline-block;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-header .nav .nav-item:not(:last-of-type) {
  margin: 0 8px 0 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-header .nav .nav-item .nav-link {
  width: 354px;
  height: 58px;
  background: transparent;
  padding: 4px 12px;
  border: 1px solid #B5D2DF;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-header .nav .nav-item .nav-link {
    width: 300px;
  }
}
@media screen and (max-width: 767px) {
  .deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-header .nav .nav-item .nav-link {
    width: 150px;
    height: 45px;
  }
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-header .nav .nav-item .nav-link.active {
  background: #424A53;
  border-color: #424A53;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-header .nav .nav-item .nav-link.active p {
  color: #ffffff;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-header .nav .nav-item .nav-link p {
  color: #000000;
  margin-bottom: 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .send-to-tabs .tabs-body .tab-content .tab-pane .deposit-item {
  margin-top: 24px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card {
  border: 1px solid #B5D2DF;
  border-radius: 4px;
  padding: 12px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card {
  min-height: 168px;
  margin: 11px 0 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .search-wrapper-v1 {
  max-width: 310px;
  margin-bottom: 10px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .no-wallet-wrapper {
  text-align: center;
  padding: 20px 30px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .no-wallet-wrapper .icon-wrapper {
  margin-bottom: 6px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .no-wallet-wrapper .icon-wrapper img {
  max-width: 24px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .no-wallet-wrapper h3 {
  font-weight: 500;
  margin-bottom: 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .user-wallet-wrapper {
  display: grid;
  grid-template-columns: repeat(5, calc(20% - 6.5px));
  column-gap: 8px;
  row-gap: 8px;
  margin: 6px 0 0;
}
@media screen and (max-width: 767px) {
  .deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .user-wallet-wrapper {
    grid-template-columns: repeat(2, calc(50% - 4.5px));
  }
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .user-wallet-wrapper .wallet-card {
  background: #D8E6F5;
  padding: 12px;
  border-radius: 4px;
  cursor: pointer;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .user-wallet-wrapper .wallet-card .icon-wrapper {
  margin-bottom: 11px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .user-wallet-wrapper .wallet-card .icon-wrapper img {
  max-width: 24px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .user-wallet-wrapper .wallet-card h3 {
  line-height: 22px;
  font-weight: 500;
  margin-bottom: 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .qrcode-wrapper {
  text-align: center;
  padding: 28px 12px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .qrcode-wrapper .qr-img {
  margin-bottom: 16px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .qrcode-wrapper .qr-img img {
  max-width: 168px;
  margin: auto;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .qrcode-wrapper .qr-content p {
  margin-bottom: 16px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card.deposit-search-card .qrcode-wrapper .qr-content .btn-style {
  height: 36px;
  border-width: 1px;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
}
@media screen and (max-width: 767px) {
  .deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs {
    display: block;
  }
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header {
  height: 32px;
}
@media screen and (max-width: 767px) {
  .deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header {
    margin-bottom: 12px;
  }
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav {
  background: transparent;
  text-align: left;
  display: inline-block;
  border-radius: 4px;
  overflow: hidden;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item {
  display: inline-block;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item .nav-link {
  background: transparent;
  padding: 4px 12px;
  border-radius: 0;
  height: 32px;
  border: 1px solid #C3DBE5;
  position: relative;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item .nav-link.active {
  background: #424A53;
  border-color: #424A53;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item .nav-link.active p {
  color: #ffffff;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item .nav-link p {
  color: #6C7B82;
  margin-bottom: 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-body .tab-content .tab-pane .amount-input input {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #000000;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-body .tab-content .tab-pane .amount-input input::placeholder {
  color: #000000;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-total {
  text-align: right;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-total p {
  margin-bottom: 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-footer {
  padding: 24px;
  background: #CEDDEB;
  border-radius: 0 0 16px 16px;
}
@media screen and (max-width: 767px) {
  .deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-footer {
    padding: 12px 24px;
  }
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-footer ul.btn-list {
  text-align: right;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-footer ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-footer ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
.deposit-wallet-modal .modal-dialog .modal-content .modal-body .deposit-wallet-wrapper .wallet-footer ul.btn-list li .btn-style {
  min-width: 179px;
}

.deposit-select-wallet-modal.fiat-deposit-modal .modal-dialog {
  max-width: 811px;
}
.deposit-select-wallet-modal.assets-withdraw-modal .modal-dialog {
  max-width: 1099px;
}
.deposit-select-wallet-modal.assets-withdraw-funds-modal .modal-dialog {
  max-width: 809px;
}
.deposit-select-wallet-modal .modal-dialog {
  max-width: 549px;
}
.deposit-select-wallet-modal .modal-dialog .modal-content {
  padding: 0;
  border-radius: 16px;
  background: #DEEBF8;
  overflow: visible;
}
@media screen and (max-width: 1199px) {
  .deposit-select-wallet-modal .modal-dialog .modal-content {
    margin: 0 10px;
  }
}
.deposit-select-wallet-modal .modal-dialog .modal-content .modal-body {
  padding: 0;
}
.deposit-select-wallet-modal.offcanvas {
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}
.deposit-select-wallet-modal.offcanvas.h-402 {
  height: 402px;
}
.deposit-select-wallet-modal.offcanvas.h-468 {
  height: 488px;
}
.deposit-select-wallet-modal.offcanvas.h-510 {
  height: 510px;
}
.deposit-select-wallet-modal.offcanvas.h-566 {
  height: 566px;
}
.deposit-select-wallet-modal.offcanvas.h-595 {
  height: 595px;
}
.deposit-select-wallet-modal.offcanvas.h-610 {
  height: 610px;
}
.deposit-select-wallet-modal.offcanvas.h-635 {
  height: 635px;
}
.deposit-select-wallet-modal.offcanvas.h-644 {
  height: 644px;
}
.deposit-select-wallet-modal .offcanvas-header {
  display: none;
}
.deposit-select-wallet-modal .offcanvas-body {
  padding: 0;
  border-radius: 0;
  background: #DEEBF8;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header {
  padding: 24px 24px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header {
    padding: 24px 16px;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header h3 {
  margin-bottom: 0;
  font-weight: 800;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header .reset-wrapper {
  text-align: right;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header .reset-wrapper a img {
  max-width: 11px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header .available-funds {
  text-align: right;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header .available-funds h3 {
    font-size: 16px;
    line-height: 24px;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header .selected-coin {
  display: flex;
  align-items: center;
  justify-content: right;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header .selected-coin .icon {
  display: grid;
  grid-template-columns: 32px 1fr;
  column-gap: 8px;
  align-items: center;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header .selected-coin .icon img {
  max-width: 32px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-header .selected-coin p {
  margin-bottom: 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body {
  padding: 0 24px 24px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body {
    padding: 0 16px 24px;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .otc-compare-wrapper {
  display: grid;
  grid-template-columns: 1fr 20px 1fr;
  column-gap: 18px;
  align-items: center;
  margin-bottom: 24px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .otc-compare-wrapper {
    column-gap: 0;
    grid-template-columns: auto;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .otc-compare-wrapper .deposit-item:not(:last-of-type) {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .otc-compare-wrapper .compare-icon {
    margin: 20px 0 0;
    text-align: center;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item:not(:last-of-type) {
  margin-bottom: 24px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item > h3 {
  margin-bottom: 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item > h3 br.mobile {
  display: none;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item > h3 br.mobile {
    display: block;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .wallet-address-text {
  margin: 12px 0 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .item-header {
  margin-bottom: 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .item-header h3 {
  margin-bottom: 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .item-header p {
  margin-bottom: 0;
  text-align: right;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group {
  margin-bottom: 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .amount-wrapper {
  display: grid;
  grid-template-columns: 38px 1fr;
  align-items: center;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .amount-wrapper .icon {
  width: 38px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px 0 0 4px;
  border: 1px solid #B5D2DF;
  border-right: unset;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .amount-wrapper .icon p {
  margin-bottom: 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .amount-wrapper .form-control {
  border-radius: 0 4px 4px 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .form-control {
  border: 1px solid #B5D2DF;
  border-radius: 4px;
  padding: 12px;
  height: 48px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #000000;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .form-control::placeholder {
  color: #7F9AA6;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .form-control.black-placeholder::placeholder {
  color: #000000;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .form:not(.search-form) .form-group .form-control.otp-input {
  letter-spacing: 31px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card {
  border: 1px solid #B5D2DF;
  border-radius: 4px;
  padding: 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .qrcode-wrapper {
  text-align: center;
  padding: 28px 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .qrcode-wrapper .qr-img {
  margin-bottom: 16px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .qrcode-wrapper .qr-img img {
  max-width: 168px;
  margin: auto;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .qrcode-wrapper .qr-content p {
  margin-bottom: 16px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .qrcode-wrapper .qr-content .btn-style {
  height: 36px;
  border-width: 1px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .qrcode-wrapper .qr-content .btn-style {
    min-width: 270px;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-total {
  text-align: right;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-total p {
  margin-bottom: 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs {
    display: block;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header {
  height: 32px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header {
    margin-bottom: 12px;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav {
  background: transparent;
  text-align: left;
  display: inline-block;
  border-radius: 4px;
  overflow: hidden;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item {
  display: inline-block;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item .nav-link {
  background: transparent;
  padding: 4px 12px;
  border-radius: 0;
  height: 32px;
  border: 1px solid #C3DBE5;
  position: relative;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item .nav-link.active {
  background: #424A53;
  border-color: #424A53;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item .nav-link.active p {
  color: #ffffff;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-header .nav .nav-item .nav-link p {
  color: #6C7B82;
  margin-bottom: 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-body .tab-content .tab-pane .amount-input input {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #000000;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .deposit-card .amount-tabs .tabs-body .tab-content .tab-pane .amount-input input::placeholder {
  color: #000000;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .scan-qr-wrapper {
  text-align: center;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .deposit-wrapper .deposit-item .scan-qr-wrapper p {
  color: #7F9AA6;
  margin-bottom: 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main > h3 {
  margin-bottom: 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-header {
  margin-bottom: 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-header h3 {
  margin-bottom: 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-header ul.share-list {
  text-align: right;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-header ul.share-list li {
  vertical-align: middle;
  display: inline-block;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-header ul.share-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-header ul.share-list li a img {
  max-width: 16px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper {
  overflow: auto;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper::-webkit-scrollbar {
  background-color: #DEEBF8;
  width: 10px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper::-webkit-scrollbar-track {
  background-color: #DEEBF8;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper::-webkit-scrollbar-thumb {
  background-color: #95ACB6;
  border-radius: 16px;
  border: 3px solid #DEEBF8;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper::-webkit-scrollbar-button {
  display: none;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper .account-card {
  border: 1px solid #B5D2DF;
  border-radius: 4px;
  padding: 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper .account-card:not(:last-of-type) {
  margin: 0 0 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper .account-card .bank-name {
  display: grid;
  grid-template-columns: 13px 1fr;
  align-items: center;
  column-gap: 7.33px;
  margin-bottom: 7px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper .account-card .bank-name .icon img {
  max-width: 13px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper .account-card .bank-name p {
  margin: 4px 0 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper .account-card ul.account-detail-list li {
  display: block;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper .account-card ul.account-detail-list li:not(:last-of-type) {
  margin: 0 0 12px;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper .account-card ul.account-detail-list li p {
  margin-bottom: 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .account-detail-main .account-detail-wrapper .account-card ul.account-detail-list li p.title {
  color: #9AADB6;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper {
  margin-top: 24px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper {
    text-align: center;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper p {
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper p {
    margin-bottom: 15px;
    line-height: 22px;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper p br.mobile {
  display: none;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper p br.mobile {
    display: block;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper ul.btn-list {
  text-align: right;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper ul.btn-list {
    text-align: center;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper ul.btn-list li {
    display: block;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper ul.btn-list li .btn-style {
  min-width: 204px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-body .upload-wrapper ul.btn-list li .btn-style {
    min-width: 100%;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-footer {
  padding: 24px;
  background: #CEDDEB;
  border-radius: 0 0 16px 16px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-footer {
    border-radius: 0;
    padding: 13px 16px;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-footer ul.btn-list {
  text-align: right;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-footer ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-footer ul.btn-list li {
    display: block;
  }
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-footer ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
.deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-footer ul.btn-list li .btn-style {
  min-width: 179px;
}
@media screen and (max-width: 767px) {
  .deposit-select-wallet-modal .deposit-wallet-wrapper .wallet-footer ul.btn-list li .btn-style {
    min-width: 100%;
  }
}

.user-auth-modal .modal-dialog {
  max-width: 1280px;
}
.user-auth-modal .modal-dialog .modal-content {
  padding: 0;
  border-radius: 12px;
  background: #DEEBF8;
}
@media screen and (max-width: 1199px) {
  .user-auth-modal .modal-dialog .modal-content {
    margin: 0 10px;
  }
}
.user-auth-modal .modal-dialog .modal-content .modal-body {
  padding: 40px;
}
@media screen and (max-width: 767px) {
  .user-auth-modal .modal-dialog .modal-content .modal-body {
    padding: 22px;
  }
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper {
  max-width: 381px;
  margin: auto;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper > h2 {
  margin-bottom: 8px;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper > p {
  margin-bottom: 50px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper > p a {
  color: #0074d4;
  font-weight: 700;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group {
  margin-bottom: 22px;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group.mb-16 {
  margin-bottom: 16px;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit {
  margin-bottom: 0;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit .login-option {
  margin: 16px 0 0;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit .login-option p {
  display: flex;
  align-items: center;
  gap: 8px;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit .login-option p a {
  color: #0074d4;
  font-weight: 700;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group.flex {
  display: grid;
  grid-template-columns: 20px auto;
  align-items: center;
  column-gap: 8px;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group.flex label {
  margin-bottom: 0;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group .key-input {
  position: relative;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group .key-input .form-control {
  padding: 9px 40px 9px 12px;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group .key-input .icon {
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 22px;
  cursor: pointer;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group .more-link {
  text-align: right;
  margin: 4px 0 0;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .form.auth-form .form-group .more-link a {
  color: #0074d4;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .social-wrapper {
  margin: 30px 0 0;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .social-wrapper .or-line {
  margin: 0;
  text-align: center;
  position: relative;
  display: block;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .social-wrapper .or-line:before {
  content: "";
  width: 100%;
  height: 1px;
  background: #000000;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .social-wrapper .or-line span {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  color: #000000;
  background: #DEEBF8;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .social-wrapper ul.social-login {
  text-align: center;
  margin: 20px 0 0;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .social-wrapper ul.social-login li {
  display: inline-block;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .social-wrapper ul.social-login li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .social-wrapper ul.social-login li a img {
  max-width: 30px;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .auth-footer {
  margin: 50px 0 0;
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .auth-footer a.auth-logo img {
  filter: brightness(0) saturate(100%);
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .form-wrapper .auth-footer p.copyright {
  text-align: right;
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .auth-right-img {
    display: none;
  }
}
.user-auth-modal .modal-dialog .modal-content .modal-body .user-auth-wrapper .auth-right-img img {
  width: 100%;
  height: 778px;
  object-fit: cover;
  border-radius: 12px;
}

.user-auth-offcanvas {
  width: 100% !important;
  background: #E6F2FE;
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .user-auth-offcanvas {
    width: 650px !important;
  }
}
.user-auth-offcanvas .offcanvas-header {
  position: absolute;
  top: 0;
  right: 0;
}
.user-auth-offcanvas .offcanvas-header .btn-close {
  border: none;
  outline: none;
  box-shadow: none;
}
.user-auth-offcanvas .offcanvas-body {
  padding: 0;
}
@media screen and (max-width: 767px) {
  .user-auth-offcanvas .offcanvas-body {
    padding: 40px 22px;
  }
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main {
  display: grid;
  grid-template-columns: 55% 45%;
  height: 100%;
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main {
    display: block;
  }
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .auth-laptop-imga img {
  width: 100%;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .auth-laptop-img {
  background: #D5E8FB;
  height: 100%;
  display: flex;
  justify-content: right;
  align-items: self-end;
  text-align: right;
  padding-top: 80px;
}
@media screen and (max-height: 710px) {
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .auth-laptop-img {
    padding-top: 40px;
  }
}
@media screen and (max-width: 1199px) {
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .auth-laptop-img {
    display: none;
  }
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .auth-laptop-img img {
  width: calc(100% - 185px);
  max-height: calc(100vh - 80px);
  object-fit: contain;
}
@media screen and (min-width: 2000px) {
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .auth-laptop-img img {
    width: auto;
  }
}
@media screen and (max-width: 1400px) and (min-width: 1200px) {
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .auth-laptop-img img {
    width: calc(100% - 40px);
  }
}
@media screen and (max-height: 710px) {
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .auth-laptop-img img {
    max-height: 100vh;
    width: calc(100% - 185px);
  }
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: auto;
}
@media screen and (max-width: 767px) {
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper {
    height: auto;
  }
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper::-webkit-scrollbar {
    background-color: #DEEBF8;
    width: 16px;
  }
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper::-webkit-scrollbar-track {
    background-color: #DEEBF8;
  }
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper::-webkit-scrollbar-thumb {
    background-color: #000000;
    border-radius: 16px;
    border: 4px solid #DEEBF8;
  }
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper::-webkit-scrollbar-button {
    display: none;
  }
}
@media screen and (max-height: 710px) {
  .user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper {
    padding: 60px 0;
  }
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper {
  width: 100%;
  max-width: 412px;
  margin: auto;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper > h3 {
  margin-bottom: 33px;
  text-align: center;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper ul.social-auth {
  text-align: center;
  margin: 0 0 33px;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper ul.social-auth li {
  display: block;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper ul.social-auth li:not(:last-of-type) {
  margin: 0 0 22px;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper ul.social-auth li .btn-style {
  min-width: 100%;
  height: 55px;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper ul.social-auth li .btn-style img {
  max-width: 24px;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group {
  margin-bottom: 24px;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit {
  margin-bottom: 0;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit .btn-style {
  height: 55px;
  font-weight: 700;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit .no-account {
  margin: 33px 0 0;
  text-align: center;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group.submit .no-account p {
  margin-bottom: 0;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group label {
  font-size: 18px;
  line-height: 25px;
  font-weight: 700;
  margin-bottom: 12px;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .otp-text {
  margin-bottom: 33px;
  text-align: center;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .resend-otp {
  text-align: right;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .resend-otp label {
  cursor: pointer;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .form-control {
  height: 48px;
  font-size: 16px;
  line-height: 22px;
  border-color: #B5D2DF;
  color: #000000;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .form-control::placeholder {
  color: #8097A2;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .form-control.otp-input {
  letter-spacing: 31px;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .key-input {
  position: relative;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .key-input .form-control {
  padding: 9px 40px 9px 12px;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .key-input .icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 24px;
  cursor: pointer;
}
.user-auth-offcanvas .offcanvas-body .user-auth-wrapper-main .user-auth-wrapper .form-wrapper .form.auth-form .form-group .more-link {
  margin: 12px 0 0;
}
.pre-registration-modal .modal-dialog {
  max-width: 600px;
}
.pre-registration-modal .modal-dialog .modal-content {
  padding: 0;
  border-radius: 16px;
  background: #ffffff;
  overflow: visible;
}
@media screen and (max-width: 1199px) {
  .pre-registration-modal .modal-dialog .modal-content {
    margin: 0 10px;
  }
}
.pre-registration-modal .modal-dialog .modal-content .modal-body {
  padding: 0;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .pre-registration-card {
  padding: 24px;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .pre-registration-card h3 {
  margin-bottom: 12px;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .pre-registration-card p {
  margin-bottom: 10px;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .pre-registration-card ul.feature-list {
  margin-bottom: 15px;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .pre-registration-card ul.feature-list li {
  display: block;
  position: relative;
  padding-left: 15px;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .pre-registration-card ul.feature-list li:not(:last-of-type) {
  margin: 0 0 10px 0;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .pre-registration-card ul.feature-list li:before {
  content: "";
  background: #191D23;
  width: 5px;
  height: 5px;
  border-radius: 50px;
  position: absolute;
  left: 0;
  top: 8px;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .registration-footer {
  padding: 16px;
  border-top: 1px solid #AFB0B0;
  background: #ffffff;
  border-radius: 0 0 16px 16px;
  text-align: right;
}
@media screen and (max-width: 767px) {
  .pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .registration-footer {
    border-radius: 0;
    padding: 13px 16px;
  }
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .registration-footer ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .registration-footer ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
.pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .registration-footer ul.btn-list li .btn-style {
  min-width: 179px;
}
@media screen and (max-width: 767px) {
  .pre-registration-modal .modal-dialog .modal-content .modal-body .pre-registration-wrapper .registration-footer ul.btn-list li .btn-style {
    min-width: 100%;
  }
}

.sec-choose-wallet {
  padding-bottom: 40px;
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet {
    padding-bottom: 30px;
  }
}
.sec-choose-wallet.sec-no-wallet .choose-wallet-main {
  margin: -200px 0 0;
}
.sec-choose-wallet .choose-wallet-main {
  margin: -140px 0 0;
  height: auto;
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .choose-wallet-main {
    margin: -290px 0 0;
  }
}
.sec-choose-wallet .choose-wallet-wrapper {
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 10px));
  column-gap: 20px;
  align-items: center;
  position: relative;
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .choose-wallet-wrapper {
    grid-template-columns: 1fr;
    row-gap: 20px;
  }
}
.sec-choose-wallet .choose-wallet-wrapper.no-grid {
  display: block;
}
.sec-choose-wallet .choose-wallet-wrapper p.or {
  width: 61px;
  height: 53px;
  padding: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  line-height: 20px;
  border-radius: 8px;
  background: #E6F2FE;
  border: 1px solid #C8C8C8;
  box-shadow: 0 4px 60px 0 rgba(0, 0, 0, 0.1490196078);
  z-index: 1;
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .choose-wallet-wrapper p.or {
    top: calc(50% - 14px);
  }
}
.sec-choose-wallet .choose-wallet-wrapper .wallet-card {
  background: #E6F2FE;
  border: 1px solid #C8C8C8;
  border-radius: 16px;
  min-height: 471px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
  text-align: center;
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-choose-wallet .choose-wallet-wrapper .wallet-card {
    min-height: 380px;
    padding: 22px 30px;
  }
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .choose-wallet-wrapper .wallet-card {
    min-height: auto;
    padding: 40px 60px;
  }
}
.sec-choose-wallet .choose-wallet-wrapper .wallet-card .card-content {
  width: 100%;
}
.sec-choose-wallet .choose-wallet-wrapper .wallet-card .card-content .icon-wrapper {
  margin-bottom: 20px;
}
.sec-choose-wallet .choose-wallet-wrapper .wallet-card .card-content .icon-wrapper img {
  max-width: 96px;
}
.sec-choose-wallet .choose-wallet-wrapper .wallet-card .card-content .content-wrapper h3.title {
  margin-bottom: 0;
}
@media screen and (max-width: 1199px) {
  .sec-choose-wallet .choose-wallet-wrapper .wallet-card .card-content .content-wrapper h3.title {
    font-size: 26px;
    line-height: 34px;
  }
}
.sec-choose-wallet .choose-wallet-wrapper .wallet-card .card-content .content-wrapper p {
  margin: 20px 0;
}
@media screen and (max-width: 1199px) {
  .sec-choose-wallet .choose-wallet-wrapper .wallet-card .card-content .content-wrapper p {
    margin: 12px 0 20px;
    font-size: 16px;
    line-height: 24px;
  }
}
.sec-choose-wallet .choose-wallet-wrapper .wallet-card .card-content .content-wrapper a.arrow-icon img {
  max-width: 49px;
}
.sec-choose-wallet .choose-wallet-wrapper .no-wallet-card {
  padding: 73px 60px;
  background: #E6F2FE;
  border: 1px solid #C8C8C8;
  border-radius: 16px;
  min-height: 298px;
  text-align: center;
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .choose-wallet-wrapper .no-wallet-card {
    padding: 40px;
    min-height: auto;
  }
}
.sec-choose-wallet .choose-wallet-wrapper .no-wallet-card h3 {
  margin-bottom: 0;
}
@media screen and (max-width: 1199px) {
  .sec-choose-wallet .choose-wallet-wrapper .no-wallet-card h3 {
    font-size: 26px;
    line-height: 34px;
  }
}
.sec-choose-wallet .choose-wallet-wrapper .no-wallet-card p {
  margin: 20px 0;
}
@media screen and (max-width: 1199px) {
  .sec-choose-wallet .choose-wallet-wrapper .no-wallet-card p {
    margin: 12px 0 20px;
    font-size: 16px;
    line-height: 24px;
  }
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .choose-wallet-wrapper .no-wallet-card ul.btn-list {
    margin-top: 13px;
  }
}
.sec-choose-wallet .choose-wallet-wrapper .no-wallet-card ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-choose-wallet .choose-wallet-wrapper .no-wallet-card ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
@media screen and (max-width: 991px) {
  .sec-choose-wallet .choose-wallet-wrapper .no-wallet-card ul.btn-list li:not(:last-of-type) {
    margin: 0 8px 0 0;
  }
}
.sec-choose-wallet .wallet-table-wrapper {
  padding: 24px;
  background: #E6F2FE;
  border: 1px solid #C8C8C8;
  border-radius: 16px;
  min-height: 298px;
  overflow: auto;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list {
  /*height: 500px;
  overflow: auto;
  @media screen and (max-width: \$screen-xs) {
    height: 362px;
  }*/
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list.desktop {
  display: block;
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list.desktop {
    display: none;
  }
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list::-webkit-scrollbar {
  background-color: #DEEBF8;
  width: 16px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list::-webkit-scrollbar-track {
  background-color: #DEEBF8;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list::-webkit-scrollbar-thumb {
  background-color: #000000;
  border-radius: 16px;
  border: 4px solid #DEEBF8;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list::-webkit-scrollbar-button {
  display: none;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-4 {
  display: grid;
  grid-template-columns: 400px 215px 215px 330px;
  column-gap: 10px;
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-4 {
    grid-template-columns: 340px 205px 205px 330px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 992px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-4 {
    grid-template-columns: 280px 190px 190px 295px;
    min-width: 995px;
  }
}
@media screen and (max-width: 991px) and (min-width: 768px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-4 {
    grid-template-columns: 270px 150px 150px 295px;
    min-width: 905px;
  }
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-4 {
    grid-template-columns: 250px 140px 140px 265px;
    min-width: 834px;
  }
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-5 {
  display: grid;
  grid-template-columns: 220px 198px 198px 198px 330px;
  column-gap: 10px;
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-5 {
    grid-template-columns: 200px 170px 180px 175px 330px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-5 {
    grid-template-columns: 200px 130px 130px 105px 295px;
    min-width: 910px;
  }
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-5 {
    grid-template-columns: 185px 105px 120px 75px 265px;
    min-width: 807px;
  }
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-7 {
  display: grid;
  grid-template-columns: 44px 148px 195px 155px 130px 225px 225px;
  column-gap: 10px;
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-7 {
    grid-template-columns: 44px 148px 195px 155px 130px 225px 225px;
    min-width: 1192px;
  }
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-8 {
  display: grid;
  grid-template-columns: 35px 35px 210px 200px 170px 140px 130px 190px;
  column-gap: 10px;
}
@media screen and (max-width: 1280px) and (min-width: 1200px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-8 {
    grid-template-columns: 35px 35px 195px 185px 160px 120px 115px 185px;
  }
}
@media screen and (max-width: 1199px) and (min-width: 768px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-8 {
    min-width: 1195px;
  }
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .grid-8 {
    grid-template-columns: 44px 44px 244px 244px 180px 160px 130px 180px;
  }
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .table-header {
  padding: 20px 8px;
  border-bottom: 1px solid #B5D2DF;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .table-header.style-v2 {
  border-top: 1px solid #B5D2DF;
  border-bottom: 1px solid #B5D2DF;
  background: #CEDDEB;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .table-header .asset-item:first-of-type {
  padding-left: 40px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .table-header .asset-item p {
  margin-bottom: 0;
  font-weight: 800;
  color: #787878;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .table-header .asset-item p img {
  cursor: pointer;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card {
  padding: 17px 8px;
  border-bottom: 1px solid #B5D2DF;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item p {
  margin-bottom: 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item .transaction-name img {
  max-width: 18px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item .transaction-name p {
  margin-bottom: 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper {
  display: grid;
  grid-template-columns: 51px 1fr;
  column-gap: 10px;
  align-items: center;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .icon img {
  max-width: 51px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .wallet-icon {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #D2DEEB;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .wallet-icon .wallet-icon {
  max-width: 21px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .wallet-icon .tag-icon {
  position: absolute;
  right: -3px;
  bottom: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #ffffff;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .content p {
  margin-bottom: 0;
  color: #4E4E4E;
  font-weight: 600;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item .name-wrapper .content p.title {
  color: #191D23;
  font-weight: 800;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item ul.btn-list {
  text-align: center;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .asset-card .asset-item ul.btn-list li:not(:last-of-type) {
  margin: 0 8px 0 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list .show-more {
  text-align: center;
  margin-top: 20px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile {
  display: none;
}
@media screen and (max-width: 767px) {
  .sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile {
    display: block;
  }
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #B5D2DF;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card:not(:last-of-type) {
  margin: 0 0 16px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card .transaction-icon {
  margin-bottom: 12px;
  padding: 6px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card .transaction-icon img {
  max-width: 18px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: space-between;
  column-gap: 12px;
  row-gap: 12px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li:nth-of-type(even) {
  text-align: left;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li p {
  margin-bottom: 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li p.f-10 {
  color: #4E4E4E;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper {
  display: grid;
  grid-template-columns: 36px 1fr;
  column-gap: 10px;
  align-items: center;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .icon img {
  max-width: 36px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .wallet-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #D2DEEB;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .wallet-icon .wallet-icon {
  max-width: 21px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .wallet-icon .tag-icon {
  position: absolute;
  right: -3px;
  bottom: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #ffffff;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .content p {
  margin-bottom: 0;
  color: #4E4E4E;
  font-weight: 600;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-detail li .name-wrapper .content p.title {
  color: #191D23;
  font-weight: 800;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card .approved-date {
  margin: 12px 0 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card .approved-date p {
  margin-bottom: 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card .approved-date p.f-10 {
  color: #4E4E4E;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-btn {
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 6px));
  align-items: center;
  justify-content: space-between;
  column-gap: 8px;
  margin: 11px 0 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-btn li {
  display: block;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.asset-btn li .btn-style {
  height: 38px;
  min-width: 100%;
  font-size: 14px;
  line-height: 22px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.trade-date-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.trade-date-list li p {
  margin-bottom: 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.trade-date-list li p.f-10 {
  color: #4E4E4E;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.source-date-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.source-date-list li p {
  margin-bottom: 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.source-date-list li p.f-10 {
  color: #4E4E4E;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.source-date-list li p.wallet-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.destination-date-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.destination-date-list li p {
  margin-bottom: 0;
}
.sec-choose-wallet .wallet-table-wrapper .asset-list-wrapper .asset-list-mobile .asset-list-card ul.destination-date-list li p.f-10 {
  color: #4E4E4E;
}

.sec-broadcast-transaction {
  padding: 45px 0 60px;
}
@media screen and (max-width: 767px) {
  .sec-broadcast-transaction {
    padding: 40px 0;
  }
}
.sec-broadcast-transaction .container > h3 {
  margin-bottom: 24px;
}
.sec-broadcast-transaction .broadcast-wrapper {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #B5D2DF;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-body {
  padding: 24px;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-body .deposit-wrapper .deposit-item:not(:last-of-type) {
  margin-bottom: 12px;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-body .deposit-wrapper .deposit-item > h3 {
  margin-bottom: 12px;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-body .deposit-wrapper .deposit-item .form .form-group {
  margin-bottom: 0;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-body .deposit-wrapper .deposit-item .custom-select {
  background: transparent;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-body .deposit-wrapper .deposit-item .btn-wrapper {
  text-align: right;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-footer {
  padding: 24px;
  background: #CEDDEB;
}
@media screen and (max-width: 767px) {
  .sec-broadcast-transaction .broadcast-wrapper .broadcast-footer {
    padding: 12px 24px;
  }
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-footer ul.btn-list {
  text-align: right;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-footer ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-footer ul.btn-list li:not(:last-of-type) {
  margin: 0 12px 0 0;
}
.sec-broadcast-transaction .broadcast-wrapper .broadcast-footer ul.btn-list li .btn-style {
  min-width: 197px;
}
@media screen and (max-width: 767px) {
  .sec-broadcast-transaction .broadcast-wrapper .broadcast-footer ul.btn-list li .btn-style {
    min-width: 120px;
  }
}

footer {
  padding: 24px;
  background: #DCEAF7;
  border-top: 1px solid #CEDDEB;
}
footer .link-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
}
@media screen and (max-width: 767px) {
  footer .link-wrapper {
    display: block;
    text-align: center;
  }
}
@media screen and (max-width: 767px) {
  footer .link-wrapper ul.link-list {
    margin-bottom: 12px;
  }
}
footer .link-wrapper ul.link-list li {
  display: inline-block;
  vertical-align: middle;
}
footer .link-wrapper ul.link-list li:not(:last-of-type) {
  margin: 0 28px 0 0;
}
footer .link-wrapper ul.link-list li a {
  color: #7F9AA6;
  font-size: 16px;
  line-height: 25px;
}
@media screen and (max-width: 767px) {
  footer .link-wrapper ul.link-list li a {
    font-size: 14px;
    line-height: 22px;
  }
}
footer .link-wrapper ul.social-list li {
  display: inline-block;
  vertical-align: middle;
}
footer .link-wrapper ul.social-list li:not(:last-of-type) {
  margin: 0 10px 0 0;
}
footer .link-wrapper ul.social-list li a img {
  max-width: 16px;
}

body.landing-page-body {
  background: #ffffff;
  padding: 0;
}

@media screen and (max-width: 767px) {
  .d-visible {
    display: none !important;
  }
}

.m-visible {
  display: none;
}
@media screen and (max-width: 767px) {
  .m-visible {
    display: block !important;
  }
}

@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner .container,
  .sec-hubrid-setup .container,
  .sec-digital-asset .container,
  .sec-mobile-wallet .container,
  .sec-trading-desk .container,
  .sec-security .container,
  .sec-compliance .container {
    max-width: 1140px;
  }
}

.landing-header {
  position: absolute;
  top: 45px;
  left: 0;
  width: 100%;
  z-index: 2;
}
@media screen and (max-width: 767px) {
  .landing-header {
    top: 9px;
  }
}
@media screen and (max-width: 767px) {
  .landing-header.menu-open .header-wrapper {
    border-radius: 8px 8px 0 0;
  }
}
.landing-header .header-wrapper {
  padding: 20px 32px;
  border-radius: 8px;
  background: #090F17;
  box-shadow: 0px 4px 52px 0px rgba(0, 0, 0, 0.1490196078);
  max-width: 787px;
  margin: auto;
  display: grid;
  grid-template-columns: 109px 1fr;
  justify-content: space-between;
  column-gap: 30px;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper {
    grid-template-columns: 72px 1fr;
    max-width: 328px;
    padding: 16px 24px;
  }
}
.landing-header .header-wrapper .logo-wrapper a.logo img {
  max-width: 109px;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .logo-wrapper a.logo img {
    max-width: 72px;
  }
}
.landing-header .header-wrapper .navbar-menu .menu-bar {
  display: none;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu .menu-bar {
    display: block;
    text-align: right;
  }
}
.landing-header .header-wrapper .navbar-menu .menu-bar img {
  max-width: 20px;
}
.landing-header .header-wrapper .navbar-menu ul.menu {
  text-align: right;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu {
    position: fixed;
    top: 66px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 328px;
    height: auto;
    box-shadow: 0 4px 52px 0 rgba(0, 0, 0, 0.1490196078);
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    display: none;
  }
  .landing-header .header-wrapper .navbar-menu ul.menu.active {
    display: block;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li {
    display: block;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li:not(:last-of-type) {
  margin: 0 25px 0 0;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li:not(:last-of-type) {
    margin: 0;
    border-bottom: 1px solid #D3E7F1;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li.arrow {
  margin: 0 45px 0 0;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li.arrow {
    margin: 0;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li.arrow:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: cover;
  width: 6px;
  height: 9px;
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li.arrow:before {
    width: 12px;
    right: 24px;
    filter: brightness(0) saturate(100%) invert(0%) sepia(97%) saturate(0%) hue-rotate(43deg) brightness(95%) contrast(102%);
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li a {
  color: #ffffff;
  font-weight: 400;
  display: inline-block;
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li a {
    display: block;
    font-weight: 500;
    text-align: left;
    color: #000000;
    padding: 20px 33px 20px 28px;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #090F17;
  border-radius: 8px;
  box-shadow: 0px 4px 52px 0px rgba(0, 0, 0, 0.1490196078);
  min-width: 180px;
  padding: 8px 0;
  margin-top: 8px;
  display: none;
  z-index: 1000;
}
.landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu.show {
  display: block;
}
.landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu li {
  display: block;
  margin: 0;
  border-bottom: none;
}
.landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu li a {
  color: #ffffff;
  padding: 12px 20px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  transition: background-color 0.2s ease;
}
.landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu li a:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu li a {
    color: #000000;
    padding: 15px 20px;
  }
  .landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu li a:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu {
    position: static;
    background: #ffffff;
    box-shadow: none;
    border-radius: 0;
    margin-top: 0;
    padding: 0;
    display: block;
  }
  .landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu.show {
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu {
    display: none;
  }
  .landing-header .header-wrapper .navbar-menu ul.menu li.dropdown .dropdown-menu.show {
    display: block;
  }
}
.landing-header .header-wrapper .navbar-menu ul.menu li.dropdown.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.landing-header .header-wrapper .navbar-menu ul.menu li.dropdown.disabled > a {
  cursor: not-allowed;
  color: rgba(255, 255, 255, 0.5);
}
@media screen and (max-width: 767px) {
  .landing-header .header-wrapper .navbar-menu ul.menu li.dropdown.disabled > a {
    color: rgba(0, 0, 0, 0.5);
  }
}

.sec-landing-banner {
  position: relative;
}
.sec-landing-banner:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner:before {
    background: transparent;
    width: 16px;
  }
}
.sec-landing-banner:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner:before, .sec-landing-banner:after {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .container {
    padding: 0;
  }
}
.sec-landing-banner .banner-wrapper {
  position: relative;
  margin: 0 60px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner .banner-wrapper {
    margin: 0 30px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper {
    margin: 0;
  }
}
.sec-landing-banner .banner-wrapper .bg-img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 390px) {
  .sec-landing-banner .banner-wrapper .bg-img {
    min-height: 650px;
  }
}
.sec-landing-banner .banner-wrapper .banner-content {
  position: absolute;
  top: 192px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 899px;
  text-align: center;
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content {
    top: 90px;
    padding: 0 16px;
  }
}
.sec-landing-banner .banner-wrapper .banner-content .banner-tag {
  padding: 12px 16px;
  min-height: 42px;
  border-radius: 8px;
  border: 1px solid #E4E4E4;
  display: inline-flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 32px;
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content .banner-tag {
    text-align: left;
    margin-bottom: 24px;
  }
}
.sec-landing-banner .banner-wrapper .banner-content .banner-tag img {
  max-width: 20px;
}
.sec-landing-banner .banner-wrapper .banner-content .banner-tag p {
  color: #424A53;
  margin-bottom: 0;
}
.sec-landing-banner .banner-wrapper .banner-content h1 {
  font-size: 72px;
  line-height: 80px;
  font-weight: 500;
  color: #000000;
  margin: 0;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-landing-banner .banner-wrapper .banner-content h1 {
    font-size: 60px;
    line-height: 70px;
  }
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content h1 {
    font-size: 40px;
    line-height: 50px;
  }
}
.sec-landing-banner .banner-wrapper .banner-content h3 {
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.9);
  margin: 32px 0;
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content h3 {
    margin: 24px 0;
    font-size: 14px;
    line-height: 22px;
  }
  .sec-landing-banner .banner-wrapper .banner-content h3 br {
    display: none;
  }
}
.sec-landing-banner .banner-wrapper .banner-content ul.btn-list li {
  display: inline-block;
  vertical-align: middle;
}
.sec-landing-banner .banner-wrapper .banner-content ul.btn-list li:not(:last-of-type) {
  margin: 0 16px 0 0;
}
@media screen and (max-width: 767px) {
  .sec-landing-banner .banner-wrapper .banner-content ul.btn-list li .btn-style {
    height: 36px;
    min-width: 111px;
  }
}

.sec-hubrid-setup {
  padding: 145px 0;
  position: relative;
  border-top: 1px solid #D3E7F1;
  border-bottom: 1px solid #D3E7F1;
}
.sec-hubrid-setup:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-hubrid-setup:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-hubrid-setup:before {
    background: transparent;
    width: 16px;
  }
}
.sec-hubrid-setup:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-hubrid-setup:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-hubrid-setup:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-hubrid-setup {
    padding: 90px 0;
  }
}
@media screen and (max-width: 767px) {
  .sec-hubrid-setup {
    padding: 41px 0;
  }
}
.sec-hubrid-setup .content-wrapper h2 {
  text-transform: capitalize;
}
.sec-hubrid-setup .content-wrapper h2 b {
  font-weight: 400;
  color: #92A9B3;
}

.sec-digital-asset {
  padding: 96px 0;
  border-bottom: 1px solid #D3E7F1;
  position: relative;
}
.sec-digital-asset:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-digital-asset:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-digital-asset:before {
    width: 16px;
  }
}
.sec-digital-asset:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-digital-asset:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-digital-asset:after {
    width: 16px;
  }
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-digital-asset {
    padding: 70px 0;
  }
}
@media screen and (max-width: 767px) {
  .sec-digital-asset {
    padding: 40px 0 30px;
    border-bottom: unset;
  }
}
.sec-digital-asset:before, .sec-digital-asset:after {
  height: calc(100% + 1px);
}
@media screen and (max-width: 767px) {
  .sec-digital-asset:before, .sec-digital-asset:after {
    height: 100%;
  }
}
.sec-digital-asset .content-wrapper h2 {
  text-transform: capitalize;
  margin-bottom: 16px;
}
@media screen and (max-width: 767px) {
  .sec-digital-asset .content-wrapper h2 {
    margin-bottom: 8px;
  }
}
.sec-digital-asset .content-wrapper h3 {
  color: rgba(47, 47, 47, 0.9);
  margin: 0;
}
@media screen and (max-width: 767px) {
  .sec-digital-asset .content-wrapper h3 {
    font-size: 14px;
    line-height: 22px;
  }
}

.sec-mobile-wallet {
  padding: 47px 0 0;
  border-bottom: 1px solid #D3E7F1;
  position: relative;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet {
    padding: 30px 0 8px;
    border-bottom: unset;
  }
}
.sec-mobile-wallet:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-mobile-wallet:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet:before {
    width: 16px;
  }
}
.sec-mobile-wallet:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-mobile-wallet:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet:after {
    width: 16px;
  }
}
.sec-mobile-wallet:before, .sec-mobile-wallet:after {
  height: calc(100% + 1px);
}
.sec-mobile-wallet .wallet-card:not(:last-of-type) {
  margin-bottom: 47px;
}
.sec-mobile-wallet .wallet-card:nth-of-type(even) .col-md-6:nth-of-type(1) {
  order: 2;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card:nth-of-type(even) .col-md-6:nth-of-type(1) {
    order: 1;
  }
}
.sec-mobile-wallet .wallet-card:nth-of-type(even) .col-md-6:nth-of-type(2) {
  order: 1;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card:nth-of-type(even) .col-md-6:nth-of-type(2) {
    order: 2;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper {
  padding: 0 40px;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper {
    padding: 0 20px;
    margin-bottom: 31px;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper h3 {
  font-family: "Gabarito";
  text-transform: capitalize;
  margin: 0 0 16px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-mobile-wallet .wallet-card .content-wrapper h3 {
    font-size: 25px;
    line-height: 33px;
  }
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper h3 {
    font-weight: 400;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 18px;
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.9);
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li {
    font-size: 16px;
    line-height: 24px;
  }
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li {
    padding-left: 14px;
    font-size: 14px;
    line-height: 22px;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li:not(:last-of-type) {
  margin: 0 0 12px;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li:not(:last-of-type) {
    margin: 0 0 6px;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li:before {
  content: "";
  background: rgba(47, 47, 47, 0.9);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 10px;
}
@media screen and (max-width: 767px) {
  .sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li:before {
    width: 4px;
    height: 4px;
  }
}
.sec-mobile-wallet .wallet-card .content-wrapper ul.feature-list li a img {
  max-width: 16px;
}
.sec-mobile-wallet .wallet-card .img-wrapper img {
  width: 100%;
}

.sec-trading-desk {
  position: relative;
  border-bottom: 1px solid #D3E7F1;
}
.sec-trading-desk:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-trading-desk:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk:before {
    width: 16px;
  }
}
.sec-trading-desk:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-trading-desk:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk {
    border-bottom: unset;
    padding-bottom: 32px;
  }
}
.sec-trading-desk:before, .sec-trading-desk:after {
  height: calc(100% + 1px);
}
.sec-trading-desk .trading-grid {
  display: grid;
  grid-template-columns: repeat(2, 50%);
  align-items: self-start;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid {
    grid-template-columns: 1fr;
  }
}
.sec-trading-desk .trading-grid .trading-card {
  padding: 64px 40px;
  min-height: 313px;
  display: grid;
  column-gap: 16px;
  grid-template-columns: 1fr 134px;
  align-items: self-start;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card {
    grid-template-columns: 1fr;
    padding: 32px 20px;
    min-height: auto;
  }
}
.sec-trading-desk .trading-grid .trading-card:first-of-type {
  border-right: 1px solid #D3E7F1;
}
.sec-trading-desk .trading-grid .trading-card .content h3 {
  font-family: "Gabarito";
  text-transform: capitalize;
  margin: 0 0 16px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-trading-desk .trading-grid .trading-card .content h3 {
    font-size: 20px;
    line-height: 28px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .content h3 {
    font-size: 24px;
    line-height: 32px;
    display: grid;
    column-gap: 16px;
    grid-template-columns: 1fr 68px;
    align-items: center;
  }
}
.sec-trading-desk .trading-grid .trading-card .content h3 img {
  display: none;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .content h3 img {
    display: block;
    width: 100%;
    border-radius: 8px;
  }
}
.sec-trading-desk .trading-grid .trading-card .content ul.feature-list li {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 18px;
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.9);
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-trading-desk .trading-grid .trading-card .content ul.feature-list li {
    font-size: 16px;
    line-height: 24px;
  }
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .content ul.feature-list li {
    padding-left: 14px;
    font-size: 14px;
    line-height: 22px;
  }
}
.sec-trading-desk .trading-grid .trading-card .content ul.feature-list li:not(:last-of-type) {
  margin: 0 0 3px;
}
.sec-trading-desk .trading-grid .trading-card .content ul.feature-list li:before {
  content: "";
  background: rgba(47, 47, 47, 0.9);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 10px;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .content ul.feature-list li:before {
    width: 4px;
    height: 4px;
  }
}
.sec-trading-desk .trading-grid .trading-card .content ul.feature-list li a img {
  max-width: 16px;
}
.sec-trading-desk .trading-grid .trading-card .icon {
  align-self: end;
}
@media screen and (max-width: 767px) {
  .sec-trading-desk .trading-grid .trading-card .icon {
    display: none;
  }
}
.sec-trading-desk .trading-grid .trading-card .icon img {
  width: 100%;
  border-radius: 16px;
}

.sec-security {
  position: relative;
  border-bottom: 1px solid #E5E5E5;
}
.sec-security:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-security:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-security:before {
    width: 16px;
  }
}
.sec-security:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-security:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-security:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-security {
    padding: 32px 0 25px;
  }
}
.sec-security .security-grid {
  display: grid;
  grid-template-columns: 1fr 466px;
  column-gap: 6px;
  align-items: center;
}
@media screen and (max-width: 767px) {
  .sec-security .security-grid {
    grid-template-columns: 1fr;
  }
}
.sec-security .security-grid .content {
  padding-left: 40px;
}
@media screen and (max-width: 767px) {
  .sec-security .security-grid .content {
    padding: 0 20px 24px;
  }
}
.sec-security .security-grid .content h3 {
  color: #000000;
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .sec-security .security-grid .content h3 {
    font-size: 14px;
    line-height: 22px;
    color: rgba(47, 47, 47, 0.9);
  }
}
.sec-security .security-grid .img-wrapper img {
  width: 100%;
  height: 315px;
  object-fit: cover;
}
@media screen and (max-width: 767px) {
  .sec-security .security-grid .img-wrapper img {
    height: 148px;
  }
}

.sec-compliance {
  position: relative;
  border-bottom: 1px solid #D3E7F1;
}
.sec-compliance:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-compliance:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance:before {
    background: transparent;
    width: 16px;
  }
}
.sec-compliance:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-compliance:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance:after {
    background: transparent;
    width: 16px;
  }
}
.sec-compliance .compliance-wrapper {
  padding: 85px 0 238px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
  background-position: bottom;
  background-size: cover;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper {
    padding: 40px 0 148px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat;
    background-position: bottom;
    background-size: contain;
  }
}
.sec-compliance .compliance-wrapper .bg-img {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateY(-50%);
}
.sec-compliance .compliance-wrapper > h2 {
  text-transform: capitalize;
  margin-bottom: 24px;
  text-align: center;
}
.sec-compliance .compliance-wrapper > h3 {
  margin-bottom: 48px;
  text-align: center;
}
.sec-compliance .compliance-wrapper ul.feature-list {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: 32px;
  row-gap: 25px;
  max-width: 1017px;
  margin: auto;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list {
    column-gap: 0;
    row-gap: 0;
    margin: auto 4px;
  }
}
.sec-compliance .compliance-wrapper ul.feature-list:has(li) li:nth-of-type(1),
.sec-compliance .compliance-wrapper ul.feature-list:has(li) li:nth-of-type(2),
.sec-compliance .compliance-wrapper ul.feature-list:has(li) li:nth-of-type(3) {
  grid-column: span 4;
}
.sec-compliance .compliance-wrapper ul.feature-list li {
  grid-column: span 3;
}
.sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(1) .feature-card {
  border-right: 1px solid #C4E3F2 !important;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(1), .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(2) {
    grid-column: span 6 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(1) .feature-card, .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(2) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(3) {
    grid-column: span 7 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(3) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
    border-right: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(4) {
    grid-column: span 5 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(4) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(5) {
    grid-column: span 5 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(5) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
    border-right: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(6) {
    grid-column: span 7 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(6) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
  }
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(7) {
    grid-column: span 12 !important;
  }
  .sec-compliance .compliance-wrapper ul.feature-list li:nth-of-type(7) .feature-card {
    border: unset;
    border-top: 1px solid #C4E3F2 !important;
    border-bottom: 1px solid #C4E3F2 !important;
  }
}
.sec-compliance .compliance-wrapper ul.feature-list li .feature-card {
  padding: 32px 20px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #C4E3F2;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li .feature-card {
    height: 100%;
    border-radius: 0;
    padding: 22px 16px;
  }
}
.sec-compliance .compliance-wrapper ul.feature-list li .feature-card h3 {
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
  color: #000000;
  font-family: "Gabarito";
  margin: 0;
}
@media screen and (max-width: 767px) {
  .sec-compliance .compliance-wrapper ul.feature-list li .feature-card h3 {
    font-size: 14px;
    line-height: 20px;
  }
}

.sec-partnerships {
  position: relative;
}
.sec-partnerships:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships:before {
    width: 16px;
  }
}
.sec-partnerships:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships:after {
    width: 16px;
  }
}
.sec-partnerships .partnerships-wrapper {
  padding: 80px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships .partnerships-wrapper {
    padding: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper {
    padding: 48px 0;
  }
}
.sec-partnerships .partnerships-wrapper:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: repeat;
  background-size: cover;
  height: 80px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-bottom: 1px solid #D3E7F1;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper:before {
    height: 48px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  }
}
.sec-partnerships .partnerships-wrapper:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: repeat;
  background-size: cover;
  height: 80px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  border-top: 1px solid #D3E7F1;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper:after {
    height: 48px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid {
  display: grid;
  grid-template-columns: 298px 298px 1fr;
  align-items: self-start;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid {
    grid-template-columns: 1fr;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card {
  padding: 40px;
  min-height: 327px;
  display: flex;
  align-items: center;
  justify-content: left;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card {
    padding: 32px;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card {
    padding: 32px 16px;
    min-height: auto;
    text-align: center;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:not(:last-of-type) {
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:not(:last-of-type) {
    border: unset;
    border-bottom: 1px solid #D3E7F1;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:nth-child(1) {
    order: 3;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:nth-child(2) {
    order: 2;
  }
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card:nth-child(3) {
    order: 1;
  }
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper h2 {
    font-size: 32px;
    line-height: 38px;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper h3 {
  color: #000000;
  font-family: "Gabarito";
  margin-bottom: 16px;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper h3 {
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 26px;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper p {
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.9);
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper p {
    font-size: 14px;
    line-height: 22px;
    color: #000000;
  }
}
.sec-partnerships .partnerships-wrapper .partnerships-grid .partnerships-card .content-wrapper p.black {
  color: #000000;
}

.sec-join {
  padding: 128px 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center;
  background-size: cover;
  position: relative;
}
.sec-join:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-join:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-join:before {
    background: transparent;
    width: 16px;
  }
}
.sec-join:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-join:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-join:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .sec-join {
    padding: 72px 0 80px;
  }
}
.sec-join:before, .sec-join:after {
  border-color: #424A53;
}
.sec-join .content-wrapper {
  text-align: center;
}
.sec-join .content-wrapper h2 {
  color: #ffffff;
  margin-bottom: 0;
}
.sec-join .content-wrapper p {
  font-weight: 500;
  color: #ffffff;
}
@media screen and (max-width: 767px) {
  .sec-join .content-wrapper p {
    font-size: 14px;
    line-height: 22px;
    margin: 16px 0 24px;
  }
  .sec-join .content-wrapper p br {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .sec-join .content-wrapper .btn-style {
    min-width: 296px;
    font-weight: 700;
  }
}

.sec-meeting {
  position: relative;
  border-bottom: 1px solid #D3E7F1;
}
.sec-meeting:before {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-meeting:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-meeting:before {
    width: 16px;
  }
}
.sec-meeting:after {
  content: "";
  background: #ffffff;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-meeting:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-meeting:after {
    width: 16px;
  }
}
.sec-meeting:before, .sec-meeting:after {
  border-color: #E5E5E5;
  z-index: 2;
}
@media screen and (max-width: 767px) {
  .sec-meeting:before, .sec-meeting:after {
    border-color: #D3E7F1;
  }
}
.sec-meeting .container-fluid {
  padding: 0;
}
.sec-meeting .partnerships-wrapper {
  padding: 80px;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-meeting .partnerships-wrapper {
    padding: 80px 40px;
  }
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper {
    padding: 48px 0;
  }
}
.sec-meeting .partnerships-wrapper:before {
  content: "";
  background: transparent;
  height: 80px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-bottom: 1px solid #E5E5E5;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper:before {
    height: 48px;
    border-color: #D3E7F1;
  }
}
.sec-meeting .partnerships-wrapper:after {
  content: "";
  background: transparent;
  height: 80px;
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  border-top: 1px solid #E5E5E5;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper:after {
    height: 48px;
    border-color: #D3E7F1;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid {
  display: grid;
  grid-template-columns: 1fr 237px 237px;
  align-items: self-start;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid {
    grid-template-columns: 1fr;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card {
  padding: 40px;
  min-height: 266px;
  display: flex;
  align-items: center;
  justify-content: left;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card {
    padding: 24px;
    min-height: auto;
    text-align: center;
    display: block;
  }
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card:first-of-type {
    padding: 32px 28px;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card:not(:first-of-type) {
  background: #F3F9FF;
  border: 1px solid #D3E7F1;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card:not(:first-of-type) {
    border: unset;
    border-top: 1px solid #D3E7F1;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card:not(:last-of-type) {
  border-right: unset;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper h2 {
    font-size: 32px;
    line-height: 38px;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper h3 {
  color: #000000;
  font-family: "Gabarito";
  margin-bottom: 16px;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper h3 {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 8px;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper a.f-24 {
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
  color: #000000;
  font-family: "Gabarito";
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper a.f-24 {
    font-size: 18px;
    line-height: 26px;
  }
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper a.f-24 br {
    display: none;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p {
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 0;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p {
    font-size: 14px;
    line-height: 22px;
  }
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p br {
    display: none;
  }
}
.sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p:not(:last-of-type) {
  margin-bottom: 16px;
}
@media screen and (max-width: 767px) {
  .sec-meeting .partnerships-wrapper .meeting-grid .meeting-card .content-wrapper p:not(:last-of-type) {
    margin-bottom: 8px;
  }
}

.landing-footer {
  position: relative;
  min-height: 332px;
  padding-bottom: 27px;
  display: flex;
  align-items: self-end;
  background: #010102;
}
.landing-footer:before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .landing-footer:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .landing-footer:before {
    background: transparent;
    width: 16px;
  }
}
.landing-footer:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-position: right;
  background-repeat: repeat;
  background-size: cover;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .landing-footer:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .landing-footer:after {
    background: transparent;
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .landing-footer {
    padding-bottom: 16px;
    min-height: 160px;
  }
}
.landing-footer:before, .landing-footer:after {
  border-color: #424A53;
  z-index: 2;
}
.landing-footer .bg-img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: contain;
  object-position: top;
}
.landing-footer .content-wrapper {
  text-align: center;
  position: relative;
  z-index: 1;
}
.landing-footer .content-wrapper p {
  font-weight: 300;
  color: rgba(255, 255, 255, 0.4);
  margin: 0;
}
@media screen and (max-width: 767px) {
  .landing-footer .content-wrapper p {
    font-size: 10px;
    line-height: 16px;
  }
}

.landing-bottom-footer {
  position: relative;
  padding: 18px 0;
  background: #010102;
  border-top: 1px solid #494949;
}
.landing-bottom-footer:before {
  content: "";
  background: #010102;
  width: 80px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-right: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .landing-bottom-footer:before {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .landing-bottom-footer:before {
    width: 16px;
  }
}
.landing-bottom-footer:after {
  content: "";
  background: #010102;
  width: 80px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid #D3E7F1;
  z-index: 1;
}
@media screen and (max-width: 1450px) and (min-width: 1200px) {
  .landing-bottom-footer:after {
    width: 40px;
  }
}
@media screen and (max-width: 767px) {
  .landing-bottom-footer:after {
    width: 16px;
  }
}
@media screen and (max-width: 767px) {
  .landing-bottom-footer {
    padding: 16px 0;
  }
}
.landing-bottom-footer:before, .landing-bottom-footer:after {
  border-color: #494949;
  z-index: 2;
}
.landing-bottom-footer .content-wrapper {
  text-align: center;
  position: relative;
  z-index: 1;
}
.landing-bottom-footer .content-wrapper p {
  font-weight: 300;
  color: #F7F7F7;
  margin: 0;
}
@media screen and (max-width: 767px) {
  .landing-bottom-footer .content-wrapper p {
    font-size: 10px;
    line-height: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_standard.scss","webpack://./src/assets/scss/main.scss","webpack://./src/assets/scss/_landing-page.scss","webpack://./src/assets/scss/_xdc-landing.scss"],"names":[],"mappings":"AAoCA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAXM;EAYN,sBAvCQ;EAwCR,mBAlCa;ACEf;;ADiIA;EACE,iBAAA;AC9HF;;ADgIA;EACE,kBAAA;EACA,mBAAA;AC7HF;AD8HE;EAHF;IAII,kBAAA;IACA,mBAAA;EC3HF;AACF;;ADkIA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAnJe;EAoJf,uBA/JS;ACgCX;ADgIE;EANF;IAOI,eAAA;IACA,iBAAA;EC7HF;AACF;;AD+HA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA9Je;EA+Jf,uBA1KS;AC8CX;AD8HE;EAPF;IAQI,eAAA;IACA,iBAAA;EC3HF;AACF;AD4HE;EACE,gBAAA;AC1HJ;AD4HE;EACE,gBAAA;AC1HJ;AD4HE;EACE,eAAA;EACA,iBAAA;AC1HJ;AD2HI;EAHF;IAII,eAAA;IACA,iBAAA;ECxHJ;AACF;ADyHI;EAPF;IAQI,eAAA;IACA,iBAAA;ECtHJ;EDuHI;IACE,aAAA;ECrHN;AACF;;ADyHA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA/Le;EAgMf,sBA1MQ;ACoFV;AD2HE;EACE,eAAA;EACA,iBAAA;ACzHJ;AD+HE;EACE,eAAA;EACA,iBAAA;AC7HJ;ADmIE;EACE,eAAA;EACA,iBAAA;ACjIJ;ADkII;EAHF;IAII,eAAA;IACA,iBAAA;EC/HJ;AACF;ADiIE;EACE,eAAA;EACA,iBAAA;AC/HJ;ADgII;EAHF;IAII,eAAA;IACA,iBAAA;EC7HJ;AACF;AD+HE;EACE,eAAA;EACA,iBAAA;AC7HJ;AD8HI;EAHF;IAII,eAAA;IACA,iBAAA;EC3HJ;AACF;AD6HE;EACE,eAAA;EACA,iBAAA;AC3HJ;AD4HI;EAHF;IAII,eAAA;IACA,iBAAA;ECzHJ;AACF;AD4HE;EACE,gBAAA;AC1HJ;AD4HE;EACE,gBAAA;AC1HJ;AD4HE;EACE,gBAAA;AC1HJ;AD6HE;EACE,uBA5QO;ACiJX;;AD8HA;EACE,eAAA;EACA,iBAAA;AC3HF;ADiIA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAhRe;EAiRf,sBA3RQ;AC4JV;ADgIE;EACE,gBAAA;AC9HJ;ADgIE;EACE,gBAAA;AC9HJ;ADgIE;EACE,gBAAA;AC9HJ;ADgIE;EACE,gBAAA;AC9HJ;ADiIE;EACE,eAAA;EACA,iBAAA;AC/HJ;ADiIE;EACE,eAAA;EACA,iBAAA;AC/HJ;ADiIE;EACE,eAAA;EACA,iBAAA;AC/HJ;ADiIE;EACE,eAAA;EACA,iBAAA;AC/HJ;ADiIE;EACE,eAAA;EACA,iBAAA;AC/HJ;ADiIE;EACE,eAAA;EACA,iBAAA;AC/HJ;ADkIE;EACE,+BAnTa;ACmLjB;;ADmIA;EACE,eAAA;EACA,iBAAA;EACA;;;IAAA;AC7HF;;ADkIA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAxUe;EAyUf,sBAnVQ;ACoNV;ADgIE;EACE,gBAAA;AC9HJ;;ADiIA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAjVe;EAkVf,sBA7VQ;EA8VR,qBAAA;AC9HF;;ADgIA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA1Ve;EA2Vf,sBArWQ;EAsWR,qBAAA;AC7HF;AD8HE;EACE,cA9Va;EA+Vb,qBAAA;AC5HJ;AD8HE;EACE,gBAAA;AC5HJ;AD8HE;EACE,gBAAA;AC5HJ;AD+HE;EACE,eAAA;EACA,iBAAA;AC7HJ;AD+HE;EACE,eAAA;EACA,iBAAA;AC7HJ;AD8HI;EAHF;IAII,eAAA;IACA,iBAAA;EC3HJ;AACF;;AD8HA;EACE,eAAA;EACA,gBAAA;AC3HF;AD4HE;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA9Xa;EA+Xb,sBAzYM;AC+QV;;AD8HA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cA3XM;EA4XN,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAzZQ;EA0ZR,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAlYM;EAmYN,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,6BAAA;AC3HF;AD4HE;EArBF;IAsBI,eAAA;IACA,iBAAA;IACA,YAAA;IACA,kBAAA;ECzHF;AACF;AD0HE;EACE,gCAAA;EACA,mBA/YI;EAgZJ,yBAAA;EACA,cAlZI;AC0RR;ADyHI;EACE,UAAA;EACA,UAAA;EACA,SAAA;EACA,sCAAA;EACA,uCAAA;EACA,kCAAA;ACvHN;ADyHI;EACE,4BAAA;ACvHN;AD0HE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;ACxHJ;AD0HE;EACE,0HAAA;EACA,eAAA;ACxHJ;AD0HE;EACE,iEAAA;ACxHJ;AD0HE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,0IAAA;EACA,UAAA;EACA,4BAAA;ACxHJ;AD0HE;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;ACxHJ;AD0HE;EACE,iBAAA;EACA,YAAA;ACxHJ;AD0HE;EACE,uBAAA;EACA,qBAjcI;EAkcJ,cAlcI;EAmcJ,kBAAA;EACA,gBAAA;ACxHJ;ADyHI;EANF;IAOI,eAAA;IACA,iBAAA;IACA,gBAAA;ECtHJ;AACF;ADuHI;EACE,aAAA;ACrHN;ADuHI;EACE,qBA/cE;EAgdF,cAhdE;AC2VR;ADwHE;EACE,cA3eQ;EA4eR,0BAAA;EACA,mBAAA;EACA,eAAA;EAGA,8HAAA;EACA,6BAAA;ACxHJ;AD0HE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,cA3fQ;ACmYZ;AD0HE;EACE,mBAAA;ACxHJ;AD0HE;EACE,6CAAA;ACxHJ;AD0HE;EACE,eAAA;ACxHJ;AD0HE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;ACxHJ;AD0HE;EACE,4BAAA;EACA,8EAAA;EACA,YAAA;EACA,YAAA;ACxHJ;AD0HE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;ACxHJ;ADyHI;EACE,eAAA;ACvHN;AD0HE;EACE,mBA9hBQ;EA+hBR,cAxgBI;EAygBJ,qBAhiBQ;ACwaZ;ADyHI;EACE,uBAAA;EACA,cAniBM;EAoiBN,qBApiBM;AC6aZ;AD0HE;EACE,mBAjhBI;EAkhBJ,cAjhBI;EAkhBJ,qBAnhBI;AC2ZR;ADyHI;EACE,mBArhBE;EAshBF,cArhBE;EAshBF,qBAvhBE;ACgaR;ADwHM;EACE,aAAA;ACtHR;;AD6HE;EACE,mBAAA;AC1HJ;AD4HM;EACE,aAAA;AC1HR;AD4HM;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;AC1HR;AD2HQ;EACE,kBAAA;ACzHV;AD2HY;EACE,eAAA;ACzHd;AD2HY;EACE,gBAAA;EACA,kBAAA;ACzHd;AD0Hc;EACE,eAAA;ACxHhB;AD4Hc;EADF;IAEI,gBAAA;ECzHd;AACF;AD+HI;EACE,kBAAA;AC7HN;AD+HQ;EACE,0BAAA;AC7HV;AD+HQ;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AC7HV;ADgIM;EACE,0BAAA;AC9HR;ADgIM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AC9HR;ADoIU;EACE,oBAAA;AClIZ;ADoIU;EACE,aAAA;AClIZ;ADoIU;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AClIZ;ADmIY;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,yBAAA;ACjId;ADmIY;EACE,yBAppBF;EAqpBE,qBArpBF;EAspBE,oCAAA;ACjId;ADsIc;EACE,qBA5pBJ;ACwhBZ;ADsIc;EACE,uCAAA;ACpIhB;AD4IM;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;AC1IR;AD4IM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,wBAAA;AC1IR;AD2IQ;EACE,UAAA;EACA,qBAhqBF;EAiqBE,mBAjqBF;ACwhBR;AD0IU;EACE,UAAA;ACxIZ;AD2IQ;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,8CAAA;EACA,UAAA;EACA,UAAA;ACzIV;AD6II;EACE,mDAAA;EACA,4BAAA;EACA,qBAAA;EACA,0CAAA;EACA,0BAAA;AC3IN;AD8IE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAltBa;EAmtBb,oBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AC5IJ;AD6II;EACE,eAAA;EACA,iBAAA;EACA,cAxsBA;EAysBA,kBAAA;EACA,QAAA;AC3IN;AD8IE;EACE,iBAAA;EACA,YAAA;AC5IJ;AD8IE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAtuBa;EAuuBb,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AC5IJ;AD6II;EACE,cA/uBW;AComBjB;AD6II;EACE,gBAAA;AC3IN;;ADwJA;;;OAAA;AE1wBE;EACE,mBFuBI;EEtBJ,UAAA;ADynBJ;;ACrnBE;EADF;IAEI,wBAAA;EDynBF;AACF;;ACvnBA;EACE,aAAA;AD0nBF;ACznBE;EAFF;IAGI,yBAAA;ED4nBF;AACF;;ACvnBI;EADF;IAEI,iBAAA;ED2nBJ;AACF;;ACvnBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cFJM;EEKN,0BAAA;AD0nBF;ACznBE;EANF;IAOI,eAAA;IACA,iBAAA;ED4nBF;AACF;AC3nBE;EAVF;IAWI,eAAA;IACA,iBAAA;ED8nBF;AACF;AC7nBE;EACE,gBAAA;AD+nBJ;AC7nBE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AD+nBJ;;AC3nBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;AD8nBF;AC7nBE;EANF;IAOI,QAAA;EDgoBF;AACF;AC7nBM;EADF;IAEI,0BAAA;EDgoBN;AACF;AC7nBE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wDAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,8BAAA;EACA,gBAAA;AD+nBJ;AC9nBI;EAXF;IAYI,+BAAA;IACA,gBAAA;IACA,kBAAA;EDioBJ;AACF;AC9nBQ;EACE,gBAAA;ADgoBV;AC/nBU;EAFF;IAGI,eAAA;EDkoBV;AACF;AC7nBM;EACE,aAAA;AD+nBR;AC9nBQ;EAFF;IAGI,cAAA;IACA,iBAAA;EDioBR;AACF;AChoBQ;EACE,eAAA;ADkoBV;AC/nBM;EACE,iBAAA;ADioBR;AChoBQ;EAFF;IAGI,eAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;IACA,WAAA;IACA,gBAAA;IACA,YAAA;IACA,oDAAA;IACA,mBF1FF;IE2FE,0BAAA;IACA,aAAA;EDmoBR;ECloBQ;IACE,cAAA;EDooBV;AACF;ACloBQ;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;ADooBV;ACnoBU;EAJF;IAKI,cAAA;EDsoBV;AACF;ACroBU;EACE,kBAAA;ADuoBZ;ACtoBY;EAFF;IAGI,SAAA;IACA,gCAAA;EDyoBZ;AACF;ACvoBU;EACE,kBAAA;ADyoBZ;ACxoBY;EAFF;IAGI,SAAA;ED2oBZ;AACF;AC1oBY;EACE,WAAA;EACA,oEAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AD4oBd;AC3oBc;EAVF;IAWI,WAAA;IACA,WAAA;IACA,wHAAA;ED8oBd;AACF;AC3oBU;EACE,cFtIJ;EEuII,gBAAA;EACA,qBAAA;AD6oBZ;AC5oBY;EAJF;IAKI,cAAA;IACA,gBAAA;IACA,gBAAA;IACA,cF5IN;IE6IM,4BAAA;ED+oBZ;AACF;;ACvoBA;EACE,kBAAA;AD0oBF;ADmDE;EACE,WAAA;EACA,mDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACjDJ;ADkDI;EAXF;IAYI,WAAA;EC/CJ;AACF;ADgDI;EAdF;IAeI,uBAAA;IACA,WAAA;EC7CJ;AACF;ADoDE;EACE,WAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;AClDJ;ADmDI;EAZF;IAaI,WAAA;EChDJ;AACF;ADiDI;EAfF;IAgBI,uBAAA;IACA,WAAA;EC9CJ;AACF;ACrrBI;EADF;IAEI,aAAA;EDwrBJ;AACF;ACrrBI;EADF;IAEI,UAAA;EDwrBJ;AACF;ACtrBE;EACE,kBAAA;EACA,cAAA;ADwrBJ;ACvrBI;EAHF;IAII,cAAA;ED0rBJ;AACF;ACzrBI;EANF;IAOI,SAAA;ED4rBJ;AACF;AC3rBI;EACE,WAAA;EACA,YAAA;AD6rBN;AC3rBI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AD6rBN;AC5rBM;EARF;IASI,SAAA;IACA,eAAA;ED+rBN;AACF;AC9rBM;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;ADgsBR;AC/rBQ;EATF;IAUI,gBAAA;IACA,mBAAA;EDksBR;AACF;ACjsBQ;EACE,eAAA;ADmsBV;ACjsBQ;EACE,cAAA;EACA,gBAAA;ADmsBV;AChsBM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cFtNA;EEuNA,SAAA;ADksBR;ACjsBQ;EANF;IAOI,eAAA;IACA,iBAAA;EDosBR;AACF;ACnsBQ;EAVF;IAWI,eAAA;IACA,iBAAA;EDssBR;AACF;ACpsBM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;ADssBR;ACrsBQ;EANF;IAOI,cAAA;IACA,eAAA;IACA,iBAAA;EDwsBR;ECvsBQ;IACE,aAAA;EDysBV;AACF;ACrsBQ;EACE,qBAAA;EACA,sBAAA;ADusBV;ACtsBU;EACE,kBAAA;ADwsBZ;ACrsBY;EADF;IAEI,YAAA;IACA,gBAAA;EDwsBZ;AACF;;AChsBA;EACE,kBAAA;EACA,sBAAA;ADmsBF;ADpHE;EACE,WAAA;EACA,mDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACsHJ;ADrHI;EAXF;IAYI,WAAA;ECwHJ;AACF;ADvHI;EAdF;IAeI,uBAAA;IACA,WAAA;EC0HJ;AACF;ADnHE;EACE,WAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;ACqHJ;ADpHI;EAZF;IAaI,WAAA;ECuHJ;AACF;ADtHI;EAfF;IAgBI,uBAAA;IACA,WAAA;ECyHJ;AACF;AC/uBE;EALF;IAMI,qBAAA;EDkvBF;AACF;ACjvBE;EACE,yBF7QI;EE8QJ,UAAA;ADmvBJ;AClvBI;EAHF;IAII,aAAA;EDqvBJ;AACF;AClvBI;EADF;IAEI,UAAA;EDqvBJ;AACF;ACnvBE;EACE,kBAAA;EACA,cAAA;ADqvBJ;ACpvBI;EAHF;IAII,cAAA;EDuvBJ;AACF;ACtvBI;EANF;IAOI,SAAA;EDyvBJ;AACF;ACxvBI;EACE,kBAAA;AD0vBN;ACzvBM;EACE,WAAA;EACA,YAAA;AD2vBR;ACzvBM;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AD2vBR;ACzvBU;EACE,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBFpVF;AC+kCV;ACtvBI;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;ADwvBN;ACvvBM;EAJF;IAKI,SAAA;IACA,eAAA;ED0vBN;AACF;ACzvBM;EACE,SAAA;AD2vBR;ACzvBM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;AD2vBR;AC1vBQ;EANF;IAOI,cAAA;IACA,eAAA;IACA,iBAAA;ED6vBR;EC5vBQ;IACE,aAAA;ED8vBV;AACF;AC1vBQ;EACE,qBAAA;EACA,sBAAA;AD4vBV;AC3vBU;EACE,kBAAA;AD6vBZ;AC5vBY;EAFF;IAGI,iBAAA;ED+vBZ;AACF;AC7vBU;EACE,sBF9XF;AC6nCV;AC9vBY;EAFF;IAGI,iBAAA;IACA,YAAA;IACA,gBAAA;EDiwBZ;AACF;;ACzvBA;EACE,kBAAA;EACA,iBAAA;AD4vBF;ADzOE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;AC2OJ;AD1OI;EAVF;IAWI,WAAA;EC6OJ;AACF;AD5OI;EAbF;IAcI,WAAA;EC+OJ;AACF;ADxOE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;AC0OJ;ADzOI;EAVF;IAWI,WAAA;EC4OJ;AACF;AD3OI;EAbF;IAcI,WAAA;EC8OJ;AACF;ACnyBE;EALF;IAMI,gBAAA;EDsyBF;AACF;ACryBE;EACE,wBAAA;ADuyBJ;ACtyBI;EAFF;IAGI,YAAA;IACA,aAAA;EDyyBJ;AACF;;ACryBA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gCAAA;ADwyBF;ADxSE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;AC0SJ;ADzSI;EAVF;IAWI,WAAA;EC4SJ;AACF;AD3SI;EAbF;IAcI,WAAA;EC8SJ;AACF;ADvSE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACySJ;ADxSI;EAVF;IAWI,WAAA;EC2SJ;AACF;AD1SI;EAbF;IAcI,WAAA;EC6SJ;AACF;AC/0BE;EAPF;IAQI,oBAAA;EDk1BF;AACF;ACj1BE;EACE,wBAAA;ADm1BJ;ACl1BI;EAFF;IAGI,YAAA;EDq1BJ;AACF;ACl1BI;EACE,kBAAA;EACA,mBAAA;ADo1BN;ACj1BE;EACE,aAAA;EACA,uCAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;ADm1BJ;ACl1BI;EANF;IAOI,4BAAA;IACA,aAAA;EDq1BJ;AACF;ACp1BI;EAVF;IAWI,2BAAA;IACA,aAAA;EDu1BJ;AACF;ACt1BI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;ADw1BN;ACv1BM;EAJF;IAKI,UAAA;IACA,YAAA;ED01BN;AACF;ACz1BM;EACE,mBAAA;AD21BR;AC11BQ;EAFF;IAGI,mBAAA;ED61BR;AACF;AC51BQ;EACE,kBAAA;AD81BV;AC71BU;EAFF;IAGI,eAAA;IACA,iBAAA;EDg2BV;AACF;AC91BQ;EACE,4BAAA;EACA,gBAAA;ADg2BV;AC/1BU;EAHF;IAII,gBAAA;IACA,eAAA;IACA,iBAAA;EDk2BV;AACF;AC91BQ;EACE,WAAA;ADg2BV;;ACz1BA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;AD41BF;ADtaE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACwaJ;ADvaI;EAVF;IAWI,WAAA;EC0aJ;AACF;ADzaI;EAbF;IAcI,WAAA;EC4aJ;AACF;ADraE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACuaJ;ADtaI;EAVF;IAWI,WAAA;ECyaJ;AACF;ADxaI;EAbF;IAcI,WAAA;EC2aJ;AACF;ACl4BE;EAPF;IAQI,oBAAA;EDq4BF;AACF;ACp4BE;EACE,wBAAA;ADs4BJ;ACr4BI;EAFF;IAGI,YAAA;EDw4BJ;AACF;ACr4BI;EACE,mBAAA;ADu4BN;ACt4BM;EAFF;IAGI,mBAAA;EDy4BN;AACF;ACt4BM;EACE,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;ADw4BR;ACv4BQ;EACE,eAAA;ADy4BV;ACv4BQ;EACE,WAAA;EACA,iCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;ADy4BV;ACt4BU;EADF;IAEI,aAAA;EDy4BV;AACF;;ACl4BA;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;ADq4BF;ADtgBE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACwgBJ;ADvgBI;EAVF;IAWI,WAAA;EC0gBJ;AACF;ADzgBI;EAbF;IAcI,WAAA;EC4gBJ;AACF;ADrgBE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACugBJ;ADtgBI;EAVF;IAWI,WAAA;ECygBJ;AACF;ADxgBI;EAbF;IAcI,WAAA;EC2gBJ;AACF;AC16BE;EARF;IASI,eAAA;ED66BF;AACF;AC56BE;EACE,wBAAA;AD86BJ;AC76BI;EAFF;IAGI,YAAA;EDg7BJ;AACF;AC96BE;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;ADg7BJ;AC/6BI;EAJF;IAKI,mBAAA;EDk7BJ;AACF;ACj7BI;EACE,mBAAA;ADm7BN;ACl7BM;EAFF;IAGI,mBAAA;EDq7BN;AACF;ACn7BI;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cFtiBE;EEuiBF,uBFnkBK;EEokBL,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;ADq7BN;ACp7BM;EAZF;IAaI,eAAA;IACA,iBAAA;EDu7BN;AACF;ACp7BE;EACE,iBAAA;EACA,cAAA;ADs7BJ;ACr7BI;EACE,WAAA;ADu7BN;;ACl7BA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gCAAA;ADq7BF;ADjqBE;EACE,WAAA;EACA,mDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACmqBJ;ADlqBI;EAXF;IAYI,WAAA;ECqqBJ;AACF;ADpqBI;EAdF;IAeI,uBAAA;IACA,WAAA;ECuqBJ;AACF;ADhqBE;EACE,WAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;ACkqBJ;ADjqBI;EAZF;IAaI,WAAA;ECoqBJ;AACF;ADnqBI;EAfF;IAgBI,uBAAA;IACA,WAAA;ECsqBJ;AACF;ACj+BE;EAPF;IAQI,eAAA;EDo+BF;AACF;ACn+BE;EAVF;IAWI,eAAA;EDs+BF;AACF;ACp+BI;EACE,0BAAA;ADs+BN;ACr+BM;EACE,gBAAA;EACA,cAAA;ADu+BR;;ACj+BA;EACE,eAAA;EACA,gCAAA;EACA,kBAAA;ADo+BF;ADtrBE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACwrBJ;ADvrBI;EAVF;IAWI,WAAA;EC0rBJ;AACF;ADzrBI;EAbF;IAcI,WAAA;EC4rBJ;AACF;ADrrBE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACurBJ;ADtrBI;EAVF;IAWI,WAAA;ECyrBJ;AACF;ADxrBI;EAbF;IAcI,WAAA;EC2rBJ;AACF;AC3gCE;EANF;IAOI,eAAA;ED8gCF;AACF;AC7gCE;EATF;IAUI,oBAAA;IACA,oBAAA;EDghCF;AACF;AC/gCE;EACE,wBAAA;ADihCJ;AChhCI;EAFF;IAGI,YAAA;EDmhCJ;AACF;AChhCI;EACE,0BAAA;EACA,mBAAA;ADkhCN;ACjhCM;EAHF;IAII,kBAAA;EDohCN;AACF;AClhCI;EACE,4BAAA;EACA,SAAA;ADohCN;ACnhCM;EAHF;IAII,eAAA;IACA,iBAAA;EDshCN;AACF;;ACjhCA;EACE,iBAAA;EACA,gCAAA;EACA,kBAAA;ADohCF;ACnhCE;EAJF;IAKI,mBAAA;IACA,oBAAA;EDshCF;AACF;ADlxBE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACoxBJ;ADnxBI;EAVF;IAWI,WAAA;ECsxBJ;AACF;ADrxBI;EAbF;IAcI,WAAA;ECwxBJ;AACF;ADjxBE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACmxBJ;ADlxBI;EAVF;IAWI,WAAA;ECqxBJ;AACF;ADpxBI;EAbF;IAcI,WAAA;ECuxBJ;AACF;AC7jCE;EACE,wBAAA;AD+jCJ;AC5jCI;EACE,mBAAA;AD8jCN;AC1jCQ;EACE,QAAA;AD4jCV;AC3jCU;EAFF;IAGI,QAAA;ED8jCV;AACF;AC5jCQ;EACE,QAAA;AD8jCV;AC7jCU;EAFF;IAGI,QAAA;EDgkCV;AACF;AC5jCI;EACE,eAAA;AD8jCN;AC7jCM;EAFF;IAGI,eAAA;IACA,mBAAA;EDgkCN;AACF;AC/jCM;EACE,uBF9rBG;EE+rBH,0BAAA;EACA,gBAAA;ADikCR;AChkCQ;EAJF;IAKI,eAAA;IACA,iBAAA;EDmkCR;AACF;AClkCQ;EARF;IASI,gBAAA;EDqkCR;AACF;AClkCQ;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;ADokCV;ACnkCU;EATF;IAUI,eAAA;IACA,iBAAA;EDskCV;AACF;ACrkCU;EAbF;IAcI,kBAAA;IACA,eAAA;IACA,iBAAA;EDwkCV;AACF;ACvkCU;EACE,gBAAA;ADykCZ;ACxkCY;EAFF;IAGI,eAAA;ED2kCZ;AACF;ACzkCU;EACE,WAAA;EACA,iCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AD2kCZ;AC1kCY;EATF;IAUI,UAAA;IACA,WAAA;ED6kCZ;AACF;AC1kCY;EACE,eAAA;AD4kCd;ACrkCM;EACE,WAAA;ADukCR;;ACjkCA;EACE,kBAAA;EAGA,gCAAA;ADkkCF;ADr6BE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACu6BJ;ADt6BI;EAVF;IAWI,WAAA;ECy6BJ;AACF;ADx6BI;EAbF;IAcI,WAAA;EC26BJ;AACF;ADp6BE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACs6BJ;ADr6BI;EAVF;IAWI,WAAA;ECw6BJ;AACF;ADv6BI;EAbF;IAcI,WAAA;EC06BJ;AACF;AC3mCE;EALF;IAMI,oBAAA;IACA,oBAAA;ED8mCF;AACF;AC7mCE;EACE,wBAAA;AD+mCJ;AC7mCE;EACE,aAAA;EACA,qCAAA;EACA,uBAAA;AD+mCJ;AC9mCI;EAJF;IAKI,0BAAA;EDinCJ;AACF;AChnCI;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,uBAAA;ADknCN;ACjnCM;EAPF;IAQI,0BAAA;IACA,kBAAA;IACA,gBAAA;EDonCN;AACF;ACnnCM;EACE,+BAAA;ADqnCR;AClnCQ;EACE,uBFpyBC;EEqyBD,0BAAA;EACA,gBAAA;ADonCV;ACnnCU;EAJF;IAKI,eAAA;IACA,iBAAA;EDsnCV;AACF;ACrnCU;EARF;IASI,eAAA;IACA,iBAAA;IACA,aAAA;IACA,gBAAA;IACA,+BAAA;IACA,mBAAA;EDwnCV;AACF;ACvnCU;EACE,aAAA;ADynCZ;ACxnCY;EAFF;IAGI,cAAA;IACA,WAAA;IACA,kBAAA;ED2nCZ;AACF;ACvnCU;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;ADynCZ;ACxnCY;EATF;IAUI,eAAA;IACA,iBAAA;ED2nCZ;AACF;AC1nCY;EAbF;IAcI,kBAAA;IACA,eAAA;IACA,iBAAA;ED6nCZ;AACF;AC5nCY;EACE,eAAA;AD8nCd;AC5nCY;EACE,WAAA;EACA,iCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AD8nCd;AC7nCc;EATF;IAUI,UAAA;IACA,WAAA;EDgoCd;AACF;AC7nCc;EACE,eAAA;AD+nChB;ACznCM;EACE,eAAA;AD2nCR;AC1nCQ;EAFF;IAGI,aAAA;ED6nCR;AACF;AC5nCQ;EACE,WAAA;EACA,mBAAA;AD8nCV;;ACvnCA;EACE,kBAAA;EAGA,gCAAA;ADwnCF;ADjlCE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACmlCJ;ADllCI;EAVF;IAWI,WAAA;ECqlCJ;AACF;ADplCI;EAbF;IAcI,WAAA;ECulCJ;AACF;ADhlCE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACklCJ;ADjlCI;EAVF;IAWI,WAAA;EColCJ;AACF;ADnlCI;EAbF;IAcI,WAAA;ECslCJ;AACF;ACjqCE;EALF;IAMI,oBAAA;EDoqCF;AACF;ACnqCE;EACE,aAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;ADqqCJ;ACpqCI;EALF;IAMI,0BAAA;EDuqCJ;AACF;ACtqCI;EACE,kBAAA;ADwqCN;ACvqCM;EAFF;IAGI,oBAAA;ED0qCN;AACF;ACzqCM;EACE,cFh3BA;EEi3BA,gBAAA;AD2qCR;AC1qCQ;EAHF;IAII,eAAA;IACA,iBAAA;IACA,4BAAA;ED6qCR;AACF;ACzqCM;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AD2qCR;AC1qCQ;EAJF;IAKI,aAAA;ED6qCR;AACF;;ACvqCA;EACE,kBAAA;EAGA,gCAAA;ADwqCF;AD9tCE;EACE,WAAA;EACA,mDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACguCJ;AD/tCI;EAXF;IAYI,WAAA;ECkuCJ;AACF;ADjuCI;EAdF;IAeI,uBAAA;IACA,WAAA;ECouCJ;AACF;AD7tCE;EACE,WAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;AC+tCJ;AD9tCI;EAZF;IAaI,WAAA;ECiuCJ;AACF;ADhuCI;EAfF;IAgBI,uBAAA;IACA,WAAA;ECmuCJ;AACF;ACttCE;EACE,qBAAA;EACA,6DAAA;EACA,2BAAA;EACA,sBAAA;ADwtCJ;ACvtCI;EALF;IAMI,qBAAA;IACA,6DAAA;IACA,2BAAA;IACA,wBAAA;ED0tCJ;AACF;ACztCI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AD2tCN;ACztCI;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AD2tCN;ACztCI;EACE,mBAAA;EACA,kBAAA;AD2tCN;ACxtCI;EACE,aAAA;EACA,sCAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;AD0tCN;ACztCM;EAPF;IAQI,aAAA;IACA,UAAA;IACA,gBAAA;ED4tCN;AACF;AC1tCQ;EACE,mBAAA;AD4tCV;ACztCM;EACE,mBAAA;AD2tCR;ACztCU;EACE,0CAAA;AD2tCZ;ACvtCU;EADF;IAEI,8BAAA;ED0tCV;ECztCU;IACE,aAAA;IACA,wCAAA;ED2tCZ;AACF;ACvtCU;EADF;IAEI,8BAAA;ED0tCV;ECztCU;IACE,aAAA;IACA,wCAAA;IACA,0CAAA;ED2tCZ;AACF;ACvtCU;EADF;IAEI,8BAAA;ED0tCV;ECztCU;IACE,aAAA;IACA,wCAAA;ED2tCZ;AACF;ACvtCU;EADF;IAEI,8BAAA;ED0tCV;ECztCU;IACE,aAAA;IACA,wCAAA;IACA,0CAAA;ED2tCZ;AACF;ACvtCU;EADF;IAEI,8BAAA;ED0tCV;ECztCU;IACE,aAAA;IACA,wCAAA;ED2tCZ;AACF;ACvtCU;EADF;IAEI,+BAAA;ED0tCV;ECztCU;IACE,aAAA;IACA,wCAAA;IACA,2CAAA;ED2tCZ;AACF;ACxtCQ;EACE,kBAAA;EACA,mBF1/BF;EE2/BE,kBAAA;EACA,yBAAA;AD0tCV;ACztCU;EALF;IAMI,YAAA;IACA,gBAAA;IACA,kBAAA;ED4tCV;AACF;AC3tCU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cFrgCJ;EEsgCI,uBFliCD;EEmiCC,SAAA;AD6tCZ;AC5tCY;EAPF;IAQI,eAAA;IACA,iBAAA;ED+tCZ;AACF;;ACvtCA;EACE,gBAAA;EACA,kBAAA;EAGA,gCAAA;ADwtCF;AD55CE;EACE,WAAA;EACA,mDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;AC85CJ;AD75CI;EAXF;IAYI,WAAA;ECg6CJ;AACF;AD/5CI;EAdF;IAeI,uBAAA;IACA,WAAA;ECk6CJ;AACF;AD35CE;EACE,WAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;AC65CJ;AD55CI;EAZF;IAaI,WAAA;EC+5CJ;AACF;AD95CI;EAfF;IAgBI,uBAAA;IACA,WAAA;ECi6CJ;AACF;ACtwCE;EANF;IAOI,oBAAA;EDywCF;AACF;ACvwCI;EACE,kBAAA;EACA,mBAAA;ADywCN;ACtwCE;EACE,gBAAA;EACA,YAAA;ADwwCJ;ACvwCI;EAEE,YAAA;ADwwCN;ACvwCM;EACE,mBF1iCA;EE2iCA,mBAAA;EACA,yBAAA;ADywCR;ACxwCQ;EACE,mBAAA;AD0wCV;ACzwCU;EAFF;IAGI,mBAAA;ED4wCV;AACF;AC1wCQ;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,4BAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBFvlCA;ACm2EV;AC3wCU;EAXF;IAYI,aAAA;IACA,eAAA;IACA,iBAAA;ED8wCV;AACF;AC5wCY;EADF;IAEI,WAAA;IACA,YAAA;IACA,qBAAA;ED+wCZ;AACF;AC3wCM;EACE,aAAA;EACA,mBF9kCA;EE+kCA,mBAAA;EACA,oBAAA;AD6wCR;AC5wCQ;EALF;IAMI,aAAA;ED+wCR;AACF;AC9wCQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBFlnCA;ACk4EV;;ACzwCA;EACE,kBAAA;AD4wCF;ADt+CE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACw+CJ;ADv+CI;EAVF;IAWI,WAAA;EC0+CJ;AACF;ADz+CI;EAbF;IAcI,WAAA;EC4+CJ;AACF;ADr+CE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACu+CJ;ADt+CI;EAVF;IAWI,WAAA;ECy+CJ;AACF;ADx+CI;EAbF;IAcI,WAAA;EC2+CJ;AACF;ACnzCE;EACE,aAAA;ADqzCJ;ACpzCI;EAFF;IAGI,aAAA;EDuzCJ;AACF;ACtzCI;EALF;IAMI,eAAA;EDyzCJ;AACF;ACxzCI;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;AD0zCN;ACzzCM;EAXF;IAYI,YAAA;IACA,oDAAA;ED4zCN;AACF;AC1zCI;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;AD4zCN;AC3zCM;EAXF;IAYI,YAAA;IACA,oDAAA;ED8zCN;AACF;AC5zCI;EACE,aAAA;EACA,sCAAA;EACA,uBAAA;AD8zCN;AC7zCM;EAJF;IAKI,0BAAA;EDg0CN;AACF;AC/zCM;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;ADi0CR;ACh0CQ;EANF;IAOI,aAAA;EDm0CR;AACF;ACl0CQ;EATF;IAUI,kBAAA;IACA,gBAAA;IACA,kBAAA;EDq0CR;AACF;ACp0CQ;EACE,+BAAA;ADs0CV;ACr0CU;EAFF;IAGI,aAAA;IACA,gCAAA;EDw0CV;AACF;ACp0CU;EADF;IAEI,QAAA;EDu0CV;AACF;ACp0CU;EADF;IAEI,QAAA;EDu0CV;AACF;ACp0CU;EADF;IAEI,QAAA;EDu0CV;AACF;ACn0CY;EADF;IAEI,eAAA;IACA,iBAAA;EDs0CZ;AACF;ACp0CU;EACE,cF9rCJ;EE+rCI,uBF3tCD;EE4tCC,mBAAA;ADs0CZ;ACr0CY;EAJF;IAKI,kBAAA;IACA,eAAA;IACA,iBAAA;EDw0CZ;AACF;ACt0CU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;ADw0CZ;ACv0CY;EANF;IAOI,eAAA;IACA,iBAAA;IACA,cFhtCN;EC0hFN;AACF;ACz0CY;EACE,cFntCN;AC8hFR;;ACl0CA;EACE,gBAAA;EACA,qEAAA;EACA,sBAAA;EACA,kBAAA;ADq0CF;ADjtDE;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACmtDJ;ADltDI;EAXF;IAYI,WAAA;ECqtDJ;AACF;ADptDI;EAdF;IAeI,uBAAA;IACA,WAAA;ECutDJ;AACF;ADhtDE;EACE,WAAA;EACA,oDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;ACktDJ;ADjtDI;EAZF;IAaI,WAAA;ECotDJ;AACF;ADntDI;EAfF;IAgBI,uBAAA;IACA,WAAA;ECstDJ;AACF;ACj3CE;EAPF;IAQI,oBAAA;EDo3CF;AACF;ACn3CE;EACE,qBAAA;ADq3CJ;ACn3CE;EACE,kBAAA;ADq3CJ;ACp3CI;EACE,cF7uCE;EE8uCF,gBAAA;ADs3CN;ACp3CI;EACE,gBAAA;EACA,cFlvCE;ACwmFR;ACr3CM;EAHF;IAII,eAAA;IACA,iBAAA;IACA,mBAAA;EDw3CN;ECv3CM;IACE,aAAA;EDy3CR;AACF;ACr3CM;EADF;IAEI,gBAAA;IACA,gBAAA;EDw3CN;AACF;;ACn3CA;EACE,sBAAA;EACA,qEAAA;EACA,sBAAA;EACA,kBAAA;ADs3CF;AD1yDE;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;AC4yDJ;AD3yDI;EAXF;IAYI,WAAA;EC8yDJ;AACF;AD7yDI;EAdF;IAeI,uBAAA;IACA,WAAA;ECgzDJ;AACF;ADzyDE;EACE,WAAA;EACA,oDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;AC2yDJ;AD1yDI;EAZF;IAaI,WAAA;EC6yDJ;AACF;AD5yDI;EAfF;IAgBI,uBAAA;IACA,WAAA;EC+yDJ;AACF;ACl6CE;EAPF;IAQI,oBAAA;EDq6CF;AACF;ACp6CE;EACE,qBAAA;ADs6CJ;ACp6CE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;ADs6CJ;ACl6CI;EACE,cF1xCE;EE2xCF,gBAAA;EACA,gBAAA;ADo6CN;ACl6CI;EACE,gBAAA;EACA,cFhyCE;EEiyCF,cAAA;ADo6CN;ACn6CM;EAJF;IAKI,eAAA;IACA,iBAAA;IACA,cAAA;EDs6CN;ECr6CM;IACE,aAAA;EDu6CR;AACF;ACn6CM;EACE,qBAAA;EACA,sBAAA;ADq6CR;ACp6CQ;EAHF;IAII,cAAA;EDu6CR;AACF;ACt6CQ;EACE,kBAAA;ADw6CV;ACv6CU;EAFF;IAGI,eAAA;ED06CV;AACF;ACx6CQ;EACE,gBAAA;EACA,gBAAA;AD06CV;;ACn6CA;EACE,kBAAA;EAGA,gCAAA;ADo6CF;ADn2DE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACq2DJ;ADp2DI;EAVF;IAWI,WAAA;ECu2DJ;AACF;ADt2DI;EAbF;IAcI,WAAA;ECy2DJ;AACF;ADl2DE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACo2DJ;ADn2DI;EAVF;IAWI,WAAA;ECs2DJ;AACF;ADr2DI;EAbF;IAcI,WAAA;ECw2DJ;AACF;AC78CE;EACE,qBAAA;EACA,UAAA;AD+8CJ;AC98CI;EAHF;IAII,qBF70Ca;EC8xFjB;AACF;AC/8CE;EACE,UAAA;ADi9CJ;AC/8CE;EAEE,aAAA;ADg9CJ;AC/8CI;EAHF;IAII,kBAAA;EDk9CJ;AACF;ACj9CI;EANF;IAOI,eAAA;EDo9CJ;AACF;ACn9CI;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;ADq9CN;ACp9CM;EATF;IAUI,YAAA;IACA,qBFv2CW;EC8zFjB;AACF;ACr9CI;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;ADu9CN;ACt9CM;EATF;IAUI,YAAA;IACA,qBFr3CW;EC80FjB;AACF;ACv9CI;EACE,aAAA;EACA,sCAAA;EACA,uBAAA;ADy9CN;ACx9CM;EAJF;IAKI,0BAAA;ED29CN;AACF;AC19CM;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AD49CR;AC39CQ;EANF;IAOI,aAAA;IACA,gBAAA;IACA,kBAAA;IACA,cAAA;ED89CR;AACF;AC39CU;EADF;IAEI,kBAAA;ED89CV;AACF;AC59CQ;EACE,mBAAA;EACA,yBAAA;AD89CV;AC79CU;EAHF;IAII,aAAA;IACA,6BAAA;EDg+CV;AACF;AC99CQ;EACE,mBAAA;ADg+CV;AC39CY;EADF;IAEI,eAAA;IACA,iBAAA;ED89CZ;AACF;AC59CU;EACE,cFj6CJ;EEk6CI,uBF97CD;EE+7CC,mBAAA;AD89CZ;AC79CY;EAJF;IAKI,eAAA;IACA,iBAAA;IACA,kBAAA;EDg+CZ;AACF;AC99CU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cF96CJ;EE+6CI,uBF38CD;AC26FX;AC/9CY;EANF;IAOI,eAAA;IACA,iBAAA;EDk+CZ;ECj+CY;IACE,aAAA;EDm+Cd;AACF;ACh+CU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cF57CJ;EE67CI,gBAAA;ADk+CZ;ACj+CY;EANF;IAOI,eAAA;IACA,iBAAA;EDo+CZ;ECn+CY;IACE,aAAA;EDq+Cd;AACF;ACn+CY;EACE,mBAAA;ADq+Cd;ACp+Cc;EAFF;IAGI,kBAAA;EDu+Cd;AACF;;AC99CA;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;ADi+CF;ADrmEE;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACumEJ;ADtmEI;EAXF;IAYI,WAAA;ECymEJ;AACF;ADxmEI;EAdF;IAeI,uBAAA;IACA,WAAA;EC2mEJ;AACF;ADpmEE;EACE,WAAA;EACA,oDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;ACsmEJ;ADrmEI;EAZF;IAaI,WAAA;ECwmEJ;AACF;ADvmEI;EAfF;IAgBI,uBAAA;IACA,WAAA;EC0mEJ;AACF;AC7gDE;EATF;IAUI,oBAAA;IACA,iBAAA;EDghDF;AACF;AC/gDE;EACE,qBAAA;EACA,UAAA;ADihDJ;AC/gDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,oBAAA;ADihDJ;AC/gDE;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;ADihDJ;AChhDI;EACE,gBAAA;EACA,+BAAA;EACA,SAAA;ADkhDN;ACjhDM;EAJF;IAKI,eAAA;IACA,iBAAA;EDohDN;AACF;;AC/gDA;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;ADkhDF;ADhsEE;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACksEJ;ADjsEI;EAXF;IAYI,WAAA;ECosEJ;AACF;ADnsEI;EAdF;IAeI,uBAAA;IACA,WAAA;ECssEJ;AACF;AD/rEE;EACE,WAAA;EACA,oDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;ACisEJ;ADhsEI;EAZF;IAaI,WAAA;ECmsEJ;AACF;ADlsEI;EAfF;IAgBI,uBAAA;IACA,WAAA;ECqsEJ;AACF;AC9jDE;EATF;IAUI,oBAAA;IACA,iBAAA;EDikDF;AACF;AChkDE;EACE,qBAAA;EACA,UAAA;ADkkDJ;AChkDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,oBAAA;ADkkDJ;AChkDE;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;ADkkDJ;AChkDM;EACE,mBAAA;ADkkDR;AChkDM;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;ADkkDR;ACjkDQ;EACE,kBAAA;ADmkDV;AClkDU;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;ADokDZ;ACjkDQ;EACE,gBAAA;EACA,cAAA;EACA,SAAA;ADmkDV;AClkDU;EAJF;IAKI,eAAA;IACA,iBAAA;EDqkDV;AACF;;AC9jDA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;ADikDF;AD7vEE;EACE,WAAA;EACA,mBE2rBsB;EF1rBtB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;AC+vEJ;AD9vEI;EAVF;IAWI,WAAA;ECiwEJ;AACF;ADhwEI;EAbF;IAcI,WAAA;ECmwEJ;AACF;AD5vEE;EACE,WAAA;EACA,mBEsqBqB;EFrqBrB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;AC8vEJ;AD7vEI;EAVF;IAWI,WAAA;ECgwEJ;AACF;AD/vEI;EAbF;IAcI,WAAA;ECkwEJ;AACF;ACxmDE;EAPF;IAQI,eAAA;ED2mDF;AACF;AC1mDE;EACE,qBAAA;EACA,UAAA;AD4mDJ;AC1mDE;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AD4mDJ;AC3mDI;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AD6mDN;AC5mDM;EAJF;IAKI,eAAA;IACA,iBAAA;ED+mDN;AACF;;AC1mDA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;AD6mDF;ADv0EE;EACE,WAAA;EACA,mBEytBsB;EFxtBtB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACy0EJ;ADx0EI;EAVF;IAWI,WAAA;EC20EJ;AACF;AD10EI;EAbF;IAcI,WAAA;EC60EJ;AACF;ADt0EE;EACE,WAAA;EACA,mBEosBqB;EFnsBrB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACw0EJ;ADv0EI;EAVF;IAWI,WAAA;EC00EJ;AACF;ADz0EI;EAbF;IAcI,WAAA;EC40EJ;AACF;ACppDE;EAPF;IAQI,eAAA;EDupDF;AACF;ACtpDE;EACE,qBAAA;EACA,UAAA;ADwpDJ;ACtpDE;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;ADwpDJ;ACvpDI;EACE,gBAAA;EACA,cAAA;EACA,SAAA;ADypDN;ACxpDM;EAJF;IAKI,eAAA;IACA,iBAAA;ED2pDN;AACF;ACxpDM;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AD0pDR;ACzpDQ;EACE,kBAAA;AD2pDV;ACxpDU;EACE,eAAA;AD0pDZ;;AExzGE;EACE,mBHwBI;EGvBJ,UAAA;AF2zGJ;;AEvzGA;EACE,kBAAA;AF0zGF;AExzGE;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AF0zGJ;AExzGI;EAfF;IAgBI,eAAA;IACA,aAAA;EF2zGJ;AACF;AEzzGI;EACE,UAAA;EACA,YAAA;EACA,mBAAA;AF2zGN;AErzGQ;EAJF;IAKI,aAAA;EFwzGR;AACF;AElzGI;EACE,kBAAA;EACA,UAAA;AFozGN;;AE/yGA;EACE,kBAAA;EACA,mBAAA;AFkzGF;AEhzGE;EAJF;IAKI,mBAAA;EFmzGF;AACF;AEjzGE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBHjEI;EGkEJ,cH/DQ;EGgER,yBAAA;AFmzGJ;AEhzGE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBH1EI;EG2EJ,cH3Da;EG4Db,cAAA;AFkzGJ;AEhzGI;EARF;IASI,eAAA;IACA,iBAAA;EFmzGJ;AACF;AEjzGI;EAbF;IAcI,eAAA;IACA,iBAAA;IACA,cAAA;EFozGJ;AACF;AElzGI;EAnBF;IAoBI,eAAA;IACA,iBAAA;IACA,cAAA;EFqzGJ;AACF;AElzGE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBHpGI;EGqGJ,cHpFa;EGqFb,gBAAA;AFozGJ;AE3yGA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;AF6yGF;AE3yGE;EAPF;IAQI,SAAA;EF8yGF;AACF;AE1yGM;EADF;IAEI,0BAAA;EF6yGN;AACF;AEzyGE;EACE,UAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AF2yGJ;AEzyGI;EAVF;IAWI,iBAAA;EF4yGJ;AACF;AE1yGI;EAdF;IAeI,eAAA;IACA,gCAAA;EF6yGJ;AACF;AE3yGI;EAnBF;IAoBI,gBAAA;IACA,uBAAA;IACA,gCAAA;IACA,kBAAA;IACA,6CAAA;EF8yGJ;AACF;AE5yGI;EA3BF;IA4BI,gBAAA;IACA,uBAAA;IACA,+BAAA;IACA,kBAAA;IACA,6CAAA;EF+yGJ;AACF;AE5yGM;EACE,qBAAA;AF8yGR;AE5yGQ;EACE,WAAA;EACA,gBAAA;AF8yGV;AExyGM;EACE,aAAA;AF0yGR;AExyGQ;EAHF;IAII,aAAA;IACA,mBAAA;IACA,sBAAA;EF2yGR;AACF;AEzyGQ;EACE,eAAA;EACA,2HAAA;AF2yGV;AEvyGM;EACE,iBAAA;AFyyGR;AEvyGQ;EAHF;IAII,oBAAA;IACA,2BAAA;EF0yGR;AACF;AExyGQ;EARF;IASI,eAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;IACA,WAAA;IACA,gBAAA;IACA,YAAA;IACA,yCAAA;IACA,mBHxLF;IGyLE,0BAAA;IACA,aAAA;EF2yGR;EEzyGQ;IACE,cAAA;EF2yGV;AACF;AExyGQ;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AF0yGV;AExyGU;EALF;IAMI,cAAA;EF2yGV;AACF;AEzyGU;EACE,kBAAA;AF2yGZ;AEzyGY;EAHF;IAII,kBAAA;EF4yGZ;AACF;AE1yGY;EAPF;IAQI,SAAA;IACA,gCAAA;EF6yGZ;AACF;AE1yGU;EACE,kBAAA;AF4yGZ;AE1yGY;EAHF;IAII,SAAA;EF6yGZ;AACF;AE3yGY;EACE,WAAA;EACA,oEAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AF6yGd;AE3yGc;EAXF;IAYI,WAAA;IACA,WAAA;IACA,wHAAA;EF8yGd;AACF;AE1yGU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBH9QJ;EG+QI,qBAAA;AF4yGZ;AE1yGY;EAPF;IAQI,cAAA;IACA,gBAAA;IACA,gBAAA;IACA,cH3PN;IG4PM,4BAAA;EF6yGZ;AACF;;AEryGA;EACE,sBAAA;EACA,8DAAA;EACA,2BAAA;EACA,sBAAA;AFwyGF;AEtyGE;EANF;IAOI,qBAAA;EFyyGF;AACF;AEvyGE;EAVF;IAWI,qBAAA;EF0yGF;AACF;AExyGE;EAdF;IAeI,qBAAA;EF2yGF;AACF;AExyGI;EADF;IAEI,kBAAA;EF2yGJ;AACF;AEzyGI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AF2yGN;AEzyGM;EANF;IAOI,eAAA;IACA,iBAAA;EF4yGN;AACF;AE1yGM;EAXF;IAYI,eAAA;IACA,iBAAA;EF6yGN;AACF;AE3yGM;EAhBF;IAiBI,eAAA;IACA,iBAAA;EF8yGN;AACF;AE5yGM;EArBF;IAsBI,eAAA;IACA,iBAAA;EF+yGN;AACF;AE5yGI;EACE,cAAA;EACA,mBAAA;AF8yGN;AE5yGM;EAJF;IAKI,mBAAA;EF+yGN;AACF;AE3yGM;EACE,qBAAA;EACA,sBAAA;AF6yGR;AE3yGQ;EACE,kBAAA;AF6yGV;AEryGE;EACE,iBAAA;AFuyGJ;AEryGI;EAHF;IAII,aAAA;EFwyGJ;AACF;;AEpyGA;EACE,oBAAA;AFuyGF;AEryGE;EAHF;IAII,oBAAA;EFwyGF;AACF;AEtyGE;EACE,kBAAA;AFwyGJ;AEtyGI;EAHF;IAII,mBAAA;EFyyGJ;AACF;AEvyGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AFyyGN;AEvyGM;EATF;IAUI,eAAA;IACA,iBAAA;EF0yGN;AACF;AEvyGI;EACE,gBAAA;AFyyGN;AEvyGM;EAHF;IAII,gBAAA;EF0yGN;AACF;;AEpyGA;EACE,oBAAA;AFuyGF;AEryGE;EAHF;IAII,eAAA;EFwyGF;AACF;AEtyGE;EAPF;IAQI,eAAA;EFyyGF;AACF;AEvyGE;EACE,aAAA;EACA,kDAAA;EACA,gBAAA;AFyyGJ;AEvyGI;EALF;IAMI,kDAAA;IACA,aAAA;EF0yGJ;AACF;AExyGI;EAVF;IAWI,0BAAA;IACA,aAAA;EF2yGJ;AACF;AEzyGI;EACE,kBAAA;EACA,mBH5ZE;EG6ZF,mBAAA;EACA,yBAAA;AF2yGN;AEzyGM;EACE,mBAAA;AF2yGR;AEzyGQ;EACE,eAAA;AF2yGV;AEtyGQ;EACE,mBAAA;AFwyGV;AEtyGU;EAHF;IAII,eAAA;IACA,iBAAA;EFyyGV;AACF;AEtyGQ;EACE,gBAAA;EACA,iBAAA;AFwyGV;;AEjyGA;EACE,mBAAA;EACA,gFAAA;AFoyGF;AElyGE;EAJF;IAKI,oCAAA;EFqyGF;AACF;;AElyGA;EACE,oBAAA;AFqyGF;AEnyGE;EAHF;IAII,eAAA;EFsyGF;AACF;AEpyGE;EAPF;IAQI,eAAA;EFuyGF;AACF;AEryGE;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;AFuyGJ;AEryGI;EANF;IAOI,cAAA;EFwyGJ;AACF;AEtyGI;EAVF;IAWI,aAAA;IACA,8BAAA;EFyyGJ;AACF;AEtyGM;EACE,gBAAA;EACA,mBAAA;AFwyGR;AEryGU;EACE;IACE,aAAA;EFuyGZ;AACF;AEjyGQ;EACE;IACE,aAAA;EFmyGV;AACF;AE/xGM;EACE,aAAA;EACA,uCAAA;EACA,gBAAA;AFiyGR;AE/xGQ;EALF;IAMI,0BAAA;IACA,aAAA;EFkyGR;AACF;AEhyGQ;EACE,uBAAA;EACA,mBHhgBF;EGigBE,mBAAA;AFkyGV;AEhyGU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBH7hBA;EG8hBA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AFkyGZ;AEhyGY;EACE,eAAA;AFkyGd;AE7xGY;EACE,kBAAA;AF+xGd;AE5xGY;EACE,gBAAA;EACA,iBAAA;AF8xGd;AEvxGI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AFyxGN;AEvxGM;EALF;IAMI,aAAA;EF0xGN;AACF;AExxGM;EATF;IAUI,OAAA;IACA,MAAA;IACA,mBAAA;EF2xGN;AACF;AExxGQ;EADF;IAEI,WAAA;IACA,gBAAA;EF2xGR;AACF;;AErxGA;EACE,oBAAA;EACA,kBAAA;AFwxGF;AEtxGE;EAJF;IAKI,eAAA;EFyxGF;AACF;AEvxGE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;AFyxGJ;AEvxGI;EAPF;IAQI,aAAA;EF0xGJ;AACF;AErxGM;EACE;IACE,aAAA;EFuxGR;AACF;AElxGE;EACE,aAAA;EACA,kDAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AFoxGJ;AElxGI;EAPF;IAQI,0BAAA;IACA,aAAA;EFqxGJ;AACF;AElxGM;EACE,aAAA;EACA,mBHtmBA;EGumBA,mBAAA;AFoxGR;AElxGQ;EACE,mBAAA;AFoxGV;AEjxGQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBHvoBE;EGwoBF,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AFmxGV;AEjxGU;EACE,eAAA;AFmxGZ;AE9wGU;EACE,mBAAA;AFgxGZ;AE7wGU;EACE,gBAAA;EACA,iBAAA;AF+wGZ;AE1wGM;EACE,oBAAA;EACA,mBHhqBI;EGiqBJ,mBAAA;AF4wGR;AE1wGQ;EACE,mBAAA;AF4wGV;AE1wGU;EACE,cHjpBJ;EGkpBI,mBAAA;AF4wGZ;AEzwGU;EACE,cHtpBJ;EGupBI,iBAAA;EACA,gBAAA;AF2wGZ;AEvwGQ;EACE,kBAAA;AFywGV;AEvwGU;EACE,WAAA;EACA,gBAAA;AFywGZ;AElwGE;EACE,gBAAA;EACA,kBAAA;AFowGJ;AElwGI;EACE,qBAAA;EACA,sBAAA;AFowGN;AElwGM;EACE,kBAAA;AFowGR;AE5vGA;EACE,oBAAA;EACA,mBAAA;AF8vGF;AE5vGE;EAJF;IAKI,eAAA;EF+vGF;AACF;AE7vGE;EACE,aAAA;EACA,kDAAA;EACA,gBAAA;AF+vGJ;AE7vGI;EALF;IAMI,kDAAA;IACA,aAAA;EFgwGJ;AACF;AE9vGI;EAVF;IAWI,0BAAA;IACA,aAAA;EFiwGJ;AACF;AE/vGI;EACE,aAAA;EACA,kBAAA;EACA,mBHntBE;EGotBF,mBAAA;AFiwGN;AE9vGQ;EACE,gBAAA;AFgwGV;AE5vGM;EACE,sBAAA;EACA,gBAAA;AF8vGR;AE5vGQ;EACE,iBAAA;EACA,gBAAA;AF8vGV;AE1vGM;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AF4vGR;AEzvGU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AF2vGZ;AEtvGU;EACE,cAAA;AFwvGZ;AErvGU;EACE,SAAA;AFuvGZ;;AE/uGA;EACE,qBAAA;EACA,mBAAA;AFkvGF;AEhvGE;EAJF;IAKI,eAAA;EFmvGF;AACF;AEjvGE;EARF;IASI,eAAA;EFovGF;AACF;AElvGE;EACE,oBAAA;EACA,wBAAA;EACA,6EAAA;AFovGJ;AElvGI;EALF;IAMI,uBAAA;EFqvGJ;AACF;AEnvGI;EATF;IAUI,aAAA;IACA,gBAAA;IACA,YAAA;EFsvGJ;AACF;AEpvGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AFsvGN;AEpvGM;EANF;IAOI,aAAA;IACA,aAAA;EFuvGN;AACF;AErvGM;EACE,WAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,UAAA;AFuvGR;AErvGQ;EAXF;IAYI,YAAA;IACA,UAAA;IACA,MAAA;IACA,SAAA;IACA,2BAAA;EFwvGR;AACF;AErvGM;EACE,kBAAA;EACA,UAAA;AFuvGR;AErvGQ;EACE,qBAAA;AFuvGV;AErvGU;EACE,gBAAA;AFuvGZ;AEhvGE;EACE,8DAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,sCAAA;EACA,uBAAA;EACA,gBAAA;AFkvGJ;AEhvGI;EAZF;IAaI,gBAAA;IACA,0BAAA;IACA,aAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;IACA,kBAAA;EFmvGJ;AACF;AEhvGM;EACE,cHt2BA;EGu2BA,gBAAA;EACA,gBAAA;AFkvGR;AEhvGQ;EALF;IAMI,eAAA;IACA,iBAAA;EFmvGR;AACF;AEjvGQ;EAVF;IAWI,eAAA;IACA,iBAAA;EFovGR;AACF;AEjvGM;EACE,cHt3BA;EGu3BA,mBAAA;AFmvGR;AEjvGQ;EAJF;IAKI,mBAAA;EFovGR;AACF;AEhvGQ;EACE,qBAAA;EACA,sBAAA;AFkvGV;AEhvGU;EACE,kBAAA;AFkvGZ;AEzuGM;EADF;IAEI,aAAA;EF4uGN;AACF;AE1uGM;EACE,WAAA;AF4uGR;AExuGI;EACE,kBAAA;AF0uGN;AExuGM;EAHF;IAII,YAAA;EF2uGN;AACF;AEzuGM;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uFAAA;AF2uGR;AEzuGQ;EATF;IAUI,YAAA;EF4uGR;AACF;AE1uGQ;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBH96BF;EG+6BE,aAAA;EACA,mBAAA;EACA,uBAAA;AF4uGV;AE1uGU;EACE,eAAA;AF4uGZ;AEvuGM;EACE,cAAA;AFyuGR;AEvuGQ;EACE,eAAA;AFyuGV;AEruGM;EACE,cAAA;EACA,gBAAA;AFuuGR;;AEjuGA;EACE,oBAAA;AFouGF;AEluGE;EAHF;IAII,eAAA;EFquGF;AACF;AEnuGE;;;;;EAKE,cAAA;AFquGJ;AEluGE;EACE,oBAAA;EACA,mBAAA;EACA,gCAAA;AFouGJ;AEluGI;EALF;IAMI,mBAAA;IACA,oBAAA;EFquGJ;AACF;AEluGM;EADF;IAEI,aAAA;IACA,gCAAA;IACA,uBAAA;IACA,mBAAA;EFquGN;AACF;AEnuGM;EARF;IASI,mBAAA;EFsuGN;AACF;AEluGU;EACE,gBAAA;AFouGZ;AEluGY;EAHF;IAII,gBAAA;EFquGZ;AACF;AEjuGQ;EACE,gBAAA;AFmuGV;AEjuGU;EAHF;IAII,gBAAA;EFouGV;AACF;AEhuGM;EACE,gBAAA;AFkuGR;AEhuGQ;EAHF;IAII,aAAA;EFmuGR;AACF;AEjuGQ;EAPF;IAQI,gBAAA;EFouGR;AACF;AEjuGU;EACE,qBAAA;EACA,sBAAA;AFmuGZ;AEjuGY;EACE,kBAAA;AFmuGd;AE/tGc;EACE,eAAA;EACA,2HAAA;AFiuGhB;AE3tGQ;EACE,gBAAA;AF6tGV;AE3tGU;EAHF;IAII,gBAAA;EF8tGV;AACF;AEvtGQ;EADF;IAEI,mBAAA;EF0tGR;AACF;AExtGQ;EACE,iBAAA;AF0tGV;AExtGU;EAHF;IAII,gBAAA;EF2tGV;AACF;AExtGQ;EACE,mBAAA;AF0tGV;AExtGU;EAHF;IAII,mBAAA;EF2tGV;AACF;AExtGQ;;EAEE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBH7lCF;ACuzIR;AEvtGQ;EACE,cAAA;EACA,cAAA;EACA,mBAAA;AFytGV;AErtGU;EACE,cAAA;AFutGZ;AErtGY;EACE,kBAAA;AFutGd;AE3sGI;;EAEE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBH5nCE;ACy0IR;AE1sGI;EACE,gBAAA;AF4sGN;AEzsGI;EACE,gBAAA;AF2sGN;AEzsGM;EACE,mBAAA;AF2sGR;;AA10IE;EADF;IAEI,iBAAA;EA80IF;AACF;;AAz0II;EACE,kBAAA;EACA,YAAA;AA40IN;AAz0IM;EALF;IAMI,YAAA;IACA,kBAAA;EA40IN;AACF;AAt0Ic;EAEE,aAAA;AAu0IhB;AAr0IgB;EAJF;IAKI,aAAA;EAw0IhB;AACF;AA/zIE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAi0IJ;AA9zIE;EACE,WAAA;EAEA,YAAA;EACA,mBDrDQ;ECsDR,4BAAA;EACA,kBAAA;EACA,iBAAA;AA+zIJ;AA7zII;EATF;IAUI,iBAAA;IACA,iBAAA;IACA,YAAA;EAg0IJ;AACF;AA7zIM;EADF;IAEI,kBAAA;EAg0IN;AACF;AA1zIM;EACE,mBAAA;EACA,kBAAA;AA4zIR;AA1zIQ;EAJF;IAKI,mBAAA;EA6zIR;AACF;AA3zIQ;EACE,mBAAA;AA6zIV;AA1zIQ;EACE,gBAAA;AA4zIV;AAzzIY;EADF;IAEI,eAAA;EA4zIZ;AACF;AAxzIY;EADF;IAEI,mBAAA;EA2zIZ;AACF;AAtzIU;EADF;IAEI,aAAA;IACA,gCAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;EAyzIV;AACF;AAvzIU;EACE,aAAA;AAyzIZ;AAvzIY;EAHF;IAII,aAAA;EA0zIZ;AACF;AAtzIQ;EACE,iBAAA;AAwzIV;AAlzIc;EADF;IAEI,cAAA;EAqzId;AACF;AAlzIgB;EADF;IAEI,eAAA;EAqzIhB;AACF;AAjzIgB;EADF;IAEI,eAAA;EAozIhB;AACF;AA/yIU;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AAizIZ;AA/yIY;EACE,kBAAA;AAizId;AA9yIY;EACE,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAgzId;AA9yIc;EANF;IAOI,qBAAA;EAizId;AACF;AA9yIgB;EADF;IAEI,kBAAA;IACA,QAAA;IACA,WAAA;IACA,2BAAA;EAizIhB;AACF;AA5yIc;EACE,gBAAA;AA8yIhB;AAxyIQ;EACE,kBAAA;AA0yIV;AAxyIU;EACE,mBDzLA;EC0LA,kBAAA;EACA,iBAAA;EACA,iDAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;AA0yIZ;AAxyIY;EAXF;IAYI,gBAAA;IACA,cAAA;IACA,iBAAA;EA2yIZ;AACF;AAzyIY;EACE,kBAAA;AA2yId;AAryIc;EACE,mBDjNJ;ACw/IZ;AAryIgB;EACE,uBAAA;AAuyIlB;AApyIoB;EACE,mBDhMd;ECiMc,YAAA;EACA,gBAAA;AAsyItB;AApyIsB;EACE,cDtMhB;AC4+IR;AApyIwB;EACE,cDzMlB;AC++IR;AA7xIkB;EACE,mBAAA;AA+xIpB;AA1xIc;EACE,kBAAA;EACA,mBAAA;EACA,0BAAA;AA4xIhB;AA1xIgB;EALF;IAMI,kBAAA;EA6xIhB;AACF;AA3xIgB;EACE,iBAAA;AA6xIlB;AA3xIkB;EACE,qBAAA;EACA,sBAAA;AA6xIpB;AA3xIoB;EACE,kBAAA;AA6xItB;AA1xIoB;EACE,YAAA;AA4xItB;AAhxIU;EAEE,aAAA;EACA,cAAA;AAixIZ;AA/wIY;EALF;IAMI,aAAA;EAkxIZ;AACF;AAhxIY;EACE,cAAA;AAkxId;AAhxIc;EAHF;IAII,aAAA;EAmxId;AACF;AD1tHE;EACE,yBAx1BQ;EAy1BR,WAAA;AC4tHJ;AD1tHE;EACE,yBA51BQ;ACwjJZ;AD1tHE;EACE,yBAv0BI;EAw0BJ,mBAAA;EACA,yBAAA;AC4tHJ;AD1tHE;EACE,aAAA;AC4tHJ;AA7xIY;EACE,aAAA;EACA,8CAAA;EACA,gBAAA;AA+xId;AA7xIc;EALF;IAMI,8CAAA;EAgyId;AACF;AA9xIc;EATF;IAUI,8CAAA;IACA,gBAAA;EAiyId;AACF;AA/xIc;EAdF;IAeI,8CAAA;IACA,gBAAA;EAkyId;AACF;AAhyIc;EAnBF;IAoBI,8CAAA;IACA,gBAAA;EAmyId;AACF;AAhyIY;EACE,aAAA;EACA,sCAAA;EACA,gBAAA;AAkyId;AAhyIc;EALF;IAMI,sCAAA;EAmyId;AACF;AAjyIc;EATF;IAUI,sCAAA;IACA,gBAAA;EAoyId;AACF;AAlyIc;EAdF;IAeI,sCAAA;IACA,gBAAA;EAqyId;AACF;AAlyIY;EACE,aAAA;EACA,yDAAA;EACA,gBAAA;AAoyId;AAlyIc;EALF;IAMI,0DAAA;EAqyId;AACF;AAnyIc;EATF;IAUI,0DAAA;IACA,gBAAA;EAsyId;AACF;AApyIc;EAdF;IAeI,wDAAA;IACA,gBAAA;EAuyId;AACF;AApyIY;EACE,aAAA;EACA,+DAAA;EACA,gBAAA;AAsyId;AApyIc;EALF;IAMI,+DAAA;IACA,iBAAA;EAuyId;AACF;AApyIY;EACE,aAAA;EAEA,oEAAA;EACA,gBAAA;AAqyId;AAnyIc;EANF;IAOI,oEAAA;EAsyId;AACF;AApyIc;EAVF;IAWI,iBAAA;EAuyId;AACF;AAryIc;EAdF;IAeI,oEAAA;EAwyId;AACF;AAryIY;EACE,aAAA;EAEA,oEAAA;EACA,gBAAA;AAsyId;AApyIc;EANF;IAOI,oEAAA;EAuyId;AACF;AAryIc;EAVF;IAWI,iBAAA;EAwyId;AACF;AAtyIc;EAdF;IAeI,oEAAA;EAyyId;AACF;AAryIc;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;EACA,wBAAA;EACA,wBAAA;AAuyIhB;AAryIgB;EACE,UAAA;EACA,qBD1YV;EC2YU,mBD3YV;ACkrJR;AAryIkB;EACE,UAAA;AAuyIpB;AAnyIgB;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,8CAAA;EACA,UAAA;EACA,UAAA;AAqyIlB;AAhyIY;EACE,iBAAA;EACA,gCAAA;AAkyId;AAhyIc;EACE,6BAAA;EACA,gCAAA;EACA,mBAAA;AAkyIhB;AA9xIgB;EACE,kBAAA;AAgyIlB;AA7xIgB;EACE,gBAAA;EACA,gBAAA;EACA,cDpcD;ECqcC,oBAAA;EACA,mBAAA;EACA,QAAA;AA+xIlB;AA7xIkB;EACE,eAAA;AA+xIpB;AAzxIY;EACE,iBAAA;AA2xId;AAzxIc;EACE,gCAAA;AA2xIhB;AAvxIgB;EACE,gBAAA;AAyxIlB;AArxIkB;EACE,eAAA;AAuxIpB;AApxIkB;EACE,gBAAA;AAsxIpB;AAlxIgB;EACE,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AAoxIlB;AAjxIoB;EACE,eAAA;AAmxItB;AA/wIkB;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAixIpB;AA/wIoB;EACE,eAAA;AAixItB;AA9wIoB;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAgxItB;AA3wIoB;EACE,gBAAA;EACA,cD3gBL;EC4gBK,gBAAA;AA6wItB;AA3wIsB;EACE,cDnhBP;ECohBO,gBAAA;AA6wIxB;AAvwIgB;EACE,kBAAA;AAywIlB;AAvwIkB;EACE,qBAAA;EACA,sBAAA;AAywIpB;AAvwIoB;EACE,iBAAA;AAywItB;AAjwIU;EACE,aAAA;AAmwIZ;AAjwIY;EAHF;IAII,cAAA;EAowIZ;AACF;AAlwIY;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;AAowId;AAlwIc;EACE,gBAAA;AAowIhB;AAjwIc;EACE,mBAAA;EACA,YAAA;AAmwIhB;AAjwIgB;EACE,eAAA;AAmwIlB;AA/vIc;EACE,aAAA;EAGA,gCAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;AA+vIhB;AA5vIkB;EACE,gBAAA;AA8vIpB;AA3vIkB;EACE,gBAAA;AA6vIpB;AA3vIoB;EACE,cDllBL;AC+0JjB;AAzvIkB;EACE,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AA2vIpB;AAxvIsB;EACE,eAAA;AA0vIxB;AAtvIoB;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAwvItB;AAtvIsB;EACE,eAAA;AAwvIxB;AArvIsB;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAuvIxB;AAlvIsB;EACE,gBAAA;EACA,cD9nBP;EC+nBO,gBAAA;AAovIxB;AAlvIwB;EACE,cDtoBT;ECuoBS,gBAAA;AAovI1B;AA5uIc;EACE,gBAAA;AA8uIhB;AA5uIgB;EACE,gBAAA;AA8uIlB;AA5uIkB;EACE,cDlpBH;ACg4JjB;AAzuIc;EACE,aAAA;EACA,iDAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AA2uIhB;AAzuIgB;EACE,cAAA;AA2uIlB;AAzuIkB;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AA2uIpB;AAtuIc;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAwuIhB;AAruIkB;EACE,gBAAA;AAuuIpB;AAruIoB;EACE,cDvrBL;AC85JjB;AAjuIc;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAmuIhB;AAhuIkB;EACE,gBAAA;AAkuIpB;AAhuIoB;EACE,cDzsBL;AC26JjB;AA/tIoB;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAiuItB;AA3tIc;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AA6tIhB;AA1tIkB;EACE,gBAAA;AA4tIpB;AA1tIoB;EACE,cDluBL;AC87JjB;AAhtIM;EACE,mBAAA;AAktIR;AAhtIQ;EAHF;IAII,mBAAA;EAmtIR;AACF;AAjtIQ;EACE,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;AAmtIV;AAjtIU;EACE,qBAAA;AAmtIZ;AAjtIY;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAmtId;AAjtIc;EARF;IASI,YAAA;IAEA,gBAAA;EAmtId;AACF;AAjtIc;EACE,WAAA;EACA,mBDjwBR;ECkwBQ,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AAmtIhB;AA/sIgB;EACE,cAAA;AAitIlB;AA9sIgB;EACE,cDhxBV;ACg+JR;AA5sIc;EACE,cDpyBC;ECqyBD,gBAAA;AA8sIhB;AA5sIgB;EAJF;IAMI,eAAA;IACA,iBAAA;IACA,gBAAA;EA8sIhB;AACF;AA5rIE;EACE,gBAAA;AA8rIJ;AA5rII;EACE,mBAAA;EACA,YAAA;AA8rIN;AA5rIM;EACE,aAAA;AA8rIR;AA3rIU;EACE,kBAAA;AA6rIZ;AA1rIc;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AA4rIhB;AAzrIc;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AA2rIhB;AAxrIc;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AA0rIhB;AAvrIc;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAyrIhB;AAvrIgB;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAyrIlB;AAvrIkB;EACE,0BAAA;AAyrIpB;;AA5qIE;EACE,kBAAA;AA+qIJ;AA7qII;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA+qIN;AA7qIM;EACE,WAAA;AA+qIR;AA7qIQ;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AA+qIV;AA5qIQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AA8qIV;AA3qIQ;EACE,eAAA;EACA,WAAA;EACA,SAAA;AA6qIV;AA3qIU;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AA6qIZ;AA3qIY;EACE,0BAAA;AA6qId;;AAjqIA;EACE,iBAAA;AAoqIF;AAlqIE;EACE,mBAAA;EACA,mBAAA;AAoqIJ;AAlqII;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;EACA,mBD77BS;ACimKf;AAjqII;EACE,gBAAA;EACA,kBAAA;AAmqIN;AAjqIM;EACE,qBAAA;AAmqIR;AAjqIQ;EACE,gBAAA;AAmqIV;AA/pIM;EACE,gBAAA;AAiqIR;AA/pIQ;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAiqIV;AA1pII;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AA4pIN;AA1pIM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA4pIR;AAzpIM;EACE,kBAAA;EACA,gBAAA;AA2pIR;AAzpIQ;EACE,cAAA;AA2pIV;AAzpIU;EACE,eAAA;AA2pIZ;AAxpIU;EACE,eAAA;EACA,YAAA;AA0pIZ;AAxpIY;EACE,eAAA;AA0pId;AAnpIQ;EACE,mBAAA;AAqpIV;AAnpIU;EACE,gBAAA;AAqpIZ;AAnpIY;EACE,YAAA;EACA,gBAAA;AAqpId;AAlpIY;EACE,gBAAA;EACA,kBAAA;AAopId;AAlpIc;EACE,gBAAA;AAopIhB;AA/oIU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAipIZ;AA9oIU;EACE,mBAAA;EACA,kBAAA;AAgpIZ;AA7oIU;EACE,iBAAA;AA+oIZ;AA7oIY;EACE,eAAA;AA+oId;AA3oIU;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cDthCJ;ACmqKR;AA3oIY;EACE,cAAA;AA6oId;AA1oIY;EACE,oBAAA;AA4oId;AAxoIU;EACE,kBAAA;AA0oIZ;AAxoIY;EACE,0BAAA;AA0oId;AAvoIY;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;AAyoId;AAroIU;EACE,gBAAA;AAuoIZ;AAxnII;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AA0nIN;AAxnIM;EANF;IAOI,mBAAA;EA2nIN;AACF;;AAlnIE;EACE,mBD5mCQ;EC6mCR,4BAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAqnIJ;AAnnII;EAPF;IAQI,iBAAA;IACA,kBAAA;EAsnIJ;AACF;AApnII;EACE,iBAAA;AAsnIN;AApnIM;EACE,kBAAA;AAsnIR;AApnIQ;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAsnIV;AAlnIM;EACE,kBAAA;AAonIR;AAlnIQ;EACE,gBAAA;EACA,YAAA;AAonIV;AAlnIU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAonIZ;AAlnIY;EACE,mBAAA;AAonId;AAjnIY;EACE,gBAAA;EACA,gBAAA;AAmnId;AAhnIY;EACE,gBAAA;AAknId;AA/mIY;EACE,eAAA;AAinId;;AArmIA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAwmIF;AAtmIE;EAPF;IAQI,uBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,UAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,mBDrqCI;EC8wKN;AACF;AAvmIE;EACE,cAAA;AAymIJ;AAvmII;EAHF;IAII,aAAA;EA0mIJ;AACF;AAvmIE;EACE,aAAA;AAymIJ;AAvmII;EAHF;IAII,cAAA;EA0mIJ;AACF;AAxmII;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AA0mIN;AAvmIQ;EACE,qBAAA;EACA,kBAAA;AAymIV;AApmIgB;EACE,6HAAA;AAsmIlB;AAjmIY;EACE,cD/sCN;ACkzKR;AA/lIU;EACE,kBAAA;AAimIZ;AA/lIY;EACE,eAAA;AAimId;AA/lIc;EACE,0HAAA;AAimIhB;AA9lIc;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAgmIhB;AA3lIU;EACE,gBAAA;EACA,gBAAA;EACA,+BAAA;AA6lIZ;AAplIM;EACE,gBAAA;AAslIR;AAplIQ;EAHF;IAII,gBAAA;EAulIR;AACF;AAllIE;EACE,iBAAA;AAolIJ;AAllII;EACE,qBAAA;EACA,sBAAA;AAolIN;AAllIM;EACE,kBAAA;AAolIR;AA/kIU;EACE,eAAA;AAilIZ;AA5kIU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA8kIZ;;AApkIE;EACE,UAAA;AAukIJ;AApkIE;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,4BAAA;EACA,mBDryCI;AC22KR;AApkII;EAPF;IAQI,iBAAA;IACA,iBAAA;EAukIJ;AACF;AApkIM;EADF;IAEI,iBAAA;EAukIN;AACF;AApkII;EACE,aAAA;AAskIN;AApkIM;EAHF;IAII,cAAA;IACA,mBAAA;IACA,kBAAA;EAukIN;AACF;AArkIM;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;EACA,mBDt1CO;AC65Kf;AApkIM;EACE,qBAAA;EACA,gBAAA;AAskIR;AApkIQ;EACE,gBAAA;AAskIV;AAjkII;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBDv2CS;ECw2CT,mBAAA;EACA,kBAAA;EACA,iBAAA;AAmkIN;AAjkIM;EATF;IAUI,gCAAA;EAokIN;AACF;AAlkIM;EAbF;IAcI,oBAAA;IACA,2BAAA;IACA,gBAAA;EAqkIN;AACF;AAnkIM;EACE,yBAAA;AAqkIR;AAnkIQ;EAHF;IAII,UAAA;IACA,kBAAA;EAskIR;AACF;AApkIQ;EACE,SAAA;AAskIV;AApkIU;EAHF;IAII,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;EAukIV;AACF;AApkIQ;EACE,mBAAA;AAskIV;AApkIU;EAHF;IAII,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;EAukIV;AACF;AAnkIU;EADF;IAEI,gBAAA;EAskIV;AACF;AApkIU;EACE,qBAAA;EACA,sBAAA;AAskIZ;AApkIY;EACE,kBAAA;AAskId;AApkIc;EAHF;IAII,iBAAA;EAukId;AACF;AAnkIc;EADF;IAEI,iBAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAskId;AACF;AApkIc;EARF;IASI,iBAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAukId;AACF;AApkIgB;EADF;IAEI,aAAA;EAukIhB;AACF;AA/jIQ;EADF;IAEI,iBAAA;EAkkIR;AACF;AAhkIQ;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AAkkIV;AAhkIU;EARF;IASI,gBAAA;EAmkIV;AACF;AAjkIU;EAZF;IAaI,kBAAA;EAokIV;AACF;AA/jII;EACE,mBDv9CS;ECw9CT,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAikIN;AA/jIM;EATF;IAUI,mBAAA;EAkkIN;AACF;AAhkIM;EAbF;IAcI,aAAA;IACA,mBAAA;EAmkIN;AACF;AAhkIQ;EADF;IAEI,aAAA;IACA,uBAAA;IACA,8BAAA;IACA,mBAAA;EAmkIR;AACF;AAjkIQ;EACE,gBAAA;EACA,gBAAA;AAmkIV;AAjkIU;EACE;IACE,aAAA;EAmkIZ;AACF;AA/jIQ;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cD1+CF;EC2+CE,uBDvgDC;ACwkLX;AA/jIU;EAPF;IAQI,eAAA;IACA,iBAAA;EAkkIV;AACF;AAhkIU;EAZF;IAaI,eAAA;IACA,iBAAA;EAmkIV;AACF;AA9jIQ;EACE,WAAA;EACA,aAAA;EACA,mBDlhDK;ECmhDL,8BAAA;EACA,gCAAA;EACA,kBAAA;AAgkIV;AAvjIQ;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AAyjIV;AAvjIU;EALF;IAMI,kBAAA;EA0jIV;AACF;AAxjIU;EACE,wBAAA;EACA,kBAAA;AA0jIZ;AAxjIY;EAJF;IAKI,uBAAA;IACA,wBAAA;IACA,gBAAA;EA2jIZ;AACF;AArjII;EACE,mBDtjDS;ECujDT,mBAAA;EACA,kBAAA;EACA,yBAAA;AAujIN;AArjIM;EACE,mBAAA;AAujIR;AAjjIU;;EAEE,wBAAA;AAmjIZ;AA/iIY;EACE,aAAA;EACA,mBAAA;AAijId;AA/iIc;EACE,kBAAA;AAijIhB;AA/iIgB;EACE,mBD9kDH;EC+kDG,mBAAA;EACA,aAAA;AAijIlB;AA/iIkB;EACE,mBAAA;AAijIpB;AA/iIoB;EACE,eAAA;AAijItB;AA5iIoB;EACE,gBAAA;EACA,gBAAA;AA8iItB;AA5iIsB;EACE,gBAAA;EACA,kBAAA;AA8iIxB;AAliII;EACE,gBAAA;AAoiIN;AAliIM;EACE,cD/lDA;ECgmDA,gBAAA;AAoiIR;AAjiIM;EACE,cDpmDA;ECqmDA,gBAAA;AAmiIR;AAhiIM;EACE,gBAAA;AAkiIR;AA/hIM;EACE,iBAAA;AAiiIR;AA/hIQ;EAHF;IAII,gBAAA;EAkiIR;AACF;AAhiIQ;EACE,qBAAA;EACA,sBAAA;AAkiIV;AAhiIU;EAJF;IAKI,cAAA;EAmiIV;AACF;AAjiIU;EACE,kBAAA;AAmiIZ;AA/hIY;EADF;IAEI,eAAA;EAkiIZ;AACF;;AAzhIE;EACE,YAAA;EACA,UAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AA4hIJ;AA1hII;EAGE,aAAA;EACA,gBAAA;EACA,uBAAA;AA0hIN;AAvhII;EACE,aAAA;AAyhIN;AArhIE;EACE,mBDrrDW;ECsrDX,oDD7pDW;EC8pDX,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAuhIJ;AArhII;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cD/rDW;ECgsDX,mBDpsDS;AC2tLf;AAjhIM;EAGE,cDzsDS;AC0tLjB;;AA1gIE;EACE,YAAA;EACA,UAAA;EACA,kCAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AA6gIJ;AA3gII;EAGE,aAAA;EACA,gBAAA;EACA,uBAAA;AA2gIN;AAxgII;EACE,aAAA;AA0gIN;AAtgIE;EACE,mBD1uDW;EC2uDX,oDDltDW;ECmtDX,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAwgIJ;AAtgII;EACE,UAAA;EACA,mBDtvDS;AC8vLf;AAhgIM;EACE,kBAAA;AAkgIR;AAhgIQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;AAkgIV;AA7/HY;EACE,eAAA;AA+/Hd;AAx/HY;EACE,cAAA;EACA,SAAA;AA0/Hd;AAv/HgB;EACE,gCAAA;AAy/HlB;AAr/Hc;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAu/HhB;AAp/HkB;EACE,gBAAA;AAs/HpB;AAn/HkB;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;AAq/HpB;AAl/HkB;EACE,cD3yDH;EC4yDG,gBAAA;AAo/HpB;AAh/HgB;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAk/HlB;AAh/HkB;EACE,eAAA;AAk/HpB;AA/+HkB;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EAEA,mBD9yDZ;AC8xLR;AAx+HQ;EACE,iBAAA;EACA,6BAAA;AA0+HV;AAx+HU;EACE,cD3zDJ;EC4zDI,gBAAA;AA0+HZ;;AAh+HI;EACE,kBAAA;EACA,gBAAA;AAm+HN;AAj+HM;EACE,yBAAA;AAm+HR;AA19HM;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AA49HR;;AAt9HA;EACE,mBDz3DU;EC03DV,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AAy9HF;AAn9HU;EACE,gBAAA;AAq9HZ;AA58HU;EACE,gBAAA;AA88HZ;AAt8HI;EACE,eAAA;AAw8HN;AAp8HE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAs8HJ;AAp8HI;EANF;IAOI,SAAA;EAu8HJ;AACF;AAr8HI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAu8HN;AAp8HQ;EACE,eAAA;AAs8HV;AAj8HQ;EACE,gBAAA;AAm8HV;AA97HI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAg8HN;AA97HM;EACE,gBAAA;AAg8HR;AA97HQ;EAHF;IAII,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;EAi8HR;AACF;AA57HU;EACE,yBAAA;AA87HZ;AAx7HQ;EACE,eAAA;EACA,gCAAA;AA07HV;AAx7HU;EAJF;IAKI,eAAA;EA27HV;AACF;AAr7HE;EACE,aAAA;EACA,kBAAA;EACA,mBDh+DQ;ECi+DR,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;AAu7HJ;AAr7HI;EAbF;IAcI,aAAA;EAw7HJ;AACF;AD7kKE;EACE,yBAx1BQ;EAy1BR,WAAA;AC+kKJ;AD7kKE;EACE,yBA51BQ;AC26LZ;AD7kKE;EACE,yBAv0BI;EAw0BJ,mBAAA;EACA,yBAAA;AC+kKJ;AD7kKE;EACE,aAAA;AC+kKJ;AAn8HI;EAoBE,aAAA;AAk7HN;AAr8HM;EACE,yBDl/DI;ECm/DJ,WAAA;AAu8HR;AAp8HM;EACE,yBDv/DI;AC67LZ;AAn8HM;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;AAq8HR;AAl8HM;EACE,aAAA;AAo8HR;AA97HI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAg8HN;AA97HM;EACE,kBAAA;AAg8HR;AAz7HM;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AA27HR;AAz7HQ;EAEE,mBAAA;AA07HV;AAv7HQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAy7HV;AAt7HY;EACE,eAAA;AAw7Hd;AAp7HU;EACE,gBAAA;AAs7HZ;AAl7HQ;EACE,gBAAA;AAo7HV;AAl7HU;EAHF;IAII,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;EAq7HV;AACF;;AA96HA;EACE,mBAAA;EACA,kBAAA;AAi7HF;AA/6HE;EAJF;IAKI,uBAAA;EAk7HF;AACF;AAh7HE;EACE,aAAA;EACA,mBAAA;EACA,kCAAA;AAk7HJ;AAh7HI;EALF;IAMI,8BAAA;EAm7HJ;AACF;AAj7HI;EATF;IAUI,cAAA;EAo7HJ;AACF;AAl7HI;EACE,gBAAA;AAo7HN;AAj7HQ;EADF;IAEI,aAAA;EAo7HR;AACF;AAh7HI;EACE,kBAAA;EACA,gBAAA;AAk7HN;AAh7HM;EAJF;IAKI,gBAAA;EAm7HN;AACF;AAj7HM;EARF;IASI,eAAA;EAo7HN;AACF;AAl7HM;EACE,qBAAA;EACA,sBAAA;AAo7HR;AAl7HQ;EACE,iBAAA;AAo7HV;AAj7HQ;EACE,qBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cDtmEF;ECumEE,yBAAA;AAm7HV;AAj7HU;EACE,cD3mEJ;EC4mEI,mBD3mEJ;AC8hMR;AAh7HU;EACE,aAAA;AAk7HZ;AA/6HU;EACE,eAAA;AAi7HZ;AA96HU;EACE,cAAA;AAg7HZ;AA96HY;EAHF;IAII,aAAA;EAi7HZ;AACF;AA96HU;EACE,aAAA;AAg7HZ;AA96HY;EAHF;IAII,cAAA;EAi7HZ;AACF;AA96HU;EACE,eAAA;EACA,eAAA;AAg7HZ;AA16HI;EACE,gBAAA;EACA,iBAAA;AA46HN;AA16HM;EAJF;IAKI,gBAAA;IACA,kBAAA;EA66HN;AACF;;AAv6HE;EAEE,8BAAA;UAAA,sBAAA;EACA,uBAAA;EACA,UAAA;AAy6HJ;;AAj6HE;EACE,iBAAA;AAo6HJ;AAl6HI;EACE,UAAA;EACA,mBAAA;EACA,mBDrsEM;ECssEN,iBAAA;AAo6HN;AAl6HM;EANF;IAOI,cAAA;EAq6HN;AACF;AAn6HM;EACE,UAAA;AAq6HR;AAl6HU;EACE,uBAAA;AAo6HZ;AAj6HY;EACE,gBAAA;EACA,gBAAA;AAm6Hd;AAh6HY;EACE,iBAAA;AAk6Hd;AA/5HgB;EACE,eAAA;AAi6HlB;AA35HU;EACE,oBAAA;AA65HZ;AAz5HgB;EACE,mBAAA;AA25HlB;AAx5HgB;EACE,mBAAA;AA05HlB;AAt5HkB;EACE,gBAAA;AAw5HpB;AAt5HoB;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDruEd;AC6nMR;AAt5HsB;EACE,cAAA;AAw5HxB;AAh5HoB;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;AAk5HtB;AAh5HsB;EACE,qBAAA;AAk5HxB;AAh5HwB;EACE,iBAAA;AAk5H1B;AA/4HwB;EACE,YAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAi5H1B;AA/4H0B;EAZF;IAaI,YAAA;EAk5H1B;AACF;AAh5H0B;EAhBF;IAiBI,YAAA;IACA,YAAA;EAm5H1B;AACF;AAj5H0B;EACE,mBAAA;EACA,qBAAA;AAm5H5B;AAj5H4B;EACE,cDvxEtB;AC0qMR;AA/4H0B;EACE,cD3xEpB;EC4xEoB,gBAAA;AAi5H5B;AAr4HwB;EACE,gBAAA;AAu4H1B;AAh4HgB;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AAk4HlB;AAh4HkB;EACE,iBAAA;EACA,gBAAA;AAk4HpB;AAh4HoB;EACE,gBAAA;EACA,mBAAA;AAk4HtB;AA/3HoB;EACE,kBAAA;EACA,kBAAA;AAi4HtB;AA/3HsB;EACE,kBAAA;AAi4HxB;AA/3HwB;EACE,eAAA;AAi4H1B;AA73HsB;EACE,gBAAA;EACA,gBAAA;AA+3HxB;AA33HoB;EACE,aAAA;EACA,mDAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AA63HtB;AA33HsB;EAPF;IAQI,mDAAA;EA83HtB;AACF;AA53HsB;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AA83HxB;AA53HwB;EACE,mBAAA;AA83H1B;AA53H0B;EACE,eAAA;AA83H5B;AA13HwB;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AA43H1B;AAv3HoB;EACE,kBAAA;EACA,kBAAA;AAy3HtB;AAv3HsB;EACE,mBAAA;AAy3HxB;AAv3HwB;EACE,gBAAA;EACA,YAAA;AAy3H1B;AAp3HwB;EACE,mBAAA;AAs3H1B;AAn3HwB;EACE,YAAA;EACA,iBAAA;AAq3H1B;AA/2HkB;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAi3HpB;AA/2HoB;EALF;IAMI,cAAA;EAk3HpB;AACF;AAh3HoB;EACE,YAAA;AAk3HtB;AAh3HsB;EAHF;IAII,mBAAA;EAm3HtB;AACF;AAj3HsB;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAm3HxB;AAj3HwB;EACE,qBAAA;AAm3H1B;AAj3H0B;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAm3H5B;AAj3H4B;EACE,mBAAA;EACA,qBAAA;AAm3H9B;AAj3H8B;EACE,cDn7ExB;ACsyMR;AA/2H4B;EACE,cDn8Eb;ECo8Ea,gBAAA;AAi3H9B;AAp2H4B;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDz8EtB;EC08EsB,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAs2H9B;AAn2H8B;EACE,cDj9ExB;ACszMR;AA51HkB;EACE,iBAAA;AA81HpB;AA51HoB;EACE,gBAAA;AA81HtB;AAt1HU;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;AAw1HZ;AAt1HY;EALF;IAMI,kBAAA;EAy1HZ;AACF;AAv1HY;EACE,iBAAA;AAy1Hd;AAv1Hc;EACE,qBAAA;EACA,sBAAA;AAy1HhB;AAv1HgB;EACE,kBAAA;AAy1HlB;AAt1HgB;EACE,gBAAA;AAw1HlB;;AAz0HI;EACE,gBAAA;AA40HN;AAv0HI;EACE,iBAAA;AAy0HN;AAp0HI;EACE,gBAAA;AAs0HN;AAl0HE;EACE,gBAAA;AAo0HJ;AAl0HI;EACE,UAAA;EACA,mBAAA;EACA,mBDzjFM;EC2jFN,iBAAA;AAm0HN;AAj0HM;EAPF;IAQI,cAAA;EAo0HN;AACF;AAl0HM;EACE,UAAA;AAo0HR;AA3zHE;EACE,4BAAA;EACA,gBAAA;AA6zHJ;AA3zHI;EACE,aAAA;AA6zHN;AA1zHI;EACE,aAAA;AA4zHN;AAzzHI;EACE,aAAA;AA2zHN;AAxzHI;EACE,aAAA;AA0zHN;AAvzHI;EACE,aAAA;AAyzHN;AAtzHI;EACE,aAAA;AAwzHN;AArzHI;EACE,aAAA;AAuzHN;AApzHI;EACE,aAAA;AAszHN;AAlzHE;EACE,aAAA;AAozHJ;AAjzHE;EACE,UAAA;EACA,gBAAA;EACA,mBDvnFQ;AC06MZ;AA9yHI;EACE,kBAAA;AAgzHN;AA7yHM;EAJF;IAKI,kBAAA;EAgzHN;AACF;AA9yHM;EACE,gBAAA;EACA,gBAAA;AAgzHR;AA7yHM;EACE,iBAAA;AA+yHR;AA5yHU;EACE,eAAA;AA8yHZ;AAzyHM;EACE,iBAAA;AA2yHR;AAxyHU;EADF;IAEI,eAAA;IACA,iBAAA;EA2yHV;AACF;AAvyHM;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAyyHR;AAvyHQ;EACE,aAAA;EACA,+BAAA;EACA,eAAA;EACA,mBAAA;AAyyHV;AAvyHU;EACE,eAAA;AAyyHZ;AAryHQ;EACE,gBAAA;AAuyHV;AAlyHI;EACE,oBAAA;AAoyHN;AAlyHM;EAHF;IAII,oBAAA;EAqyHN;AACF;AAlyHQ;EACE,aAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAoyHV;AAlyHU;EAPF;IAQI,aAAA;IACA,2BAAA;EAqyHV;AACF;AAlyHY;EACE,gBAAA;AAoyHd;AA/xHY;EADF;IAEI,gBAAA;IACA,kBAAA;EAkyHZ;AACF;AA7xHU;EACE,mBAAA;AA+xHZ;AA5xHU;EACE,mBAAA;AA8xHZ;AA5xHY;EACE,aAAA;AA8xHd;AA5xHc;EAHF;IAII,cAAA;EA+xHd;AACF;AA3xHU;EACE,gBAAA;AA6xHZ;AA1xHU;EACE,mBAAA;AA4xHZ;AA1xHY;EACE,gBAAA;AA4xHd;AAzxHY;EACE,gBAAA;EACA,iBAAA;AA2xHd;AAtxHY;EACE,gBAAA;AAwxHd;AAtxHc;EACE,aAAA;EACA,+BAAA;EACA,mBAAA;AAwxHhB;AAtxHgB;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;AAwxHlB;AAtxHkB;EACE,gBAAA;AAwxHpB;AApxHgB;EACE,0BAAA;AAsxHlB;AAlxHc;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDrwFR;ACyhNR;AAlxHgB;EACE,cAAA;AAoxHlB;AAhxHkB;EACE,cD7wFZ;AC+hNR;AA9wHgB;EACE,oBAAA;AAgxHlB;AA1wHU;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AA4wHZ;AA1wHY;EACE,kBAAA;EACA,kBAAA;AA4wHd;AA1wHc;EACE,mBAAA;AA4wHhB;AA1wHgB;EACE,gBAAA;EACA,YAAA;AA4wHlB;AAvwHgB;EACE,mBAAA;AAywHlB;AAtwHgB;EACE,YAAA;EACA,iBAAA;AAwwHlB;AAtwHkB;EAJF;IAKI,gBAAA;EAywHlB;AACF;AApwHY;EACE,iBAAA;AAswHd;AApwHc;EACE,gBAAA;AAswHhB;AAlwHY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAowHd;AAlwHc;EALF;IAMI,cAAA;EAqwHd;AACF;AAnwHc;EACE,YAAA;AAqwHhB;AAnwHgB;EAHF;IAII,mBAAA;EAswHhB;AACF;AApwHgB;EACE,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAswHlB;AApwHkB;EACE,qBAAA;AAswHpB;AApwHoB;EACE,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAswHtB;AApwHsB;EACE,mBAAA;EACA,qBAAA;AAswHxB;AApwHwB;EACE,cD12FlB;ACgnNR;AAlwHsB;EACE,cD13FP;EC23FO,gBAAA;AAowHxB;AAvvHsB;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDh4FhB;ECi4FgB,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAyvHxB;AAtvHwB;EACE,cDx4FlB;ACgoNR;AA9uHU;EACE,kBAAA;AAgvHZ;AA9uHY;EACE,cAAA;EACA,mBAAA;AAgvHd;AAzuHQ;EACE,mBAAA;AA2uHV;AAxuHQ;EACE,mBAAA;AA0uHV;AAxuHU;EACE,gBAAA;AA0uHZ;AAvuHU;EACE,iBAAA;AAyuHZ;AAvuHY;EACE,sBAAA;EACA,qBAAA;AAyuHd;AAvuHc;EACE,kBAAA;AAyuHhB;AAruHgB;EACE,eAAA;AAuuHlB;AAhuHQ;EAEE,cAAA;AAiuHV;AA3tHU;EACE,yBD99FA;EC+9FA,WAAA;AA6tHZ;AA1tHU;EACE,yBDn+FA;AC+rNZ;AAztHU;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;AA2tHZ;AAxtHU;EACE,aAAA;AA0tHZ;AAvtHU;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;AAytHZ;AAvtHY;EACE,gBAAA;AAytHd;AAttHY;EACE,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAwtHd;AArtHgB;EACE,eAAA;AAutHlB;AAntHc;EACE,eAAA;AAqtHhB;AAhtHc;EAEE,cAAA;AAitHhB;AA/sHgB;EAEE,gBAAA;AAgtHlB;AAzsHgB;EACE,gBAAA;AA2sHlB;AAzsHkB;EACE,cAAA;AA2sHpB;AAlsHM;EACE,gBAAA;AAosHR;AAlsHQ;EAHF;IAII,kBAAA;EAqsHR;AACF;AAnsHQ;EACE,gBAAA;AAqsHV;AAnsHU;EAHF;IAII,mBAAA;IACA,iBAAA;EAssHV;AACF;AApsHU;EACE,aAAA;AAssHZ;AApsHY;EAHF;IAII,cAAA;EAusHZ;AACF;AAnsHQ;EACE,iBAAA;AAqsHV;AAnsHU;EAHF;IAII,kBAAA;EAssHV;AACF;AApsHU;EACE,qBAAA;EACA,sBAAA;AAssHZ;AApsHY;EAJF;IAKI,cAAA;EAusHZ;AACF;AArsHY;EACE,kBAAA;AAusHd;AApsHY;EACE,gBAAA;AAssHd;AApsHc;EAHF;IAII,eAAA;EAusHd;AACF;AAhsHI;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;AAksHN;AAhsHM;EALF;IAMI,gBAAA;IACA,kBAAA;EAmsHN;AACF;AAjsHM;EACE,iBAAA;AAmsHR;AAjsHQ;EACE,qBAAA;EACA,sBAAA;AAmsHV;AAjsHU;EAJF;IAKI,cAAA;EAosHV;AACF;AAlsHU;EACE,kBAAA;AAosHZ;AAjsHU;EACE,gBAAA;AAmsHZ;AAjsHY;EAHF;IAII,eAAA;EAosHZ;AACF;;AA3rHE;EACE,iBAAA;AA8rHJ;AA5rHI;EACE,UAAA;EACA,mBAAA;EACA,mBD1oGM;ACw0NZ;AA5rHM;EALF;IAMI,cAAA;EA+rHN;AACF;AA7rHM;EACE,aAAA;AA+rHR;AA7rHQ;EAHF;IAII,aAAA;EAgsHR;AACF;AA7rHU;EACE,gBAAA;EACA,YAAA;AA+rHZ;AA7rHY;EACE,kBAAA;AA+rHd;AA5rHY;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA8rHd;AA5rHc;EACE,cD7oGT;EC8oGS,gBAAA;AA8rHhB;AAzrHc;EACE,mBAAA;AA2rHhB;AAzrHgB;EACE,mBAAA;AA2rHlB;AAxrHgB;EACE,gBAAA;AA0rHlB;AAxrHkB;EACE,gBAAA;AA0rHpB;AAxrHoB;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA0rHtB;AAxrHsB;EACE,cDtqGjB;ECuqGiB,gBAAA;AA0rHxB;AAprHgB;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;AAsrHlB;AAprHkB;EACE,gBAAA;AAsrHpB;AAlrHgB;EACE,kBAAA;AAorHlB;AAlrHkB;EACE,0BAAA;AAorHpB;AAjrHkB;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;AAmrHpB;AA/qHgB;EACE,iBAAA;EACA,eAAA;AAirHlB;AA/qHkB;EACE,cD9sGb;AC+3NP;AA3qHY;EACE,gBAAA;AA6qHd;AA3qHc;EACE,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AA6qHhB;AA3qHgB;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBDnuGV;ECouGU,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;AA6qHlB;AA1qHgB;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cD/uGV;ECgvGU,mBDxwGN;ECywGM,eAAA;EACA,kBAAA;EACA,UAAA;AA4qHlB;AAxqHc;EACE,kBAAA;EACA,gBAAA;AA0qHhB;AAxqHgB;EACE,qBAAA;AA0qHlB;AAxqHkB;EACE,kBAAA;AA0qHpB;AAtqHoB;EACE,eAAA;AAwqHtB;AAjqHY;EACE,gBAAA;AAmqHd;AAhqHgB;EACE,oCAAA;AAkqHlB;AA9pHc;EACE,iBAAA;EACA,gBAAA;AAgqHhB;AA1pHY;EADF;IAEI,aAAA;EA6pHZ;AACF;AA3pHY;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AA6pHd;;AAppHA;EACE,sBAAA;EACA,mBDp0Ga;AC29Nf;AArpHE;EAJF;IAKI,uBAAA;EAwpHF;AACF;AAtpHE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AAwpHJ;AAtpHI;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AAwpHN;AAppHE;EACE,UAAA;AAspHJ;AAppHI;EAHF;IAII,kBAAA;EAupHJ;AACF;AArpHI;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AAupHN;AArpHM;EALF;IAMI,cAAA;EAwpHN;AACF;AArpHQ;EACE,WAAA;AAupHV;AAnpHM;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;AAqpHR;AAnpHQ;EATF;IAUI,iBAAA;EAspHR;AACF;AAppHQ;EAbF;IAcI,aAAA;EAupHR;AACF;AArpHQ;EACE,yBAAA;EACA,8BAAA;EACA,mBAAA;AAupHV;AArpHU;EALF;IAMI,WAAA;EAwpHV;AACF;AAtpHU;EATF;IAUI,wBAAA;EAypHV;AACF;AAvpHU;EAbF;IAcI,iBAAA;IACA,yBAAA;EA0pHV;AACF;AAtpHM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AAwpHR;AAtpHQ;EAPF;IAQI,YAAA;EAypHR;ED9tMA;IACE,yBAx1BQ;IAy1BR,WAAA;ECguMF;ED9tMA;IACE,yBA51BQ;EC4jOV;ED9tMA;IACE,yBAv0BI;IAw0BJ,mBAAA;IACA,yBAAA;ECguMF;ED9tMA;IACE,aAAA;ECguMF;AACF;AArqHQ;EAZF;IAaI,eAAA;EAwqHR;AACF;AAtqHQ;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAwqHV;AAtqHU;EACE,mBAAA;EACA,kBAAA;AAwqHZ;AArqHU;EACE,kBAAA;EACA,gBAAA;AAuqHZ;AArqHY;EACE,cAAA;AAuqHd;AArqHc;EACE,gBAAA;AAuqHhB;AApqHc;EACE,eAAA;EACA,YAAA;AAsqHhB;AApqHgB;EACE,eAAA;AAsqHlB;AA/pHY;EACE,mBAAA;AAiqHd;AA/pHc;EACE,gBAAA;AAiqHhB;AA/pHgB;EACE,YAAA;EACA,gBAAA;AAiqHlB;AA9pHgB;EACE,gBAAA;EACA,kBAAA;AAgqHlB;AA9pHkB;EACE,gBAAA;AAgqHpB;AA3pHc;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AA6pHhB;AA1pHc;EACE,mBAAA;EACA,kBAAA;AA4pHhB;AAzpHc;EACE,iBAAA;AA2pHhB;AAzpHgB;EACE,eAAA;AA2pHlB;AAvpHc;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cD39GR;AConOR;AAvpHgB;EACE,cAAA;AAypHlB;AAtpHgB;EACE,oBAAA;AAwpHlB;AAppHc;EACE,kBAAA;AAspHhB;AAppHgB;EACE,0BAAA;AAspHlB;AAnpHgB;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;AAqpHlB;AAjpHc;EACE,gBAAA;AAmpHhB;AAtoHE;EACE,gBAAA;AAwoHJ;AAtoHI;EACE,UAAA;EACA,mBAAA;EAEA,mBD7gHE;EC8gHF,iBAAA;AAuoHN;AAroHM;EAPF;IAQI,cAAA;EAwoHN;AACF;AAtoHM;EACE,UAAA;AAwoHR;AAroHU;EACE,aAAA;AAuoHZ;AAroHY;EACE,mBAAA;AAuoHd;AApoHY;EACE,mBAAA;AAsoHd;AAnoHY;EACE,mBAAA;AAqoHd;AAnoHc;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AAqoHhB;AAnoHgB;EACE,kBAAA;AAqoHlB;AAloHgB;EACE,WAAA;EACA,mBDjkHD;ECkkHC,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AAooHlB;AA7nHU;EACE,aAAA;EACA,6BAAA;EAEA,mBDlkHJ;ECmkHI,4BAAA;EACA,iBAAA;AA8nHZ;AA5nHY;EARF;IASI,gBAAA;IACA,kBAAA;EA+nHZ;AACF;AA5nHc;EACE,qBAAA;EACA,sBAAA;AA8nHhB;AA5nHgB;EACE,kBAAA;AA8nHlB;AA3nHgB;EACE,gBAAA;AA6nHlB;AA3nHkB;EAHF;IAII,eAAA;EA8nHlB;AACF;;AAhnHA;EACE,oBAAA;AAmnHF;AAjnHE;EAHF;IAII,oBAAA;EAonHF;AACF;AAjnHI;EACE,kBAAA;AAmnHN;AA/mHE;EACE,kBAAA;EACA,YAAA;AAinHJ;AA/mHI;EAJF;IAKI,kBAAA;EAknHJ;AACF;AA/mHE;EACE,aAAA;EACA,kDAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAinHJ;AA/mHI;EAPF;IAQI,0BAAA;IACA,aAAA;EAknHJ;AACF;AAhnHI;EACE,cAAA;AAknHN;AA/mHI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBD5qHS;EC6qHT,yBAAA;EACA,oDAAA;EACA,UAAA;AAinHN;AA/mHM;EAhBF;IAiBI,qBAAA;EAknHN;AACF;AA/mHI;EACE,mBDvrHS;ECwrHT,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AAinHN;AA/mHM;EAXF;IAYI,iBAAA;IACA,kBAAA;EAknHN;AACF;AAhnHM;EAhBF;IAiBI,gBAAA;IACA,kBAAA;EAmnHN;AACF;AAjnHM;EACE,WAAA;AAmnHR;AAjnHQ;EACE,mBAAA;AAmnHV;AAjnHU;EACE,eAAA;AAmnHZ;AA9mHU;EACE,gBAAA;AAgnHZ;AA9mHY;EAHF;IAII,eAAA;IACA,iBAAA;EAinHZ;AACF;AA9mHU;EACE,cAAA;AAgnHZ;AA9mHY;EAHF;IAII,mBAAA;IACA,eAAA;IACA,iBAAA;EAinHZ;AACF;AA7mHY;EACE,eAAA;AA+mHd;AAxmHI;EACE,kBAAA;EACA,mBDrvHS;ECsvHT,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA0mHN;AAxmHM;EARF;IASI,aAAA;IACA,gBAAA;EA2mHN;AACF;AAzmHM;EACE,gBAAA;AA2mHR;AAzmHQ;EAHF;IAII,eAAA;IACA,iBAAA;EA4mHR;AACF;AAzmHM;EACE,cAAA;AA2mHR;AAzmHQ;EAHF;IAII,mBAAA;IACA,eAAA;IACA,iBAAA;EA4mHR;AACF;AAxmHQ;EADF;IAEI,gBAAA;EA2mHR;AACF;AAzmHQ;EACE,qBAAA;EACA,sBAAA;AA2mHV;AAzmHU;EACE,kBAAA;AA2mHZ;AAzmHY;EAHF;IAII,iBAAA;EA4mHZ;AACF;AArmHE;EACE,aAAA;EACA,mBD1yHW;EC2yHX,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AAumHJ;AApmHM;EAEE;;;;IAAA;AAymHR;AApmHQ;EACE,cAAA;AAsmHV;AApmHU;EAHF;IAII,aAAA;EAumHV;AACF;ADhlNE;EACE,yBAx1BQ;EAy1BR,WAAA;ACklNJ;ADhlNE;EACE,yBA51BQ;AC86OZ;ADhlNE;EACE,yBAv0BI;EAw0BJ,mBAAA;EACA,yBAAA;ACklNJ;ADhlNE;EACE,aAAA;ACklNJ;AAjnHQ;EACE,aAAA;EACA,8CAAA;EACA,gBAAA;AAmnHV;AAjnHU;EALF;IAMI,8CAAA;EAonHV;AACF;AAlnHU;EATF;IAUI,8CAAA;IACA,gBAAA;EAqnHV;AACF;AAnnHU;EAdF;IAeI,8CAAA;IACA,gBAAA;EAsnHV;AACF;AApnHU;EAnBF;IAoBI,8CAAA;IACA,gBAAA;EAunHV;AACF;AApnHQ;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;AAsnHV;AApnHU;EALF;IAMI,oDAAA;EAunHV;AACF;AArnHU;EATF;IAUI,oDAAA;IACA,gBAAA;EAwnHV;AACF;AAtnHU;EAdF;IAeI,mDAAA;IACA,gBAAA;EAynHV;AACF;AAtnHQ;EACE,aAAA;EACA,+DAAA;EACA,gBAAA;AAwnHV;AAtnHU;EALF;IAMI,+DAAA;IACA,iBAAA;EAynHV;AACF;AAtnHQ;EACE,aAAA;EAEA,oEAAA;EACA,gBAAA;AAunHV;AArnHU;EANF;IAOI,oEAAA;EAwnHV;AACF;AAtnHU;EAVF;IAWI,iBAAA;EAynHV;AACF;AAvnHU;EAdF;IAeI,oEAAA;EA0nHV;AACF;AAvnHQ;EACE,iBAAA;EACA,gCAAA;AAynHV;AAvnHU;EACE,6BAAA;EACA,gCAAA;EACA,mBAAA;AAynHZ;AArnHY;EACE,kBAAA;AAunHd;AApnHY;EACE,gBAAA;EACA,gBAAA;EACA,cD15HG;EC25HH,oBAAA;EACA,mBAAA;EACA,QAAA;AAsnHd;AApnHc;EACE,eAAA;AAsnHhB;AAhnHQ;EACE,iBAAA;EACA,gCAAA;AAknHV;AA7mHY;EACE,gBAAA;AA+mHd;AA3mHc;EACE,eAAA;AA6mHhB;AA1mHc;EACE,gBAAA;AA4mHhB;AAxmHY;EACE,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AA0mHd;AAvmHgB;EACE,eAAA;AAymHlB;AArmHc;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAumHhB;AArmHgB;EACE,eAAA;AAumHlB;AApmHgB;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAsmHlB;AAjmHgB;EACE,gBAAA;EACA,cDh+HD;ECi+HC,gBAAA;AAmmHlB;AAjmHkB;EACE,cDx+HH;ECy+HG,gBAAA;AAmmHpB;AA7lHY;EACE,kBAAA;AA+lHd;AA7lHc;EACE,qBAAA;EACA,sBAAA;AA+lHhB;AA7lHgB;EACE,iBAAA;AA+lHlB;AAxlHQ;EACE,kBAAA;EACA,gBAAA;AA0lHV;AAtlHM;EACE,aAAA;AAwlHR;AAtlHQ;EAHF;IAII,cAAA;EAylHR;AACF;AAvlHQ;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;AAylHV;AAvlHU;EACE,gBAAA;AAylHZ;AAtlHU;EACE,mBAAA;EACA,YAAA;AAwlHZ;AAtlHY;EACE,eAAA;AAwlHd;AAplHU;EACE,aAAA;EAGA,gCAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;AAolHZ;AAjlHc;EACE,gBAAA;AAmlHhB;AAhlHc;EACE,gBAAA;AAklHhB;AAhlHgB;EACE,cD5iID;AC8nPjB;AA9kHc;EACE,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AAglHhB;AA7kHkB;EACE,eAAA;AA+kHpB;AA3kHgB;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA6kHlB;AA3kHkB;EACE,eAAA;AA6kHpB;AA1kHkB;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AA4kHpB;AAvkHkB;EACE,gBAAA;EACA,cDxlIH;ECylIG,gBAAA;AAykHpB;AAvkHoB;EACE,cDhmIL;ECimIK,gBAAA;AAykHtB;AAjkHU;EACE,gBAAA;AAmkHZ;AAjkHY;EACE,gBAAA;AAmkHd;AAjkHc;EACE,cD5mIC;AC+qPjB;AA9jHU;EACE,aAAA;EACA,iDAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AAgkHZ;AA9jHY;EACE,cAAA;AAgkHd;AA9jHc;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AAgkHhB;AA3jHU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AA6jHZ;AA1jHc;EACE,gBAAA;AA4jHhB;AA1jHgB;EACE,cDjpID;AC6sPjB;AAtjHU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAwjHZ;AArjHc;EACE,gBAAA;AAujHhB;AArjHgB;EACE,cDnqID;AC0tPjB;AApjHgB;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAsjHlB;AAhjHU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AAkjHZ;AA/iHc;EACE,gBAAA;AAijHhB;AA/iHgB;EACE,cD5rID;AC6uPjB;;AAtiHA;EACE,oBAAA;AAyiHF;AAviHE;EAHF;IAII,eAAA;EA0iHF;AACF;AAxiHE;EACE,mBAAA;AA0iHJ;AAviHE;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;AAyiHJ;AAviHI;EACE,aAAA;AAyiHN;AAriHU;EACE,mBAAA;AAuiHZ;AApiHU;EACE,mBAAA;AAsiHZ;AAliHY;EACE,gBAAA;AAoiHd;AAhiHU;EACE,uBAAA;AAkiHZ;AA/hHU;EACE,iBAAA;AAiiHZ;AA3hHI;EACE,aAAA;EACA,mBAAA;AA6hHN;AA3hHM;EAJF;IAKI,kBAAA;EA8hHN;AACF;AA5hHM;EACE,iBAAA;AA8hHR;AA5hHQ;EACE,qBAAA;EACA,sBAAA;AA8hHV;AA5hHU;EACE,kBAAA;AA8hHZ;AA3hHU;EACE,gBAAA;AA6hHZ;AA3hHY;EAHF;IAII,gBAAA;EA8hHZ;AACF;;AArhHA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAwhHF;AAthHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAwhHJ;AAthHI;EANF;IAOI,cAAA;IACA,kBAAA;EAyhHJ;AACF;AAthHM;EADF;IAEI,mBAAA;EAyhHN;AACF;AAvhHM;EACE,qBAAA;EACA,sBAAA;AAyhHR;AAvhHQ;EACE,kBAAA;AAyhHV;AAthHQ;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAwhHV;AAthHU;EALF;IAMI,eAAA;IACA,iBAAA;EAyhHV;AACF;AAnhHM;EACE,qBAAA;EACA,sBAAA;AAqhHR;AAnhHQ;EACE,kBAAA;AAqhHV;AAjhHU;EACE,eAAA;AAmhHZ;;AAvgHE;EACE,mBD50II;EC60IJ,UAAA;AA0gHJ;;AArgHE;EADF;IAEI,wBAAA;EAygHF;AACF;;AAtgHA;EACE,aAAA;AAygHF;AAvgHE;EAHF;IAII,yBAAA;EA0gHF;AACF;;AA//GI;EADF;;;;;;;IAEI,iBAAA;EAygHJ;AACF;;AArgHA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;AAwgHF;AAtgHE;EAPF;IAQI,QAAA;EAygHF;AACF;AArgHM;EADF;IAEI,0BAAA;EAwgHN;AACF;AApgHE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wDAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,8BAAA;EACA,gBAAA;AAsgHJ;AApgHI;EAZF;IAaI,+BAAA;IACA,gBAAA;IACA,kBAAA;EAugHJ;AACF;AAngHQ;EACE,gBAAA;AAqgHV;AAngHU;EAHF;IAII,eAAA;EAsgHV;AACF;AAhgHM;EACE,aAAA;AAkgHR;AAhgHQ;EAHF;IAII,cAAA;IACA,iBAAA;EAmgHR;AACF;AAjgHQ;EACE,eAAA;AAmgHV;AA//GM;EACE,iBAAA;AAigHR;AA//GQ;EAHF;IAII,eAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;IACA,WAAA;IACA,gBAAA;IACA,YAAA;IACA,oDAAA;IACA,mBDx7IF;ICy7IE,0BAAA;IACA,aAAA;EAkgHR;EAhgHQ;IACE,cAAA;EAkgHV;AACF;AA//GQ;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AAigHV;AA//GU;EALF;IAMI,cAAA;EAkgHV;AACF;AAhgHU;EACE,kBAAA;AAkgHZ;AAhgHY;EAHF;IAII,SAAA;IACA,gCAAA;EAmgHZ;AACF;AAhgHU;EACE,kBAAA;AAkgHZ;AAhgHY;EAHF;IAII,SAAA;EAmgHZ;AACF;AAjgHY;EACE,WAAA;EACA,oEAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AAmgHd;AAjgHc;EAXF;IAYI,WAAA;IACA,WAAA;IACA,wHAAA;EAogHd;AACF;AAhgHU;EACE,cD9+IJ;EC++II,gBAAA;EACA,qBAAA;AAkgHZ;AAhgHY;EALF;IAMI,cAAA;IACA,gBAAA;IACA,gBAAA;IACA,cDr/IN;ICs/IM,4BAAA;EAmgHZ;AACF;AA9/GY;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,kBAAA;EACA,wDAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;AAggHd;AA9/Gc;EACE,cAAA;AAggHhB;AA7/Gc;EACE,cAAA;EACA,SAAA;EACA,mBAAA;AA+/GhB;AA7/GgB;EACE,cDphJV;ECqhJU,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;AA+/GlB;AA7/GkB;EACE,0CAAA;AA+/GpB;AA5/GkB;EAZF;IAaI,cD/hJZ;ICgiJY,kBAAA;EA+/GlB;EA7/GkB;IACE,qCAAA;EA+/GpB;AACF;AA1/Gc;EA7CF;IA8CI,gBAAA;IACA,mBD5iJR;IC6iJQ,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,UAAA;IACA,cAAA;EA6/Gd;EA3/Gc;IACE,cAAA;EA6/GhB;AACF;AAz/GY;EACE;IACE,aAAA;EA2/Gd;EAz/Gc;IACE,cAAA;EA2/GhB;AACF;AAv/GY;EACE,YAAA;EACA,mBAAA;AAy/Gd;AAv/Gc;EACE,mBAAA;EACA,+BAAA;AAy/GhB;AAv/GgB;EAJF;IAKI,yBAAA;EA0/GhB;AACF;;AAh/GA;EACE,kBAAA;AAm/GF;ADtvOE;EACE,WAAA;EACA,mDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACwvOJ;ADvvOI;EAXF;IAYI,WAAA;EC0vOJ;AACF;ADzvOI;EAdF;IAeI,uBAAA;IACA,WAAA;EC4vOJ;AACF;ADrvOE;EACE,WAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;ACuvOJ;ADtvOI;EAZF;IAaI,WAAA;ECyvOJ;AACF;ADxvOI;EAfF;IAgBI,uBAAA;IACA,WAAA;EC2vOJ;AACF;AA5hHI;EAFF;IAGI,aAAA;EA+hHJ;AACF;AA3hHI;EADF;IAEI,UAAA;EA8hHJ;AACF;AA3hHE;EACE,kBAAA;EACA,cAAA;AA6hHJ;AA3hHI;EAJF;IAKI,cAAA;EA8hHJ;AACF;AA5hHI;EARF;IASI,SAAA;EA+hHJ;AACF;AA7hHI;EACE,WAAA;EACA,YAAA;AA+hHN;AA7hHM;EAJF;IAKI,iBAAA;EAgiHN;AACF;AA7hHI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA+hHN;AA7hHM;EATF;IAUI,SAAA;IACA,eAAA;EAgiHN;AACF;AA9hHM;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAgiHR;AA9hHQ;EAVF;IAWI,gBAAA;IACA,mBAAA;EAiiHR;AACF;AA/hHQ;EACE,eAAA;AAiiHV;AA9hHQ;EACE,cAAA;EACA,gBAAA;AAgiHV;AA5hHM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDxqJA;ECyqJA,SAAA;AA8hHR;AA5hHQ;EAPF;IAQI,eAAA;IACA,iBAAA;EA+hHR;AACF;AA7hHQ;EAZF;IAaI,eAAA;IACA,iBAAA;EAgiHR;AACF;AA7hHM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;AA+hHR;AA7hHQ;EAPF;IAQI,cAAA;IACA,eAAA;IACA,iBAAA;EAgiHR;EA9hHQ;IACE,aAAA;EAgiHV;AACF;AA3hHQ;EACE,qBAAA;EACA,sBAAA;AA6hHV;AA3hHU;EACE,kBAAA;AA6hHZ;AAzhHY;EADF;IAEI,YAAA;IACA,gBAAA;EA4hHZ;AACF;;AAphHA;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gCAAA;AAuhHF;ADp6OE;EACE,WAAA;EACA,mDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACs6OJ;ADr6OI;EAXF;IAYI,WAAA;ECw6OJ;AACF;ADv6OI;EAdF;IAeI,uBAAA;IACA,WAAA;EC06OJ;AACF;ADn6OE;EACE,WAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;ACq6OJ;ADp6OI;EAZF;IAaI,WAAA;ECu6OJ;AACF;ADt6OI;EAfF;IAgBI,uBAAA;IACA,WAAA;ECy6OJ;AACF;AAlkHE;EARF;IASI,eAAA;EAqkHF;AACF;AAnkHE;EAZF;IAaI,eAAA;EAskHF;AACF;AAnkHI;EACE,0BAAA;AAqkHN;AAnkHM;EACE,gBAAA;EACA,cAAA;AAqkHR;;AA/jHA;EACE,eAAA;EACA,gCAAA;EACA,kBAAA;AAkkHF;ADz7OE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;AC27OJ;AD17OI;EAVF;IAWI,WAAA;EC67OJ;AACF;AD57OI;EAbF;IAcI,WAAA;EC+7OJ;AACF;ADx7OE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;AC07OJ;ADz7OI;EAVF;IAWI,WAAA;EC47OJ;AACF;AD37OI;EAbF;IAcI,WAAA;EC87OJ;AACF;AAxmHE;EAPF;IAQI,eAAA;EA2mHF;AACF;AAzmHE;EAXF;IAYI,oBAAA;IACA,oBAAA;EA4mHF;AACF;AA1mHE;EAEE,wBAAA;AA2mHJ;AAzmHI;EAJF;IAKI,YAAA;EA4mHJ;AACF;AAxmHI;EACE,0BAAA;EACA,mBAAA;AA0mHN;AAxmHM;EAJF;IAKI,kBAAA;EA2mHN;AACF;AAxmHI;EACE,4BAAA;EACA,SAAA;AA0mHN;AAxmHM;EAJF;IAKI,eAAA;IACA,iBAAA;EA2mHN;AACF;;AAtmHA;EACE,iBAAA;EACA,gCAAA;EACA,kBAAA;AAymHF;AAvmHE;EALF;IAMI,mBAAA;IACA,oBAAA;EA0mHF;AACF;ADrhPE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACuhPJ;ADthPI;EAVF;IAWI,WAAA;ECyhPJ;AACF;ADxhPI;EAbF;IAcI,WAAA;EC2hPJ;AACF;ADphPE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACshPJ;ADrhPI;EAVF;IAWI,WAAA;ECwhPJ;AACF;ADvhPI;EAbF;IAcI,WAAA;EC0hPJ;AACF;AA/oHE;EAEE,wBAAA;AAgpHJ;AA5oHI;EACE,mBAAA;AA8oHN;AAzoHQ;EACE,QAAA;AA2oHV;AAzoHU;EAHF;IAII,QAAA;EA4oHV;AACF;AAzoHQ;EACE,QAAA;AA2oHV;AAzoHU;EAHF;IAII,QAAA;EA4oHV;AACF;AAvoHI;EACE,eAAA;AAyoHN;AAvoHM;EAHF;IAII,eAAA;IACA,mBAAA;EA0oHN;AACF;AAxoHM;EACE,uBDx3JG;ECy3JH,0BAAA;EACA,gBAAA;AA0oHR;AAxoHQ;EALF;IAMI,eAAA;IACA,iBAAA;EA2oHR;AACF;AAzoHQ;EAVF;IAWI,gBAAA;EA4oHR;AACF;AAxoHQ;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;AA0oHV;AAxoHU;EAVF;IAWI,eAAA;IACA,iBAAA;EA2oHV;AACF;AAzoHU;EAfF;IAgBI,kBAAA;IACA,eAAA;IACA,iBAAA;EA4oHV;AACF;AA1oHU;EACE,gBAAA;AA4oHZ;AA1oHY;EAHF;IAII,eAAA;EA6oHZ;AACF;AA1oHU;EACE,WAAA;EACA,iCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AA4oHZ;AA1oHY;EAVF;IAWI,UAAA;IACA,WAAA;EA6oHZ;AACF;AAzoHY;EACE,eAAA;AA2oHd;AAnoHM;EACE,WAAA;AAqoHR;;AA/nHA;EACE,kBAAA;EAGA,gCAAA;AAgoHF;ADxqPE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;AC0qPJ;ADzqPI;EAVF;IAWI,WAAA;EC4qPJ;AACF;AD3qPI;EAbF;IAcI,WAAA;EC8qPJ;AACF;ADvqPE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACyqPJ;ADxqPI;EAVF;IAWI,WAAA;EC2qPJ;AACF;AD1qPI;EAbF;IAcI,WAAA;EC6qPJ;AACF;AAxqHE;EANF;IAOI,oBAAA;IACA,oBAAA;EA2qHF;AACF;AAzqHE;EAEE,wBAAA;AA0qHJ;AAvqHE;EACE,aAAA;EACA,qCAAA;EACA,uBAAA;AAyqHJ;AAvqHI;EALF;IAMI,0BAAA;EA0qHJ;AACF;AAxqHI;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,uBAAA;AA0qHN;AAxqHM;EARF;IASI,0BAAA;IACA,kBAAA;IACA,gBAAA;EA2qHN;AACF;AAzqHM;EACE,+BAAA;AA2qHR;AAvqHQ;EACE,uBDl/JC;ECm/JD,0BAAA;EACA,gBAAA;AAyqHV;AAvqHU;EALF;IAMI,eAAA;IACA,iBAAA;EA0qHV;AACF;AAxqHU;EAVF;IAWI,eAAA;IACA,iBAAA;IACA,aAAA;IACA,gBAAA;IACA,+BAAA;IACA,mBAAA;EA2qHV;AACF;AAzqHU;EACE,aAAA;AA2qHZ;AAzqHY;EAHF;IAII,cAAA;IACA,WAAA;IACA,kBAAA;EA4qHZ;AACF;AAvqHU;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;AAyqHZ;AAvqHY;EAVF;IAWI,eAAA;IACA,iBAAA;EA0qHZ;AACF;AAxqHY;EAfF;IAgBI,kBAAA;IACA,eAAA;IACA,iBAAA;EA2qHZ;AACF;AAzqHY;EACE,eAAA;AA2qHd;AAxqHY;EACE,WAAA;EACA,iCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;AA0qHd;AAxqHc;EAVF;IAWI,UAAA;IACA,WAAA;EA2qHd;AACF;AAvqHc;EACE,eAAA;AAyqHhB;AAlqHM;EACE,eAAA;AAoqHR;AAlqHQ;EAHF;IAII,aAAA;EAqqHR;AACF;AAnqHQ;EACE,WAAA;EACA,mBAAA;AAqqHV;;AA9pHA;EACE,kBAAA;EAGA,gCAAA;AA+pHF;ADp1PE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACs1PJ;ADr1PI;EAVF;IAWI,WAAA;ECw1PJ;AACF;ADv1PI;EAbF;IAcI,WAAA;EC01PJ;AACF;ADn1PE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACq1PJ;ADp1PI;EAVF;IAWI,WAAA;ECu1PJ;AACF;ADt1PI;EAbF;IAcI,WAAA;ECy1PJ;AACF;AAvsHE;EANF;IAOI,oBAAA;EA0sHF;AACF;AAxsHE;EACE,aAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;AA0sHJ;AAxsHI;EANF;IAOI,0BAAA;EA2sHJ;AACF;AAzsHI;EACE,kBAAA;AA2sHN;AAzsHM;EAHF;IAII,oBAAA;EA4sHN;AACF;AA1sHM;EACE,cDllKA;ECmlKA,gBAAA;AA4sHR;AA1sHQ;EAJF;IAKI,eAAA;IACA,iBAAA;IACA,4BAAA;EA6sHR;AACF;AAxsHM;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AA0sHR;AAxsHQ;EALF;IAMI,aAAA;EA2sHR;AACF;;AArsHA;EACE,kBAAA;EAGA,gCAAA;AAssHF;ADj+PE;EACE,WAAA;EACA,mDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACm+PJ;ADl+PI;EAXF;IAYI,WAAA;ECq+PJ;AACF;ADp+PI;EAdF;IAeI,uBAAA;IACA,WAAA;ECu+PJ;AACF;ADh+PE;EACE,WAAA;EACA,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;ACk+PJ;ADj+PI;EAZF;IAaI,WAAA;ECo+PJ;AACF;ADn+PI;EAfF;IAgBI,uBAAA;IACA,WAAA;ECs+PJ;AACF;AAnvHE;EACE,qBAAA;EACA,6DAAA;EACA,2BAAA;EACA,sBAAA;AAqvHJ;AAnvHI;EANF;IAOI,qBAAA;IACA,6DAAA;IACA,2BAAA;IACA,wBAAA;EAsvHJ;AACF;AApvHI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AAsvHN;AAnvHI;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAqvHN;AAlvHI;EACE,mBAAA;EACA,kBAAA;AAovHN;AAjvHI;EACE,aAAA;EACA,sCAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;AAmvHN;AAjvHM;EARF;IASI,aAAA;IACA,UAAA;IACA,gBAAA;EAovHN;AACF;AAhvHQ;;;EAGE,mBAAA;AAkvHV;AA9uHM;EACE,mBAAA;AAgvHR;AA7uHU;EACE,0CAAA;AA+uHZ;AAzuHU;EAFF;IAGI,8BAAA;EA4uHV;EA1uHU;IACE,aAAA;IACA,wCAAA;EA4uHZ;AACF;AAvuHU;EADF;IAEI,8BAAA;EA0uHV;EAxuHU;IACE,aAAA;IACA,wCAAA;IACA,0CAAA;EA0uHZ;AACF;AAruHU;EADF;IAEI,8BAAA;EAwuHV;EAtuHU;IACE,aAAA;IACA,wCAAA;EAwuHZ;AACF;AAnuHU;EADF;IAEI,8BAAA;EAsuHV;EApuHU;IACE,aAAA;IACA,wCAAA;IACA,0CAAA;EAsuHZ;AACF;AAjuHU;EADF;IAEI,8BAAA;EAouHV;EAluHU;IACE,aAAA;IACA,wCAAA;EAouHZ;AACF;AA/tHU;EADF;IAEI,+BAAA;EAkuHV;EAhuHU;IACE,aAAA;IACA,wCAAA;IACA,2CAAA;EAkuHZ;AACF;AA9tHQ;EACE,kBAAA;EACA,mBDzvKF;EC0vKE,kBAAA;EACA,yBAAA;AAguHV;AA9tHU;EANF;IAOI,YAAA;IACA,gBAAA;IACA,kBAAA;EAiuHV;AACF;AA/tHU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDtwKJ;ECuwKI,uBDnyKD;ECoyKC,SAAA;AAiuHZ;AA/tHY;EARF;IASI,eAAA;IACA,iBAAA;EAkuHZ;AACF;;AA1tHA;EACE,kBAAA;AA6tHF;AD9mQE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACgnQJ;AD/mQI;EAVF;IAWI,WAAA;ECknQJ;AACF;ADjnQI;EAbF;IAcI,WAAA;EConQJ;AACF;AD7mQE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;AC+mQJ;AD9mQI;EAVF;IAWI,WAAA;ECinQJ;AACF;ADhnQI;EAbF;IAcI,WAAA;ECmnQJ;AACF;AAnwHE;EACE,aAAA;AAqwHJ;AAnwHI;EAHF;IAII,aAAA;EAswHJ;AACF;AApwHI;EAPF;IAQI,eAAA;EAuwHJ;AACF;AArwHI;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;AAuwHN;AArwHM;EAZF;IAaI,YAAA;IACA,oDAAA;EAwwHN;AACF;AArwHI;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;AAuwHN;AArwHM;EAZF;IAaI,YAAA;IACA,oDAAA;EAwwHN;AACF;AArwHI;EACE,aAAA;EACA,sCAAA;EACA,uBAAA;AAuwHN;AArwHM;EALF;IAMI,0BAAA;EAwwHN;AACF;AAtwHM;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAwwHR;AAtwHQ;EAPF;IAQI,aAAA;EAywHR;AACF;AAvwHQ;EAXF;IAYI,kBAAA;IACA,gBAAA;IACA,kBAAA;EA0wHR;AACF;AAxwHQ;EACE,+BAAA;AA0wHV;AAxwHU;EAHF;IAII,aAAA;IACA,gCAAA;EA2wHV;AACF;AAtwHU;EADF;IAEI,QAAA;EAywHV;AACF;AArwHU;EADF;IAEI,QAAA;EAwwHV;AACF;AApwHU;EADF;IAEI,QAAA;EAuwHV;AACF;AAlwHY;EADF;IAEI,eAAA;IACA,iBAAA;EAqwHZ;AACF;AAlwHU;EACE,cDx4KJ;ECy4KI,uBDr6KD;ECs6KC,mBAAA;AAowHZ;AAlwHY;EALF;IAMI,kBAAA;IACA,eAAA;IACA,iBAAA;EAqwHZ;AACF;AAlwHU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;AAowHZ;AAlwHY;EAPF;IAQI,eAAA;IACA,iBAAA;IACA,cD75KN;ECkqSN;AACF;AAnwHY;EACE,cDj6KN;ACsqSR;;AA3vHA;EACE,gBAAA;EACA,qEAAA;EACA,sBAAA;EACA,kBAAA;AA8vHF;ADz1QE;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;AC21QJ;AD11QI;EAXF;IAYI,WAAA;EC61QJ;AACF;AD51QI;EAdF;IAeI,uBAAA;IACA,WAAA;EC+1QJ;AACF;ADx1QE;EACE,WAAA;EACA,oDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;AC01QJ;ADz1QI;EAZF;IAaI,WAAA;EC41QJ;AACF;AD31QI;EAfF;IAgBI,uBAAA;IACA,WAAA;EC81QJ;AACF;AAzyHE;EARF;IASI,oBAAA;EA4yHF;AACF;AA1yHE;EAEE,qBAAA;AA2yHJ;AAxyHE;EACE,kBAAA;AA0yHJ;AAxyHI;EACE,cDj8KE;ECk8KF,gBAAA;AA0yHN;AAvyHI;EACE,gBAAA;EACA,cDv8KE;ACgvSR;AAvyHM;EAJF;IAKI,eAAA;IACA,iBAAA;IACA,mBAAA;EA0yHN;EAxyHM;IACE,aAAA;EA0yHR;AACF;AAryHM;EADF;IAEI,gBAAA;IACA,gBAAA;EAwyHN;AACF;;AAnyHA;EACE,kBAAA;EAGA,gCAAA;AAoyHF;AD/3QE;EACE,WAAA;EACA,mBAx4BI;EAy4BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;ACi4QJ;ADh4QI;EAVF;IAWI,WAAA;ECm4QJ;AACF;ADl4QI;EAbF;IAcI,WAAA;ECq4QJ;AACF;AD93QE;EACE,WAAA;EACA,mBA95BI;EA+5BJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;ACg4QJ;AD/3QI;EAVF;IAWI,WAAA;ECk4QJ;AACF;ADj4QI;EAbF;IAcI,WAAA;ECo4QJ;AACF;AA50HE;EAEE,qBAAA;EACA,UAAA;AA60HJ;AA30HI;EALF;IAMI,qBD5+Ka;EC0zSjB;AACF;AA30HE;EACE,UAAA;AA60HJ;AA10HE;EAEE,aAAA;AA20HJ;AAz0HI;EAJF;IAKI,kBAAA;EA40HJ;AACF;AA10HI;EARF;IASI,eAAA;EA60HJ;AACF;AA30HI;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;AA60HN;AA30HM;EAVF;IAWI,YAAA;IACA,qBD5gLW;EC01SjB;AACF;AA30HI;EACE,WAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;AA60HN;AA30HM;EAVF;IAWI,YAAA;IACA,qBD5hLW;EC02SjB;AACF;AA30HI;EACE,aAAA;EACA,sCAAA;EACA,uBAAA;AA60HN;AA30HM;EALF;IAMI,0BAAA;EA80HN;AACF;AA50HM;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AA80HR;AA50HQ;EAPF;IAQI,aAAA;IACA,gBAAA;IACA,kBAAA;IACA,cAAA;EA+0HR;AACF;AA30HU;EADF;IAEI,kBAAA;EA80HV;AACF;AA30HQ;EACE,mBAAA;EACA,yBAAA;AA60HV;AA30HU;EAJF;IAKI,aAAA;IACA,6BAAA;EA80HV;AACF;AA30HQ;EACE,mBAAA;AA60HV;AAx0HY;EADF;IAEI,eAAA;IACA,iBAAA;EA20HZ;AACF;AAx0HU;EACE,cDjlLJ;ECklLI,uBD9mLD;EC+mLC,mBAAA;AA00HZ;AAx0HY;EALF;IAMI,eAAA;IACA,iBAAA;IACA,kBAAA;EA20HZ;AACF;AAx0HU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDhmLJ;ECimLI,uBD7nLD;ACu8SX;AAx0HY;EAPF;IAQI,eAAA;IACA,iBAAA;EA20HZ;EAz0HY;IACE,aAAA;EA20Hd;AACF;AAv0HU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDjnLJ;ECknLI,gBAAA;AAy0HZ;AAv0HY;EAPF;IAQI,eAAA;IACA,iBAAA;EA00HZ;EAx0HY;IACE,aAAA;EA00Hd;AACF;AAv0HY;EACE,mBAAA;AAy0Hd;AAv0Hc;EAHF;IAII,kBAAA;EA00Hd;AACF;;AAj0HA;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AAo0HF;ADjoRE;EACE,WAAA;EACA,oDAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;ACmoRJ;ADloRI;EAXF;IAYI,WAAA;ECqoRJ;AACF;ADpoRI;EAdF;IAeI,uBAAA;IACA,WAAA;ECuoRJ;AACF;ADhoRE;EACE,WAAA;EACA,oDAAA;EACA,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;ACkoRJ;ADjoRI;EAZF;IAaI,WAAA;ECooRJ;AACF;ADnoRI;EAfF;IAgBI,uBAAA;IACA,WAAA;ECsoRJ;AACF;AA/2HE;EAVF;IAWI,oBAAA;IACA,iBAAA;EAk3HF;AACF;AAh3HE;EAEE,qBAAA;EACA,UAAA;AAi3HJ;AA92HE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,oBAAA;AAg3HJ;AA72HE;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AA+2HJ;AA72HI;EACE,gBAAA;EACA,+BAAA;EACA,SAAA;AA+2HN;AA72HM;EALF;IAMI,eAAA;IACA,iBAAA;EAg3HN;AACF;;AA32HA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;AA82HF;ADzqRE;EACE,WAAA;EACA,mBC0zJsB;EDzzJtB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,+BAAA;EACA,UAAA;AC2qRJ;AD1qRI;EAVF;IAWI,WAAA;EC6qRJ;AACF;AD5qRI;EAbF;IAcI,WAAA;EC+qRJ;AACF;ADxqRE;EACE,WAAA;EACA,mBCqyJqB;EDpyJrB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,8BAAA;EACA,UAAA;AC0qRJ;ADzqRI;EAVF;IAWI,WAAA;EC4qRJ;AACF;AD3qRI;EAbF;IAcI,WAAA;EC8qRJ;AACF;AAp5HE;EARF;IASI,eAAA;EAu5HF;AACF;AAr5HE;EAEE,qBAAA;EACA,UAAA;AAs5HJ;AAn5HE;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;AAq5HJ;AAn5HI;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AAq5HN;AAn5HM;EALF;IAMI,eAAA;IACA,iBAAA;EAs5HN;AACF","sourcesContent":["$screen-xs: 767px;\r\n$gabarito: 'Gabarito';\r\n$manrope: 'Manrope';\r\n$inter: 'Inter';\r\n\r\n$primary01: #DEEBF8;\r\n$primary02: #5235E8;\r\n\r\n$bg-primary01: #E6F2FE;\r\n$bg-primary02: #F0F1F3;\r\n$bg-primary03: #D3E4EC;\r\n\r\n$text-primary01: #191D23;\r\n$text-primary02: #787878;\r\n$text-primary03: #929DAE;\r\n$text-primary04: #64748B;\r\n$text-primary05: #4E4E4E;\r\n$text-primary06: #6C7B82;\r\n$text-primary07: rgba(230, 242, 254, 0.7);\r\n$text-primary08: #0D0637;\r\n$text-primary09: #717184;\r\n\r\n$border-primary01: #B5D2DF;\r\n$border-primary02: #AFB0B0;\r\n$border-primary03: #C3DBE5;\r\n$border-primary04: #D3E7F1;\r\n$border-primary05: #E5E5E5;\r\n\r\n$white: #ffffff;\r\n$black: #000000;\r\n$red: #F15338;\r\n$blue: #0074d4;\r\n\r\n$box-shadow01: 0 4px 20px 4px rgba(183, 186, 203, .15);\r\n$transition: all 0.2s ease-in-out;\r\n\r\nbody {\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  font-weight: 400;\r\n  color: $black;\r\n  font-family: $manrope;\r\n  background: $bg-primary01;\r\n}\r\n@mixin before-bg-line-img($image-url) {\r\n  &:before {\r\n    content: '';\r\n    background: url(#{$image-url});\r\n    background-repeat: repeat;\r\n    background-size: cover;\r\n    width: 80px;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    border-right: 1px solid $border-primary04;\r\n\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      width: 40px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      background: transparent;\r\n      width: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n// Usage\r\n//@include after-bg-line-img(\"../images/banner-left-bg-lines.png\");\r\n@mixin after-bg-line-img($image-url) {\r\n  &:after {\r\n    content: '';\r\n    background: url(#{$image-url});\r\n    background-position: right;\r\n    background-repeat: repeat;\r\n    background-size: cover;\r\n    width: 80px;\r\n    height: 100%;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    border-left: 1px solid $border-primary04;\r\n\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      width: 40px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      background: transparent;\r\n      width: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin before-bg-line($bg-color) {\r\n  &:before {\r\n    content: '';\r\n    background: $bg-color;\r\n    width: 80px;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    border-right: 1px solid $border-primary04;\r\n    z-index: 1;\r\n\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      width: 40px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      width: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin after-bg-line($bg-color) {\r\n  &:after {\r\n    content: '';\r\n    background: $bg-color;\r\n    width: 80px;\r\n    height: 100%;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    border-left: 1px solid $border-primary04;\r\n    z-index: 1;\r\n\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      width: 40px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      width: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n.container {\r\n  max-width: 1280px;\r\n}\r\n.p-lr-40{\r\n  padding-left: 40px;\r\n  padding-right: 40px;\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding-left: 32px;\r\n    padding-right: 32px;\r\n  }\r\n}\r\n\r\n\r\n//      ****************************  Text Element  ****************************\r\n\r\n\r\nh1 {\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  font-weight: 500;\r\n  color: $text-primary01;\r\n  font-family: $gabarito;\r\n  @media screen and (max-width: 991px) {\r\n    font-size: 28px;\r\n    line-height: 36px;\r\n  }\r\n}\r\nh2, .h2 {\r\n  font-size: 40px;\r\n  line-height: 48px;\r\n  font-weight: 700;\r\n  color: $text-primary01;\r\n  font-family: $gabarito;\r\n\r\n  @media screen and (max-width: 991px) {\r\n    font-size: 28px;\r\n    line-height: 36px;\r\n  }\r\n  &.w-500{\r\n    font-weight: 500;\r\n  }\r\n  &.w-400{\r\n    font-weight: 400;\r\n  }\r\n  &.f-48{\r\n    font-size: 48px;\r\n    line-height: 58px;\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      font-size: 40px;\r\n      line-height: 48px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      font-size: 24px;\r\n      line-height: 34px;\r\n      br{\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n}\r\nh3, .h3 {\r\n  font-size: 18px;\r\n  line-height: 26px;\r\n  font-weight: 700;\r\n  color: $text-primary01;\r\n  font-family: $manrope;\r\n  @media screen and (max-width: $screen-xs) {\r\n    //font-size: 16px;\r\n    //line-height: 22px;\r\n  }\r\n  &.f-17 {\r\n    font-size: 17px;\r\n    line-height: 25px;\r\n    @media screen and (max-width: $screen-xs) {\r\n      //font-size: 15px;\r\n      //line-height: 22px;\r\n    }\r\n  }\r\n  &.f-20 {\r\n    font-size: 20px;\r\n    line-height: 28px;\r\n    @media screen and (max-width: $screen-xs) {\r\n      //font-size: 18px;\r\n      //line-height: 26px;\r\n    }\r\n  }\r\n  &.f-24 {\r\n    font-size: 24px;\r\n    line-height: 32px;\r\n    @media screen and (max-width: $screen-xs) {\r\n      font-size: 20px;\r\n      line-height: 28px;\r\n    }\r\n  }\r\n  &.f-30 {\r\n    font-size: 30px;\r\n    line-height: 38px;\r\n    @media screen and (max-width: $screen-xs) {\r\n      font-size: 25px;\r\n      line-height: 33px;\r\n    }\r\n  }\r\n  &.f-32 {\r\n    font-size: 32px;\r\n    line-height: 40px;\r\n    @media screen and (max-width: $screen-xs) {\r\n      font-size: 25px;\r\n      line-height: 33px;\r\n    }\r\n  }\r\n  &.f-40 {\r\n    font-size: 40px;\r\n    line-height: 48px;\r\n    @media screen and (max-width: $screen-xs) {\r\n      font-size: 35px;\r\n      line-height: 42px;\r\n    }\r\n  }\r\n\r\n  &.w-400 {\r\n    font-weight: 400;\r\n  }\r\n  &.w-500 {\r\n    font-weight: 500;\r\n  }\r\n  &.w-600 {\r\n    font-weight: 600;\r\n  }\r\n\r\n  &.h-font {\r\n    font-family: $gabarito;\r\n  }\r\n}\r\n.h3 {\r\n  font-size: 22px;\r\n  line-height: 30px;\r\n  @media screen and (max-width: $screen-xs) {\r\n    //font-size: 18px;\r\n    //line-height: 26px;\r\n  }\r\n}\r\np, .p {\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n  font-weight: 500;\r\n  color: $text-primary01;\r\n  font-family: $manrope;\r\n  &.w-500 {\r\n    font-weight: 500;\r\n  }\r\n  &.w-600 {\r\n    font-weight: 600;\r\n  }\r\n  &.w-700 {\r\n    font-weight: 700;\r\n  }\r\n  &.w-800 {\r\n    font-weight: 800;\r\n  }\r\n\r\n  &.f-10 {\r\n    font-size: 10px;\r\n    line-height: 16px;\r\n  }\r\n  &.f-12 {\r\n    font-size: 12px;\r\n    line-height: 18px;\r\n  }\r\n  &.f-13 {\r\n    font-size: 13px;\r\n    line-height: 18px;\r\n  }\r\n  &.f-15 {\r\n    font-size: 15px;\r\n    line-height: 12px;\r\n  }\r\n  &.f-18 {\r\n    font-size: 18px;\r\n    line-height: 26px;\r\n  }\r\n  &.f-20 {\r\n    font-size: 20px;\r\n    line-height: 28px;\r\n  }\r\n\r\n  &.gray01{\r\n    color: $text-primary07;\r\n  }\r\n}\r\n.p {\r\n  font-size: 16px;\r\n  line-height: 25px;\r\n  /*@media screen and (max-width: $screen-xs) {\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n  }*/\r\n}\r\nstrong {\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n  font-weight: 600;\r\n  color: $text-primary01;\r\n  font-family: $manrope;\r\n  &.w-400{\r\n    font-weight: 400;\r\n  }\r\n}\r\nspan { // not used\r\n  font-size: 12px;\r\n  line-height: 19px;\r\n  font-weight: 400;\r\n  color: $text-primary02;\r\n  font-family: $manrope;\r\n  display: inline-block;\r\n}\r\na, .a {\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n  font-weight: 500;\r\n  color: $text-primary01;\r\n  font-family: $manrope;\r\n  text-decoration: none;\r\n  &:hover {\r\n    color: $text-primary01;\r\n    text-decoration: none;\r\n  }\r\n  &.w-600 {\r\n    font-weight: 600;\r\n  }\r\n  &.w-700 {\r\n    font-weight: 700;\r\n  }\r\n\r\n  &.f-12 {\r\n    font-size: 12px;\r\n    line-height: 18px;\r\n  }\r\n  &.f-16 {\r\n    font-size: 16px;\r\n    line-height: 25px;\r\n    @media screen and (max-width: $screen-xs) {\r\n      font-size: 14px;\r\n      line-height: 22px;\r\n    }\r\n  }\r\n}\r\nul {\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  li {\r\n    list-style: none;\r\n    display: inline-block;\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n    font-weight: 500;\r\n    color: $text-primary01;\r\n    font-family: $manrope;\r\n  }\r\n}\r\n//      ****************************  Button Element  ****************************\r\n.btn-style {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: auto;\r\n  height: 44px;\r\n  padding: 10px 16px;\r\n  color: $white;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  text-decoration: none;\r\n  font-family: $manrope;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  font-weight: 400;\r\n  background: $black;\r\n  border: 2px solid $black;\r\n  transition: all .3s ease-in-out;\r\n  overflow: hidden;\r\n  text-shadow: 0 40px 0 $white;\r\n  @media screen and (max-width: $screen-xs) {\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n    height: 44px;\r\n    padding: 10px 12px;\r\n  }\r\n  &:hover {\r\n    transition: all .3s ease-in-out;\r\n    background: $black;\r\n    border: 2px solid $black;\r\n    color: $white;\r\n    &:after {\r\n      left: -30%;\r\n      opacity: 1;\r\n      top: -20%;\r\n      transition-duration: .7s, .7s, .15s;\r\n      transition-property: left, top, opacity;\r\n      transition-timing-function: linear;\r\n    }\r\n    span {\r\n      transform: translateY(-40px);\r\n    }\r\n  }\r\n  span {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    font-weight: 600;\r\n  }\r\n  .icon-white {\r\n    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(17deg) brightness(104%) contrast(104%);\r\n    max-width: 18px;\r\n  }\r\n  span {\r\n    transition: transform 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55), -webkit-transform 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n  }\r\n  &:after {\r\n    content: \"\";\r\n    height: 200%;\r\n    width: 200%;\r\n    position: absolute;\r\n    left: -210%;\r\n    top: -50%;\r\n    background: linear-gradient(90deg, hsla(0, 0%, 100%, .13), hsla(0, 0%, 100%, .13) 77%, hsla(0, 0%, 100%, .5) 92%, hsla(0, 0%, 100%, 0));\r\n    opacity: 0;\r\n    transition: all .7s ease 0s;\r\n  }\r\n  &.small {\r\n    padding: 10px 15px 11px;\r\n    height: 30px;\r\n    font-size: 12px;\r\n    line-height: 18px;\r\n  }\r\n  &.h-36 {\r\n    padding: 5px 32px;\r\n    height: 36px;\r\n  }\r\n  &.transparent {\r\n    background: transparent;\r\n    border-color: $black;\r\n    color: $black;\r\n    padding: 10px 32px;\r\n    font-weight: 700;\r\n    @media screen and (max-width: $screen-xs) {\r\n      font-size: 14px;\r\n      line-height: 20px;\r\n      padding: 8px 8px;\r\n    }\r\n    &:after {\r\n      display: none;\r\n    }\r\n    &.white-border {\r\n      border-color: $white;\r\n      color: $white;\r\n    }\r\n  }\r\n  &.colored-border {\r\n    color: $primary01;\r\n    text-transform: capitalize;\r\n    border-radius: 60px;\r\n    background: 0 0;\r\n    //border-image-slice: 1!important;\r\n    //border-image: linear-gradient(135deg,#0088CC 0%,#e36159 80%);\r\n    background: linear-gradient(#fff, #fff) padding-box, linear-gradient(90deg, rgb(255 1 2), rgb(243 182 0 / 50%)) border-box;\r\n    border: 2px solid transparent;\r\n  }\r\n  &.text {\r\n    min-width: 90px;\r\n    height: 32px;\r\n    padding: 7px 5px;\r\n    background: transparent;\r\n    border: none;\r\n    box-shadow: none;\r\n    color: $primary01;\r\n  }\r\n  &.round {\r\n    border-radius: 50px;\r\n  }\r\n  &.shadow {\r\n    box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;\r\n  }\r\n  &.full {\r\n    min-width: 100%;\r\n  }\r\n  &.icon {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n  }\r\n  &.gradient {\r\n    background: rgb(219, 10, 10);\r\n    background: linear-gradient(0deg, rgba(219, 10, 10, 1) 0%, rgba(253, 219, 45, 1) 100%);\r\n    border: none;\r\n    color: white;\r\n  }\r\n  &.icon-circle {\r\n    border-radius: 50%;\r\n    padding: 3px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 60px;\r\n    height: 60px;\r\n    i {\r\n      font-size: 22px;\r\n    }\r\n  }\r\n  &.pink {\r\n    background: $primary01;\r\n    color: $white;\r\n    border-color: $primary01;\r\n    &:hover {\r\n      background: transparent;\r\n      color: $primary01;\r\n      border-color: $primary01;\r\n    }\r\n  }\r\n  &.white {\r\n    background: $white;\r\n    color: $black;\r\n    border-color: $white;\r\n    &:hover {\r\n      background: $white;\r\n      color: $black;\r\n      border-color: $white;\r\n      &:after{\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n//      ****************************  Global Element  ****************************\r\n.form {\r\n  .form-group {\r\n    margin-bottom: 24px;\r\n    .upload-card {\r\n      input[type=file] {\r\n        display: none;\r\n      }\r\n      label.upload-label {\r\n        width: 100%;\r\n        height: 179px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        border-radius: 4px;\r\n        margin-bottom: 16px;\r\n        cursor: pointer;\r\n        background: transparent;\r\n        border: 1px solid $border-primary01;\r\n        .upload-gallery-wrapper {\r\n          text-align: center;\r\n          .upload-content {\r\n            .upload-icon {\r\n              max-width: 60px;\r\n            }\r\n            p {\r\n              font-weight: 600;\r\n              margin: 10px 0 8px;\r\n              &.or {\r\n                margin: 0 0 8px;\r\n              }\r\n            }\r\n            .btn-style{\r\n              @media screen and (max-width: $screen-xs) {\r\n                min-width: 146px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .search-wrapper {\r\n      position: relative;\r\n      &.align-left {\r\n        .form-control {\r\n          padding: 9px 12px 9px 35px;\r\n        }\r\n        .search-icon {\r\n          position: absolute;\r\n          right: unset;\r\n          left: 12px;\r\n          top: 50%;\r\n          transform: translateY(-50%);\r\n          max-width: 16px;\r\n        }\r\n      }\r\n      .form-control {\r\n        padding: 9px 35px 9px 12px;\r\n      }\r\n      .search-icon {\r\n        position: absolute;\r\n        right: 12px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        max-width: 16px;\r\n      }\r\n    }\r\n    &.radio-group {\r\n      ul.radio-list {\r\n        li {\r\n          &:not(:last-of-type) {\r\n            margin: 0 10px 6px 0;\r\n          }\r\n          input {\r\n            display: none;\r\n          }\r\n          label:not(.radio-label) {\r\n            position: relative;\r\n            padding-left: 25px;\r\n            cursor: pointer;\r\n            margin-bottom: 0;\r\n            &:before, &:after {\r\n              content: \"\";\r\n              width: 18px;\r\n              height: 18px;\r\n              border-radius: 50%;\r\n              background-color: transparent;\r\n              border: 1px solid $border-primary01;\r\n              position: absolute;\r\n              top: 50%;\r\n              left: 0;\r\n              transform: translateY(-50%);\r\n              transition: all .2s ease;\r\n            }\r\n            &::after {\r\n              background-color: $primary01;\r\n              border-color: $primary01;\r\n              transform: translateY(-50%) scale(0);\r\n            }\r\n          }\r\n          input[type=\"radio\"] {\r\n            &:checked + label {\r\n              &::before {\r\n                border-color: $primary01;\r\n              }\r\n              &::after {\r\n                transform: translateY(-50%) scale(0.55);\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    &.checkbox-group {\r\n      label {\r\n        position: relative;\r\n        top: 1px;\r\n        cursor: pointer;\r\n        margin: 0 0 0 3px;\r\n      }\r\n      input[type=checkbox] {\r\n        position: relative;\r\n        height: 20px;\r\n        width: 20px;\r\n        cursor: pointer;\r\n        border-radius: 4px;\r\n        border: 2px solid $black;\r\n        vertical-align: text-top;\r\n        -webkit-appearance: none;\r\n        &:checked {\r\n          opacity: 1;\r\n          border-color: $black;\r\n          background: $black;\r\n          &:before {\r\n            opacity: 1;\r\n          }\r\n        }\r\n        &:before {\r\n          content: '';\r\n          width: 5px;\r\n          height: 10px;\r\n          position: absolute;\r\n          top: 45%;\r\n          right: calc(50% - 1px);\r\n          border: solid $white;\r\n          border-width: 0 2px 2px 0;\r\n          transform: rotate(45deg) translate(-50%, -50%);\r\n          z-index: 2;\r\n          opacity: 0;\r\n        }\r\n      }\r\n    }\r\n    select {\r\n      background: url(\"../images/icons/arrow-down-gray-icon.svg\");\r\n      background-repeat: no-repeat;\r\n      background-size: 12px;\r\n      background-position: calc(100% - 13px) 50%;\r\n      padding: 9px 35px 9px 12px;\r\n    }\r\n  }\r\n  label {\r\n    font-size: 14px;\r\n    line-height: 18px;\r\n    font-weight: 500;\r\n    color: $text-primary01;\r\n    display: inline-flex;\r\n    align-items: self-start;\r\n    gap: 1px;\r\n    margin-bottom: 4px;\r\n    sup {\r\n      font-size: 14px;\r\n      line-height: 10px;\r\n      color: $red;\r\n      position: relative;\r\n      top: 1px;\r\n    }\r\n  }\r\n  textarea {\r\n    min-height: 121px;\r\n    resize: none;\r\n  }\r\n  .form-control {\r\n    width: 100%;\r\n    height: 44px;\r\n    font-size: 14px;\r\n    line-height: 22px;\r\n    font-weight: 400;\r\n    color: $text-primary04;\r\n    border-radius: 4px;\r\n    padding: 9px 12px 9px;\r\n    border: 1px solid $border-primary01;\r\n    position: relative;\r\n    outline: none;\r\n    appearance: none;\r\n    background-color: transparent;\r\n    &::placeholder {\r\n      color: $text-primary04;\r\n    }\r\n    &:focus {\r\n      box-shadow: none;\r\n    }\r\n  }\r\n}\r\n//@include ellipsis(3);\r\n@mixin ellipsis($line) {\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: $line;\r\n  color: #373737;\r\n  -webkit-box-orient: vertical;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n/*<div class=\"circle-animation\">\r\n<span class=\"tp-circle-1\"></span>\r\n<span class=\"tp-circle-2\"></span>\r\n</div>*/\r\n//@include circle-animation(width, height, border-color, circle-color, circle-color, top, bottom, left, right, transform, index);\r\n//@include circle-animation(600px, 600px, #3f3f47, #ffadad, #3FE0D0, 50%, unset, unset, 50px, translateY(-50%), -1);\r\n@mixin circle-animation($width:300px, $height:300px, $borderColor:#3f3f47, $color01:#e04023, $color02:#3FE0D0,\r\n $top:50%, $bottom:unset, $left:50%, $right:unset, $transform:translate(-50%, -50%), $index: -1) {\r\n  .circle-animation {\r\n    top: $top;\r\n    bottom: $bottom;\r\n    left: $left;\r\n    right: $right;\r\n    border: 1px solid $borderColor;\r\n    width: $width;\r\n    height: $height;\r\n    position: absolute;\r\n    transform: $transform;\r\n    border-radius: 50%;\r\n    z-index: $index;\r\n    .tp-circle-1, .tp-circle-2 {\r\n      content: \"\";\r\n      display: block;\r\n      width: 50%;\r\n      height: 1px;\r\n      position: absolute;\r\n      top: calc(50% - 1px);\r\n      left: 50%;\r\n      background: transparent;\r\n      transform-origin: left;\r\n    }\r\n    .tp-circle-1 {\r\n      animation: circle-animation 13s linear infinite;\r\n      &:before {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 22px;\r\n        height: 22px;\r\n        border-radius: 50%;\r\n        top: -25px;\r\n        right: -12px;\r\n        background-color: $color01;\r\n      }\r\n    }\r\n    @keyframes circle-animation {\r\n      0% {\r\n        transform: rotate(0deg)\r\n      }\r\n      to {\r\n        transform: rotate(1turn)\r\n      }\r\n    }\r\n    .tp-circle-2 {\r\n      transform: scaleX(-1);\r\n      animation: circle-animation2 13s linear infinite;\r\n      &:after {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 14px;\r\n        height: 14px;\r\n        border-radius: 50%;\r\n        bottom: -25px;\r\n        right: -7px;\r\n        background-color: $color02;\r\n      }\r\n    }\r\n    @keyframes circle-animation2 {\r\n      0% {\r\n        transform: scaleX(-1) rotate(1turn)\r\n      }\r\n      to {\r\n        transform: scaleX(-1) rotate(0deg)\r\n      }\r\n    }\r\n  }\r\n}\r\n// Custom Scrollbar\r\n@mixin scrollbar-v1 {\r\n  &::-webkit-scrollbar {\r\n    background-color: $primary01;\r\n    width: 16px;\r\n  }\r\n  &::-webkit-scrollbar-track {\r\n    background-color: $primary01;\r\n  }\r\n  &::-webkit-scrollbar-thumb {\r\n    background-color: $black;\r\n    border-radius: 16px;\r\n    border: 4px solid $primary01;\r\n  }\r\n  &::-webkit-scrollbar-button {\r\n    display: none;\r\n  }\r\n}\r\n\r\n\r\n// Usage\r\n//@include before-bg-line-img(\"../images/banner-left-bg-lines.png\");\r\n@mixin before-bg-line-img($image-url) {\r\n  &:before {\r\n    content: '';\r\n    background: url(#{$image-url});\r\n    background-repeat: repeat;\r\n    background-size: cover;\r\n    width: 80px;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    border-right: 1px solid $border-primary04;\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      width: 40px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      background: transparent;\r\n      width: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n// Usage\r\n//@include after-bg-line-img(\"../images/banner-left-bg-lines.png\");\r\n@mixin after-bg-line-img($image-url) {\r\n  &:after {\r\n    content: '';\r\n    background: url(#{$image-url});\r\n    background-position: right;\r\n    background-repeat: repeat;\r\n    background-size: cover;\r\n    width: 80px;\r\n    height: 100%;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    border-left: 1px solid $border-primary04;\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      width: 40px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      background: transparent;\r\n      width: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n// Usage\r\n//@include before-bg-line($white);\r\n@mixin before-bg-line($bg-color) {\r\n  &:before {\r\n    content: '';\r\n    background: $bg-color;\r\n    width: 80px;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    border-right: 1px solid $border-primary04;\r\n    z-index: 1;\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      width: 40px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      width: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n// Usage\r\n//@include after-bg-line($white);\r\n@mixin after-bg-line($bg-color) {\r\n  &:after {\r\n    content: '';\r\n    background: $bg-color;\r\n    width: 80px;\r\n    height: 100%;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    border-left: 1px solid $border-primary04;\r\n    z-index: 1;\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      width: 40px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      width: 16px;\r\n    }\r\n  }\r\n}\r\n","@import \"standard\";\r\n@import \"../fonts/stylesheet.css\";\r\n@import \"../fonts/inter/stylesheet.css\";\r\n@import \"all.min.css\";\r\n@import \"landing-page\";\r\n@import \"xdc-landing\";\r\n\r\n\r\n// *****************************************************  HOME SCSS  *****************************************************\r\n\r\nbody {\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 0 0 70px;\r\n  }\r\n}\r\n\r\n.sec-wallet {\r\n  &.sec-otc-wallet {\r\n    .wallet-wrapper {\r\n      margin: -180px 0 0;\r\n      height: auto;\r\n\r\n      //height: calc(100vh - 268px);\r\n      @media screen and (max-width: $screen-xs) {\r\n        height: auto;\r\n        margin: -310px 0 0;\r\n      }\r\n\r\n      .wallet-wrapper-table {\r\n        .asset-wrapper {\r\n          .asset-body {\r\n            .asset-list-wrapper {\r\n              .asset-list {\r\n                //height: calc(100vh - 414px);\r\n                height: 500px;\r\n\r\n                @media screen and (max-width: $screen-xs) {\r\n                  height: 357px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .p-h-1 {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    max-width: 125px;\r\n  }\r\n\r\n  .wallet-wrapper {\r\n    width: 100%;\r\n    //height: calc(100vh - 346px);\r\n    height: auto;\r\n    background: $primary01;\r\n    border-radius: 16px 16px 0 0;\r\n    padding: 16px 24px;\r\n    margin: -32px 0 0;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      margin: -80px 0 0;\r\n      padding: 16px 8px;\r\n      height: auto;\r\n    }\r\n\r\n    &.mt-375 {\r\n      @media screen and (max-width: $screen-xs) {\r\n        margin: -375px 0 0;\r\n      }\r\n    }\r\n\r\n    .wallet-wrapper-table {}\r\n\r\n    .asset-wrapper {\r\n      .asset-header {\r\n        margin-bottom: 24px;\r\n        position: relative;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin-bottom: 16px;\r\n        }\r\n\r\n        >.title {\r\n          margin-bottom: 24px;\r\n        }\r\n\r\n        .search-wrapper-v1 {\r\n          max-width: 310px;\r\n\r\n          &.w-100 {\r\n            @media screen and (max-width: $screen-xs) {\r\n              max-width: 100%;\r\n            }\r\n          }\r\n\r\n          &.mb-16 {\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin-bottom: 16px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .otc-search-wrapper {\r\n          @media screen and (max-width: $screen-xs) {\r\n            display: grid;\r\n            grid-template-columns: 1fr 130px;\r\n            align-items: center;\r\n            column-gap: 16px;\r\n            margin: 16px 0 0;\r\n          }\r\n\r\n          .show-mobile {\r\n            display: none;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              display: flex;\r\n            }\r\n          }\r\n        }\r\n\r\n        ul.btn-list {\r\n          text-align: right;\r\n\r\n          @media screen and (max-width: $screen-xs) {}\r\n\r\n          &.otc-btn-list {\r\n            li {\r\n              @media screen and (max-width: $screen-xs) {\r\n                display: block;\r\n              }\r\n\r\n              &:not(:last-of-type) {\r\n                @media screen and (max-width: $screen-xs) {\r\n                  margin: 0 0 8px;\r\n                }\r\n              }\r\n\r\n              .btn-style {\r\n                @media screen and (max-width: $screen-xs) {\r\n                  min-width: 100%;\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          li {\r\n            display: inline-block;\r\n            vertical-align: middle;\r\n            position: relative;\r\n\r\n            &:not(:last-of-type) {\r\n              margin: 0 12px 0 0;\r\n            }\r\n\r\n            .date-btn {\r\n              padding: 8px 12px;\r\n              border-color: #D0D5DD;\r\n              color: #64748B;\r\n              font-weight: 400;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                justify-content: left;\r\n              }\r\n\r\n              .arrow-icon {\r\n                @media screen and (max-width: $screen-xs) {\r\n                  position: absolute;\r\n                  top: 50%;\r\n                  right: 15px;\r\n                  transform: translateY(-50%);\r\n                }\r\n              }\r\n            }\r\n\r\n            .btn-style {\r\n              &.m-w-130 {\r\n                min-width: 130px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .filter-wrapper {\r\n          position: relative;\r\n\r\n          .select-date {\r\n            background: $primary01;\r\n            border-radius: 8px;\r\n            padding: 24px 0 0;\r\n            box-shadow: 0 3px 12px 2px rgba(31, 34, 39, .21);\r\n            width: 360px;\r\n            position: absolute;\r\n            left: 0;\r\n            top: 60px;\r\n            z-index: 4;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              max-width: 350px;\r\n              overflow: auto;\r\n              padding: 10px 0 0;\r\n            }\r\n\r\n            .select-date-wrapper {\r\n              text-align: center;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                //transform: scale(.9);\r\n              }\r\n\r\n              .rdrCalendarWrapper {\r\n                background: $primary01;\r\n\r\n                .rdrDateDisplayWrapper {\r\n                  background: transparent;\r\n\r\n                  .rdrDateDisplay {\r\n                    .rdrDateInput {\r\n                      background: $black;\r\n                      border: none;\r\n                      box-shadow: none;\r\n\r\n                      input {\r\n                        color: $white;\r\n\r\n                        &::placeholder {\r\n                          color: $white;\r\n                        }\r\n                      }\r\n                    }\r\n                  }\r\n\r\n                }\r\n\r\n                .rdrMonthAndYearWrapper {\r\n                  button {\r\n                    background: #CEDDEB;\r\n                  }\r\n                }\r\n              }\r\n\r\n              .btn-wrapper {\r\n                padding: 12px 24px;\r\n                background: #CEDDEB;\r\n                border-radius: 0 0 8px 8px;\r\n\r\n                @media screen and (max-width: $screen-xs) {\r\n                  padding: 12px 24px;\r\n                }\r\n\r\n                ul.btn-list {\r\n                  text-align: right;\r\n\r\n                  li {\r\n                    display: inline-block;\r\n                    vertical-align: middle;\r\n\r\n                    &:not(:last-of-type) {\r\n                      margin: 0 12px 0 0;\r\n                    }\r\n\r\n                    .btn-style {\r\n                      height: 40px;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .asset-body {\r\n        .asset-list-wrapper {\r\n          .asset-list {\r\n            //height: calc(100vh - 514px);\r\n            height: 500px;\r\n            overflow: auto;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              height: 362px;\r\n            }\r\n\r\n            &.desktop {\r\n              display: block;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                display: none;\r\n              }\r\n            }\r\n\r\n            @include scrollbar-v1;\r\n\r\n            .grid-4 {\r\n              display: grid;\r\n              grid-template-columns: 400px 215px 215px 330px;\r\n              column-gap: 10px;\r\n\r\n              @media screen and (max-width: 1280px) and (min-width: 1200px) {\r\n                grid-template-columns: 340px 205px 205px 330px;\r\n              }\r\n\r\n              @media screen and (max-width: 1199px) and (min-width: 992px) {\r\n                grid-template-columns: 280px 190px 190px 295px;\r\n                min-width: 995px;\r\n              }\r\n\r\n              @media screen and (max-width: 991px) and (min-width: 768px) {\r\n                grid-template-columns: 270px 150px 150px 295px;\r\n                min-width: 905px;\r\n              }\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                grid-template-columns: 250px 140px 140px 265px;\r\n                min-width: 834px;\r\n              }\r\n            }\r\n\r\n            .grid-3 {\r\n              display: grid;\r\n              grid-template-columns: 500px 2fr 330px;\r\n              column-gap: 10px;\r\n\r\n              @media screen and (max-width: 1280px) and (min-width: 1200px) {\r\n                grid-template-columns: 200px 1fr 330px;\r\n              }\r\n\r\n              @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n                grid-template-columns: 180px 1fr 295px;\r\n                min-width: 700px;\r\n              }\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                grid-template-columns: 160px 1fr 265px;\r\n                min-width: 650px;\r\n              }\r\n            }\r\n\r\n            .grid-6 {\r\n              display: grid;\r\n              grid-template-columns: 220px 198px 175px 150px 90px 330px;\r\n              column-gap: 10px;\r\n\r\n              @media screen and (max-width: 1280px) and (min-width: 1200px) {\r\n                grid-template-columns: 200px 170px 180px 175px 155px 330px;\r\n              }\r\n\r\n              @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n                grid-template-columns: 200px 130px 130px 105px 100px 295px;\r\n                min-width: 910px;\r\n              }\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                grid-template-columns: 185px 105px 120px 75px 65px 265px;\r\n                min-width: 807px;\r\n              }\r\n            }\r\n\r\n            .grid-7 {\r\n              display: grid;\r\n              grid-template-columns: 44px 148px 195px 155px 130px 225px 225px;\r\n              column-gap: 10px;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                grid-template-columns: 44px 148px 195px 155px 130px 225px 225px;\r\n                min-width: 1192px;\r\n              }\r\n            }\r\n\r\n            .Otc-grid-8 {\r\n              display: grid;\r\n              //grid-template-columns: 44px 44px 244px 244px 180px 160px 130px 180px;\r\n              grid-template-columns: 35px 90px 200px 140px 170px 140px 250px 190px;\r\n              column-gap: 10px;\r\n\r\n              @media screen and (max-width: 1280px) and (min-width: 1200px) {\r\n                grid-template-columns: 35px 35px 195px 185px 160px 120px 115px 185px;\r\n              }\r\n\r\n              @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n                min-width: 1195px;\r\n              }\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                grid-template-columns: 44px 44px 244px 244px 180px 160px 130px 180px;\r\n              }\r\n            }\r\n\r\n            .grid-8 {\r\n              display: grid;\r\n              //grid-template-columns: 44px 44px 244px 244px 180px 160px 130px 180px;\r\n              grid-template-columns: 35px 35px 210px 200px 170px 140px 130px 190px;\r\n              column-gap: 10px;\r\n\r\n              @media screen and (max-width: 1280px) and (min-width: 1200px) {\r\n                grid-template-columns: 35px 35px 195px 185px 160px 120px 115px 185px;\r\n              }\r\n\r\n              @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n                min-width: 1195px;\r\n              }\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                grid-template-columns: 44px 44px 244px 244px 180px 160px 130px 180px;\r\n              }\r\n            }\r\n\r\n            .checkbox-wrapper {\r\n              input[type=checkbox] {\r\n                position: relative;\r\n                height: 16px;\r\n                width: 16px;\r\n                cursor: pointer;\r\n                border-radius: 2px;\r\n                border: 2px solid rgba(4, 9, 33, .32);\r\n                vertical-align: text-top;\r\n                -webkit-appearance: none;\r\n\r\n                &:checked {\r\n                  opacity: 1;\r\n                  border-color: $black;\r\n                  background: $black;\r\n\r\n                  &:before {\r\n                    opacity: 1;\r\n                  }\r\n                }\r\n\r\n                &:before {\r\n                  content: '';\r\n                  width: 5px;\r\n                  height: 10px;\r\n                  position: absolute;\r\n                  top: 45%;\r\n                  right: calc(50% - 1px);\r\n                  border: solid $white;\r\n                  border-width: 0 2px 2px 0;\r\n                  transform: rotate(45deg) translate(-50%, -50%);\r\n                  z-index: 2;\r\n                  opacity: 0;\r\n                }\r\n              }\r\n            }\r\n\r\n            .table-header {\r\n              padding: 20px 8px;\r\n              border-bottom: 1px solid $border-primary01;\r\n\r\n              &.style-v2 {\r\n                border-top: 1px solid $border-primary01;\r\n                border-bottom: 1px solid $border-primary01;\r\n                background: #CEDDEB;\r\n              }\r\n\r\n              .asset-item {\r\n                &:first-of-type {\r\n                  padding-left: 40px;\r\n                }\r\n\r\n                p {\r\n                  margin-bottom: 0;\r\n                  font-weight: 800;\r\n                  color: $text-primary02;\r\n                  display: inline-flex;\r\n                  align-items: center;\r\n                  gap: 4px;\r\n\r\n                  img {\r\n                    cursor: pointer;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n\r\n            .asset-card {\r\n              padding: 17px 8px;\r\n\r\n              &:not(:last-of-type) {\r\n                border-bottom: 1px solid $border-primary01;\r\n              }\r\n\r\n              .asset-item {\r\n                p {\r\n                  margin-bottom: 0;\r\n                }\r\n\r\n                .transaction-name {\r\n                  img {\r\n                    max-width: 18px;\r\n                  }\r\n\r\n                  p {\r\n                    margin-bottom: 0;\r\n                  }\r\n                }\r\n\r\n                .name-wrapper {\r\n                  display: grid;\r\n                  grid-template-columns: 51px 1fr;\r\n                  column-gap: 10px;\r\n                  align-items: center;\r\n\r\n                  .icon {\r\n                    img {\r\n                      max-width: 51px;\r\n                    }\r\n                  }\r\n\r\n                  .wallet-icon {\r\n                    width: 46px;\r\n                    height: 46px;\r\n                    border-radius: 50%;\r\n                    background: #D2DEEB;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    position: relative;\r\n\r\n                    .wallet-icon {\r\n                      max-width: 21px;\r\n                    }\r\n\r\n                    .tag-icon {\r\n                      position: absolute;\r\n                      right: -3px;\r\n                      bottom: 0;\r\n                      width: 18px;\r\n                      height: 18px;\r\n                      border-radius: 50%;\r\n                      border: 1px solid $white;\r\n                    }\r\n                  }\r\n\r\n                  .content {\r\n                    p {\r\n                      margin-bottom: 0;\r\n                      color: $text-primary05;\r\n                      font-weight: 600;\r\n\r\n                      &.title {\r\n                        color: $text-primary01;\r\n                        font-weight: 800;\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n\r\n                ul.btn-list {\r\n                  text-align: center;\r\n\r\n                  li {\r\n                    display: inline-block;\r\n                    vertical-align: middle;\r\n\r\n                    &:not(:last-of-type) {\r\n                      margin: 0 8px 0 0;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .asset-list-mobile {\r\n            display: none;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              display: block;\r\n            }\r\n\r\n            .asset-list-card {\r\n              padding: 16px;\r\n              border-radius: 8px;\r\n              border: 1px solid $border-primary01;\r\n\r\n              &:not(:last-of-type) {\r\n                margin: 0 0 16px;\r\n              }\r\n\r\n              .transaction-icon {\r\n                margin-bottom: 12px;\r\n                padding: 6px;\r\n\r\n                img {\r\n                  max-width: 18px;\r\n                }\r\n              }\r\n\r\n              ul.asset-detail {\r\n                display: grid;\r\n                //grid-template-columns: repeat(2, calc(50% - 6px));\r\n                //grid-template-columns: 1fr 90px;\r\n                grid-template-columns: auto auto;\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                column-gap: 12px;\r\n                row-gap: 12px;\r\n\r\n                li {\r\n                  &:nth-of-type(even) {\r\n                    text-align: left;\r\n                  }\r\n\r\n                  p {\r\n                    margin-bottom: 0;\r\n\r\n                    &.f-10 {\r\n                      color: $text-primary05;\r\n                    }\r\n                  }\r\n\r\n                  .name-wrapper {\r\n                    display: grid;\r\n                    grid-template-columns: 36px 1fr;\r\n                    column-gap: 10px;\r\n                    align-items: center;\r\n\r\n                    .icon {\r\n                      img {\r\n                        max-width: 36px;\r\n                      }\r\n                    }\r\n\r\n                    .wallet-icon {\r\n                      width: 36px;\r\n                      height: 36px;\r\n                      border-radius: 50%;\r\n                      background: #D2DEEB;\r\n                      display: flex;\r\n                      align-items: center;\r\n                      justify-content: center;\r\n                      position: relative;\r\n\r\n                      .wallet-icon {\r\n                        max-width: 21px;\r\n                      }\r\n\r\n                      .tag-icon {\r\n                        position: absolute;\r\n                        right: -3px;\r\n                        bottom: 0;\r\n                        width: 18px;\r\n                        height: 18px;\r\n                        border-radius: 50%;\r\n                        border: 1px solid $white;\r\n                      }\r\n                    }\r\n\r\n                    .content {\r\n                      p {\r\n                        margin-bottom: 0;\r\n                        color: $text-primary05;\r\n                        font-weight: 600;\r\n\r\n                        &.title {\r\n                          color: $text-primary01;\r\n                          font-weight: 800;\r\n                        }\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n\r\n              .approved-date {\r\n                margin: 12px 0 0;\r\n\r\n                p {\r\n                  margin-bottom: 0;\r\n\r\n                  &.f-10 {\r\n                    color: $text-primary05;\r\n                  }\r\n                }\r\n              }\r\n\r\n              ul.asset-btn {\r\n                display: grid;\r\n                grid-template-columns: repeat(2, calc(50% - 6px));\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                column-gap: 8px;\r\n                margin: 11px 0 0;\r\n\r\n                li {\r\n                  display: block;\r\n\r\n                  .btn-style {\r\n                    height: 38px;\r\n                    min-width: 100%;\r\n                    font-size: 14px;\r\n                    line-height: 22px;\r\n                  }\r\n                }\r\n              }\r\n\r\n              ul.trade-date-list {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                gap: 12px;\r\n                margin-bottom: 12px;\r\n\r\n                li {\r\n                  p {\r\n                    margin-bottom: 0;\r\n\r\n                    &.f-10 {\r\n                      color: $text-primary05;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n\r\n              ul.source-date-list {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                gap: 12px;\r\n                margin-bottom: 12px;\r\n\r\n                li {\r\n                  p {\r\n                    margin-bottom: 0;\r\n\r\n                    &.f-10 {\r\n                      color: $text-primary05;\r\n                    }\r\n\r\n                    &.wallet-name {\r\n                      white-space: nowrap;\r\n                      overflow: hidden;\r\n                      text-overflow: ellipsis;\r\n                      max-width: 130px;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n\r\n              ul.destination-date-list {\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: space-between;\r\n                gap: 12px;\r\n                margin-bottom: 0;\r\n\r\n                li {\r\n                  p {\r\n                    margin-bottom: 0;\r\n\r\n                    &.f-10 {\r\n                      color: $text-primary05;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .tabs-wrapper {\r\n      .tabs-header {\r\n        margin-bottom: 24px;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin-bottom: 16px;\r\n        }\r\n\r\n        .nav {\r\n          background: transparent;\r\n          text-align: left;\r\n          display: block;\r\n          border-bottom: 2px solid $border-primary01;\r\n\r\n          .nav-item {\r\n            display: inline-block;\r\n\r\n            .nav-link {\r\n              background: transparent;\r\n              padding: 16px 20px;\r\n              border-radius: 0;\r\n              height: 57px;\r\n              border: unset;\r\n              position: relative;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                height: 27px;\r\n                //padding: 3px 14px;\r\n                padding: 3px 8px;\r\n              }\r\n\r\n              &:before {\r\n                content: \"\";\r\n                background: $black;\r\n                width: 100%;\r\n                height: 2px;\r\n                position: absolute;\r\n                left: 0;\r\n                bottom: -2px;\r\n                display: none;\r\n              }\r\n\r\n              &.active {\r\n                &:before {\r\n                  display: block;\r\n                }\r\n\r\n                h3 {\r\n                  color: $black;\r\n                }\r\n              }\r\n\r\n              h3 {\r\n                color: $text-primary03;\r\n                margin-bottom: 0;\r\n\r\n                @media screen and (max-width: $screen-xs) {\r\n                  //font-size: 14px;\r\n                  font-size: 12px;\r\n                  line-height: 18px;\r\n                  font-weight: 500;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .tabs-body {\r\n        .tab-content {\r\n          .tab-pane {}\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Google-only Authentication Styles\r\n.auth-modal {\r\n  .modal-dialog {\r\n    max-width: 500px;\r\n\r\n    .modal-content {\r\n      border-radius: 12px;\r\n      border: none;\r\n\r\n      .modal-body {\r\n        padding: 40px;\r\n\r\n        .auth-modal-wrapper.google-only {\r\n          .auth-modal-center {\r\n            text-align: center;\r\n\r\n            .content-wrapper {\r\n              h2 {\r\n                font-size: 28px;\r\n                font-weight: 600;\r\n                margin-bottom: 12px;\r\n                color: #333;\r\n              }\r\n\r\n              p {\r\n                font-size: 16px;\r\n                color: #666;\r\n                margin-bottom: 30px;\r\n              }\r\n\r\n              .google-login-center {\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                margin-bottom: 30px;\r\n              }\r\n\r\n              .switch-auth {\r\n                font-size: 14px;\r\n                color: #666;\r\n                margin: 0;\r\n\r\n                a {\r\n                  color: #007bff;\r\n                  text-decoration: none;\r\n                  font-weight: 500;\r\n\r\n                  &:hover {\r\n                    text-decoration: underline;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.auth-offcanvas {\r\n  .offcanvas-body {\r\n    padding: 30px 20px;\r\n\r\n    .auth-content.google-only-offcanvas {\r\n      text-align: center;\r\n      height: 100%;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n\r\n      .content-wrapper {\r\n        width: 100%;\r\n\r\n        p {\r\n          font-size: 16px;\r\n          color: #666;\r\n          margin-bottom: 30px;\r\n        }\r\n\r\n        .google-login-center {\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n          margin-bottom: 30px;\r\n        }\r\n\r\n        .switch-auth {\r\n          font-size: 14px;\r\n          color: #666;\r\n          margin: 0;\r\n\r\n          a {\r\n            color: #007bff;\r\n            text-decoration: none;\r\n            font-weight: 500;\r\n\r\n            &:hover {\r\n              text-decoration: underline;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// *****************************************************  LOGIN SCSS  *****************************************************\r\n\r\n.sec-auth {\r\n  padding: 0 0 60px;\r\n\r\n  .auth-banner-wrapper {\r\n    background: #D5E8FB;\r\n    margin-bottom: 50px;\r\n\r\n    span.top-notch {\r\n      display: block;\r\n      width: 164px;\r\n      height: 31px;\r\n      margin: auto;\r\n      border-radius: 0 0 30px 30px;\r\n      background: $bg-primary01;\r\n    }\r\n\r\n    .auth-banner-card {\r\n      margin: 42px 0 0;\r\n      text-align: center;\r\n\r\n      a.logo {\r\n        display: inline-block;\r\n\r\n        img {\r\n          max-width: 100px;\r\n        }\r\n      }\r\n\r\n      .laptop-img {\r\n        margin: 33px 0 0;\r\n\r\n        img {\r\n          width: 100%;\r\n          max-width: 360px;\r\n          margin: auto;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .user-auth-wrapper {\r\n    .form-wrapper {\r\n      width: 100%;\r\n      max-width: 310px;\r\n      margin: auto;\r\n\r\n      >h3 {\r\n        font-size: 24px;\r\n        line-height: 30px;\r\n        font-weight: 500;\r\n        text-align: center;\r\n        margin-bottom: 24px;\r\n      }\r\n\r\n      ul.social-auth {\r\n        text-align: center;\r\n        margin: 0 0 24px;\r\n\r\n        li {\r\n          display: block;\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 0 8px;\r\n          }\r\n\r\n          .btn-style {\r\n            min-width: 100%;\r\n            height: 55px;\r\n\r\n            img {\r\n              max-width: 24px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .form.auth-form {\r\n        .form-group {\r\n          margin-bottom: 16px;\r\n\r\n          &.submit {\r\n            margin-bottom: 0;\r\n\r\n            .btn-style {\r\n              height: 55px;\r\n              font-weight: 700;\r\n            }\r\n\r\n            .no-account {\r\n              margin: 24px 0 0;\r\n              text-align: center;\r\n\r\n              p {\r\n                margin-bottom: 0;\r\n              }\r\n            }\r\n          }\r\n\r\n          label {\r\n            font-size: 14px;\r\n            line-height: 22px;\r\n            font-weight: 700;\r\n            margin-bottom: 12px;\r\n          }\r\n\r\n          .otp-text {\r\n            margin-bottom: 33px;\r\n            text-align: center;\r\n          }\r\n\r\n          .resend-otp {\r\n            text-align: right;\r\n\r\n            label {\r\n              cursor: pointer;\r\n            }\r\n          }\r\n\r\n          .form-control {\r\n            height: 48px;\r\n            font-size: 16px;\r\n            line-height: 22px;\r\n            border-color: #B5D2DF;\r\n            color: $black;\r\n\r\n            &::placeholder {\r\n              color: #8097A2;\r\n            }\r\n\r\n            &.otp-input {\r\n              letter-spacing: 31px;\r\n            }\r\n          }\r\n\r\n          .key-input {\r\n            position: relative;\r\n\r\n            .form-control {\r\n              padding: 9px 40px 9px 12px;\r\n            }\r\n\r\n            .icon {\r\n              position: absolute;\r\n              right: 12px;\r\n              top: 50%;\r\n              transform: translateY(-50%);\r\n              max-width: 24px;\r\n              cursor: pointer;\r\n            }\r\n          }\r\n\r\n          .more-link {\r\n            margin: 12px 0 0;\r\n\r\n            a {}\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// *****************************************************  REGISTRATION SCSS  *****************************************************\r\n\r\n.sec-registration {\r\n  .img-wrapper {\r\n    img {\r\n      width: 100%;\r\n      height: 100vh;\r\n      object-fit: contain;\r\n      object-position: top;\r\n\r\n      @media screen and (max-width: 1199px) {\r\n        object-fit: contain;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// *****************************************************  PROFILE SCSS  *****************************************************\r\n\r\n.sec-profile {\r\n  .profile-wrapper {\r\n    background: $primary01;\r\n    border-radius: 16px 16px 0 0;\r\n    padding: 16px 24px;\r\n    margin: -80px 0 0;\r\n    min-height: 600px;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      min-height: 400px;\r\n      margin: -280px 0 0;\r\n    }\r\n\r\n    .profile-card {\r\n      margin: -85px 0 0;\r\n\r\n      .user-image {\r\n        text-align: center;\r\n\r\n        img {\r\n          width: 120px;\r\n          height: 120px;\r\n          border-radius: 50%;\r\n          object-fit: cover;\r\n          margin: 0 auto 30px;\r\n        }\r\n      }\r\n\r\n      .user-detail {\r\n        text-align: center;\r\n\r\n        ul.personal-list {\r\n          max-width: 300px;\r\n          margin: auto;\r\n\r\n          li {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            gap: 20px;\r\n\r\n            &:not(:last-of-type) {\r\n              margin-bottom: 20px;\r\n            }\r\n\r\n            h3 {\r\n              font-weight: 600;\r\n              margin-bottom: 0;\r\n            }\r\n\r\n            p {\r\n              margin-bottom: 0;\r\n            }\r\n\r\n            .btn-style {\r\n              min-width: 100%;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// *****************************************************  GLOBAL SCSS  *****************************************************\r\n\r\nheader {\r\n  width: 100%;\r\n  padding: 18px 0;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 12px 21px 14px;\r\n    width: 100%;\r\n    height: 66px;\r\n    position: fixed;\r\n    top: unset;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 4;\r\n    background: $black;\r\n  }\r\n\r\n  .header-desktop {\r\n    display: block;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .header-mobile {\r\n    display: none;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      display: block;\r\n    }\r\n\r\n    ul.mobile-menu {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      gap: 12px;\r\n      max-width: 335px;\r\n      margin: auto;\r\n\r\n      li {\r\n        a {\r\n          display: inline-block;\r\n          text-align: center;\r\n\r\n          &.active {\r\n            .icon {\r\n              img {\r\n                &:not(.user-img) {\r\n                  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7499%) hue-rotate(130deg) brightness(99%) contrast(101%);\r\n                }\r\n              }\r\n            }\r\n\r\n            p {\r\n              color: $white;\r\n            }\r\n          }\r\n\r\n          .icon {\r\n            margin-bottom: 4px;\r\n\r\n            img {\r\n              max-width: 18px;\r\n\r\n              &:not(.user-img) {\r\n                filter: brightness(0) saturate(100%) invert(50%) sepia(15%) saturate(18%) hue-rotate(111deg) brightness(97%) contrast(87%);\r\n              }\r\n\r\n              &.user-img {\r\n                width: 18px;\r\n                height: 18px;\r\n                border-radius: 50%;\r\n                object-fit: cover;\r\n              }\r\n            }\r\n          }\r\n\r\n          p {\r\n            margin-bottom: 0;\r\n            font-weight: 400;\r\n            color: rgba(255, 255, 255, .50);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .logo-wrapper {\r\n    a.logo {\r\n      img {\r\n        max-width: 118px;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          max-width: 100px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  ul.features {\r\n    text-align: right;\r\n\r\n    li {\r\n      display: inline-block;\r\n      vertical-align: middle;\r\n\r\n      &:not(:last-of-type) {\r\n        margin: 0 24px 0 0;\r\n      }\r\n\r\n      a {\r\n        &.bel-wrapper {\r\n          img {\r\n            max-width: 24px;\r\n          }\r\n        }\r\n\r\n        &.user-wrapper {\r\n          img {\r\n            width: 42px;\r\n            height: 42px;\r\n            object-fit: cover;\r\n            border-radius: 50%;\r\n          }\r\n        }\r\n      }\r\n\r\n    }\r\n  }\r\n}\r\n\r\n.sec-banner {\r\n  .container-fluid {\r\n    padding: 0;\r\n  }\r\n\r\n  .banner-wrapper {\r\n    width: 100%;\r\n    min-height: 362px;\r\n    padding: 92px 0 59px;\r\n    border-radius: 0 0 16px 16px;\r\n    background: $black;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      min-height: 571px;\r\n      padding: 0 0 50px;\r\n    }\r\n\r\n    &.mh-400 {\r\n      @media screen and (max-width: $screen-xs) {\r\n        min-height: 400px;\r\n      }\r\n    }\r\n\r\n    .top-notch-wrapper {\r\n      display: none;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        display: block;\r\n        margin-bottom: 42px;\r\n        text-align: center;\r\n      }\r\n\r\n      span.top-notch {\r\n        display: block;\r\n        width: 164px;\r\n        height: 31px;\r\n        margin: auto;\r\n        border-radius: 0 0 30px 30px;\r\n        background: $bg-primary01;\r\n      }\r\n\r\n      a.logo {\r\n        display: inline-block;\r\n        margin: 48px 0 0;\r\n\r\n        img {\r\n          max-width: 100px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .crypto-card {\r\n      display: grid;\r\n      grid-template-columns: 1fr 395px;\r\n      align-items: center;\r\n      background: $bg-primary01;\r\n      border-radius: 16px;\r\n      position: relative;\r\n      min-height: 221px;\r\n\r\n      @media screen and (max-width: 991px) and (min-width: 768px) {\r\n        grid-template-columns: 1fr 245px;\r\n      }\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 16px 16px 0;\r\n        grid-template-columns: auto;\r\n        overflow: hidden;\r\n      }\r\n\r\n      .content-wrapper {\r\n        padding: 41px 0 41px 32px;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          padding: 0;\r\n          text-align: center;\r\n        }\r\n\r\n        h1 {\r\n          margin: 0;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            font-size: 20px;\r\n            line-height: 24px;\r\n            max-width: 225px;\r\n            margin: auto;\r\n          }\r\n        }\r\n\r\n        h3 {\r\n          margin: 11px 0 15px;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            font-size: 10px;\r\n            line-height: 14px;\r\n            max-width: 225px;\r\n            margin: auto;\r\n          }\r\n        }\r\n\r\n        ul.btn-list {\r\n          @media screen and (max-width: $screen-xs) {\r\n            margin-top: 13px;\r\n          }\r\n\r\n          li {\r\n            display: inline-block;\r\n            vertical-align: middle;\r\n\r\n            &:not(:last-of-type) {\r\n              margin: 0 12px 0 0;\r\n\r\n              @media screen and (max-width: 991px) {\r\n                margin: 0 8px 0 0;\r\n              }\r\n            }\r\n\r\n            .btn-style {\r\n              @media screen and (max-width: 991px) and (min-width: 768px) {\r\n                padding: 10px 6px;\r\n                height: 38px;\r\n                font-size: 14px;\r\n                line-height: 22px;\r\n              }\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                padding: 10px 6px;\r\n                height: 38px;\r\n                font-size: 12px;\r\n                line-height: 18px;\r\n              }\r\n\r\n              img {\r\n                @media screen and (max-width: 991px) and (min-width: 768px) {\r\n                  display: none;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .img-wrapper {\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin: 0 0 -32px;\r\n        }\r\n\r\n        img {\r\n          width: 100%;\r\n          height: 100%;\r\n          max-width: 400px;\r\n          position: absolute;\r\n          right: 0;\r\n          top: 0;\r\n\r\n          @media screen and (max-width: 991px) and (min-width: 768px) {\r\n            max-width: 270px;\r\n          }\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            position: relative;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .value-asset-card {\r\n      background: $bg-primary01;\r\n      border-radius: 16px;\r\n      position: relative;\r\n      padding: 8px 25px;\r\n      min-height: 227px;\r\n      display: grid;\r\n      align-items: center;\r\n\r\n      @media screen and (max-width: 991px) and (min-width: 768px) {\r\n        margin-bottom: 16px;\r\n      }\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 16px;\r\n        margin-bottom: 12px;\r\n      }\r\n\r\n      .content-wrapper {\r\n        @media screen and (max-width: $screen-xs) {\r\n          display: flex;\r\n          align-items: self-start;\r\n          justify-content: space-between;\r\n          margin-bottom: 22px;\r\n        }\r\n\r\n        h3 {\r\n          margin: 0 0 12px;\r\n          font-weight: 500;\r\n\r\n          @media screen and (max-width: 1199px) and (min-width: 992px) {\r\n            br {\r\n              display: none;\r\n            }\r\n          }\r\n        }\r\n\r\n        strong {\r\n          font-size: 42px;\r\n          line-height: 50px;\r\n          font-weight: 600;\r\n          color: $black;\r\n          font-family: $gabarito;\r\n\r\n          @media screen and (max-width: 1199px) and (min-width: 992px) {\r\n            font-size: 35px;\r\n            line-height: 43px;\r\n          }\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            font-size: 32px;\r\n            line-height: 40px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .chart-wrapper {\r\n        .line-chart {\r\n          width: 100%;\r\n          height: 150px;\r\n          background: $bg-primary01;\r\n          border-left: 1px solid #9BACB4;\r\n          border-bottom: 1px solid #9BACB4;\r\n          position: relative;\r\n\r\n          canvas {\r\n            //width: 100% !important;\r\n            //height: 100% !important;\r\n\r\n          }\r\n        }\r\n\r\n        .pie-chart {\r\n          width: 100%;\r\n          height: 210px;\r\n          text-align: right;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            text-align: center;\r\n          }\r\n\r\n          canvas {\r\n            height: 210px !important;\r\n            margin: 0 0 0 auto;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              width: 210px !important;\r\n              height: 210px !important;\r\n              margin: 0 auto 0;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .your-asset-card {\r\n      background: $bg-primary01;\r\n      border-radius: 16px;\r\n      position: relative;\r\n      padding: 20px 0 20px 16px;\r\n\r\n      >h3 {\r\n        margin-bottom: 16px;\r\n      }\r\n\r\n      .asset-slider {\r\n        .slick-slider {\r\n\r\n          .slick-dots,\r\n          .slick-arrow {\r\n            display: none !important;\r\n          }\r\n\r\n          .slick-list {\r\n            .slick-track {\r\n              display: flex;\r\n              align-items: center;\r\n\r\n              .slick-slide {\r\n                margin-right: 16px;\r\n\r\n                .your-asset-card {\r\n                  background: $bg-primary03;\r\n                  border-radius: 16px;\r\n                  padding: 16px;\r\n\r\n                  .icon {\r\n                    margin-bottom: 10px;\r\n\r\n                    img {\r\n                      max-width: 27px;\r\n                    }\r\n                  }\r\n\r\n                  .content {\r\n                    h3 {\r\n                      margin-bottom: 0;\r\n                      font-weight: 400;\r\n\r\n                      &.title {\r\n                        font-weight: 500;\r\n                        margin-bottom: 8px;\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .otc-banner-wrapper {\r\n      margin-top: 12px;\r\n\r\n      h2 {\r\n        color: $white;\r\n        margin-bottom: 0;\r\n      }\r\n\r\n      h3 {\r\n        color: $white;\r\n        margin-bottom: 0;\r\n      }\r\n\r\n      p {\r\n        margin: 16px 0 0;\r\n      }\r\n\r\n      ul.btn-list {\r\n        text-align: right;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin: 16px 0 0;\r\n        }\r\n\r\n        li {\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            display: block;\r\n          }\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 12px 0 0;\r\n          }\r\n\r\n          .btn-style {\r\n            @media screen and (max-width: $screen-xs) {\r\n              min-width: 100%;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-v1 {\r\n  button {\r\n    width: unset;\r\n    padding: 0;\r\n    background: transparent !important;\r\n    border: none;\r\n    outline: none;\r\n    box-shadow: none;\r\n\r\n    &:focus,\r\n    &:active,\r\n    &:hover {\r\n      outline: none;\r\n      box-shadow: none;\r\n      background: transparent;\r\n    }\r\n\r\n    &:after {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .dropdown-menu {\r\n    background: $bg-primary01;\r\n    box-shadow: $box-shadow01;\r\n    padding: 0;\r\n    border: none;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    min-width: 180px;\r\n    margin: 7px 0 0;\r\n\r\n    .dropdown-item {\r\n      padding: 15px 24px;\r\n      font-size: 14px;\r\n      line-height: 22px;\r\n      font-weight: 500;\r\n      color: $text-primary01;\r\n      background: $bg-primary01;\r\n\r\n      &:hover {\r\n        //background: $bg-primary02;\r\n      }\r\n\r\n      &:focus,\r\n      &:active,\r\n      &:hover {\r\n        color: $text-primary01;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.notification-dropdown {\r\n  button {\r\n    width: unset;\r\n    padding: 0;\r\n    background: transparent !important;\r\n    border: none;\r\n    outline: none;\r\n    box-shadow: none;\r\n\r\n    &:focus,\r\n    &:active,\r\n    &:hover {\r\n      outline: none;\r\n      box-shadow: none;\r\n      background: transparent;\r\n    }\r\n\r\n    &:after {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .dropdown-menu {\r\n    background: $bg-primary01;\r\n    box-shadow: $box-shadow01;\r\n    padding: 0;\r\n    border: none;\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    width: 400px;\r\n    max-width: 400px;\r\n    margin: 7px 0 0;\r\n\r\n    .dropdown-item {\r\n      padding: 0;\r\n      background: $bg-primary01;\r\n\r\n      &:focus,\r\n      &:active,\r\n      &:hover {\r\n        //color: $text-primary01;\r\n      }\r\n\r\n      .notification-wrapper {\r\n        padding: 16px 24px;\r\n\r\n        .notification-header {\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: space-between;\r\n          gap: 20px;\r\n          padding: 0 0 16px;\r\n          border-bottom: 1px solid $border-primary03;\r\n\r\n          h3 {}\r\n\r\n          .cross-icon {\r\n            img {\r\n              max-width: 13px;\r\n            }\r\n          }\r\n        }\r\n\r\n        .notification-body {\r\n          ul.notification-list {\r\n            li {\r\n              display: block;\r\n              margin: 0;\r\n\r\n              &:not(:last-of-type) {\r\n                .notification-card {\r\n                  border-bottom: 1px solid $border-primary03;\r\n                }\r\n              }\r\n\r\n              .notification-card {\r\n                display: flex;\r\n                align-items: center;\r\n                gap: 16px;\r\n                padding: 16px 0;\r\n\r\n                .content {\r\n                  h3 {\r\n                    margin-bottom: 0;\r\n                  }\r\n\r\n                  p {\r\n                    margin: 8px 0;\r\n                    line-height: 20px;\r\n                    white-space: normal;\r\n                  }\r\n\r\n                  span.date {\r\n                    color: $text-primary02;\r\n                    font-weight: 500;\r\n                  }\r\n                }\r\n\r\n                .icon {\r\n                  display: flex;\r\n                  align-items: center;\r\n                  gap: 16px;\r\n\r\n                  .success {\r\n                    max-width: 60px;\r\n                  }\r\n\r\n                  span.status {\r\n                    width: 8px;\r\n                    height: 8px;\r\n                    border-radius: 50px;\r\n                    //background: #2B4AFF;\r\n                    background: $black;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .notification-footer {\r\n          padding: 16px 0 0;\r\n          border-top: 1px solid $border-primary03;\r\n\r\n          a {\r\n            color: $black;\r\n            font-weight: 500;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.search-wrapper-v1 {\r\n  .form {\r\n    .form-group {\r\n      position: relative;\r\n      margin-bottom: 0;\r\n\r\n      .form-control {\r\n        padding: 9px 8px 9px 32px;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          //height: 32px;\r\n          //font-size: 12px;\r\n          //line-height: 18px;\r\n        }\r\n      }\r\n\r\n      .icon {\r\n        position: absolute;\r\n        right: unset;\r\n        left: 10px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        max-width: 12px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.custom-select {\r\n  background: $primary01;\r\n  border: 1px solid $border-primary01;\r\n  border-radius: 4px;\r\n  padding: 12px;\r\n  cursor: pointer;\r\n  position: relative;\r\n\r\n  &.wallet-dropdown {\r\n    .select-header {\r\n      .name-wrapper {\r\n        .content {\r\n          p {\r\n            padding: 4px 0 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    ul.select-options {\r\n      li {\r\n        .option-card {\r\n          p {\r\n            padding: 4px 0 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.coin-dropdown {\r\n    .coin-img {\r\n      max-width: 32px;\r\n    }\r\n  }\r\n\r\n  .select-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 20px;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      gap: 10px;\r\n    }\r\n\r\n    .name-wrapper {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 8px;\r\n\r\n      .icon {\r\n        img {\r\n          max-width: 32px;\r\n        }\r\n      }\r\n\r\n      .content {\r\n        p {\r\n          margin-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .arrow-wrapper {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 6px;\r\n\r\n      p {\r\n        margin-bottom: 0;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          white-space: nowrap;\r\n          max-width: 100px;\r\n          text-overflow: ellipsis;\r\n          overflow: hidden;\r\n        }\r\n      }\r\n\r\n      a.arrow {\r\n        &.open {\r\n          img {\r\n            transform: rotate(180deg)\r\n          }\r\n\r\n          ;\r\n        }\r\n\r\n        img {\r\n          max-width: 32px;\r\n          transition: all .3s ease-in-out;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            max-width: 20px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  ul.select-options {\r\n    padding: 19px;\r\n    border-radius: 4px;\r\n    background: $primary01;\r\n    border: 1px solid $border-primary01;\r\n    position: absolute;\r\n    top: 60px;\r\n    left: 0;\r\n    width: 100%;\r\n    height: auto;\r\n    overflow: auto;\r\n    z-index: 3;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 14px;\r\n    }\r\n\r\n    @include scrollbar-v1;\r\n\r\n    &:has(li:nth-of-type(6)) {\r\n      &::-webkit-scrollbar {\r\n        background-color: $primary01;\r\n        width: 12px;\r\n      }\r\n\r\n      &::-webkit-scrollbar-track {\r\n        background-color: $primary01;\r\n      }\r\n\r\n      &::-webkit-scrollbar-thumb {\r\n        background-color: #95ACB6;\r\n        border-radius: 8px;\r\n        border: 4px solid $primary01;\r\n      }\r\n\r\n      &::-webkit-scrollbar-button {\r\n        display: none;\r\n      }\r\n\r\n      height: 250px;\r\n    }\r\n\r\n    li {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      gap: 20px;\r\n\r\n      &:not(:last-of-type) {\r\n        margin-bottom: 4px;\r\n\r\n        .option-card {\r\n          //border-bottom: 1px solid $border-primary01;\r\n        }\r\n      }\r\n\r\n      .option-card {\r\n        width: 100%;\r\n        padding: 12px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        gap: 20px;\r\n        border-radius: 4px;\r\n        transition: all .3s ease-in-out;\r\n\r\n        &:hover,\r\n        &.active {\r\n          background: #D8E6F5;\r\n        }\r\n\r\n        .option-name {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 8px;\r\n\r\n          .icon-wrapper {\r\n            img {\r\n              max-width: 32px;\r\n            }\r\n          }\r\n\r\n          p {\r\n            margin-bottom: 0;\r\n          }\r\n        }\r\n\r\n        >p {\r\n          margin-bottom: 0;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            white-space: nowrap;\r\n            max-width: 100px;\r\n            text-overflow: ellipsis;\r\n            overflow: hidden;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.pagination-wrapper-main {\r\n  background: #CEDDEB;\r\n  padding: 24px 12px;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 18px 12px 16px;\r\n  }\r\n\r\n  .pagination-wrapper {\r\n    display: grid;\r\n    align-items: center;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n\r\n    @media screen and (max-width: 991px) and (min-width: 768px) {\r\n      grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      display: block;\r\n    }\r\n\r\n    p {\r\n      margin-bottom: 0;\r\n\r\n      &.empty-tag {\r\n        @media screen and (max-width: 991px) {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    ul.pagination-list {\r\n      text-align: center;\r\n      min-width: 445px;\r\n\r\n      @media screen and (max-width: 991px) and (min-width: 768px) {\r\n        text-align: left;\r\n      }\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        min-width: auto;\r\n      }\r\n\r\n      li {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n\r\n        &:not(:last-of-type) {\r\n          margin: 0 8px 0 0;\r\n        }\r\n\r\n        .pagination-btn {\r\n          display: inline-block;\r\n          height: 38px;\r\n          padding: 7px 12px 8px;\r\n          font-size: 16px;\r\n          line-height: 22px;\r\n          font-weight: 600;\r\n          border-radius: 4px;\r\n          color: $black;\r\n          border: 1px solid $black;\r\n\r\n          &.active {\r\n            color: $white;\r\n            background: $black;\r\n          }\r\n\r\n          &.no-border {\r\n            border: unset;\r\n          }\r\n\r\n          &.w-96 {\r\n            min-width: 96px;\r\n          }\r\n\r\n          &.desktop {\r\n            display: block;\r\n\r\n            @media screen and (max-width: 991px) {\r\n              display: none;\r\n            }\r\n          }\r\n\r\n          &.mobile {\r\n            display: none;\r\n\r\n            @media screen and (max-width: 991px) {\r\n              display: block;\r\n            }\r\n          }\r\n\r\n          .arrow-icon {\r\n            max-width: 16px;\r\n            margin: 0 0 2px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .show-result {\r\n      margin-bottom: 0;\r\n      text-align: right;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        margin: 12px 0 0;\r\n        text-align: center;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.pre-registration-page {\r\n  .modal-backdrop {\r\n    //backdrop-filter: blur(3px);\r\n    backdrop-filter: unset;\r\n    background: transparent;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n// *****************************************************  MODAL SCSS  *****************************************************\r\n\r\n.deposit-wallet-modal {\r\n  .modal-dialog {\r\n    max-width: 1099px;\r\n\r\n    .modal-content {\r\n      padding: 0;\r\n      border-radius: 16px;\r\n      background: $primary01;\r\n      overflow: visible;\r\n\r\n      @media screen and (max-width: 1199px) {\r\n        margin: 0 10px;\r\n      }\r\n\r\n      .modal-body {\r\n        padding: 0;\r\n\r\n        .deposit-wallet-wrapper {\r\n          .wallet-header {\r\n            padding: 16px 24px 24px;\r\n\r\n            //margin-bottom: 24px;\r\n            h3 {\r\n              margin-bottom: 0;\r\n              font-weight: 800;\r\n            }\r\n\r\n            .reset-wrapper {\r\n              text-align: right;\r\n\r\n              a {\r\n                img {\r\n                  max-width: 11px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .wallet-body {\r\n            padding: 0 24px 24px;\r\n\r\n            .deposit-wrapper {\r\n              .deposit-item {\r\n                &:not(:last-of-type) {\r\n                  margin-bottom: 24px;\r\n                }\r\n\r\n                >h3 {\r\n                  margin-bottom: 12px;\r\n                }\r\n\r\n                .form:not(.search-form) {\r\n                  .form-group {\r\n                    margin-bottom: 0;\r\n\r\n                    .form-control {\r\n                      border: 1px solid $border-primary01;\r\n                      border-radius: 4px;\r\n                      padding: 12px;\r\n                      height: 48px;\r\n                      font-size: 16px;\r\n                      line-height: 24px;\r\n                      font-weight: 500;\r\n                      color: $black;\r\n\r\n                      &::placeholder {\r\n                        color: #7F9AA6;\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n\r\n                .send-to-tabs {\r\n                  .tabs-header {\r\n                    .nav {\r\n                      background: transparent;\r\n                      text-align: left;\r\n                      display: inline-block;\r\n\r\n                      .nav-item {\r\n                        display: inline-block;\r\n\r\n                        &:not(:last-of-type) {\r\n                          margin: 0 8px 0 0;\r\n                        }\r\n\r\n                        .nav-link {\r\n                          width: 354px;\r\n                          height: 58px;\r\n                          background: transparent;\r\n                          padding: 4px 12px;\r\n                          border: 1px solid $border-primary01;\r\n                          position: relative;\r\n                          display: flex;\r\n                          align-items: center;\r\n                          justify-content: center;\r\n                          border-radius: 4px;\r\n\r\n                          @media screen and (max-width: 991px) and (min-width: 768px) {\r\n                            width: 300px;\r\n                          }\r\n\r\n                          @media screen and (max-width: $screen-xs) {\r\n                            width: 150px;\r\n                            height: 45px;\r\n                          }\r\n\r\n                          &.active {\r\n                            background: #424A53;\r\n                            border-color: #424A53;\r\n\r\n                            p {\r\n                              color: $white;\r\n                            }\r\n                          }\r\n\r\n                          p {\r\n                            color: $black;\r\n                            margin-bottom: 0;\r\n                          }\r\n                        }\r\n                      }\r\n                    }\r\n                  }\r\n\r\n                  .tabs-body {\r\n\r\n                    //margin: 0 0 5px;\r\n                    .tab-content {\r\n                      .tab-pane {\r\n                        .deposit-item {\r\n                          margin-top: 24px;\r\n                        }\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n\r\n                .deposit-card {\r\n                  border: 1px solid $border-primary01;\r\n                  border-radius: 4px;\r\n                  padding: 12px;\r\n\r\n                  &.deposit-search-card {\r\n                    min-height: 168px;\r\n                    margin: 11px 0 0;\r\n\r\n                    .search-wrapper-v1 {\r\n                      max-width: 310px;\r\n                      margin-bottom: 10px;\r\n                    }\r\n\r\n                    .no-wallet-wrapper {\r\n                      text-align: center;\r\n                      padding: 20px 30px;\r\n\r\n                      .icon-wrapper {\r\n                        margin-bottom: 6px;\r\n\r\n                        img {\r\n                          max-width: 24px;\r\n                        }\r\n                      }\r\n\r\n                      h3 {\r\n                        font-weight: 500;\r\n                        margin-bottom: 0;\r\n                      }\r\n                    }\r\n\r\n                    .user-wallet-wrapper {\r\n                      display: grid;\r\n                      grid-template-columns: repeat(5, calc(20% - 6.5px));\r\n                      column-gap: 8px;\r\n                      row-gap: 8px;\r\n                      margin: 6px 0 0;\r\n\r\n                      @media screen and (max-width: $screen-xs) {\r\n                        grid-template-columns: repeat(2, calc(50% - 4.5px));\r\n                      }\r\n\r\n                      .wallet-card {\r\n                        background: #D8E6F5;\r\n                        padding: 12px;\r\n                        border-radius: 4px;\r\n                        cursor: pointer;\r\n\r\n                        .icon-wrapper {\r\n                          margin-bottom: 11px;\r\n\r\n                          img {\r\n                            max-width: 24px;\r\n                          }\r\n                        }\r\n\r\n                        h3 {\r\n                          line-height: 22px;\r\n                          font-weight: 500;\r\n                          margin-bottom: 0;\r\n                        }\r\n                      }\r\n                    }\r\n\r\n                    .qrcode-wrapper {\r\n                      text-align: center;\r\n                      padding: 28px 12px;\r\n\r\n                      .qr-img {\r\n                        margin-bottom: 16px;\r\n\r\n                        img {\r\n                          max-width: 168px;\r\n                          margin: auto;\r\n                        }\r\n                      }\r\n\r\n                      .qr-content {\r\n                        p {\r\n                          margin-bottom: 16px;\r\n                        }\r\n\r\n                        .btn-style {\r\n                          height: 36px;\r\n                          border-width: 1px;\r\n                        }\r\n                      }\r\n                    }\r\n                  }\r\n\r\n                  .amount-tabs {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    gap: 8px;\r\n\r\n                    @media screen and (max-width: $screen-xs) {\r\n                      display: block;\r\n                    }\r\n\r\n                    .tabs-header {\r\n                      height: 32px;\r\n\r\n                      @media screen and (max-width: $screen-xs) {\r\n                        margin-bottom: 12px;\r\n                      }\r\n\r\n                      .nav {\r\n                        background: transparent;\r\n                        text-align: left;\r\n                        display: inline-block;\r\n                        border-radius: 4px;\r\n                        overflow: hidden;\r\n\r\n                        .nav-item {\r\n                          display: inline-block;\r\n\r\n                          .nav-link {\r\n                            background: transparent;\r\n                            padding: 4px 12px;\r\n                            border-radius: 0;\r\n                            height: 32px;\r\n                            border: 1px solid $border-primary03;\r\n                            position: relative;\r\n\r\n                            &.active {\r\n                              background: #424A53;\r\n                              border-color: #424A53;\r\n\r\n                              p {\r\n                                color: $white;\r\n                              }\r\n                            }\r\n\r\n                            p {\r\n                              color: $text-primary06;\r\n                              margin-bottom: 0;\r\n                            }\r\n                          }\r\n                        }\r\n                      }\r\n                    }\r\n\r\n                    .tabs-body {\r\n\r\n                      //margin: 0 0 5px;\r\n                      .tab-content {\r\n                        .tab-pane {\r\n                          .amount-input {\r\n                            input {\r\n                              font-size: 16px;\r\n                              line-height: 24px;\r\n                              font-weight: 600;\r\n                              color: $black;\r\n                              background: transparent;\r\n                              border: none;\r\n                              outline: none;\r\n                              box-shadow: none;\r\n\r\n                              //height: 25px;\r\n                              &::placeholder {\r\n                                color: $black;\r\n                              }\r\n                            }\r\n                          }\r\n                        }\r\n                      }\r\n                    }\r\n                  }\r\n\r\n                  .amount-total {\r\n                    text-align: right;\r\n\r\n                    p {\r\n                      margin-bottom: 0;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .wallet-footer {\r\n            padding: 24px;\r\n            background: #CEDDEB;\r\n            border-radius: 0 0 16px 16px;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              padding: 12px 24px;\r\n            }\r\n\r\n            ul.btn-list {\r\n              text-align: right;\r\n\r\n              li {\r\n                display: inline-block;\r\n                vertical-align: middle;\r\n\r\n                &:not(:last-of-type) {\r\n                  margin: 0 12px 0 0;\r\n                }\r\n\r\n                .btn-style {\r\n                  min-width: 179px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.deposit-select-wallet-modal {\r\n\r\n  // Modal SCSS\r\n  &.fiat-deposit-modal {\r\n    .modal-dialog {\r\n      max-width: 811px;\r\n    }\r\n  }\r\n\r\n  &.assets-withdraw-modal {\r\n    .modal-dialog {\r\n      max-width: 1099px;\r\n    }\r\n  }\r\n\r\n  &.assets-withdraw-funds-modal {\r\n    .modal-dialog {\r\n      max-width: 809px;\r\n    }\r\n  }\r\n\r\n  .modal-dialog {\r\n    max-width: 549px;\r\n\r\n    .modal-content {\r\n      padding: 0;\r\n      border-radius: 16px;\r\n      background: $primary01;\r\n      //overflow: hidden;\r\n      overflow: visible;\r\n\r\n      @media screen and (max-width: 1199px) {\r\n        margin: 0 10px;\r\n      }\r\n\r\n      .modal-body {\r\n        padding: 0;\r\n\r\n        .deposit-wallet-wrapper {}\r\n      }\r\n    }\r\n  }\r\n\r\n  // Offcanvas SCSS\r\n\r\n  &.offcanvas {\r\n    border-radius: 16px 16px 0 0;\r\n    overflow: hidden;\r\n\r\n    &.h-402 {\r\n      height: 402px;\r\n    }\r\n\r\n    &.h-468 {\r\n      height: 488px;\r\n    }\r\n\r\n    &.h-510 {\r\n      height: 510px;\r\n    }\r\n\r\n    &.h-566 {\r\n      height: 566px;\r\n    }\r\n\r\n    &.h-595 {\r\n      height: 595px;\r\n    }\r\n\r\n    &.h-610 {\r\n      height: 610px;\r\n    }\r\n\r\n    &.h-635 {\r\n      height: 635px;\r\n    }\r\n\r\n    &.h-644 {\r\n      height: 644px;\r\n    }\r\n  }\r\n\r\n  .offcanvas-header {\r\n    display: none;\r\n  }\r\n\r\n  .offcanvas-body {\r\n    padding: 0;\r\n    border-radius: 0;\r\n    background: $primary01;\r\n\r\n  }\r\n\r\n  .deposit-wallet-wrapper {\r\n    .wallet-header {\r\n      padding: 24px 24px;\r\n\r\n      //margin-bottom: 24px;\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 24px 16px;\r\n      }\r\n\r\n      h3 {\r\n        margin-bottom: 0;\r\n        font-weight: 800;\r\n      }\r\n\r\n      .reset-wrapper {\r\n        text-align: right;\r\n\r\n        a {\r\n          img {\r\n            max-width: 11px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .available-funds {\r\n        text-align: right;\r\n\r\n        h3 {\r\n          @media screen and (max-width: $screen-xs) {\r\n            font-size: 16px;\r\n            line-height: 24px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .selected-coin {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: right;\r\n\r\n        .icon {\r\n          display: grid;\r\n          grid-template-columns: 32px 1fr;\r\n          column-gap: 8px;\r\n          align-items: center;\r\n\r\n          img {\r\n            max-width: 32px;\r\n          }\r\n        }\r\n\r\n        p {\r\n          margin-bottom: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .wallet-body {\r\n      padding: 0 24px 24px;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 0 16px 24px;\r\n      }\r\n\r\n      .deposit-wrapper {\r\n        .otc-compare-wrapper {\r\n          display: grid;\r\n          grid-template-columns: 1fr 20px 1fr;\r\n          column-gap: 18px;\r\n          align-items: center;\r\n          margin-bottom: 24px;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            column-gap: 0;\r\n            grid-template-columns: auto;\r\n          }\r\n\r\n          .deposit-item {\r\n            &:not(:last-of-type) {\r\n              margin-bottom: 0;\r\n            }\r\n          }\r\n\r\n          .compare-icon {\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin: 20px 0 0;\r\n              text-align: center;\r\n            }\r\n          }\r\n        }\r\n\r\n        .deposit-item {\r\n          &:not(:last-of-type) {\r\n            margin-bottom: 24px;\r\n          }\r\n\r\n          >h3 {\r\n            margin-bottom: 12px;\r\n\r\n            br.mobile {\r\n              display: none;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                display: block;\r\n              }\r\n            }\r\n          }\r\n\r\n          .wallet-address-text {\r\n            margin: 12px 0 0;\r\n          }\r\n\r\n          .item-header {\r\n            margin-bottom: 12px;\r\n\r\n            h3 {\r\n              margin-bottom: 0;\r\n            }\r\n\r\n            p {\r\n              margin-bottom: 0;\r\n              text-align: right;\r\n            }\r\n          }\r\n\r\n          .form:not(.search-form) {\r\n            .form-group {\r\n              margin-bottom: 0;\r\n\r\n              .amount-wrapper {\r\n                display: grid;\r\n                grid-template-columns: 38px 1fr;\r\n                align-items: center;\r\n\r\n                .icon {\r\n                  width: 38px;\r\n                  height: 48px;\r\n                  display: flex;\r\n                  align-items: center;\r\n                  justify-content: center;\r\n                  border-radius: 4px 0 0 4px;\r\n                  border: 1px solid $border-primary01;\r\n                  border-right: unset;\r\n\r\n                  p {\r\n                    margin-bottom: 0;\r\n                  }\r\n                }\r\n\r\n                .form-control {\r\n                  border-radius: 0 4px 4px 0;\r\n                }\r\n              }\r\n\r\n              .form-control {\r\n                border: 1px solid $border-primary01;\r\n                border-radius: 4px;\r\n                padding: 12px;\r\n                height: 48px;\r\n                font-size: 16px;\r\n                line-height: 24px;\r\n                font-weight: 500;\r\n                color: $black;\r\n\r\n                &::placeholder {\r\n                  color: #7F9AA6;\r\n                }\r\n\r\n                &.black-placeholder {\r\n                  &::placeholder {\r\n                    color: $black;\r\n                  }\r\n                }\r\n\r\n                &.otp-input {\r\n                  letter-spacing: 31px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .deposit-card {\r\n            border: 1px solid $border-primary01;\r\n            border-radius: 4px;\r\n            padding: 12px;\r\n\r\n            .qrcode-wrapper {\r\n              text-align: center;\r\n              padding: 28px 12px;\r\n\r\n              .qr-img {\r\n                margin-bottom: 16px;\r\n\r\n                img {\r\n                  max-width: 168px;\r\n                  margin: auto;\r\n                }\r\n              }\r\n\r\n              .qr-content {\r\n                p {\r\n                  margin-bottom: 16px;\r\n                }\r\n\r\n                .btn-style {\r\n                  height: 36px;\r\n                  border-width: 1px;\r\n\r\n                  @media screen and (max-width: $screen-xs) {\r\n                    min-width: 270px;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n\r\n            .amount-total {\r\n              text-align: right;\r\n\r\n              p {\r\n                margin-bottom: 0;\r\n              }\r\n            }\r\n\r\n            .amount-tabs {\r\n              display: flex;\r\n              align-items: center;\r\n              gap: 8px;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                display: block;\r\n              }\r\n\r\n              .tabs-header {\r\n                height: 32px;\r\n\r\n                @media screen and (max-width: $screen-xs) {\r\n                  margin-bottom: 12px;\r\n                }\r\n\r\n                .nav {\r\n                  background: transparent;\r\n                  text-align: left;\r\n                  display: inline-block;\r\n                  border-radius: 4px;\r\n                  overflow: hidden;\r\n\r\n                  .nav-item {\r\n                    display: inline-block;\r\n\r\n                    .nav-link {\r\n                      background: transparent;\r\n                      padding: 4px 12px;\r\n                      border-radius: 0;\r\n                      height: 32px;\r\n                      border: 1px solid $border-primary03;\r\n                      position: relative;\r\n\r\n                      &.active {\r\n                        background: #424A53;\r\n                        border-color: #424A53;\r\n\r\n                        p {\r\n                          color: $white;\r\n                        }\r\n                      }\r\n\r\n                      p {\r\n                        color: $text-primary06;\r\n                        margin-bottom: 0;\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n\r\n              .tabs-body {\r\n\r\n                //margin: 0 0 5px;\r\n                .tab-content {\r\n                  .tab-pane {\r\n                    .amount-input {\r\n                      input {\r\n                        font-size: 16px;\r\n                        line-height: 24px;\r\n                        font-weight: 600;\r\n                        color: $black;\r\n                        background: transparent;\r\n                        border: none;\r\n                        outline: none;\r\n                        box-shadow: none;\r\n\r\n                        //height: 25px;\r\n                        &::placeholder {\r\n                          color: $black;\r\n                        }\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .scan-qr-wrapper {\r\n            text-align: center;\r\n\r\n            p {\r\n              color: #7F9AA6;\r\n              margin-bottom: 12px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .account-detail-main {\r\n        >h3 {\r\n          margin-bottom: 12px;\r\n        }\r\n\r\n        .account-detail-header {\r\n          margin-bottom: 12px;\r\n\r\n          h3 {\r\n            margin-bottom: 0;\r\n          }\r\n\r\n          ul.share-list {\r\n            text-align: right;\r\n\r\n            li {\r\n              vertical-align: middle;\r\n              display: inline-block;\r\n\r\n              &:not(:last-of-type) {\r\n                margin: 0 12px 0 0;\r\n              }\r\n\r\n              a {\r\n                img {\r\n                  max-width: 16px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .account-detail-wrapper {\r\n          //height: 305px;\r\n          overflow: auto;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            //height: 368px;\r\n          }\r\n\r\n          &::-webkit-scrollbar {\r\n            background-color: $primary01;\r\n            width: 10px;\r\n          }\r\n\r\n          &::-webkit-scrollbar-track {\r\n            background-color: $primary01;\r\n          }\r\n\r\n          &::-webkit-scrollbar-thumb {\r\n            background-color: #95ACB6;\r\n            border-radius: 16px;\r\n            border: 3px solid $primary01;\r\n          }\r\n\r\n          &::-webkit-scrollbar-button {\r\n            display: none;\r\n          }\r\n\r\n          .account-card {\r\n            border: 1px solid $border-primary01;\r\n            border-radius: 4px;\r\n            padding: 12px;\r\n\r\n            &:not(:last-of-type) {\r\n              margin: 0 0 12px;\r\n            }\r\n\r\n            .bank-name {\r\n              display: grid;\r\n              grid-template-columns: 13px 1fr;\r\n              align-items: center;\r\n              column-gap: 7.33px;\r\n              margin-bottom: 7px;\r\n\r\n              .icon {\r\n                img {\r\n                  max-width: 13px;\r\n                }\r\n              }\r\n\r\n              p {\r\n                margin: 4px 0 0;\r\n              }\r\n            }\r\n\r\n            ul.account-detail-list {\r\n              li {\r\n                //display: inline-block;\r\n                display: block;\r\n\r\n                &:not(:last-of-type) {\r\n                  //margin: 0 24px 0 0;\r\n                  margin: 0 0 12px;\r\n\r\n                  @media screen and (max-width: $screen-xs) {\r\n                    //margin: 0 24px 8px 0;\r\n                  }\r\n                }\r\n\r\n                p {\r\n                  margin-bottom: 0;\r\n\r\n                  &.title {\r\n                    color: #9AADB6;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .upload-wrapper {\r\n        margin-top: 24px;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          text-align: center;\r\n        }\r\n\r\n        p {\r\n          margin-bottom: 0;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            margin-bottom: 15px;\r\n            line-height: 22px;\r\n          }\r\n\r\n          br.mobile {\r\n            display: none;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              display: block;\r\n            }\r\n          }\r\n        }\r\n\r\n        ul.btn-list {\r\n          text-align: right;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            text-align: center;\r\n          }\r\n\r\n          li {\r\n            display: inline-block;\r\n            vertical-align: middle;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              display: block;\r\n            }\r\n\r\n            &:not(:last-of-type) {\r\n              margin: 0 12px 0 0;\r\n            }\r\n\r\n            .btn-style {\r\n              min-width: 204px;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                min-width: 100%;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .wallet-footer {\r\n      padding: 24px;\r\n      background: #CEDDEB;\r\n      border-radius: 0 0 16px 16px;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        border-radius: 0;\r\n        padding: 13px 16px;\r\n      }\r\n\r\n      ul.btn-list {\r\n        text-align: right;\r\n\r\n        li {\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            display: block;\r\n          }\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 12px 0 0;\r\n          }\r\n\r\n          .btn-style {\r\n            min-width: 179px;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              min-width: 100%;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.user-auth-modal {\r\n  .modal-dialog {\r\n    max-width: 1280px;\r\n\r\n    .modal-content {\r\n      padding: 0;\r\n      border-radius: 12px;\r\n      background: $primary01;\r\n\r\n      @media screen and (max-width: 1199px) {\r\n        margin: 0 10px;\r\n      }\r\n\r\n      .modal-body {\r\n        padding: 40px;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          padding: 22px;\r\n        }\r\n\r\n        .user-auth-wrapper {\r\n          .form-wrapper {\r\n            max-width: 381px;\r\n            margin: auto;\r\n\r\n            >h2 {\r\n              margin-bottom: 8px;\r\n            }\r\n\r\n            >p {\r\n              margin-bottom: 50px;\r\n              display: flex;\r\n              align-items: center;\r\n              gap: 8px;\r\n\r\n              a {\r\n                color: $blue;\r\n                font-weight: 700;\r\n              }\r\n            }\r\n\r\n            .form.auth-form {\r\n              .form-group {\r\n                margin-bottom: 22px;\r\n\r\n                &.mb-16 {\r\n                  margin-bottom: 16px;\r\n                }\r\n\r\n                &.submit {\r\n                  margin-bottom: 0;\r\n\r\n                  .login-option {\r\n                    margin: 16px 0 0;\r\n\r\n                    p {\r\n                      display: flex;\r\n                      align-items: center;\r\n                      gap: 8px;\r\n\r\n                      a {\r\n                        color: $blue;\r\n                        font-weight: 700;\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n\r\n                &.flex {\r\n                  display: grid;\r\n                  grid-template-columns: 20px auto;\r\n                  align-items: center;\r\n                  column-gap: 8px;\r\n\r\n                  label {\r\n                    margin-bottom: 0;\r\n                  }\r\n                }\r\n\r\n                .key-input {\r\n                  position: relative;\r\n\r\n                  .form-control {\r\n                    padding: 9px 40px 9px 12px;\r\n                  }\r\n\r\n                  .icon {\r\n                    position: absolute;\r\n                    right: 13px;\r\n                    top: 50%;\r\n                    transform: translateY(-50%);\r\n                    max-width: 22px;\r\n                    cursor: pointer;\r\n                  }\r\n                }\r\n\r\n                .more-link {\r\n                  text-align: right;\r\n                  margin: 4px 0 0;\r\n\r\n                  a {\r\n                    color: $blue;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n\r\n            .social-wrapper {\r\n              margin: 30px 0 0;\r\n\r\n              .or-line {\r\n                margin: 0;\r\n                text-align: center;\r\n                position: relative;\r\n                display: block;\r\n\r\n                &:before {\r\n                  content: \"\";\r\n                  width: 100%;\r\n                  height: 1px;\r\n                  background: $black;\r\n                  position: absolute;\r\n                  left: 0;\r\n                  top: 50%;\r\n                  transform: translateY(-50%);\r\n                  z-index: 1;\r\n                }\r\n\r\n                span {\r\n                  font-size: 16px;\r\n                  line-height: 22px;\r\n                  font-weight: 500;\r\n                  color: $black;\r\n                  background: $primary01;\r\n                  padding: 0 20px;\r\n                  position: relative;\r\n                  z-index: 2;\r\n                }\r\n              }\r\n\r\n              ul.social-login {\r\n                text-align: center;\r\n                margin: 20px 0 0;\r\n\r\n                li {\r\n                  display: inline-block;\r\n\r\n                  &:not(:last-of-type) {\r\n                    margin: 0 12px 0 0;\r\n                  }\r\n\r\n                  a {\r\n                    img {\r\n                      max-width: 30px;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n\r\n            .auth-footer {\r\n              margin: 50px 0 0;\r\n\r\n              a.auth-logo {\r\n                img {\r\n                  filter: brightness(0) saturate(100%)\r\n                }\r\n              }\r\n\r\n              p.copyright {\r\n                text-align: right;\r\n                margin-bottom: 0;\r\n              }\r\n            }\r\n          }\r\n\r\n          .auth-right-img {\r\n            @media screen and (max-width: $screen-xs) {\r\n              display: none;\r\n            }\r\n\r\n            img {\r\n              width: 100%;\r\n              height: 778px;\r\n              object-fit: cover;\r\n              border-radius: 12px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.user-auth-offcanvas {\r\n  width: 100% !important;\r\n  background: $bg-primary01;\r\n\r\n  @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n    width: 650px !important;\r\n  }\r\n\r\n  .offcanvas-header {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n\r\n    .btn-close {\r\n      border: none;\r\n      outline: none;\r\n      box-shadow: none;\r\n    }\r\n  }\r\n\r\n  .offcanvas-body {\r\n    padding: 0;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 40px 22px;\r\n    }\r\n\r\n    .user-auth-wrapper-main {\r\n      display: grid;\r\n      grid-template-columns: 55% 45%;\r\n      height: 100%;\r\n\r\n      @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n        display: block;\r\n      }\r\n\r\n      .auth-laptop-imga {\r\n        img {\r\n          width: 100%;\r\n        }\r\n      }\r\n\r\n      .auth-laptop-img {\r\n        background: #D5E8FB;\r\n        height: 100%;\r\n        display: flex;\r\n        justify-content: right;\r\n        align-items: self-end;\r\n        text-align: right;\r\n        padding-top: 80px;\r\n\r\n        @media screen and (max-height: 710px) {\r\n          padding-top: 40px;\r\n        }\r\n\r\n        @media screen and (max-width: 1199px) {\r\n          display: none;\r\n        }\r\n\r\n        img {\r\n          width: calc(100% - 185px);\r\n          max-height: calc(100vh - 80px);\r\n          object-fit: contain;\r\n\r\n          @media screen and (min-width: 2000px) {\r\n            width: auto;\r\n          }\r\n\r\n          @media screen and (max-width: 1400px) and (min-width: 1200px) {\r\n            width: calc(100% - 40px);\r\n          }\r\n\r\n          @media screen and (max-height: 710px) {\r\n            max-height: calc(100vh);\r\n            width: calc(100% - 185px);\r\n          }\r\n        }\r\n      }\r\n\r\n      .user-auth-wrapper {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: 100%;\r\n        overflow: auto;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          height: auto;\r\n          @include scrollbar-v1;\r\n        }\r\n\r\n        @media screen and (max-height: 710px) {\r\n          padding: 60px 0;\r\n        }\r\n\r\n        .form-wrapper {\r\n          width: 100%;\r\n          max-width: 412px;\r\n          margin: auto;\r\n\r\n          >h3 {\r\n            margin-bottom: 33px;\r\n            text-align: center;\r\n          }\r\n\r\n          ul.social-auth {\r\n            text-align: center;\r\n            margin: 0 0 33px;\r\n\r\n            li {\r\n              display: block;\r\n\r\n              &:not(:last-of-type) {\r\n                margin: 0 0 22px;\r\n              }\r\n\r\n              .btn-style {\r\n                min-width: 100%;\r\n                height: 55px;\r\n\r\n                img {\r\n                  max-width: 24px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .form.auth-form {\r\n            .form-group {\r\n              margin-bottom: 24px;\r\n\r\n              &.submit {\r\n                margin-bottom: 0;\r\n\r\n                .btn-style {\r\n                  height: 55px;\r\n                  font-weight: 700;\r\n                }\r\n\r\n                .no-account {\r\n                  margin: 33px 0 0;\r\n                  text-align: center;\r\n\r\n                  p {\r\n                    margin-bottom: 0;\r\n                  }\r\n                }\r\n              }\r\n\r\n              label {\r\n                font-size: 18px;\r\n                line-height: 25px;\r\n                font-weight: 700;\r\n                margin-bottom: 12px;\r\n              }\r\n\r\n              .otp-text {\r\n                margin-bottom: 33px;\r\n                text-align: center;\r\n              }\r\n\r\n              .resend-otp {\r\n                text-align: right;\r\n\r\n                label {\r\n                  cursor: pointer;\r\n                }\r\n              }\r\n\r\n              .form-control {\r\n                height: 48px;\r\n                font-size: 16px;\r\n                line-height: 22px;\r\n                border-color: #B5D2DF;\r\n                color: $black;\r\n\r\n                &::placeholder {\r\n                  color: #8097A2;\r\n                }\r\n\r\n                &.otp-input {\r\n                  letter-spacing: 31px;\r\n                }\r\n              }\r\n\r\n              .key-input {\r\n                position: relative;\r\n\r\n                .form-control {\r\n                  padding: 9px 40px 9px 12px;\r\n                }\r\n\r\n                .icon {\r\n                  position: absolute;\r\n                  right: 12px;\r\n                  top: 50%;\r\n                  transform: translateY(-50%);\r\n                  max-width: 24px;\r\n                  cursor: pointer;\r\n                }\r\n              }\r\n\r\n              .more-link {\r\n                margin: 12px 0 0;\r\n\r\n                a {}\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.pre-registration-modal {\r\n  .modal-dialog {\r\n    max-width: 600px;\r\n\r\n    .modal-content {\r\n      padding: 0;\r\n      border-radius: 16px;\r\n      //background: $primary01;\r\n      background: $white;\r\n      overflow: visible;\r\n\r\n      @media screen and (max-width: 1199px) {\r\n        margin: 0 10px;\r\n      }\r\n\r\n      .modal-body {\r\n        padding: 0;\r\n\r\n        .pre-registration-wrapper {\r\n          .pre-registration-card {\r\n            padding: 24px;\r\n\r\n            h3 {\r\n              margin-bottom: 12px;\r\n            }\r\n\r\n            p {\r\n              margin-bottom: 10px;\r\n            }\r\n\r\n            ul.feature-list {\r\n              margin-bottom: 15px;\r\n\r\n              li {\r\n                display: block;\r\n                position: relative;\r\n                padding-left: 15px;\r\n\r\n                &:not(:last-of-type) {\r\n                  margin: 0 0 10px 0;\r\n                }\r\n\r\n                &:before {\r\n                  content: \"\";\r\n                  background: $text-primary01;\r\n                  width: 5px;\r\n                  height: 5px;\r\n                  border-radius: 50px;\r\n                  position: absolute;\r\n                  left: 0;\r\n                  top: 8px;\r\n                }\r\n              }\r\n            }\r\n\r\n          }\r\n\r\n          .registration-footer {\r\n            padding: 16px;\r\n            border-top: 1px solid $border-primary02;\r\n            //background: #CEDDEB;\r\n            background: $white;\r\n            border-radius: 0 0 16px 16px;\r\n            text-align: right;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              border-radius: 0;\r\n              padding: 13px 16px;\r\n            }\r\n\r\n            ul.btn-list {\r\n              li {\r\n                display: inline-block;\r\n                vertical-align: middle;\r\n\r\n                &:not(:last-of-type) {\r\n                  margin: 0 12px 0 0;\r\n                }\r\n\r\n                .btn-style {\r\n                  min-width: 179px;\r\n\r\n                  @media screen and (max-width: $screen-xs) {\r\n                    min-width: 100%;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n.sec-choose-wallet {\r\n  padding-bottom: 40px;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding-bottom: 30px;\r\n  }\r\n\r\n  &.sec-no-wallet {\r\n    .choose-wallet-main {\r\n      margin: -200px 0 0;\r\n    }\r\n  }\r\n\r\n  .choose-wallet-main {\r\n    margin: -140px 0 0;\r\n    height: auto;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      margin: -290px 0 0;\r\n    }\r\n  }\r\n\r\n  .choose-wallet-wrapper {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, calc(50% - 10px));\r\n    column-gap: 20px;\r\n    align-items: center;\r\n    position: relative;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 1fr;\r\n      row-gap: 20px;\r\n    }\r\n\r\n    &.no-grid {\r\n      display: block;\r\n    }\r\n\r\n    p.or {\r\n      width: 61px;\r\n      height: 53px;\r\n      padding: 16px;\r\n      position: absolute;\r\n      top: 50%;\r\n      left: 50%;\r\n      transform: translate(-50%, -50%);\r\n      margin: 0;\r\n      line-height: 20px;\r\n      border-radius: 8px;\r\n      background: $bg-primary01;\r\n      border: 1px solid #C8C8C8;\r\n      box-shadow: 0 4px 60px 0 #00000026;\r\n      z-index: 1;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        top: calc(50% - 14px);\r\n      }\r\n    }\r\n\r\n    .wallet-card {\r\n      background: $bg-primary01;\r\n      border: 1px solid #C8C8C8;\r\n      border-radius: 16px;\r\n      min-height: 471px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      padding: 60px;\r\n      text-align: center;\r\n\r\n      @media screen and (max-width: 991px) and (min-width: 768px) {\r\n        min-height: 380px;\r\n        padding: 22px 30px;\r\n      }\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        min-height: auto;\r\n        padding: 40px 60px;\r\n      }\r\n\r\n      .card-content {\r\n        width: 100%;\r\n\r\n        .icon-wrapper {\r\n          margin-bottom: 20px;\r\n\r\n          img {\r\n            max-width: 96px;\r\n          }\r\n        }\r\n\r\n        .content-wrapper {\r\n          h3.title {\r\n            margin-bottom: 0;\r\n\r\n            @media screen and (max-width: 1199px) {\r\n              font-size: 26px;\r\n              line-height: 34px;\r\n            }\r\n          }\r\n\r\n          p {\r\n            margin: 20px 0;\r\n\r\n            @media screen and (max-width: 1199px) {\r\n              margin: 12px 0 20px;\r\n              font-size: 16px;\r\n              line-height: 24px;\r\n            }\r\n          }\r\n\r\n          a.arrow-icon {\r\n            img {\r\n              max-width: 49px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .no-wallet-card {\r\n      padding: 73px 60px;\r\n      background: $bg-primary01;\r\n      border: 1px solid #C8C8C8;\r\n      border-radius: 16px;\r\n      min-height: 298px;\r\n      text-align: center;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 40px;\r\n        min-height: auto;\r\n      }\r\n\r\n      h3 {\r\n        margin-bottom: 0;\r\n\r\n        @media screen and (max-width: 1199px) {\r\n          font-size: 26px;\r\n          line-height: 34px;\r\n        }\r\n      }\r\n\r\n      p {\r\n        margin: 20px 0;\r\n\r\n        @media screen and (max-width: 1199px) {\r\n          margin: 12px 0 20px;\r\n          font-size: 16px;\r\n          line-height: 24px;\r\n        }\r\n      }\r\n\r\n      ul.btn-list {\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin-top: 13px;\r\n        }\r\n\r\n        li {\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 12px 0 0;\r\n\r\n            @media screen and (max-width: 991px) {\r\n              margin: 0 8px 0 0;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .wallet-table-wrapper {\r\n    padding: 24px;\r\n    background: $bg-primary01;\r\n    border: 1px solid #C8C8C8;\r\n    border-radius: 16px;\r\n    min-height: 298px;\r\n    overflow: auto;\r\n\r\n    .asset-list-wrapper {\r\n      .asset-list {\r\n\r\n        /*height: 500px;\r\n        overflow: auto;\r\n        @media screen and (max-width: $screen-xs) {\r\n          height: 362px;\r\n        }*/\r\n        &.desktop {\r\n          display: block;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            display: none;\r\n          }\r\n        }\r\n\r\n        @include scrollbar-v1;\r\n\r\n        .grid-4 {\r\n          display: grid;\r\n          grid-template-columns: 400px 215px 215px 330px;\r\n          column-gap: 10px;\r\n\r\n          @media screen and (max-width: 1280px) and (min-width: 1200px) {\r\n            grid-template-columns: 340px 205px 205px 330px;\r\n          }\r\n\r\n          @media screen and (max-width: 1199px) and (min-width: 992px) {\r\n            grid-template-columns: 280px 190px 190px 295px;\r\n            min-width: 995px;\r\n          }\r\n\r\n          @media screen and (max-width: 991px) and (min-width: 768px) {\r\n            grid-template-columns: 270px 150px 150px 295px;\r\n            min-width: 905px;\r\n          }\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-template-columns: 250px 140px 140px 265px;\r\n            min-width: 834px;\r\n          }\r\n        }\r\n\r\n        .grid-5 {\r\n          display: grid;\r\n          grid-template-columns: 220px 198px 198px 198px 330px;\r\n          column-gap: 10px;\r\n\r\n          @media screen and (max-width: 1280px) and (min-width: 1200px) {\r\n            grid-template-columns: 200px 170px 180px 175px 330px;\r\n          }\r\n\r\n          @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n            grid-template-columns: 200px 130px 130px 105px 295px;\r\n            min-width: 910px;\r\n          }\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-template-columns: 185px 105px 120px 75px 265px;\r\n            min-width: 807px;\r\n          }\r\n        }\r\n\r\n        .grid-7 {\r\n          display: grid;\r\n          grid-template-columns: 44px 148px 195px 155px 130px 225px 225px;\r\n          column-gap: 10px;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-template-columns: 44px 148px 195px 155px 130px 225px 225px;\r\n            min-width: 1192px;\r\n          }\r\n        }\r\n\r\n        .grid-8 {\r\n          display: grid;\r\n          //grid-template-columns: 44px 44px 244px 244px 180px 160px 130px 180px;\r\n          grid-template-columns: 35px 35px 210px 200px 170px 140px 130px 190px;\r\n          column-gap: 10px;\r\n\r\n          @media screen and (max-width: 1280px) and (min-width: 1200px) {\r\n            grid-template-columns: 35px 35px 195px 185px 160px 120px 115px 185px;\r\n          }\r\n\r\n          @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n            min-width: 1195px;\r\n          }\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-template-columns: 44px 44px 244px 244px 180px 160px 130px 180px;\r\n          }\r\n        }\r\n\r\n        .table-header {\r\n          padding: 20px 8px;\r\n          border-bottom: 1px solid $border-primary01;\r\n\r\n          &.style-v2 {\r\n            border-top: 1px solid $border-primary01;\r\n            border-bottom: 1px solid $border-primary01;\r\n            background: #CEDDEB;\r\n          }\r\n\r\n          .asset-item {\r\n            &:first-of-type {\r\n              padding-left: 40px;\r\n            }\r\n\r\n            p {\r\n              margin-bottom: 0;\r\n              font-weight: 800;\r\n              color: $text-primary02;\r\n              display: inline-flex;\r\n              align-items: center;\r\n              gap: 4px;\r\n\r\n              img {\r\n                cursor: pointer;\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .asset-card {\r\n          padding: 17px 8px;\r\n          border-bottom: 1px solid $border-primary01;\r\n\r\n          &:not(:last-of-type) {}\r\n\r\n          .asset-item {\r\n            p {\r\n              margin-bottom: 0;\r\n            }\r\n\r\n            .transaction-name {\r\n              img {\r\n                max-width: 18px;\r\n              }\r\n\r\n              p {\r\n                margin-bottom: 0;\r\n              }\r\n            }\r\n\r\n            .name-wrapper {\r\n              display: grid;\r\n              grid-template-columns: 51px 1fr;\r\n              column-gap: 10px;\r\n              align-items: center;\r\n\r\n              .icon {\r\n                img {\r\n                  max-width: 51px;\r\n                }\r\n              }\r\n\r\n              .wallet-icon {\r\n                width: 46px;\r\n                height: 46px;\r\n                border-radius: 50%;\r\n                background: #D2DEEB;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                position: relative;\r\n\r\n                .wallet-icon {\r\n                  max-width: 21px;\r\n                }\r\n\r\n                .tag-icon {\r\n                  position: absolute;\r\n                  right: -3px;\r\n                  bottom: 0;\r\n                  width: 18px;\r\n                  height: 18px;\r\n                  border-radius: 50%;\r\n                  border: 1px solid $white;\r\n                }\r\n              }\r\n\r\n              .content {\r\n                p {\r\n                  margin-bottom: 0;\r\n                  color: $text-primary05;\r\n                  font-weight: 600;\r\n\r\n                  &.title {\r\n                    color: $text-primary01;\r\n                    font-weight: 800;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n\r\n            ul.btn-list {\r\n              text-align: center;\r\n\r\n              li {\r\n                display: inline-block;\r\n                vertical-align: middle;\r\n\r\n                &:not(:last-of-type) {\r\n                  margin: 0 8px 0 0;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        .show-more {\r\n          text-align: center;\r\n          margin-top: 20px;\r\n        }\r\n      }\r\n\r\n      .asset-list-mobile {\r\n        display: none;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          display: block;\r\n        }\r\n\r\n        .asset-list-card {\r\n          padding: 16px;\r\n          border-radius: 8px;\r\n          border: 1px solid $border-primary01;\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 0 16px;\r\n          }\r\n\r\n          .transaction-icon {\r\n            margin-bottom: 12px;\r\n            padding: 6px;\r\n\r\n            img {\r\n              max-width: 18px;\r\n            }\r\n          }\r\n\r\n          ul.asset-detail {\r\n            display: grid;\r\n            //grid-template-columns: repeat(2, calc(50% - 6px));\r\n            //grid-template-columns: 1fr 90px;\r\n            grid-template-columns: auto auto;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            column-gap: 12px;\r\n            row-gap: 12px;\r\n\r\n            li {\r\n              &:nth-of-type(even) {\r\n                text-align: left;\r\n              }\r\n\r\n              p {\r\n                margin-bottom: 0;\r\n\r\n                &.f-10 {\r\n                  color: $text-primary05;\r\n                }\r\n              }\r\n\r\n              .name-wrapper {\r\n                display: grid;\r\n                grid-template-columns: 36px 1fr;\r\n                column-gap: 10px;\r\n                align-items: center;\r\n\r\n                .icon {\r\n                  img {\r\n                    max-width: 36px;\r\n                  }\r\n                }\r\n\r\n                .wallet-icon {\r\n                  width: 36px;\r\n                  height: 36px;\r\n                  border-radius: 50%;\r\n                  background: #D2DEEB;\r\n                  display: flex;\r\n                  align-items: center;\r\n                  justify-content: center;\r\n                  position: relative;\r\n\r\n                  .wallet-icon {\r\n                    max-width: 21px;\r\n                  }\r\n\r\n                  .tag-icon {\r\n                    position: absolute;\r\n                    right: -3px;\r\n                    bottom: 0;\r\n                    width: 18px;\r\n                    height: 18px;\r\n                    border-radius: 50%;\r\n                    border: 1px solid $white;\r\n                  }\r\n                }\r\n\r\n                .content {\r\n                  p {\r\n                    margin-bottom: 0;\r\n                    color: $text-primary05;\r\n                    font-weight: 600;\r\n\r\n                    &.title {\r\n                      color: $text-primary01;\r\n                      font-weight: 800;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          .approved-date {\r\n            margin: 12px 0 0;\r\n\r\n            p {\r\n              margin-bottom: 0;\r\n\r\n              &.f-10 {\r\n                color: $text-primary05;\r\n              }\r\n            }\r\n          }\r\n\r\n          ul.asset-btn {\r\n            display: grid;\r\n            grid-template-columns: repeat(2, calc(50% - 6px));\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            column-gap: 8px;\r\n            margin: 11px 0 0;\r\n\r\n            li {\r\n              display: block;\r\n\r\n              .btn-style {\r\n                height: 38px;\r\n                min-width: 100%;\r\n                font-size: 14px;\r\n                line-height: 22px;\r\n              }\r\n            }\r\n          }\r\n\r\n          ul.trade-date-list {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            gap: 12px;\r\n            margin-bottom: 12px;\r\n\r\n            li {\r\n              p {\r\n                margin-bottom: 0;\r\n\r\n                &.f-10 {\r\n                  color: $text-primary05;\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          ul.source-date-list {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            gap: 12px;\r\n            margin-bottom: 12px;\r\n\r\n            li {\r\n              p {\r\n                margin-bottom: 0;\r\n\r\n                &.f-10 {\r\n                  color: $text-primary05;\r\n                }\r\n\r\n                &.wallet-name {\r\n                  white-space: nowrap;\r\n                  overflow: hidden;\r\n                  text-overflow: ellipsis;\r\n                  max-width: 130px;\r\n                }\r\n              }\r\n            }\r\n          }\r\n\r\n          ul.destination-date-list {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            gap: 12px;\r\n            margin-bottom: 0;\r\n\r\n            li {\r\n              p {\r\n                margin-bottom: 0;\r\n\r\n                &.f-10 {\r\n                  color: $text-primary05;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-broadcast-transaction {\r\n  padding: 45px 0 60px;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 40px 0;\r\n  }\r\n\r\n  .container>h3 {\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .broadcast-wrapper {\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    border: 1px solid $border-primary01;\r\n\r\n    .broadcast-body {\r\n      padding: 24px;\r\n\r\n      .deposit-wrapper {\r\n        .deposit-item {\r\n          &:not(:last-of-type) {\r\n            margin-bottom: 12px;\r\n          }\r\n\r\n          >h3 {\r\n            margin-bottom: 12px;\r\n          }\r\n\r\n          .form {\r\n            .form-group {\r\n              margin-bottom: 0;\r\n            }\r\n          }\r\n\r\n          .custom-select {\r\n            background: transparent;\r\n          }\r\n\r\n          .btn-wrapper {\r\n            text-align: right;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .broadcast-footer {\r\n      padding: 24px;\r\n      background: #CEDDEB;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 12px 24px;\r\n      }\r\n\r\n      ul.btn-list {\r\n        text-align: right;\r\n\r\n        li {\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 12px 0 0;\r\n          }\r\n\r\n          .btn-style {\r\n            min-width: 197px;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              min-width: 120px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\nfooter {\r\n  padding: 24px;\r\n  background: #DCEAF7;\r\n  border-top: 1px solid #CEDDEB;\r\n\r\n  .link-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 28px;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      display: block;\r\n      text-align: center;\r\n    }\r\n\r\n    ul.link-list {\r\n      @media screen and (max-width: $screen-xs) {\r\n        margin-bottom: 12px;\r\n      }\r\n\r\n      li {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n\r\n        &:not(:last-of-type) {\r\n          margin: 0 28px 0 0;\r\n        }\r\n\r\n        a {\r\n          color: #7F9AA6;\r\n          font-size: 16px;\r\n          line-height: 25px;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            font-size: 14px;\r\n            line-height: 22px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    ul.social-list {\r\n      li {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n\r\n        &:not(:last-of-type) {\r\n          margin: 0 10px 0 0;\r\n        }\r\n\r\n        a {\r\n          img {\r\n            max-width: 16px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Landing Page SCSS\r\n\r\nbody {\r\n  &.landing-page-body {\r\n    background: $white;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.d-visible {\r\n  @media screen and (max-width: $screen-xs) {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.m-visible {\r\n  display: none;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    display: block !important;\r\n  }\r\n}\r\n\r\n.sec-landing-banner,\r\n.sec-hubrid-setup,\r\n.sec-digital-asset,\r\n.sec-mobile-wallet,\r\n.sec-trading-desk,\r\n.sec-security,\r\n.sec-compliance {\r\n  .container {\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      max-width: 1140px;\r\n    }\r\n  }\r\n}\r\n\r\n.landing-header {\r\n  position: absolute;\r\n  top: 45px;\r\n  left: 0;\r\n  width: 100%;\r\n  z-index: 2;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    top: 9px;\r\n  }\r\n\r\n  &.menu-open {\r\n    .header-wrapper {\r\n      @media screen and (max-width: $screen-xs) {\r\n        border-radius: 8px 8px 0 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .header-wrapper {\r\n    padding: 20px 32px;\r\n    border-radius: 8px;\r\n    background: #090F17;\r\n    box-shadow: 0px 4px 52px 0px #00000026;\r\n    max-width:787px;\r\n    margin: auto;\r\n    display: grid;\r\n    grid-template-columns: 109px 1fr;\r\n    justify-content: space-between;\r\n    column-gap: 30px;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 72px 1fr;\r\n      max-width: 328px;\r\n      padding: 16px 24px;\r\n    }\r\n\r\n    .logo-wrapper {\r\n      a.logo {\r\n        img {\r\n          max-width: 109px;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            max-width: 72px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .navbar-menu {\r\n      .menu-bar {\r\n        display: none;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          display: block;\r\n          text-align: right;\r\n        }\r\n\r\n        img {\r\n          max-width: 20px;\r\n        }\r\n      }\r\n\r\n      ul.menu {\r\n        text-align: right;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          position: fixed;\r\n          top: 66px;\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n          width: 100%;\r\n          max-width: 328px;\r\n          height: auto;\r\n          box-shadow: 0 4px 52px 0 #00000026;\r\n          background: $white;\r\n          border-radius: 0 0 8px 8px;\r\n          display: none;\r\n\r\n          &.active {\r\n            display: block;\r\n          }\r\n        }\r\n\r\n        li {\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n          position: relative;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            display: block;\r\n          }\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 25px 0 0;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin: 0;\r\n              border-bottom: 1px solid $border-primary04;\r\n            }\r\n          }\r\n\r\n          &.arrow {\r\n            margin: 0 45px 0 0;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin: 0;\r\n            }\r\n\r\n            &:before {\r\n              content: '';\r\n              background: url(\"../images/icons/arrow-down-white-icon.svg\") no-repeat center;\r\n              background-size: cover;\r\n              width: 6px;\r\n              height: 9px;\r\n              position: absolute;\r\n              right: -16px;\r\n              top: 50%;\r\n              transform: translateY(-50%);\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                width: 12px;\r\n                right: 24px;\r\n                filter: brightness(0) saturate(100%) invert(0%) sepia(97%) saturate(0%) hue-rotate(43deg) brightness(95%) contrast(102%);\r\n              }\r\n            }\r\n          }\r\n\r\n          a {\r\n            color: $white;\r\n            font-weight: 400;\r\n            display: inline-block;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              display: block;\r\n              font-weight: 500;\r\n              text-align: left;\r\n              color: $black;\r\n              padding: 20px 33px 20px 28px;\r\n            }\r\n          }\r\n\r\n          // Products dropdown styles\r\n          &.dropdown {\r\n            .dropdown-menu {\r\n              position: absolute;\r\n              top: 100%;\r\n              left: 0;\r\n              background: #090F17;\r\n              border-radius: 8px;\r\n              box-shadow: 0px 4px 52px 0px #00000026;\r\n              min-width: 180px;\r\n              padding: 8px 0;\r\n              margin-top: 8px;\r\n              display: none;\r\n              z-index: 1000;\r\n\r\n              &.show {\r\n                display: block;\r\n              }\r\n\r\n              li {\r\n                display: block;\r\n                margin: 0;\r\n                border-bottom: none;\r\n\r\n                a {\r\n                  color: $white;\r\n                  padding: 12px 20px;\r\n                  font-weight: 400;\r\n                  font-size: 14px;\r\n                  line-height: 20px;\r\n                  transition: background-color 0.2s ease;\r\n\r\n                  &:hover {\r\n                    background-color: rgba(255, 255, 255, 0.1);\r\n                  }\r\n\r\n                  @media screen and (max-width: $screen-xs) {\r\n                    color: $black;\r\n                    padding: 15px 20px;\r\n\r\n                    &:hover {\r\n                      background-color: rgba(0, 0, 0, 0.05);\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                position: static;\r\n                background: $white;\r\n                box-shadow: none;\r\n                border-radius: 0;\r\n                margin-top: 0;\r\n                padding: 0;\r\n                display: block;\r\n\r\n                &.show {\r\n                  display: block;\r\n                }\r\n              }\r\n            }\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              .dropdown-menu {\r\n                display: none;\r\n\r\n                &.show {\r\n                  display: block;\r\n                }\r\n              }\r\n            }\r\n\r\n            &.disabled {\r\n              opacity: 0.5;\r\n              cursor: not-allowed;\r\n\r\n              >a {\r\n                cursor: not-allowed;\r\n                color: rgba(255, 255, 255, 0.5);\r\n\r\n                @media screen and (max-width: $screen-xs) {\r\n                  color: rgba(0, 0, 0, 0.5);\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-landing-banner {\r\n  position: relative;\r\n  @include before-bg-line-img(\"../images/banner-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/banner-right-bg-lines.png\");\r\n\r\n  &:before,\r\n  &:after {\r\n    @media screen and (max-width: $screen-xs) {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .container {\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 0;\r\n    }\r\n  }\r\n\r\n  .banner-wrapper {\r\n    position: relative;\r\n    margin: 0 60px;\r\n\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      margin: 0 30px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      margin: 0;\r\n    }\r\n\r\n    .bg-img {\r\n      width: 100%;\r\n      height: 100%;\r\n\r\n      @media screen and (max-width: 390px) {\r\n        min-height: 650px;\r\n      }\r\n    }\r\n\r\n    .banner-content {\r\n      position: absolute;\r\n      top: 192px;\r\n      left: 50%;\r\n      transform: translateX(-50%);\r\n      width: 100%;\r\n      max-width: 899px;\r\n      text-align: center;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        top: 90px;\r\n        padding: 0 16px;\r\n      }\r\n\r\n      .banner-tag {\r\n        padding: 12px 16px;\r\n        min-height: 42px;\r\n        border-radius: 8px;\r\n        border: 1px solid #E4E4E4;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 11px;\r\n        margin-bottom: 32px;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          text-align: left;\r\n          margin-bottom: 24px;\r\n        }\r\n\r\n        img {\r\n          max-width: 20px;\r\n        }\r\n\r\n        p {\r\n          color: #424A53;\r\n          margin-bottom: 0;\r\n        }\r\n      }\r\n\r\n      h1 {\r\n        font-size: 72px;\r\n        line-height: 80px;\r\n        font-weight: 500;\r\n        color: $black;\r\n        margin: 0;\r\n\r\n        @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n          font-size: 60px;\r\n          line-height: 70px;\r\n        }\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          font-size: 40px;\r\n          line-height: 50px;\r\n        }\r\n      }\r\n\r\n      h3 {\r\n        font-size: 18px;\r\n        line-height: 26px;\r\n        font-weight: 500;\r\n        color: rgba(47, 47, 47, 0.9);\r\n        margin: 32px 0;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin: 24px 0;\r\n          font-size: 14px;\r\n          line-height: 22px;\r\n\r\n          br {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n\r\n      ul.btn-list {\r\n        li {\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 16px 0 0;\r\n          }\r\n\r\n          .btn-style {\r\n            @media screen and (max-width: $screen-xs) {\r\n              height: 36px;\r\n              min-width: 111px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-hubrid-setup {\r\n  padding: 145px 0;\r\n  position: relative;\r\n  border-top: 1px solid $border-primary04;\r\n  border-bottom: 1px solid $border-primary04;\r\n  @include before-bg-line-img(\"../images/hubrid-setup-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/hubrid-setup-right-bg-lines.png\");\r\n\r\n  @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n    padding: 90px 0;\r\n  }\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 41px 0;\r\n  }\r\n\r\n  .content-wrapper {\r\n    h2 {\r\n      text-transform: capitalize;\r\n\r\n      b {\r\n        font-weight: 400;\r\n        color: #92A9B3;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-digital-asset {\r\n  padding: 96px 0;\r\n  border-bottom: 1px solid $border-primary04;\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n\r\n  @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n    padding: 70px 0;\r\n  }\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 40px 0 30px;\r\n    border-bottom: unset;\r\n  }\r\n\r\n  &:before,\r\n  &:after {\r\n    height: calc(100% + 1px);\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      height: calc(100%);\r\n    }\r\n  }\r\n\r\n  .content-wrapper {\r\n    h2 {\r\n      text-transform: capitalize;\r\n      margin-bottom: 16px;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        margin-bottom: 8px;\r\n      }\r\n    }\r\n\r\n    h3 {\r\n      color: rgba(47, 47, 47, 0.9);\r\n      margin: 0;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 14px;\r\n        line-height: 22px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-mobile-wallet {\r\n  padding: 47px 0 0;\r\n  border-bottom: 1px solid $border-primary04;\r\n  position: relative;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 30px 0 8px;\r\n    border-bottom: unset;\r\n  }\r\n\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n\r\n  &:before,\r\n  &:after {\r\n    height: calc(100% + 1px);\r\n  }\r\n\r\n  .wallet-card {\r\n    &:not(:last-of-type) {\r\n      margin-bottom: 47px;\r\n    }\r\n\r\n    &:nth-of-type(even) {\r\n      .col-md-6 {\r\n        &:nth-of-type(1) {\r\n          order: 2;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 1;\r\n          }\r\n        }\r\n\r\n        &:nth-of-type(2) {\r\n          order: 1;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 2;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .content-wrapper {\r\n      padding: 0 40px;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 0 20px;\r\n        margin-bottom: 31px;\r\n      }\r\n\r\n      h3 {\r\n        font-family: $gabarito;\r\n        text-transform: capitalize;\r\n        margin: 0 0 16px;\r\n\r\n        @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n          font-size: 25px;\r\n          line-height: 33px;\r\n        }\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          font-weight: 400;\r\n        }\r\n      }\r\n\r\n      ul.feature-list {\r\n        li {\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n          position: relative;\r\n          padding-left: 18px;\r\n          font-size: 18px;\r\n          line-height: 26px;\r\n          font-weight: 500;\r\n          color: rgba(47, 47, 47, 0.9);\r\n\r\n          @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n            font-size: 16px;\r\n            line-height: 24px;\r\n          }\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            padding-left: 14px;\r\n            font-size: 14px;\r\n            line-height: 22px;\r\n          }\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 0 12px;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin: 0 0 6px;\r\n            }\r\n          }\r\n\r\n          &:before {\r\n            content: '';\r\n            background: rgba(47, 47, 47, 0.9);\r\n            width: 5px;\r\n            height: 5px;\r\n            border-radius: 50%;\r\n            position: absolute;\r\n            left: 0;\r\n            top: 10px;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              width: 4px;\r\n              height: 4px;\r\n            }\r\n          }\r\n\r\n          a {\r\n            img {\r\n              max-width: 16px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .img-wrapper {\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-trading-desk {\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  border-bottom: 1px solid $border-primary04;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    border-bottom: unset;\r\n    padding-bottom: 32px;\r\n  }\r\n\r\n  &:before,\r\n  &:after {\r\n    height: calc(100% + 1px);\r\n  }\r\n\r\n  .trading-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 50%);\r\n    align-items: self-start;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n\r\n    .trading-card {\r\n      padding: 64px 40px;\r\n      min-height: 313px;\r\n      display: grid;\r\n      column-gap: 16px;\r\n      grid-template-columns: 1fr 134px;\r\n      align-items: self-start;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        grid-template-columns: 1fr;\r\n        padding: 32px 20px;\r\n        min-height: auto;\r\n      }\r\n\r\n      &:first-of-type {\r\n        border-right: 1px solid $border-primary04;\r\n      }\r\n\r\n      .content {\r\n        h3 {\r\n          font-family: $gabarito;\r\n          text-transform: capitalize;\r\n          margin: 0 0 16px;\r\n\r\n          @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n            font-size: 20px;\r\n            line-height: 28px;\r\n          }\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            font-size: 24px;\r\n            line-height: 32px;\r\n            display: grid;\r\n            column-gap: 16px;\r\n            grid-template-columns: 1fr 68px;\r\n            align-items: center;\r\n          }\r\n\r\n          img {\r\n            display: none;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              display: block;\r\n              width: 100%;\r\n              border-radius: 8px;\r\n            }\r\n          }\r\n        }\r\n\r\n        ul.feature-list {\r\n          li {\r\n            display: inline-block;\r\n            vertical-align: middle;\r\n            position: relative;\r\n            padding-left: 18px;\r\n            font-size: 18px;\r\n            line-height: 26px;\r\n            font-weight: 500;\r\n            color: rgba(47, 47, 47, 0.9);\r\n\r\n            @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n              font-size: 16px;\r\n              line-height: 24px;\r\n            }\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              padding-left: 14px;\r\n              font-size: 14px;\r\n              line-height: 22px;\r\n            }\r\n\r\n            &:not(:last-of-type) {\r\n              margin: 0 0 3px;\r\n            }\r\n\r\n            &:before {\r\n              content: '';\r\n              background: rgba(47, 47, 47, 0.9);\r\n              width: 5px;\r\n              height: 5px;\r\n              border-radius: 50%;\r\n              position: absolute;\r\n              left: 0;\r\n              top: 10px;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                width: 4px;\r\n                height: 4px;\r\n              }\r\n            }\r\n\r\n            a {\r\n              img {\r\n                max-width: 16px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .icon {\r\n        align-self: end;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          display: none;\r\n        }\r\n\r\n        img {\r\n          width: 100%;\r\n          border-radius: 16px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-security {\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  border-bottom: 1px solid $border-primary05;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 32px 0 25px;\r\n  }\r\n\r\n  .security-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 466px;\r\n    column-gap: 6px;\r\n    align-items: center;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n\r\n    .content {\r\n      padding-left: 40px;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 0 20px 24px;\r\n      }\r\n\r\n      h3 {\r\n        color: $black;\r\n        margin-bottom: 0;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          font-size: 14px;\r\n          line-height: 22px;\r\n          color: rgba(47, 47, 47, 0.9);\r\n        }\r\n      }\r\n    }\r\n\r\n    .img-wrapper {\r\n      img {\r\n        width: 100%;\r\n        height: 315px;\r\n        object-fit: cover;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          height: 148px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-compliance {\r\n  position: relative;\r\n  @include before-bg-line-img(\"../images/compliance-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/compliance-right-bg-lines.png\");\r\n  border-bottom: 1px solid $border-primary04;\r\n\r\n  .compliance-wrapper {\r\n    padding: 85px 0 238px;\r\n    background: url(\"../images/compliance-bg-img.png\") no-repeat;\r\n    background-position: bottom;\r\n    background-size: cover;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 40px 0 148px;\r\n      background: url(\"../images/compliance-bg-mobile-img.png\") no-repeat;\r\n      background-position: bottom;\r\n      background-size: contain;\r\n    }\r\n\r\n    .bg-img {\r\n      position: absolute;\r\n      bottom: 0;\r\n      left: 50%;\r\n      transform: translateY(-50%);\r\n    }\r\n\r\n    >h2 {\r\n      text-transform: capitalize;\r\n      margin-bottom: 24px;\r\n      text-align: center;\r\n    }\r\n\r\n    >h3 {\r\n      margin-bottom: 48px;\r\n      text-align: center;\r\n    }\r\n\r\n    ul.feature-list {\r\n      display: grid;\r\n      grid-template-columns: repeat(12, 1fr);\r\n      column-gap: 32px;\r\n      row-gap: 25px;\r\n      max-width: 1017px;\r\n      margin: auto;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        column-gap: 0;\r\n        row-gap: 0;\r\n        margin: auto 4px;\r\n      }\r\n\r\n      &:has(li) {\r\n\r\n        li:nth-of-type(1),\r\n        li:nth-of-type(2),\r\n        li:nth-of-type(3) {\r\n          grid-column: span 4;\r\n        }\r\n      }\r\n\r\n      li {\r\n        grid-column: span 3;\r\n\r\n        &:nth-of-type(1) {\r\n          .feature-card {\r\n            border-right: 1px solid #C4E3F2 !important;\r\n          }\r\n        }\r\n\r\n        &:nth-of-type(1),\r\n        &:nth-of-type(2) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 6 !important;\r\n\r\n            .feature-card {\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2 !important;\r\n            }\r\n          }\r\n        }\r\n\r\n        &:nth-of-type(3) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 7 !important;\r\n\r\n            .feature-card {\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2 !important;\r\n              border-right: 1px solid #C4E3F2 !important;\r\n            }\r\n          }\r\n        }\r\n\r\n        &:nth-of-type(4) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 5 !important;\r\n\r\n            .feature-card {\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2 !important;\r\n            }\r\n          }\r\n        }\r\n\r\n        &:nth-of-type(5) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 5 !important;\r\n\r\n            .feature-card {\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2 !important;\r\n              border-right: 1px solid #C4E3F2 !important;\r\n            }\r\n          }\r\n        }\r\n\r\n        &:nth-of-type(6) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 7 !important;\r\n\r\n            .feature-card {\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2 !important;\r\n            }\r\n          }\r\n        }\r\n\r\n        &:nth-of-type(7) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 12 !important;\r\n\r\n            .feature-card {\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2 !important;\r\n              border-bottom: 1px solid #C4E3F2 !important;\r\n            }\r\n          }\r\n        }\r\n\r\n        .feature-card {\r\n          padding: 32px 20px;\r\n          background: $white;\r\n          border-radius: 8px;\r\n          border: 1px solid #C4E3F2;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            height: 100%;\r\n            border-radius: 0;\r\n            padding: 22px 16px;\r\n          }\r\n\r\n          h3 {\r\n            font-size: 20px;\r\n            line-height: 28px;\r\n            font-weight: 400;\r\n            color: $black;\r\n            font-family: $gabarito;\r\n            margin: 0;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 14px;\r\n              line-height: 20px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-partnerships {\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n\r\n  .partnerships-wrapper {\r\n    padding: 80px;\r\n\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      padding: 40px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 48px 0;\r\n    }\r\n\r\n    &:before {\r\n      content: '';\r\n      background: url('../images/partnerships-top-bg-lines.png');\r\n      background-repeat: repeat;\r\n      background-size: cover;\r\n      height: 80px;\r\n      width: 100%;\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      border-bottom: 1px solid $border-primary04;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        height: 48px;\r\n        background: url('../images/partnerships-top-bg-lines-mobile.png');\r\n      }\r\n    }\r\n\r\n    &:after {\r\n      content: '';\r\n      background: url('../images/partnerships-bottom-bg-lines.png');\r\n      background-repeat: repeat;\r\n      background-size: cover;\r\n      height: 80px;\r\n      width: 100%;\r\n      position: absolute;\r\n      left: 0;\r\n      bottom: 0;\r\n      border-top: 1px solid $border-primary04;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        height: 48px;\r\n        background: url('../images/partnerships-bottom-bg-lines-mobile.png');\r\n      }\r\n    }\r\n\r\n    .partnerships-grid {\r\n      display: grid;\r\n      grid-template-columns: 298px 298px 1fr;\r\n      align-items: self-start;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        grid-template-columns: 1fr;\r\n      }\r\n\r\n      .partnerships-card {\r\n        padding: 40px;\r\n        min-height: 327px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: left;\r\n\r\n        @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n          padding: 32px;\r\n        }\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          padding: 32px 16px;\r\n          min-height: auto;\r\n          text-align: center;\r\n        }\r\n\r\n        &:not(:last-of-type) {\r\n          border-right: 1px solid $border-primary04;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            border: unset;\r\n            border-bottom: 1px solid $border-primary04;\r\n          }\r\n        }\r\n\r\n        // 👇 Change order here\r\n        &:nth-child(1) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 3;\r\n          }\r\n        }\r\n\r\n        &:nth-child(2) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 2;\r\n          }\r\n        }\r\n\r\n        &:nth-child(3) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 1;\r\n          }\r\n        }\r\n\r\n        .content-wrapper {\r\n          h2 {\r\n            @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n              font-size: 32px;\r\n              line-height: 38px;\r\n            }\r\n          }\r\n\r\n          h3 {\r\n            color: $black;\r\n            font-family: $gabarito;\r\n            margin-bottom: 16px;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin-bottom: 8px;\r\n              font-size: 18px;\r\n              line-height: 26px;\r\n            }\r\n          }\r\n\r\n          p {\r\n            font-size: 18px;\r\n            line-height: 26px;\r\n            font-weight: 500;\r\n            color: rgba(47, 47, 47, 0.9);\r\n            margin-bottom: 0;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 14px;\r\n              line-height: 22px;\r\n              color: $black;\r\n            }\r\n\r\n            &.black {\r\n              color: $black;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.sec-join {\r\n  padding: 128px 0;\r\n  background: url(\"../images/join-bg-img.png\") no-repeat center;\r\n  background-size: cover;\r\n  position: relative;\r\n  @include before-bg-line-img(\"../images/join-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/join-right-bg-lines.png\");\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 72px 0 80px;\r\n  }\r\n\r\n  &:before,\r\n  &:after {\r\n    border-color: #424A53;\r\n  }\r\n\r\n  .content-wrapper {\r\n    text-align: center;\r\n\r\n    h2 {\r\n      color: $white;\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    p {\r\n      font-weight: 500;\r\n      color: $white;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 14px;\r\n        line-height: 22px;\r\n        margin: 16px 0 24px;\r\n\r\n        br {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    .btn-style {\r\n      @media screen and (max-width: $screen-xs) {\r\n        min-width: 296px;\r\n        font-weight: 700;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-meeting {\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  border-bottom: 1px solid $border-primary04;\r\n\r\n  &:before,\r\n  &:after {\r\n    border-color: #E5E5E5;\r\n    z-index: 2;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      border-color: $border-primary04;\r\n    }\r\n  }\r\n\r\n  .container-fluid {\r\n    padding: 0;\r\n  }\r\n\r\n  .partnerships-wrapper {\r\n    //padding: 80px 68px 80px 145px;\r\n    padding: 80px;\r\n\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      padding: 80px 40px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 48px 0;\r\n    }\r\n\r\n    &:before {\r\n      content: '';\r\n      background: transparent;\r\n      height: 80px;\r\n      width: 100%;\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      border-bottom: 1px solid #E5E5E5;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        height: 48px;\r\n        border-color: $border-primary04;\r\n      }\r\n    }\r\n\r\n    &:after {\r\n      content: '';\r\n      background: transparent;\r\n      height: 80px;\r\n      width: 100%;\r\n      position: absolute;\r\n      right: 0;\r\n      bottom: 0;\r\n      border-top: 1px solid #E5E5E5;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        height: 48px;\r\n        border-color: $border-primary04;\r\n      }\r\n    }\r\n\r\n    .meeting-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 237px 237px;\r\n      align-items: self-start;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        grid-template-columns: 1fr;\r\n      }\r\n\r\n      .meeting-card {\r\n        padding: 40px;\r\n        min-height: 266px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: left;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          padding: 24px;\r\n          min-height: auto;\r\n          text-align: center;\r\n          display: block;\r\n          //justify-content: center;\r\n        }\r\n\r\n        &:first-of-type {\r\n          @media screen and (max-width: $screen-xs) {\r\n            padding: 32px 28px;\r\n          }\r\n        }\r\n\r\n        &:not(:first-of-type) {\r\n          background: #F3F9FF;\r\n          border: 1px solid #D3E7F1;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            border: unset;\r\n            border-top: 1px solid #D3E7F1;\r\n          }\r\n        }\r\n\r\n        &:not(:last-of-type) {\r\n          border-right: unset;\r\n        }\r\n\r\n        .content-wrapper {\r\n          h2 {\r\n            @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n              font-size: 32px;\r\n              line-height: 38px;\r\n            }\r\n          }\r\n\r\n          h3 {\r\n            color: $black;\r\n            font-family: $gabarito;\r\n            margin-bottom: 16px;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 24px;\r\n              line-height: 32px;\r\n              margin-bottom: 8px;\r\n            }\r\n          }\r\n\r\n          a.f-24 {\r\n            font-size: 24px;\r\n            line-height: 32px;\r\n            font-weight: 500;\r\n            color: $black;\r\n            font-family: $gabarito;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 18px;\r\n              line-height: 26px;\r\n\r\n              br {\r\n                display: none;\r\n              }\r\n            }\r\n          }\r\n\r\n          p {\r\n            font-size: 18px;\r\n            line-height: 26px;\r\n            font-weight: 500;\r\n            color: $black;\r\n            margin-bottom: 0;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 14px;\r\n              line-height: 22px;\r\n\r\n              br {\r\n                display: none;\r\n              }\r\n            }\r\n\r\n            &:not(:last-of-type) {\r\n              margin-bottom: 16px;\r\n\r\n              @media screen and (max-width: $screen-xs) {\r\n                margin-bottom: 8px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.landing-footer {\r\n  position: relative;\r\n  min-height: 332px;\r\n  padding-bottom: 27px;\r\n  display: flex;\r\n  align-items: self-end;\r\n  background: #010102;\r\n  @include before-bg-line-img(\"../images/footer-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/footer-right-bg-lines.png\");\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding-bottom: 16px;\r\n    min-height: 160px;\r\n  }\r\n\r\n  &:before,\r\n  &:after {\r\n    border-color: #424A53;\r\n    z-index: 2;\r\n  }\r\n\r\n  .bg-img {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    object-fit: contain;\r\n    object-position: top;\r\n  }\r\n\r\n  .content-wrapper {\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 1;\r\n\r\n    p {\r\n      font-weight: 300;\r\n      color: rgba(255, 255, 255, 0.4);\r\n      margin: 0;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 10px;\r\n        line-height: 16px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.landing-bottom-footer {\r\n  position: relative;\r\n  padding: 18px 0;\r\n  background: #010102;\r\n  border-top: 1px solid #494949;\r\n  @include before-bg-line(#010102);\r\n  @include after-bg-line(#010102);\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 16px 0;\r\n  }\r\n\r\n  &:before,\r\n  &:after {\r\n    border-color: #494949;\r\n    z-index: 2;\r\n  }\r\n\r\n  .content-wrapper {\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 1;\r\n\r\n    p {\r\n      font-weight: 300;\r\n      color: #F7F7F7;\r\n      margin: 0;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 10px;\r\n        line-height: 16px;\r\n      }\r\n    }\r\n  }\r\n}","\r\n// Landing Page SCSS\r\n\r\nbody{\r\n  &.landing-page-body{\r\n    background: $white;\r\n    padding: 0;\r\n  }\r\n}\r\n.d-visible{\r\n  @media screen and (max-width: $screen-xs) {\r\n    display: none!important;\r\n  }\r\n}\r\n.m-visible{\r\n  display: none;\r\n  @media screen and (max-width: $screen-xs) {\r\n    display: block!important;\r\n  }\r\n}\r\n\r\n.sec-landing-banner, .sec-hubrid-setup, .sec-digital-asset, .sec-mobile-wallet, .sec-trading-desk, .sec-security, .sec-compliance{\r\n  .container{\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      max-width: 1140px;\r\n    }\r\n  }\r\n}\r\n\r\n.title-style-01{\r\n  font-size: 56px;\r\n  line-height: 80px;\r\n  font-weight: 500;\r\n  color: $black;\r\n  text-transform: capitalize;\r\n  @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n    font-size: 46px;\r\n    line-height: 62px;\r\n  }\r\n  @media screen and (max-width: $screen-xs) {\r\n    font-size: 26px;\r\n    line-height: 34px;\r\n  }\r\n  &.lh-same{\r\n    line-height: 1.2;\r\n  }\r\n  b{\r\n    padding: 0 8px;\r\n    font-weight: 500;\r\n    border-radius: 7px;\r\n    background: #D9EAFF;\r\n  }\r\n}\r\n\r\n.landing-header{\r\n  position: absolute;\r\n  top: 45px;\r\n  left: 0;\r\n  width: 100%;\r\n  z-index: 2;\r\n  @media screen and (max-width: $screen-xs) {\r\n    top: 9px;\r\n  }\r\n  &.menu-open{\r\n    .header-wrapper{\r\n      @media screen and (max-width: $screen-xs) {\r\n        border-radius: 8px 8px 0 0;\r\n      }\r\n    }\r\n  }\r\n  .header-wrapper{\r\n    padding: 20px 32px;\r\n    border-radius: 8px;\r\n    background: #090F17;\r\n    box-shadow: 0px 4px 52px 0px #00000026;\r\n    max-width: 746px;\r\n    margin: auto;\r\n    display: grid;\r\n    grid-template-columns: 109px 1fr;\r\n    justify-content: space-between;\r\n    column-gap: 30px;\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 72px 1fr;\r\n      max-width: 328px;\r\n      padding: 16px 24px;\r\n    }\r\n    .logo-wrapper{\r\n      a.logo{\r\n        img{\r\n          max-width: 109px;\r\n          @media screen and (max-width: $screen-xs) {\r\n            max-width: 72px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .navbar-menu{\r\n      .menu-bar{\r\n        display: none;\r\n        @media screen and (max-width: $screen-xs) {\r\n          display: block;\r\n          text-align: right;\r\n        }\r\n        img{\r\n          max-width: 20px;\r\n        }\r\n      }\r\n      ul.menu{\r\n        text-align: right;\r\n        @media screen and (max-width: $screen-xs) {\r\n          position: fixed;\r\n          top: 66px;\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n          width: 100%;\r\n          max-width: 328px;\r\n          height: auto;\r\n          box-shadow: 0 4px 52px 0 #00000026;\r\n          background: $white;\r\n          border-radius: 0 0 8px 8px;\r\n          display: none;\r\n          &.active {\r\n            display: block;\r\n          }\r\n        }\r\n        li{\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n          position: relative;\r\n          @media screen and (max-width: $screen-xs) {\r\n            display: block;\r\n          }\r\n          &:not(:last-of-type){\r\n            margin: 0 25px 0 0;\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin: 0;\r\n              border-bottom: 1px solid $border-primary04;\r\n            }\r\n          }\r\n          &.arrow{\r\n            margin: 0 45px 0 0;\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin: 0;\r\n            }\r\n            &:before{\r\n              content: '';\r\n              background: url(\"../images/icons/arrow-down-white-icon.svg\") no-repeat center;\r\n              background-size: cover;\r\n              width: 6px;\r\n              height: 9px;\r\n              position: absolute;\r\n              right: -16px;\r\n              top: 50%;\r\n              transform: translateY(-50%);\r\n              @media screen and (max-width: $screen-xs) {\r\n                width: 12px;\r\n                right: 24px;\r\n                filter: brightness(0) saturate(100%) invert(0%) sepia(97%) saturate(0%) hue-rotate(43deg) brightness(95%) contrast(102%);\r\n              }\r\n            }\r\n          }\r\n          a{\r\n            color: $white;\r\n            font-weight: 400;\r\n            display: inline-block;\r\n            @media screen and (max-width: $screen-xs) {\r\n              display: block;\r\n              font-weight: 500;\r\n              text-align: left;\r\n              color: $black;\r\n              padding: 20px 33px 20px 28px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-landing-banner{\r\n  position: relative;\r\n  @include before-bg-line-img(\"../images/banner-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/banner-right-bg-lines.png\");\r\n  &:before, &:after{\r\n    @media screen and (max-width: $screen-xs) {\r\n      display: none;\r\n    }\r\n  }\r\n  .container{\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 0;\r\n    }\r\n  }\r\n  .banner-wrapper{\r\n    position: relative;\r\n    margin: 0 60px;\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      margin: 0 30px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      margin: 0;\r\n    }\r\n    .bg-img{\r\n      width: 100%;\r\n      height: 100%;\r\n    }\r\n    .banner-content{\r\n      position: absolute;\r\n      top: 192px;\r\n      left: 50%;\r\n      transform: translateX(-50%);\r\n      width: 100%;\r\n      max-width: 899px;\r\n      text-align: center;\r\n      @media screen and (max-width: $screen-xs) {\r\n        top: 90px;\r\n        padding: 0 16px;\r\n      }\r\n      .banner-tag{\r\n        padding: 12px 16px;\r\n        min-height: 42px;\r\n        border-radius: 8px;\r\n        border: 1px solid #E4E4E4;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 11px;\r\n        margin-bottom: 32px;\r\n        @media screen and (max-width: $screen-xs) {\r\n          text-align: left;\r\n          margin-bottom: 24px;\r\n        }\r\n        img{\r\n          max-width: 20px;\r\n        }\r\n        p{\r\n          color: #424A53;\r\n          margin-bottom: 0;\r\n        }\r\n      }\r\n      h1{\r\n        font-size: 72px;\r\n        line-height: 80px;\r\n        font-weight: 500;\r\n        color: $black;\r\n        margin: 0;\r\n        @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n          font-size: 60px;\r\n          line-height: 70px;\r\n        }\r\n        @media screen and (max-width: $screen-xs) {\r\n          font-size: 40px;\r\n          line-height: 50px;\r\n        }\r\n      }\r\n      h3{\r\n        font-size: 18px;\r\n        line-height: 26px;\r\n        font-weight: 500;\r\n        color: rgba(47, 47, 47, 0.9);\r\n        margin: 32px 0;\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin: 24px 0;\r\n          font-size: 14px;\r\n          line-height: 22px;\r\n          br{\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n      ul.btn-list{\r\n        li{\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n          &:not(:last-of-type){\r\n            margin: 0 16px 0 0;\r\n          }\r\n          .btn-style{\r\n            @media screen and (max-width: $screen-xs) {\r\n              height: 36px;\r\n              min-width: 111px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-crypto-banner{\r\n  position: relative;\r\n  padding: 120px 0 100px;\r\n  @include before-bg-line-img(\"../images/banner-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/banner-right-bg-lines.png\");\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 100px 0 62px;\r\n  }\r\n  &:before, &:after{\r\n    background-color: $white;\r\n    z-index: 1;\r\n    @media screen and (max-width: $screen-xs) {\r\n      display: none;\r\n    }\r\n  }\r\n  .container{\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 0;\r\n    }\r\n  }\r\n  .banner-wrapper{\r\n    position: relative;\r\n    margin: 0 60px;\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      margin: 0 30px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      margin: 0;\r\n    }\r\n    .banner-img{\r\n      position: relative;\r\n      .bg-img{\r\n        width: 100%;\r\n        height: 100%;\r\n      }\r\n      ul.crypto-list{\r\n        width: 100%;\r\n        max-width: 80%;\r\n        position: absolute;\r\n        left: 50%;\r\n        top: 50%;\r\n        transform: translateY(-50%) translateX(-50%);\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        li{\r\n          .btn-style{\r\n            height: 34px;\r\n            padding: 8px 20px!important;\r\n            border-radius: 60px;\r\n            font-size: 11px;\r\n            line-height: 17px;\r\n            font-weight: 700;\r\n            border-color: #C5D4E4;\r\n            font-family: $manrope;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .banner-content{\r\n      max-width: 940px;\r\n      margin: auto;\r\n      text-align: center;\r\n      @media screen and (max-width: $screen-xs) {\r\n        top: 90px;\r\n        padding: 0 16px;\r\n      }\r\n      h1{\r\n        margin: 0;\r\n      }\r\n      h3{\r\n        font-size: 18px;\r\n        line-height: 26px;\r\n        font-weight: 500;\r\n        color: rgba(47, 47, 47, 0.9);\r\n        margin: 32px 0;\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin: 24px 0;\r\n          font-size: 14px;\r\n          line-height: 22px;\r\n          br{\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n      ul.btn-list{\r\n        li{\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n          &:not(:last-of-type){\r\n            margin: 0 16px 0 0;\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin: 0 8px 0 0;\r\n            }\r\n          }\r\n          .btn-style{\r\n            font-family: $manrope;\r\n            @media screen and (max-width: $screen-xs) {\r\n              padding: 8px 22px;\r\n              height: 36px;\r\n              min-width: 111px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-empty-banner{\r\n  position: relative;\r\n  min-height: 150px;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  @media screen and (max-width: $screen-xs) {\r\n    min-height: 80px;\r\n  }\r\n  &:before, &:after{\r\n    height: calc(100% + 1px);\r\n    @media screen and (max-width: $screen-xs) {\r\n      height: calc(100%);\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.sec-otc-trading-desk{\r\n  padding: 100px 0;\r\n  position: relative;\r\n  border-top: 1px solid $border-primary04;\r\n  border-bottom: 1px solid $border-primary04;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 56px 0 40px;\r\n  }\r\n  &:before, &:after{\r\n    height: calc(100% + 1px);\r\n    @media screen and (max-width: $screen-xs) {\r\n      height: calc(100%);\r\n    }\r\n  }\r\n  .container{\r\n    >h2{\r\n      text-align: center;\r\n      margin-bottom: 44px;\r\n    }\r\n  }\r\n  .desk-grid{\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 485px);\r\n    align-items: self-start;\r\n    justify-content: center;\r\n    column-gap: 36px;\r\n    @media screen and (max-width: 991px) and (min-width: 768px) {\r\n      grid-template-columns: 485px;\r\n      row-gap: 36px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 100%;\r\n      row-gap: 36px;\r\n    }\r\n    .desk-card{\r\n      padding: 32px;\r\n      border-radius: 16px;\r\n      border: 1px solid #C5D4E4;\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 0;\r\n        border: none;\r\n      }\r\n      .content-wrapper{\r\n        margin-bottom: 24px;\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin-bottom: 16px;\r\n        }\r\n        h3{\r\n          margin-bottom: 8px;\r\n          @media screen and (max-width: $screen-xs) {\r\n            font-size: 24px;\r\n            line-height: 32px;\r\n          }\r\n        }\r\n        p{\r\n          color: rgba(47, 47, 47, 0.7);\r\n          min-height: 99px;\r\n          @media screen and (max-width: $screen-xs) {\r\n            min-height: auto;\r\n            font-size: 14px;\r\n            line-height: 22px;\r\n          }\r\n        }\r\n      }\r\n      .img-wrapper{\r\n        img{\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-crypto-legal{\r\n  padding: 100px 0;\r\n  position: relative;\r\n  border-top: 1px solid $border-primary04;\r\n  //border-bottom: 1px solid $border-primary04;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 32px 0 40px;\r\n  }\r\n  &:before, &:after{\r\n    height: calc(100% + 1px);\r\n    @media screen and (max-width: $screen-xs) {\r\n      height: calc(100%);\r\n    }\r\n  }\r\n  .legal-card{\r\n    h2{\r\n      margin-bottom: 16px;\r\n      @media screen and (max-width: $screen-xs) {\r\n        margin-bottom: 24px;\r\n      }\r\n    }\r\n    ul.legal-list{\r\n      li{\r\n        font-size: 14px;\r\n        line-height: 22px;\r\n        color: rgba(47, 47, 47, 0.9);\r\n        display: block;\r\n        vertical-align: middle;\r\n        position: relative;\r\n        padding-left: 14px;\r\n        &:not(:last-of-type){\r\n          margin: 0 0 4px;\r\n        }\r\n        &:before{\r\n          content: '';\r\n          background: rgba(47, 47, 47, 0.9);\r\n          width: 4px;\r\n          height: 4px;\r\n          border-radius: 50%;\r\n          position: absolute;\r\n          left: 0;\r\n          top: 9px;\r\n        }\r\n        br{\r\n          @media screen and (max-width: $screen-xs) {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-crypto-global{\r\n  padding: 100px 0 42px;\r\n  position: relative;\r\n  background: #F9FCFF;\r\n  //border-top: 1px solid $border-primary04;\r\n  //border-bottom: 1px solid $border-primary04;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 41px 0;\r\n  }\r\n  &:before, &:after{\r\n    height: calc(100% + 1px);\r\n    @media screen and (max-width: $screen-xs) {\r\n      height: calc(100%);\r\n    }\r\n  }\r\n  .sec-heading{\r\n    max-width: 1042px;\r\n    text-align: center;\r\n    margin: 0 auto 27px;\r\n    @media screen and (max-width: $screen-xs) {\r\n      margin: 0 auto 12px;\r\n    }\r\n    h2{\r\n      margin-bottom: 24px;\r\n      @media screen and (max-width: $screen-xs) {\r\n        margin-bottom: 13px;\r\n      }\r\n    }\r\n    h3{\r\n      margin: 0;\r\n      font-size: 33px;\r\n      line-height: 50px;\r\n      font-weight: 500;\r\n      color: $black;\r\n      font-family: $gabarito;\r\n      text-transform: capitalize;\r\n      border-radius: 7px;\r\n      padding: 4px 12px;\r\n      background: #D9EAFF;\r\n      display: inline-block;\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 20px;\r\n        line-height: 28px;\r\n      }\r\n    }\r\n  }\r\n  .map-img{\r\n    max-width: 1078px;\r\n    margin: 0 auto;\r\n    img{\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n.sec-hubrid-setup{\r\n  padding: 145px 0;\r\n  position: relative;\r\n  border-top: 1px solid $border-primary04;\r\n  border-bottom: 1px solid $border-primary04;\r\n  @include before-bg-line-img(\"../images/hubrid-setup-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/hubrid-setup-right-bg-lines.png\");\r\n  @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n    padding: 90px 0;\r\n  }\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 41px 0;\r\n  }\r\n  .content-wrapper{\r\n    h2{\r\n      text-transform: capitalize;\r\n      b{\r\n        font-weight: 400;\r\n        color: #92A9B3;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-digital-asset{\r\n  padding: 96px 0;\r\n  border-bottom: 1px solid $border-primary04;\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n    padding: 70px 0;\r\n  }\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 40px 0 30px;\r\n    border-bottom: unset;\r\n  }\r\n  &:before, &:after{\r\n    height: calc(100% + 1px);\r\n    @media screen and (max-width: $screen-xs) {\r\n      height: calc(100%);\r\n    }\r\n  }\r\n  .content-wrapper{\r\n    h2{\r\n      text-transform: capitalize;\r\n      margin-bottom: 16px;\r\n      @media screen and (max-width: $screen-xs) {\r\n        margin-bottom: 8px;\r\n      }\r\n    }\r\n    h3{\r\n      color: rgba(47, 47, 47, 0.9);\r\n      margin: 0;\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 14px;\r\n        line-height: 22px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-mobile-wallet{\r\n  padding: 47px 0 0;\r\n  border-bottom: 1px solid $border-primary04;\r\n  position: relative;\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 30px 0 8px;\r\n    border-bottom: unset;\r\n  }\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  &:before, &:after{\r\n    height: calc(100% + 1px);\r\n  }\r\n  .wallet-card{\r\n    &:not(:last-of-type){\r\n      margin-bottom: 47px;\r\n    }\r\n    &:nth-of-type(even){\r\n      .col-md-6{\r\n        &:nth-of-type(1){\r\n          order: 2;\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 1;\r\n          }\r\n        }\r\n        &:nth-of-type(2){\r\n          order: 1;\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 2;\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .content-wrapper{\r\n      padding: 0 40px;\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 0 20px;\r\n        margin-bottom: 31px;\r\n      }\r\n      h3{\r\n        font-family: $gabarito;\r\n        text-transform: capitalize;\r\n        margin: 0 0 16px;\r\n        @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n          font-size: 25px;\r\n          line-height: 33px;\r\n        }\r\n        @media screen and (max-width: $screen-xs) {\r\n          font-weight: 400;\r\n        }\r\n      }\r\n      ul.feature-list{\r\n        li{\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n          position: relative;\r\n          padding-left: 18px;\r\n          font-size: 18px;\r\n          line-height: 26px;\r\n          font-weight: 500;\r\n          color: rgba(47, 47, 47, 0.9);\r\n          @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n            font-size: 16px;\r\n            line-height: 24px;\r\n          }\r\n          @media screen and (max-width: $screen-xs) {\r\n            padding-left: 14px;\r\n            font-size: 14px;\r\n            line-height: 22px;\r\n          }\r\n          &:not(:last-of-type){\r\n            margin: 0 0 12px;\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin: 0 0 6px;\r\n            }\r\n          }\r\n          &:before {\r\n            content: '';\r\n            background: rgba(47, 47, 47, 0.9);\r\n            width: 5px;\r\n            height: 5px;\r\n            border-radius: 50%;\r\n            position: absolute;\r\n            left: 0;\r\n            top: 10px;\r\n            @media screen and (max-width: $screen-xs) {\r\n              width: 4px;\r\n              height: 4px;\r\n            }\r\n          }\r\n          a{\r\n            img{\r\n              max-width: 16px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .img-wrapper{\r\n      img{\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-trading-desk{\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  border-bottom: 1px solid $border-primary04;\r\n  @media screen and (max-width: $screen-xs) {\r\n    border-bottom: unset;\r\n    padding-bottom: 32px;\r\n  }\r\n  &:before, &:after{\r\n    height: calc(100% + 1px);\r\n  }\r\n  .trading-grid{\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 50%);\r\n    align-items: self-start;\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n    .trading-card{\r\n      padding: 64px 40px;\r\n      min-height: 313px;\r\n      display: grid;\r\n      column-gap: 16px;\r\n      grid-template-columns: 1fr 134px;\r\n      align-items: self-start;\r\n      @media screen and (max-width: $screen-xs) {\r\n        grid-template-columns: 1fr;\r\n        padding: 32px 20px;\r\n        min-height: auto;\r\n      }\r\n      &:first-of-type{\r\n        border-right: 1px solid $border-primary04;\r\n      }\r\n      .content{\r\n        h3{\r\n          font-family: $gabarito;\r\n          text-transform: capitalize;\r\n          margin: 0 0 16px;\r\n          @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n            font-size: 20px;\r\n            line-height: 28px;\r\n          }\r\n          @media screen and (max-width: $screen-xs) {\r\n            font-size: 24px;\r\n            line-height: 32px;\r\n            display: grid;\r\n            column-gap: 16px;\r\n            grid-template-columns: 1fr 68px;\r\n            align-items: center;\r\n          }\r\n          img{\r\n            display: none;\r\n            @media screen and (max-width: $screen-xs) {\r\n              display: block;\r\n              width: 100%;\r\n              border-radius: 8px;\r\n            }\r\n          }\r\n        }\r\n        ul.feature-list{\r\n          li{\r\n            display: inline-block;\r\n            vertical-align: middle;\r\n            position: relative;\r\n            padding-left: 18px;\r\n            font-size: 18px;\r\n            line-height: 26px;\r\n            font-weight: 500;\r\n            color: rgba(47, 47, 47, 0.9);\r\n            @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n              font-size: 16px;\r\n              line-height: 24px;\r\n            }\r\n            @media screen and (max-width: $screen-xs) {\r\n              padding-left: 14px;\r\n              font-size: 14px;\r\n              line-height: 22px;\r\n            }\r\n            &:not(:last-of-type){\r\n              margin: 0 0 3px;\r\n            }\r\n            &:before {\r\n              content: '';\r\n              background: rgba(47, 47, 47, 0.9);\r\n              width: 5px;\r\n              height: 5px;\r\n              border-radius: 50%;\r\n              position: absolute;\r\n              left: 0;\r\n              top: 10px;\r\n              @media screen and (max-width: $screen-xs) {\r\n                width: 4px;\r\n                height: 4px;\r\n              }\r\n            }\r\n            a{\r\n              img{\r\n                max-width: 16px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .icon{\r\n        align-self: end;\r\n        @media screen and (max-width: $screen-xs) {\r\n          display: none;\r\n        }\r\n        img{\r\n          width: 100%;\r\n          border-radius: 16px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-security{\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  border-bottom: 1px solid $border-primary05;\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 32px 0 25px;\r\n  }\r\n  .security-grid{\r\n    display: grid;\r\n    grid-template-columns: 1fr 466px;\r\n    column-gap: 6px;\r\n    align-items: center;\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 1fr;\r\n    }\r\n    .content{\r\n      padding-left: 40px;\r\n      @media screen and (max-width: $screen-xs) {\r\n        padding: 0 20px 24px;\r\n      }\r\n      h3{\r\n        color: $black;\r\n        margin-bottom: 0;\r\n        @media screen and (max-width: $screen-xs) {\r\n          font-size: 14px;\r\n          line-height: 22px;\r\n          color: rgba(47, 47, 47, 0.9);\r\n        }\r\n      }\r\n    }\r\n    .img-wrapper{\r\n      img{\r\n        width: 100%;\r\n        height: 315px;\r\n        object-fit: cover;\r\n        @media screen and (max-width: $screen-xs) {\r\n          height: 148px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-compliance{\r\n  position: relative;\r\n  @include before-bg-line-img(\"../images/compliance-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/compliance-right-bg-lines.png\");\r\n  border-bottom: 1px solid $border-primary04;\r\n  .compliance-wrapper{\r\n    padding: 85px 0 238px;\r\n    background: url(\"../images/compliance-bg-img.png\") no-repeat;\r\n    background-position: bottom;\r\n    background-size: cover;\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 40px 0 148px;\r\n      background: url(\"../images/compliance-bg-mobile-img.png\") no-repeat;\r\n      background-position: bottom;\r\n      background-size: contain;\r\n    }\r\n    .bg-img{\r\n      position: absolute;\r\n      bottom: 0;\r\n      left: 50%;\r\n      transform: translateY(-50%);\r\n    }\r\n    >h2{\r\n      text-transform: capitalize;\r\n      margin-bottom: 24px;\r\n      text-align: center;\r\n    }\r\n    >h3{\r\n      margin-bottom: 48px;\r\n      text-align: center;\r\n    }\r\n\r\n    ul.feature-list{\r\n      display: grid;\r\n      grid-template-columns: repeat(12, 1fr);\r\n      column-gap: 32px;\r\n      row-gap: 25px;\r\n      max-width: 1017px;\r\n      margin: auto;\r\n      @media screen and (max-width: $screen-xs) {\r\n        column-gap: 0;\r\n        row-gap: 0;\r\n        margin: auto 4px;\r\n      }\r\n      &:has(li) {\r\n        li:nth-of-type(1), li:nth-of-type(2), li:nth-of-type(3) {\r\n          grid-column: span 4;\r\n        }\r\n      }\r\n      li{\r\n        grid-column: span 3;\r\n        &:nth-of-type(1){\r\n          .feature-card{\r\n            border-right: 1px solid #C4E3F2!important;\r\n          }\r\n        }\r\n        &:nth-of-type(1), &:nth-of-type(2){\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 6!important;\r\n            .feature-card{\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2!important;\r\n            }\r\n          }\r\n        }\r\n        &:nth-of-type(3){\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 7!important;\r\n            .feature-card{\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2!important;\r\n              border-right: 1px solid #C4E3F2!important;\r\n            }\r\n          }\r\n        }\r\n        &:nth-of-type(4){\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 5!important;\r\n            .feature-card{\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2!important;\r\n            }\r\n          }\r\n        }\r\n        &:nth-of-type(5){\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 5!important;\r\n            .feature-card{\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2!important;\r\n              border-right: 1px solid #C4E3F2!important;\r\n            }\r\n          }\r\n        }\r\n        &:nth-of-type(6){\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 7!important;\r\n            .feature-card{\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2!important;\r\n            }\r\n          }\r\n        }\r\n        &:nth-of-type(7){\r\n          @media screen and (max-width: $screen-xs) {\r\n            grid-column: span 12!important;\r\n            .feature-card{\r\n              border: unset;\r\n              border-top: 1px solid #C4E3F2!important;\r\n              border-bottom: 1px solid #C4E3F2!important;\r\n            }\r\n          }\r\n        }\r\n        .feature-card{\r\n          padding: 32px 20px;\r\n          background: $white;\r\n          border-radius: 8px;\r\n          border: 1px solid #C4E3F2;\r\n          @media screen and (max-width: $screen-xs) {\r\n            height: 100%;\r\n            border-radius: 0;\r\n            padding: 22px 16px;\r\n          }\r\n          h3{\r\n            font-size: 20px;\r\n            line-height: 28px;\r\n            font-weight: 400;\r\n            color: $black;\r\n            font-family: $gabarito;\r\n            margin: 0;\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 14px;\r\n              line-height: 20px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-crypto-faqs{\r\n  padding: 108px 0;\r\n  position: relative;\r\n  @include before-bg-line-img(\"../images/compliance-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/compliance-right-bg-lines.png\");\r\n  border-bottom: 1px solid $border-primary04;\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 56px 0 40px;\r\n  }\r\n  .container{\r\n    >h2{\r\n      text-align: center;\r\n      margin-bottom: 36px;\r\n    }\r\n  }\r\n  .faq-wrapper{\r\n    max-width: 950px;\r\n    margin: auto;\r\n    .accordion {\r\n      //max-width: 1000px;\r\n      margin: auto;\r\n      .accordion-item {\r\n        background: $white;\r\n        border-radius: 10px;\r\n        border: 1px solid #D3E7F1;\r\n        &:not(:last-of-type) {\r\n          margin-bottom: 24px;\r\n          @media screen and (max-width: $screen-xs) {\r\n            margin-bottom: 12px;\r\n          }\r\n        }\r\n        button {\r\n          border: unset;\r\n          padding: 30px 27px;\r\n          background: transparent;\r\n          box-shadow: unset !important;\r\n          border-radius: 14px !important;\r\n          font-size: 22px;\r\n          line-height: 32px;\r\n          font-weight: 600;\r\n          color: rgba(47, 47, 47, 0.9);\r\n          font-family: $manrope;\r\n          @media screen and (max-width: $screen-xs) {\r\n            padding: 16px;\r\n            font-size: 14px;\r\n            line-height: 22px;\r\n          }\r\n          &:after{\r\n            @media screen and (max-width: $screen-xs) {\r\n              width: 16px;\r\n              height: 16px;\r\n              background-size: 16px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n      .accordion-body{\r\n        border: unset;\r\n        background: $white;\r\n        border-radius: 14px;\r\n        padding: 0 24px 24px;\r\n        @media screen and (max-width: $screen-xs) {\r\n          padding: 16px;\r\n        }\r\n        p{\r\n          margin-bottom: 0;\r\n          font-size: 16px;\r\n          line-height: 24px;\r\n          font-family: $manrope;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-partnerships{\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  .partnerships-wrapper{\r\n    padding: 80px;\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      padding: 40px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 48px 0;\r\n    }\r\n    &:before {\r\n      content: '';\r\n      background: url('../images/partnerships-top-bg-lines.png');\r\n      background-repeat: repeat;\r\n      background-size: cover;\r\n      height: 80px;\r\n      width: 100%;\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      border-bottom: 1px solid $border-primary04;\r\n      @media screen and (max-width: $screen-xs) {\r\n        height: 48px;\r\n        background: url('../images/partnerships-top-bg-lines-mobile.png');\r\n      }\r\n    }\r\n    &:after {\r\n      content: '';\r\n      background: url('../images/partnerships-bottom-bg-lines.png');\r\n      background-repeat: repeat;\r\n      background-size: cover;\r\n      height: 80px;\r\n      width: 100%;\r\n      position: absolute;\r\n      left: 0;\r\n      bottom: 0;\r\n      border-top: 1px solid $border-primary04;\r\n      @media screen and (max-width: $screen-xs) {\r\n        height: 48px;\r\n        background: url('../images/partnerships-bottom-bg-lines-mobile.png');\r\n      }\r\n    }\r\n    .partnerships-grid{\r\n      display: grid;\r\n      grid-template-columns: 298px 298px 1fr;\r\n      align-items: self-start;\r\n      @media screen and (max-width: $screen-xs) {\r\n        grid-template-columns: 1fr;\r\n      }\r\n      .partnerships-card{\r\n        padding: 40px;\r\n        min-height: 327px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: left;\r\n        @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n          padding: 32px;\r\n        }\r\n        @media screen and (max-width: $screen-xs) {\r\n          padding: 32px 16px;\r\n          min-height: auto;\r\n          text-align: center;\r\n        }\r\n        &:not(:last-of-type){\r\n          border-right: 1px solid $border-primary04;\r\n          @media screen and (max-width: $screen-xs) {\r\n            border: unset;\r\n            border-bottom: 1px solid $border-primary04;\r\n          }\r\n        }\r\n        // 👇 Change order here\r\n        &:nth-child(1) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 3;\r\n          }\r\n        }\r\n        &:nth-child(2) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 2;\r\n          }\r\n        }\r\n        &:nth-child(3) {\r\n          @media screen and (max-width: $screen-xs) {\r\n            order: 1;\r\n          }\r\n        }\r\n        .content-wrapper{\r\n          h2{\r\n            @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n              font-size: 32px;\r\n              line-height: 38px;\r\n            }\r\n          }\r\n          h3{\r\n            color: $black;\r\n            font-family: $gabarito;\r\n            margin-bottom: 16px;\r\n            @media screen and (max-width: $screen-xs) {\r\n              margin-bottom: 8px;\r\n              font-size: 18px;\r\n              line-height: 26px;\r\n            }\r\n          }\r\n          p{\r\n            font-size: 18px;\r\n            line-height: 26px;\r\n            font-weight: 500;\r\n            color: rgba(47, 47, 47, 0.9);\r\n            margin-bottom: 0;\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 14px;\r\n              line-height: 22px;\r\n              color: $black;\r\n            }\r\n            &.black{\r\n              color: $black;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-join{\r\n  padding: 128px 0;\r\n  background: url(\"../images/join-bg-img.png\") no-repeat center;\r\n  background-size: cover;\r\n  position: relative;\r\n  @include before-bg-line-img(\"../images/join-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/join-right-bg-lines.png\");\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 72px 0 80px;\r\n  }\r\n  &:before, &:after{\r\n    border-color: #424A53;\r\n  }\r\n  .content-wrapper{\r\n    text-align: center;\r\n    h2{\r\n      color: $white;\r\n      margin-bottom: 0;\r\n    }\r\n    p{\r\n      font-weight: 500;\r\n      color: $white;\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 14px;\r\n        line-height: 22px;\r\n        margin: 16px 0 24px;\r\n        br{\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n    .btn-style{\r\n      @media screen and (max-width: $screen-xs) {\r\n        min-width: 296px;\r\n        font-weight: 700;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-join-partner{\r\n  padding: 147px 0 144px;\r\n  background: url(\"../images/join-bg-img.png\") no-repeat center;\r\n  background-size: cover;\r\n  position: relative;\r\n  @include before-bg-line-img(\"../images/join-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/join-right-bg-lines.png\");\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 72px 0 80px;\r\n  }\r\n  &:before, &:after{\r\n    border-color: #424A53;\r\n  }\r\n  .content-wrapper{\r\n    text-align: center;\r\n    max-width: 809px;\r\n    margin: 0 auto;\r\n    @media screen and (max-width: $screen-xs) {\r\n      //padding: 0 16px;\r\n    }\r\n    h2{\r\n      color: $white;\r\n      font-weight: 400;\r\n      margin-bottom: 0;\r\n    }\r\n    p{\r\n      font-weight: 500;\r\n      color: $white;\r\n      margin: 24px 0;\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 14px;\r\n        line-height: 22px;\r\n        margin: 16px 0;\r\n        br{\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n    ul.btn-list{\r\n      li{\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        @media screen and (max-width: $screen-xs) {\r\n          display: block;\r\n        }\r\n        &:not(:last-of-type){\r\n          margin: 0 24px 0 0;\r\n          @media screen and (max-width: $screen-xs) {\r\n            margin: 0 0 8px;\r\n          }\r\n        }\r\n        .btn-style{\r\n          font-weight: 700;\r\n          min-width: 305px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-meeting{\r\n  position: relative;\r\n  @include before-bg-line($white);\r\n  @include after-bg-line($white);\r\n  border-bottom: 1px solid $border-primary04;\r\n  &:before, &:after{\r\n    border-color: #E5E5E5;\r\n    z-index: 2;\r\n    @media screen and (max-width: $screen-xs) {\r\n      border-color: $border-primary04;\r\n    }\r\n  }\r\n  .container-fluid{\r\n    padding: 0;\r\n  }\r\n  .partnerships-wrapper{\r\n    //padding: 80px 68px 80px 145px;\r\n    padding: 80px;\r\n    @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n      padding: 80px 40px;\r\n    }\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 48px 0;\r\n    }\r\n    &:before {\r\n      content: '';\r\n      background: transparent;\r\n      height: 80px;\r\n      width: 100%;\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      border-bottom: 1px solid #E5E5E5;\r\n      @media screen and (max-width: $screen-xs) {\r\n        height: 48px;\r\n        border-color: $border-primary04;\r\n      }\r\n    }\r\n    &:after {\r\n      content: '';\r\n      background: transparent;\r\n      height: 80px;\r\n      width: 100%;\r\n      position: absolute;\r\n      right: 0;\r\n      bottom: 0;\r\n      border-top: 1px solid #E5E5E5;\r\n      @media screen and (max-width: $screen-xs) {\r\n        height: 48px;\r\n        border-color: $border-primary04;\r\n      }\r\n    }\r\n    .meeting-grid{\r\n      display: grid;\r\n      grid-template-columns: 1fr 237px 237px;\r\n      align-items: self-start;\r\n      @media screen and (max-width: $screen-xs) {\r\n        grid-template-columns: 1fr;\r\n      }\r\n      .meeting-card{\r\n        padding: 40px;\r\n        min-height: 266px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: left;\r\n        @media screen and (max-width: $screen-xs) {\r\n          padding: 24px;\r\n          min-height: auto;\r\n          text-align: center;\r\n          display: block;\r\n          //justify-content: center;\r\n        }\r\n        &:first-of-type{\r\n          @media screen and (max-width: $screen-xs) {\r\n            padding: 32px 28px;\r\n          }\r\n        }\r\n        &:not(:first-of-type){\r\n          background: #F3F9FF;\r\n          border: 1px solid #D3E7F1;\r\n          @media screen and (max-width: $screen-xs) {\r\n            border: unset;\r\n            border-top: 1px solid #D3E7F1;\r\n          }\r\n        }\r\n        &:not(:last-of-type){\r\n          border-right: unset;\r\n        }\r\n\r\n        .content-wrapper{\r\n          h2{\r\n            @media screen and (max-width: 1450px) and (min-width: 1200px) {\r\n              font-size: 32px;\r\n              line-height: 38px;\r\n            }\r\n          }\r\n          h3{\r\n            color: $black;\r\n            font-family: $gabarito;\r\n            margin-bottom: 16px;\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 24px;\r\n              line-height: 32px;\r\n              margin-bottom: 8px;\r\n            }\r\n          }\r\n          a.f-24{\r\n            font-size: 24px;\r\n            line-height: 32px;\r\n            font-weight: 500;\r\n            color: $black;\r\n            font-family: $gabarito;\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 18px;\r\n              line-height: 26px;\r\n              br{\r\n                display: none;\r\n              }\r\n            }\r\n          }\r\n          p{\r\n            font-size: 18px;\r\n            line-height: 26px;\r\n            font-weight: 500;\r\n            color: $black;\r\n            margin-bottom: 0;\r\n            @media screen and (max-width: $screen-xs) {\r\n              font-size: 14px;\r\n              line-height: 22px;\r\n              br{\r\n                display: none;\r\n              }\r\n            }\r\n            &:not(:last-of-type){\r\n              margin-bottom: 16px;\r\n              @media screen and (max-width: $screen-xs) {\r\n                margin-bottom: 8px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.landing-footer{\r\n  position: relative;\r\n  min-height: 332px;\r\n  padding-bottom: 27px;\r\n  display: flex;\r\n  align-items: self-end;\r\n  background: #010102;\r\n  @include before-bg-line-img(\"../images/footer-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/footer-right-bg-lines.png\");\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding-bottom: 16px;\r\n    min-height: 160px;\r\n  }\r\n  &:before, &:after{\r\n    border-color: #424A53;\r\n    z-index: 2;\r\n  }\r\n  .bg-img{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    object-fit: contain;\r\n    object-position: top;\r\n  }\r\n  .content-wrapper{\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 1;\r\n    p{\r\n      font-weight: 300;\r\n      color: rgba(255, 255, 255, 0.4);\r\n      margin: 0;\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 10px;\r\n        line-height: 16px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.crypto-landing-footer{\r\n  position: relative;\r\n  min-height: 451px;\r\n  padding-bottom: 27px;\r\n  display: flex;\r\n  align-items: self-end;\r\n  background: #010102;\r\n  @include before-bg-line-img(\"../images/footer-left-bg-lines.png\");\r\n  @include after-bg-line-img(\"../images/footer-right-bg-lines.png\");\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding-bottom: 16px;\r\n    min-height: 238px;\r\n  }\r\n  &:before, &:after{\r\n    border-color: #424A53;\r\n    z-index: 2;\r\n  }\r\n  .bg-img{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    object-fit: contain;\r\n    object-position: top;\r\n  }\r\n  .content-wrapper{\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 1;\r\n    ul.link-list{\r\n      &:not(:last-of-type){\r\n        margin-bottom: 16px;\r\n      }\r\n      li{\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        position: relative;\r\n        &:not(:last-of-type){\r\n          margin: 0 18px 0 0;\r\n          &:before{\r\n            content: '';\r\n            background: #F7F7F7;\r\n            width: 4px;\r\n            height: 4px;\r\n            border-radius: 50%;\r\n            position: absolute;\r\n            right: -11px;\r\n            top: 9px;\r\n          }\r\n        }\r\n        a{\r\n          font-weight: 300;\r\n          color: #F7F7F7;\r\n          margin: 0;\r\n          @media screen and (max-width: $screen-xs) {\r\n            font-size: 12px;\r\n            line-height: 16px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.landing-bottom-footer{\r\n  position: relative;\r\n  padding: 18px 0;\r\n  background: #010102;\r\n  border-top: 1px solid #494949;\r\n  @include before-bg-line(#010102);\r\n  @include after-bg-line(#010102);\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 16px 0;\r\n  }\r\n  &:before, &:after{\r\n    border-color: #494949;\r\n    z-index: 2;\r\n  }\r\n  .content-wrapper{\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 1;\r\n    p{\r\n      font-weight: 300;\r\n      color: #F7F7F7;\r\n      margin: 0;\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 10px;\r\n        line-height: 16px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.crypto-landing-bottom-footer{\r\n  position: relative;\r\n  padding: 18px 0;\r\n  background: #010102;\r\n  border-top: 1px solid #494949;\r\n  @include before-bg-line(#010102);\r\n  @include after-bg-line(#010102);\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 16px 0;\r\n  }\r\n  &:before, &:after{\r\n    border-color: #494949;\r\n    z-index: 2;\r\n  }\r\n  .content-wrapper{\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    p{\r\n      font-weight: 300;\r\n      color: #F7F7F7;\r\n      margin: 0;\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 10px;\r\n        line-height: 16px;\r\n      }\r\n    }\r\n    ul.social-list{\r\n      li{\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        position: relative;\r\n        &:not(:last-of-type){\r\n          margin: 0 10px 0 0;\r\n        }\r\n        a{\r\n          img{\r\n            max-width: 20px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Landing Page SCSS\r\n\r\nbody {\r\n  &.xdc-landing-page-body {\r\n    background: $white;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.xdc-landing-main {\r\n  position: relative;\r\n\r\n  .xdc-border-grid {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 0;\r\n    transform: translateX(-50%);\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    max-width: 1200px;\r\n    margin: auto;\r\n    z-index: 1;\r\n    padding: 0 13px;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 0 30px;\r\n      display: none;\r\n    }\r\n\r\n    .xdc-bg-border {\r\n      width: 1px;\r\n      height: 100%;\r\n      background: #DAD6F5;\r\n\r\n      &:nth-of-type(1),\r\n      &:nth-of-type(2),\r\n      &:nth-of-type(3),\r\n      &:nth-of-type(4) {\r\n        @media screen and (max-width: $screen-xs) {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  section {\r\n    .container {\r\n      position: relative;\r\n      z-index: 2;\r\n    }\r\n  }\r\n}\r\n\r\n.xdc-heading {\r\n  text-align: center;\r\n  margin-bottom: 60px;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    margin-bottom: 40px;\r\n  }\r\n\r\n  strong {\r\n    font-size: 16px;\r\n    line-height: 16px;\r\n    font-weight: 400;\r\n    font-family: $inter;\r\n    color: $primary02;\r\n    text-transform: uppercase;\r\n  }\r\n\r\n  h2 {\r\n    font-size: 44px;\r\n    line-height: 52px;\r\n    font-weight: 600;\r\n    font-family: $inter;\r\n    color: $text-primary08;\r\n    margin: 25px 0;\r\n\r\n    @media screen and (max-width: 1366px) and (min-width: 1200px) {\r\n      font-size: 38px;\r\n      line-height: 48px;\r\n    }\r\n\r\n    @media screen and (max-width: 991px) and (min-width: 768px) {\r\n      font-size: 34px;\r\n      line-height: 42px;\r\n      margin: 16px 0;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      font-size: 30px;\r\n      line-height: 40px;\r\n      margin: 12px 0;\r\n    }\r\n  }\r\n\r\n  p {\r\n    font-size: 17px;\r\n    line-height: 25px;\r\n    font-weight: 400;\r\n    font-family: $inter;\r\n    color: $text-primary09;\r\n    margin-bottom: 0;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      //font-size: 15px;\r\n      //line-height: 23px;\r\n    }\r\n  }\r\n}\r\n\r\n.xdc-header {\r\n  position: absolute;\r\n  top: 32px;\r\n  left: 0;\r\n  width: 100%;\r\n  z-index: 2;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    top: 16px;\r\n  }\r\n\r\n  &.menu-open {\r\n    .header-wrapper {\r\n      @media screen and (max-width: $screen-xs) {\r\n        border-radius: 8px 8px 0 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .header-wrapper {\r\n    padding: 0;\r\n    max-width: 1200px;\r\n    margin: auto;\r\n    display: grid;\r\n    grid-template-columns: 200px 1fr;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    column-gap: 30px;\r\n\r\n    @media screen and (max-width: 1300px) and (min-width: 1200px) {\r\n      max-width: 1140px;\r\n    }\r\n\r\n    @media screen and (max-width: 1199px) and (min-width: 992px) {\r\n      padding: 0 24px;\r\n      grid-template-columns: 120px 1fr;\r\n    }\r\n\r\n    @media screen and (max-width: 991px) and (min-width: 768px) {\r\n      max-width: 600px;\r\n      padding: 14px 22px 11px;\r\n      grid-template-columns: 120px 1fr;\r\n      border-radius: 8px;\r\n      box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      max-width: 328px;\r\n      padding: 14px 22px 11px;\r\n      grid-template-columns: 90px 1fr;\r\n      border-radius: 8px;\r\n      box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;\r\n    }\r\n\r\n    .logo-wrapper {\r\n      a.logo {\r\n        display: inline-block;\r\n\r\n        img {\r\n          width: 100%;\r\n          max-width: 200px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .navbar-menu {\r\n      .menu-bar {\r\n        display: none;\r\n\r\n        @media screen and (max-width: 991px) {\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: right;\r\n        }\r\n\r\n        img {\r\n          max-width: 20px;\r\n          filter: brightness(0) saturate(100%) invert(0%) sepia(2%) saturate(7500%) hue-rotate(212deg) brightness(105%) contrast(95%);\r\n        }\r\n      }\r\n\r\n      ul.menu {\r\n        text-align: right;\r\n\r\n        @media screen and (max-width: 991px) and (min-width: 768px) {\r\n          top: 89px !important;\r\n          max-width: 600px !important;\r\n        }\r\n\r\n        @media screen and (max-width: 991px) {\r\n          position: fixed;\r\n          top: 66px;\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n          width: 100%;\r\n          max-width: 328px;\r\n          height: auto;\r\n          box-shadow: rgba(0, 0, 0, 0.16) 0 1px 4px;\r\n          background: $white;\r\n          border-radius: 0 0 8px 8px;\r\n          display: none;\r\n\r\n          &.active {\r\n            display: block;\r\n          }\r\n        }\r\n\r\n        li {\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n          position: relative;\r\n\r\n          @media screen and (max-width: 991px) {\r\n            display: block;\r\n          }\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 35px 0 0;\r\n\r\n            @media screen and (max-width: 1199px) and (min-width: 992px) {\r\n              margin: 0 25px 0 0;\r\n            }\r\n\r\n            @media screen and (max-width: 991px) {\r\n              margin: 0;\r\n              border-bottom: 1px solid $border-primary04;\r\n            }\r\n          }\r\n\r\n          &.arrow {\r\n            margin: 0 45px 0 0;\r\n\r\n            @media screen and (max-width: 991px) {\r\n              margin: 0;\r\n            }\r\n\r\n            &:before {\r\n              content: '';\r\n              background: url(\"../images/icons/arrow-down-white-icon.svg\") no-repeat center;\r\n              background-size: cover;\r\n              width: 6px;\r\n              height: 9px;\r\n              position: absolute;\r\n              right: -16px;\r\n              top: 50%;\r\n              transform: translateY(-50%);\r\n\r\n              @media screen and (max-width: 991px) {\r\n                width: 12px;\r\n                right: 24px;\r\n                filter: brightness(0) saturate(100%) invert(0%) sepia(97%) saturate(0%) hue-rotate(43deg) brightness(95%) contrast(102%);\r\n              }\r\n            }\r\n          }\r\n\r\n          a {\r\n            font-size: 15px;\r\n            line-height: 23px;\r\n            font-weight: 400;\r\n            font-family: $inter;\r\n            display: inline-block;\r\n\r\n            @media screen and (max-width: 991px) {\r\n              display: block;\r\n              font-weight: 500;\r\n              text-align: left;\r\n              color: $black;\r\n              padding: 20px 33px 20px 28px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-xdc-banner {\r\n  padding: 175px 0 157px;\r\n  background: url(\"../images/xdc-banner-bg-img.png\") no-repeat;\r\n  background-position: bottom;\r\n  background-size: cover;\r\n\r\n  @media screen and (max-width: 1199px) and (min-width: 992px) {\r\n    padding: 175px 0 80px;\r\n  }\r\n\r\n  @media screen and (max-width: 991px) and (min-width: 768px) {\r\n    padding: 160px 0 70px;\r\n  }\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 120px 0 40px;\r\n  }\r\n\r\n  .content-wrapper {\r\n    @media screen and (max-width: 991px) {\r\n      text-align: center;\r\n    }\r\n\r\n    h1 {\r\n      font-size: 75px;\r\n      line-height: 83px;\r\n      font-weight: 600;\r\n      margin-bottom: 0;\r\n\r\n      @media screen and (max-width: 1366px) and (min-width: 1200px) {\r\n        font-size: 65px;\r\n        line-height: 73px;\r\n      }\r\n\r\n      @media screen and (max-width: 1199px) and (min-width: 992px) {\r\n        font-size: 55px;\r\n        line-height: 62px;\r\n      }\r\n\r\n      @media screen and (max-width: 991px) and (min-width: 768px) {\r\n        font-size: 45px;\r\n        line-height: 52px;\r\n      }\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 35px;\r\n        line-height: 42px;\r\n      }\r\n    }\r\n\r\n    h3 {\r\n      color: #717184;\r\n      margin: 43px 0 55px;\r\n\r\n      @media screen and (max-width: 991px) {\r\n        margin: 20px 0 30px;\r\n      }\r\n    }\r\n\r\n    ul.btn-list {\r\n      li {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n\r\n        &:not(:last-of-type) {\r\n          margin: 0 17px 0 0;\r\n        }\r\n\r\n        .btn-style {}\r\n      }\r\n    }\r\n  }\r\n\r\n  .img-wrapper {\r\n    text-align: right;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.xdc-statistics {\r\n  padding: 78px 0 61px;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 40px 0 10px;\r\n  }\r\n\r\n  .statistics-card {\r\n    text-align: center;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      margin-bottom: 40px;\r\n    }\r\n\r\n    strong {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      gap: 10px;\r\n      font-size: 46px;\r\n      line-height: 46px;\r\n      font-weight: 700;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        font-size: 40px;\r\n        line-height: 40px;\r\n      }\r\n    }\r\n\r\n    p {\r\n      margin: 26px 0 0;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        margin: 16px 0 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n.sec-xdc-features {\r\n  padding: 61px 0 82px;\r\n\r\n  @media screen and (max-width: 991px) and (min-width: 768px) {\r\n    padding: 60px 0;\r\n  }\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 40px 0;\r\n  }\r\n\r\n  .feature-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, calc(25% - 16px));\r\n    column-gap: 21px;\r\n\r\n    @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n      grid-template-columns: repeat(2, calc(50% - 16px));\r\n      row-gap: 20px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 1fr;\r\n      row-gap: 20px;\r\n    }\r\n\r\n    .feature-card {\r\n      padding: 36px 28px;\r\n      background: $white;\r\n      border-radius: 20px;\r\n      border: 1px solid #DAD6F5;\r\n\r\n      .icon {\r\n        margin-bottom: 29px;\r\n\r\n        img {\r\n          max-width: 40px;\r\n        }\r\n      }\r\n\r\n      .content {\r\n        h3 {\r\n          margin-bottom: 20px;\r\n\r\n          @media screen and (max-width: 1366px) and (min-width: 1200px) {\r\n            font-size: 18px;\r\n            line-height: 26px;\r\n          }\r\n        }\r\n\r\n        p {\r\n          margin-bottom: 0;\r\n          line-height: 24px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.about-bg-main {\r\n  background: #FFFFFF;\r\n  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(237, 235, 254, 1) 71%);\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    background: rgba(237, 235, 254, .4);\r\n  }\r\n}\r\n\r\n.sec-xdc-about {\r\n  padding: 81px 0 62px;\r\n\r\n  @media screen and (max-width: 991px) and (min-width: 768px) {\r\n    padding: 60px 0;\r\n  }\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 40px 0;\r\n  }\r\n\r\n  .about-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 430px;\r\n    align-items: center;\r\n    column-gap: 0;\r\n\r\n    @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n      display: block;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      display: flex;\r\n      flex-direction: column-reverse;\r\n    }\r\n\r\n    .content-wrapper {\r\n      .xdc-heading {\r\n        text-align: left;\r\n        margin-bottom: 23px;\r\n\r\n        h2 {\r\n          @media screen and (max-width: $screen-xs) {\r\n            br {\r\n              display: none;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      p {\r\n        @media screen and (max-width: $screen-xs) {\r\n          br {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n\r\n      .about-card-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(2, calc(285px - 10px));\r\n        column-gap: 20px;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          grid-template-columns: 1fr;\r\n          row-gap: 20px;\r\n        }\r\n\r\n        .about-card {\r\n          padding: 24px 23px 20px;\r\n          background: $white;\r\n          border-radius: 20px;\r\n\r\n          .icon {\r\n            width: 60px;\r\n            height: 60px;\r\n            border-radius: 16px;\r\n            background: $primary02;\r\n            margin-bottom: 22px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n\r\n            img {\r\n              max-width: 40px;\r\n            }\r\n          }\r\n\r\n          .content {\r\n            h3 {\r\n              margin-bottom: 6px;\r\n            }\r\n\r\n            p {\r\n              margin-bottom: 0;\r\n              line-height: 24px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .img-wrapper {\r\n      position: relative;\r\n      left: -36px;\r\n      top: 60px;\r\n\r\n      @media screen and (max-width: 1199px) and (min-width: 768px) {\r\n        display: none;\r\n      }\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        left: 0;\r\n        top: 0;\r\n        margin-bottom: 30px;\r\n      }\r\n\r\n      img {\r\n        @media screen and (max-width: $screen-xs) {\r\n          width: 100%;\r\n          max-width: 300px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-choose-xdc {\r\n  padding: 62px 0 83px;\r\n  position: relative;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 40px 0;\r\n  }\r\n\r\n  .bg-circle {\r\n    position: absolute;\r\n    bottom: 90px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    z-index: 1;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .xdc-heading {\r\n    h2 {\r\n      @media screen and (max-width: $screen-xs) {\r\n        br {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .choose-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, calc(33% - 10px));\r\n    column-gap: 20px;\r\n    position: relative;\r\n    z-index: 2;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      grid-template-columns: 1fr;\r\n      row-gap: 20px;\r\n    }\r\n\r\n    .choose-column {\r\n      .choose-card {\r\n        padding: 34px;\r\n        background: $white;\r\n        border-radius: 20px;\r\n\r\n        &:not(:last-of-type) {\r\n          margin-bottom: 23px;\r\n        }\r\n\r\n        .icon {\r\n          width: 60px;\r\n          height: 60px;\r\n          border-radius: 16px;\r\n          background: $primary02;\r\n          margin-bottom: 25px;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n\r\n          img {\r\n            max-width: 40px;\r\n          }\r\n        }\r\n\r\n        .content {\r\n          h3 {\r\n            margin-bottom: 15px;\r\n          }\r\n\r\n          p {\r\n            margin-bottom: 0;\r\n            line-height: 24px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .mobile-card {\r\n        padding: 35px 33px 0;\r\n        background: $primary02;\r\n        border-radius: 20px;\r\n\r\n        .content {\r\n          margin-bottom: 47px;\r\n\r\n          h3 {\r\n            color: $white;\r\n            margin-bottom: 20px;\r\n          }\r\n\r\n          p {\r\n            color: $white;\r\n            line-height: 24px;\r\n            margin-bottom: 0;\r\n          }\r\n        }\r\n\r\n        .mobile-img {\r\n          text-align: center;\r\n\r\n          img {\r\n            width: 100%;\r\n            max-width: 335px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  ul.btn-list {\r\n    margin-top: 44px;\r\n    text-align: center;\r\n\r\n    li {\r\n      display: inline-block;\r\n      vertical-align: middle;\r\n\r\n      &:not(:last-of-type) {\r\n        margin: 0 28px 0 0;\r\n      }\r\n\r\n      .btn-style {}\r\n    }\r\n  }\r\n}\r\n\r\n.sec-review {\r\n  padding: 81px 0 62px;\r\n  background: #EDEBFE;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 40px 0;\r\n  }\r\n\r\n  .review-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, calc(33% - 10px));\r\n    column-gap: 20px;\r\n\r\n    @media screen and (max-width: 991px) and (min-width: 768px) {\r\n      grid-template-columns: repeat(2, calc(50% - 10px));\r\n      row-gap: 20px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      grid-template-columns: 1fr;\r\n      row-gap: 20px;\r\n    }\r\n\r\n    .review-card {\r\n      padding: 45px;\r\n      text-align: center;\r\n      background: $white;\r\n      border-radius: 20px;\r\n\r\n      .star-img {\r\n        img {\r\n          max-width: 160px;\r\n        }\r\n      }\r\n\r\n      .review-content {\r\n        margin: 35px auto 64px;\r\n        max-width: 250px;\r\n\r\n        p {\r\n          line-height: 20px;\r\n          margin-bottom: 0;\r\n        }\r\n      }\r\n\r\n      .user-profile {\r\n        display: grid;\r\n        grid-template-columns: 42px auto;\r\n        align-items: center;\r\n        justify-content: center;\r\n        column-gap: 20px;\r\n\r\n        .user-img {\r\n          img {\r\n            width: 42px;\r\n            height: 42px;\r\n            border-radius: 50%;\r\n            object-fit: cover;\r\n            object-position: top;\r\n          }\r\n        }\r\n\r\n        .user-content {\r\n          strong {\r\n            display: block;\r\n          }\r\n\r\n          p {\r\n            margin: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.sec-xdc-chain {\r\n  padding: 62px 0 119px;\r\n  background: #EDEBFE;\r\n\r\n  @media screen and (max-width: 991px) and (min-width: 768px) {\r\n    padding: 60px 0;\r\n  }\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 40px 0;\r\n  }\r\n\r\n  .chain-list-card {\r\n    border-radius: 100px;\r\n    padding: 30px 171px 39px;\r\n    background: linear-gradient(180deg, #FFFFFF 30%, rgba(255, 255, 255, 0) 100%);\r\n\r\n    @media screen and (max-width: 991px) and (min-width: 768px) {\r\n      padding: 20px 60px 29px;\r\n    }\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      padding: 60px;\r\n      max-width: 220px;\r\n      margin: auto;\r\n    }\r\n\r\n    ul.chain-list {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      position: relative;\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        display: grid;\r\n        row-gap: 40px;\r\n      }\r\n\r\n      &:before {\r\n        content: \"\";\r\n        background: #D5CDFD;\r\n        height: 1px;\r\n        width: 100%;\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 0;\r\n        transform: translateY(-50%);\r\n        z-index: 1;\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          height: 100%;\r\n          width: 1px;\r\n          top: 0;\r\n          left: 50%;\r\n          transform: translateX(-50%);\r\n        }\r\n      }\r\n\r\n      li {\r\n        position: relative;\r\n        z-index: 2;\r\n\r\n        .chain-icon {\r\n          display: inline-block;\r\n\r\n          img {\r\n            max-width: 100px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .safe-crypto-card {\r\n    background: url(\"../images/safe-card-bg-img.png\") no-repeat;\r\n    background-position: bottom;\r\n    background-size: cover;\r\n    padding: 70px 64px 0;\r\n    border-radius: 20px;\r\n    margin-top: 116px;\r\n    display: grid;\r\n    grid-template-columns: 1fr 335px 150px;\r\n    align-items: self-start;\r\n    column-gap: 40px;\r\n\r\n    @media screen and (max-width: 991px) {\r\n      margin-top: 30px;\r\n      grid-template-columns: 1fr;\r\n      padding: 32px;\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 40px;\r\n      text-align: center;\r\n    }\r\n\r\n    .safe-content {\r\n      h2 {\r\n        color: $white;\r\n        font-weight: 600;\r\n        margin-bottom: 0;\r\n\r\n        @media screen and (max-width: 1199px) and (min-width: 992px) {\r\n          font-size: 28px;\r\n          line-height: 36px;\r\n        }\r\n\r\n        @media screen and (max-width: 1366px) and (min-width: 1200px) {\r\n          font-size: 36px;\r\n          line-height: 44px;\r\n        }\r\n      }\r\n\r\n      p {\r\n        color: $white;\r\n        margin: 30px 0 35px;\r\n\r\n        @media screen and (max-width: 1199px) {\r\n          margin: 20px 0 25px;\r\n        }\r\n      }\r\n\r\n      ul.btn-list {\r\n        li {\r\n          display: inline-block;\r\n          vertical-align: middle;\r\n\r\n          &:not(:last-of-type) {\r\n            margin: 0 17px 0 0;\r\n          }\r\n\r\n          .btn-style {}\r\n        }\r\n      }\r\n    }\r\n\r\n    .safe-mobile-img {\r\n      @media screen and (max-width: 991px) {\r\n        display: none;\r\n      }\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n    .barcode-wrapper {\r\n      text-align: center;\r\n\r\n      @media screen and (max-width: 991px) {\r\n        margin: auto;\r\n      }\r\n\r\n      .barcode-icon-main {\r\n        width: 150px;\r\n        height: 150px;\r\n        border-radius: 40px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        background: linear-gradient(131.3deg, #DAF727 31.14%, rgba(255, 255, 255, 0.25) 97.16%);\r\n\r\n        @media screen and (max-width: 991px) {\r\n          margin: auto;\r\n        }\r\n\r\n        .barcode-icon {\r\n          width: 134px;\r\n          height: 134px;\r\n          border-radius: 35px;\r\n          background: $white;\r\n          display: flex;\r\n          align-items: center;\r\n          justify-content: center;\r\n\r\n          img {\r\n            max-width: 90px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .arrow-icon {\r\n        margin: 18px 0;\r\n\r\n        img {\r\n          max-width: 22px;\r\n        }\r\n      }\r\n\r\n      p {\r\n        color: #F8F8F8;\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.xdc-footer {\r\n  padding: 83px 0 67px;\r\n\r\n  @media screen and (max-width: $screen-xs) {\r\n    padding: 50px 0;\r\n  }\r\n\r\n  p,\r\n  a,\r\n  ul li,\r\n  ol li,\r\n  strong {\r\n    color: #717184;\r\n  }\r\n\r\n  .top-footer {\r\n    padding-bottom: 64px;\r\n    margin-bottom: 51px;\r\n    border-bottom: 1px solid #DAD6F5;\r\n\r\n    @media screen and (max-width: $screen-xs) {\r\n      margin-bottom: 30px;\r\n      padding-bottom: 10px;\r\n    }\r\n\r\n    .social-wrapper {\r\n      @media screen and (max-width: 991px) and (min-width: 768px) {\r\n        display: grid;\r\n        grid-template-columns: auto auto;\r\n        align-items: self-start;\r\n        margin-bottom: 40px;\r\n      }\r\n\r\n      @media screen and (max-width: $screen-xs) {\r\n        margin-bottom: 40px;\r\n      }\r\n\r\n      .logo-wrapper {\r\n        a.logo {\r\n          img {\r\n            max-width: 200px;\r\n\r\n            @media screen and (max-width: $screen-xs) {\r\n              max-width: 140px;\r\n            }\r\n          }\r\n        }\r\n\r\n        p {\r\n          margin: 50px 0 0;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            margin: 20px 0 0;\r\n          }\r\n        }\r\n      }\r\n\r\n      .social-card {\r\n        margin-top: 74px;\r\n\r\n        @media screen and (max-width: 991px) and (min-width: 768px) {\r\n          margin-top: 0;\r\n        }\r\n\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin-top: 40px;\r\n        }\r\n\r\n        ul.social-list {\r\n          li {\r\n            display: inline-block;\r\n            vertical-align: middle;\r\n\r\n            &:not(:last-of-type) {\r\n              margin: 0 22px 0 0;\r\n            }\r\n\r\n            a {\r\n              img {\r\n                max-width: 18px;\r\n                filter: brightness(0) saturate(100%) invert(45%) sepia(11%) saturate(515%) hue-rotate(202deg) brightness(96%) contrast(89%);\r\n              }\r\n            }\r\n          }\r\n        }\r\n\r\n        p {\r\n          margin: 35px 0 0;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            margin: 20px 0 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .link-wrapper {\r\n      .link-card {\r\n        @media screen and (max-width: $screen-xs) {\r\n          margin-bottom: 30px;\r\n        }\r\n\r\n        &:first-of-type {\r\n          min-height: 181px;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            min-height: auto;\r\n          }\r\n        }\r\n\r\n        &:not(:last-of-type) {\r\n          margin-bottom: 44px;\r\n\r\n          @media screen and (max-width: $screen-xs) {\r\n            margin-bottom: 30px;\r\n          }\r\n        }\r\n\r\n        strong,\r\n        a {\r\n          font-size: 14px;\r\n          line-height: 20px;\r\n          font-weight: 400;\r\n          font-family: $inter;\r\n        }\r\n\r\n        strong {\r\n          display: block;\r\n          color: #0E0637;\r\n          margin-bottom: 12px;\r\n        }\r\n\r\n        ul.link-list {\r\n          li {\r\n            display: block;\r\n\r\n            &:not(:last-of-type) {\r\n              margin-bottom: 3px;\r\n            }\r\n\r\n            a {}\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .bottom-footer {\r\n\r\n    strong,\r\n    p {\r\n      font-size: 13px;\r\n      line-height: 19px;\r\n      font-weight: 300;\r\n      font-family: $inter;\r\n    }\r\n\r\n    strong {\r\n      font-weight: 500;\r\n    }\r\n\r\n    p {\r\n      margin-bottom: 0;\r\n\r\n      &:not(:last-of-type) {\r\n        margin-bottom: 18px;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
